(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 4251:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var AlertTriangle=function AlertTriangle(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{fill:"",d:"M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"}),/*#__PURE__*/_react["default"].createElement("path",{stroke:"",d:"M12 9v4M12 17h.01"}))};var _default=AlertTriangle;exports.Z=_default;

/***/ }),

/***/ 287:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Archive=function Archive(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M21 8v13H3V8M1 3h22v5H1zM10 12h4"}))};var _default=Archive;exports.Z=_default;

/***/ }),

/***/ 8064:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Check=function Check(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M20 6L9 17l-5-5"}))};var _default=Check;exports.Z=_default;

/***/ }),

/***/ 4869:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Download=function Download(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"}))};var _default=Download;exports.Z=_default;

/***/ }),

/***/ 9950:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Eye=function Eye(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"}),/*#__PURE__*/_react["default"].createElement("circle",{cx:"12",cy:"12",r:"3"}))};var _default=Eye;exports.Z=_default;

/***/ }),

/***/ 183:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var EyeOff=function EyeOff(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22"}))};var _default=EyeOff;exports.Z=_default;

/***/ }),

/***/ 8628:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var FastForward=function FastForward(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M13 19l9-7-9-7v14zM2 19l9-7-9-7v14z"}))};var _default=FastForward;exports.Z=_default;

/***/ }),

/***/ 1089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Gift=function Gift(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"}))};var _default=Gift;exports.Z=_default;

/***/ }),

/***/ 5628:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Home=function Home(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"}),/*#__PURE__*/_react["default"].createElement("path",{d:"M9 22V12h6v10"}))};var _default=Home;exports.Z=_default;

/***/ }),

/***/ 7212:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Image=function Image(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("rect",{width:"18",height:"18",x:"3",y:"3",rx:"2",ry:"2"}),/*#__PURE__*/_react["default"].createElement("circle",{cx:"8.5",cy:"8.5",r:"1.5"}),/*#__PURE__*/_react["default"].createElement("path",{d:"M21 15l-5-5L5 21"}))};var _default=Image;exports.Z=_default;

/***/ }),

/***/ 5359:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var InfoFill=function InfoFill(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("circle",{cx:"12",cy:"12",r:"10",fill:color}),/*#__PURE__*/_react["default"].createElement("path",{stroke:"var(--geist-icons-background)",d:"M12 16v-4M12 8h.01"}))};var _default=InfoFill;exports.Z=_default;

/***/ }),

/***/ 4083:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Menu=function Menu(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M3 12h18M3 6h18M3 18h18"}))};var _default=Menu;exports.Z=_default;

/***/ }),

/***/ 6342:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Minus=function Minus(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M5 12h14"}))};var _default=Minus;exports.Z=_default;

/***/ }),

/***/ 6247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Plus=function Plus(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M12 5v14M5 12h14"}))};var _default=Plus;exports.Z=_default;

/***/ }),

/***/ 1614:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Power=function Power(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M18.36 6.64a9 9 0 11-12.73 0M12 2v10"}))};var _default=Power;exports.Z=_default;

/***/ }),

/***/ 4551:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Save=function Save(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"}),/*#__PURE__*/_react["default"].createElement("path",{d:"M17 21v-8H7v8M7 3v5h8"}))};var _default=Save;exports.Z=_default;

/***/ }),

/***/ 2607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Star=function Star(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"}))};var _default=Star;exports.Z=_default;

/***/ }),

/***/ 5840:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var Tool=function Tool(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"}))};var _default=Tool;exports.Z=_default;

/***/ }),

/***/ 3685:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var User=function User(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"}),/*#__PURE__*/_react["default"].createElement("circle",{cx:"12",cy:"7",r:"4"}))};var _default=User;exports.Z=_default;

/***/ }),

/***/ 756:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(4836);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(434));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(215));var _react=_interopRequireDefault(__webpack_require__(7294));var X=function X(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M18 6L6 18M6 6l12 12"}))};var _default=X;exports.Z=_default;

/***/ }),

/***/ 9361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 8363:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;

exports.Z = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

/***/ }),

/***/ 9742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 8764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(9742)
var ieee754 = __webpack_require__(645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 6489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var dec = opt.decode || decode;

  var index = 0
  while (index < str.length) {
    var eqIdx = str.indexOf('=', index)

    // no more cookie pairs
    if (eqIdx === -1) {
      break
    }

    var endIdx = str.indexOf(';', index)

    if (endIdx === -1) {
      endIdx = str.length
    } else if (endIdx < eqIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1
      continue
    }

    var key = str.slice(index, eqIdx).trim()

    // only assign once
    if (undefined === obj[key]) {
      var val = str.slice(eqIdx + 1, endIdx).trim()

      // quoted values
      if (val.charCodeAt(0) === 0x22) {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString()
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority

    switch (priority) {
      case 'low':
        str += '; Priority=Low'
        break
      case 'medium':
        str += '; Priority=Medium'
        break
      case 'high':
        str += '; Priority=High'
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} str
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 3162:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof __webpack_require__.g&&__webpack_require__.g.global===__webpack_require__.g?__webpack_require__.g:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g, true&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map

/***/ }),

/***/ 645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 9548:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4836);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.BroadcastChannel = BroadcastChannel;
exports.apiBaseUrl = apiBaseUrl;
exports.fetchData = fetchData;
exports.now = now;

var _regenerator = _interopRequireDefault(__webpack_require__(4687));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8416));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(7156));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function fetchData(_x, _x2, _x3) {
  return _fetchData.apply(this, arguments);
}

function _fetchData() {
  _fetchData = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(path, __NEXTAUTH, logger) {
    var _ref,
        ctx,
        _ref$req,
        req,
        url,
        options,
        res,
        data,
        _args = arguments;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 3 && _args[3] !== undefined ? _args[3] : {}, ctx = _ref.ctx, _ref$req = _ref.req, req = _ref$req === void 0 ? ctx === null || ctx === void 0 ? void 0 : ctx.req : _ref$req;
            url = "".concat(apiBaseUrl(__NEXTAUTH), "/").concat(path);
            _context.prev = 2;
            options = req !== null && req !== void 0 && req.headers.cookie ? {
              headers: {
                cookie: req.headers.cookie
              }
            } : {};
            _context.next = 6;
            return fetch(url, options);

          case 6:
            res = _context.sent;
            _context.next = 9;
            return res.json();

          case 9:
            data = _context.sent;

            if (res.ok) {
              _context.next = 12;
              break;
            }

            throw data;

          case 12:
            return _context.abrupt("return", Object.keys(data).length > 0 ? data : null);

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](2);
            logger.error("CLIENT_FETCH_ERROR", {
              error: _context.t0,
              url: url
            });
            return _context.abrupt("return", null);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 15]]);
  }));
  return _fetchData.apply(this, arguments);
}

function apiBaseUrl(__NEXTAUTH) {
  if (typeof window === "undefined") {
    return "".concat(__NEXTAUTH.baseUrlServer).concat(__NEXTAUTH.basePathServer);
  }

  return __NEXTAUTH.basePath;
}

function now() {
  return Math.floor(Date.now() / 1000);
}

function BroadcastChannel() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "nextauth.message";
  return {
    receive: function receive(onReceive) {
      var handler = function handler(event) {
        var _event$newValue;

        if (event.key !== name) return;
        var message = JSON.parse((_event$newValue = event.newValue) !== null && _event$newValue !== void 0 ? _event$newValue : "{}");
        if ((message === null || message === void 0 ? void 0 : message.event) !== "session" || !(message !== null && message !== void 0 && message.data)) return;
        onReceive(message);
      };

      window.addEventListener("storage", handler);
      return function () {
        return window.removeEventListener("storage", handler);
      };
    },
    post: function post(message) {
      if (typeof window === "undefined") return;
      localStorage.setItem(name, JSON.stringify(_objectSpread(_objectSpread({}, message), {}, {
        timestamp: now()
      })));
    }
  };
}

/***/ }),

/***/ 6925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4836);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.UnsupportedStrategy = exports.UnknownError = exports.OAuthCallbackError = exports.MissingSecret = exports.MissingAuthorize = exports.MissingAdapter = exports.MissingAPIRoute = exports.InvalidCallbackUrl = exports.AccountNotLinkedError = void 0;
exports.adapterErrorHandler = adapterErrorHandler;
exports.capitalize = capitalize;
exports.eventsErrorHandler = eventsErrorHandler;
exports.upperSnake = upperSnake;

var _regenerator = _interopRequireDefault(__webpack_require__(4687));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(7156));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(6115));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8416));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6690));

var _createClass2 = _interopRequireDefault(__webpack_require__(9728));

var _inherits2 = _interopRequireDefault(__webpack_require__(1655));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(4993));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(3808));

var _wrapNativeSuper2 = _interopRequireDefault(__webpack_require__(3496));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var UnknownError = function (_Error) {
  (0, _inherits2.default)(UnknownError, _Error);

  var _super = _createSuper(UnknownError);

  function UnknownError(error) {
    var _message;

    var _this;

    (0, _classCallCheck2.default)(this, UnknownError);
    _this = _super.call(this, (_message = error === null || error === void 0 ? void 0 : error.message) !== null && _message !== void 0 ? _message : error);
    _this.name = "UnknownError";
    _this.code = error.code;

    if (error instanceof Error) {
      _this.stack = error.stack;
    }

    return _this;
  }

  (0, _createClass2.default)(UnknownError, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        name: this.name,
        message: this.message,
        stack: this.stack
      };
    }
  }]);
  return UnknownError;
}((0, _wrapNativeSuper2.default)(Error));

exports.UnknownError = UnknownError;

var OAuthCallbackError = function (_UnknownError) {
  (0, _inherits2.default)(OAuthCallbackError, _UnknownError);

  var _super2 = _createSuper(OAuthCallbackError);

  function OAuthCallbackError() {
    var _this2;

    (0, _classCallCheck2.default)(this, OAuthCallbackError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "name", "OAuthCallbackError");
    return _this2;
  }

  return (0, _createClass2.default)(OAuthCallbackError);
}(UnknownError);

exports.OAuthCallbackError = OAuthCallbackError;

var AccountNotLinkedError = function (_UnknownError2) {
  (0, _inherits2.default)(AccountNotLinkedError, _UnknownError2);

  var _super3 = _createSuper(AccountNotLinkedError);

  function AccountNotLinkedError() {
    var _this3;

    (0, _classCallCheck2.default)(this, AccountNotLinkedError);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "name", "AccountNotLinkedError");
    return _this3;
  }

  return (0, _createClass2.default)(AccountNotLinkedError);
}(UnknownError);

exports.AccountNotLinkedError = AccountNotLinkedError;

var MissingAPIRoute = function (_UnknownError3) {
  (0, _inherits2.default)(MissingAPIRoute, _UnknownError3);

  var _super4 = _createSuper(MissingAPIRoute);

  function MissingAPIRoute() {
    var _this4;

    (0, _classCallCheck2.default)(this, MissingAPIRoute);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this4), "name", "MissingAPIRouteError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this4), "code", "MISSING_NEXTAUTH_API_ROUTE_ERROR");
    return _this4;
  }

  return (0, _createClass2.default)(MissingAPIRoute);
}(UnknownError);

exports.MissingAPIRoute = MissingAPIRoute;

var MissingSecret = function (_UnknownError4) {
  (0, _inherits2.default)(MissingSecret, _UnknownError4);

  var _super5 = _createSuper(MissingSecret);

  function MissingSecret() {
    var _this5;

    (0, _classCallCheck2.default)(this, MissingSecret);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this5), "name", "MissingSecretError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this5), "code", "NO_SECRET");
    return _this5;
  }

  return (0, _createClass2.default)(MissingSecret);
}(UnknownError);

exports.MissingSecret = MissingSecret;

var MissingAuthorize = function (_UnknownError5) {
  (0, _inherits2.default)(MissingAuthorize, _UnknownError5);

  var _super6 = _createSuper(MissingAuthorize);

  function MissingAuthorize() {
    var _this6;

    (0, _classCallCheck2.default)(this, MissingAuthorize);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this6 = _super6.call.apply(_super6, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this6), "name", "MissingAuthorizeError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this6), "code", "CALLBACK_CREDENTIALS_HANDLER_ERROR");
    return _this6;
  }

  return (0, _createClass2.default)(MissingAuthorize);
}(UnknownError);

exports.MissingAuthorize = MissingAuthorize;

var MissingAdapter = function (_UnknownError6) {
  (0, _inherits2.default)(MissingAdapter, _UnknownError6);

  var _super7 = _createSuper(MissingAdapter);

  function MissingAdapter() {
    var _this7;

    (0, _classCallCheck2.default)(this, MissingAdapter);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this7 = _super7.call.apply(_super7, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this7), "name", "MissingAdapterError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this7), "code", "EMAIL_REQUIRES_ADAPTER_ERROR");
    return _this7;
  }

  return (0, _createClass2.default)(MissingAdapter);
}(UnknownError);

exports.MissingAdapter = MissingAdapter;

var UnsupportedStrategy = function (_UnknownError7) {
  (0, _inherits2.default)(UnsupportedStrategy, _UnknownError7);

  var _super8 = _createSuper(UnsupportedStrategy);

  function UnsupportedStrategy() {
    var _this8;

    (0, _classCallCheck2.default)(this, UnsupportedStrategy);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this8 = _super8.call.apply(_super8, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this8), "name", "UnsupportedStrategyError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this8), "code", "CALLBACK_CREDENTIALS_JWT_ERROR");
    return _this8;
  }

  return (0, _createClass2.default)(UnsupportedStrategy);
}(UnknownError);

exports.UnsupportedStrategy = UnsupportedStrategy;

var InvalidCallbackUrl = function (_UnknownError8) {
  (0, _inherits2.default)(InvalidCallbackUrl, _UnknownError8);

  var _super9 = _createSuper(InvalidCallbackUrl);

  function InvalidCallbackUrl() {
    var _this9;

    (0, _classCallCheck2.default)(this, InvalidCallbackUrl);

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this9 = _super9.call.apply(_super9, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this9), "name", "InvalidCallbackUrl");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this9), "code", "INVALID_CALLBACK_URL_ERROR");
    return _this9;
  }

  return (0, _createClass2.default)(InvalidCallbackUrl);
}(UnknownError);

exports.InvalidCallbackUrl = InvalidCallbackUrl;

function upperSnake(s) {
  return s.replace(/([A-Z])/g, "_$1").toUpperCase();
}

function capitalize(s) {
  return "".concat(s[0].toUpperCase()).concat(s.slice(1));
}

function eventsErrorHandler(methods, logger) {
  return Object.keys(methods).reduce(function (acc, name) {
    acc[name] = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
      var method,
          _args = arguments;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              method = methods[name];
              _context.next = 4;
              return method.apply(void 0, _args);

            case 4:
              return _context.abrupt("return", _context.sent);

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              logger.error("".concat(upperSnake(name), "_EVENT_ERROR"), _context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));
    return acc;
  }, {});
}

function adapterErrorHandler(adapter, logger) {
  if (!adapter) return;
  return Object.keys(adapter).reduce(function (acc, name) {
    acc[name] = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
      var _len9,
          args,
          _key9,
          method,
          e,
          _args2 = arguments;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              for (_len9 = _args2.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
                args[_key9] = _args2[_key9];
              }

              logger.debug("adapter_".concat(name), {
                args: args
              });
              method = adapter[name];
              _context2.next = 6;
              return method.apply(void 0, args);

            case 6:
              return _context2.abrupt("return", _context2.sent);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              logger.error("adapter_error_".concat(name), _context2.t0);
              e = new UnknownError(_context2.t0);
              e.name = "".concat(capitalize(name), "Error");
              throw e;

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));
    return acc;
  }, {});
}

/***/ }),

/***/ 3299:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(3454);


var _interopRequireDefault = __webpack_require__(4836);

var _typeof = __webpack_require__(8698);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _exportNames = {
  useSession: true,
  getSession: true,
  getCsrfToken: true,
  getProviders: true,
  signIn: true,
  signOut: true,
  SessionProvider: true
};
exports.SessionProvider = SessionProvider;
exports.getCsrfToken = getCsrfToken;
exports.getProviders = getProviders;
exports.getSession = getSession;
exports.signIn = signIn;
exports.signOut = signOut;
exports.useSession = useSession;

var _regenerator = _interopRequireDefault(__webpack_require__(4687));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8416));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(7424));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(7156));

var React = _interopRequireWildcard(__webpack_require__(7294));

var _logger2 = _interopRequireWildcard(__webpack_require__(6553));

var _parseUrl = _interopRequireDefault(__webpack_require__(762));

var _utils = __webpack_require__(9548);

var _jsxRuntime = __webpack_require__(5893);

var _types = __webpack_require__(527);

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

var _process$env$NEXTAUTH, _ref, _process$env$NEXTAUTH2, _process$env$NEXTAUTH3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __NEXTAUTH = {
  baseUrl: (0, _parseUrl.default)((_process$env$NEXTAUTH = process.env.NEXTAUTH_URL) !== null && _process$env$NEXTAUTH !== void 0 ? _process$env$NEXTAUTH : process.env.VERCEL_URL).origin,
  basePath: (0, _parseUrl.default)(process.env.NEXTAUTH_URL).path,
  baseUrlServer: (0, _parseUrl.default)((_ref = (_process$env$NEXTAUTH2 = process.env.NEXTAUTH_URL_INTERNAL) !== null && _process$env$NEXTAUTH2 !== void 0 ? _process$env$NEXTAUTH2 : process.env.NEXTAUTH_URL) !== null && _ref !== void 0 ? _ref : process.env.VERCEL_URL).origin,
  basePathServer: (0, _parseUrl.default)((_process$env$NEXTAUTH3 = process.env.NEXTAUTH_URL_INTERNAL) !== null && _process$env$NEXTAUTH3 !== void 0 ? _process$env$NEXTAUTH3 : process.env.NEXTAUTH_URL).path,
  _lastSync: 0,
  _session: undefined,
  _getSession: function _getSession() {}
};
var broadcast = (0, _utils.BroadcastChannel)();
var logger = (0, _logger2.proxyLogger)(_logger2.default, __NEXTAUTH.basePath);
var SessionContext = React.createContext(undefined);

function useSession(options) {
  var value = React.useContext(SessionContext);

  if (!value && "production" !== "production") {}

  var _ref2 = options !== null && options !== void 0 ? options : {},
      required = _ref2.required,
      onUnauthenticated = _ref2.onUnauthenticated;

  var requiredAndNotLoading = required && value.status === "unauthenticated";
  React.useEffect(function () {
    if (requiredAndNotLoading) {
      var url = "/api/auth/signin?".concat(new URLSearchParams({
        error: "SessionRequired",
        callbackUrl: window.location.href
      }));
      if (onUnauthenticated) onUnauthenticated();else window.location.href = url;
    }
  }, [requiredAndNotLoading, onUnauthenticated]);

  if (requiredAndNotLoading) {
    return {
      data: value.data,
      status: "loading"
    };
  }

  return value;
}

function getSession(_x) {
  return _getSession2.apply(this, arguments);
}

function _getSession2() {
  _getSession2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2(params) {
    var _params$broadcast;

    var session;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _utils.fetchData)("session", __NEXTAUTH, logger, params);

          case 2:
            session = _context2.sent;

            if ((_params$broadcast = params === null || params === void 0 ? void 0 : params.broadcast) !== null && _params$broadcast !== void 0 ? _params$broadcast : true) {
              broadcast.post({
                event: "session",
                data: {
                  trigger: "getSession"
                }
              });
            }

            return _context2.abrupt("return", session);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getSession2.apply(this, arguments);
}

function getCsrfToken(_x2) {
  return _getCsrfToken.apply(this, arguments);
}

function _getCsrfToken() {
  _getCsrfToken = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(params) {
    var response;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _utils.fetchData)("csrf", __NEXTAUTH, logger, params);

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response === null || response === void 0 ? void 0 : response.csrfToken);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getCsrfToken.apply(this, arguments);
}

function getProviders() {
  return _getProviders.apply(this, arguments);
}

function _getProviders() {
  _getProviders = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4() {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return (0, _utils.fetchData)("providers", __NEXTAUTH, logger);

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getProviders.apply(this, arguments);
}

function signIn(_x3, _x4, _x5) {
  return _signIn.apply(this, arguments);
}

function _signIn() {
  _signIn = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee5(provider, options, authorizationParams) {
    var _ref5, _ref5$callbackUrl, callbackUrl, _ref5$redirect, redirect, baseUrl, providers, isCredentials, isEmail, isSupportingReturn, signInUrl, _signInUrl, res, data, _data$url, url, error;

    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _ref5 = options !== null && options !== void 0 ? options : {}, _ref5$callbackUrl = _ref5.callbackUrl, callbackUrl = _ref5$callbackUrl === void 0 ? window.location.href : _ref5$callbackUrl, _ref5$redirect = _ref5.redirect, redirect = _ref5$redirect === void 0 ? true : _ref5$redirect;
            baseUrl = (0, _utils.apiBaseUrl)(__NEXTAUTH);
            _context5.next = 4;
            return getProviders();

          case 4:
            providers = _context5.sent;

            if (providers) {
              _context5.next = 8;
              break;
            }

            window.location.href = "".concat(baseUrl, "/error");
            return _context5.abrupt("return");

          case 8:
            if (!(!provider || !(provider in providers))) {
              _context5.next = 11;
              break;
            }

            window.location.href = "".concat(baseUrl, "/signin?").concat(new URLSearchParams({
              callbackUrl: callbackUrl
            }));
            return _context5.abrupt("return");

          case 11:
            isCredentials = providers[provider].type === "credentials";
            isEmail = providers[provider].type === "email";
            isSupportingReturn = isCredentials || isEmail;
            signInUrl = "".concat(baseUrl, "/").concat(isCredentials ? "callback" : "signin", "/").concat(provider);
            _signInUrl = "".concat(signInUrl, "?").concat(new URLSearchParams(authorizationParams));
            _context5.t0 = fetch;
            _context5.t1 = _signInUrl;
            _context5.t2 = {
              "Content-Type": "application/x-www-form-urlencoded"
            };
            _context5.t3 = URLSearchParams;
            _context5.t4 = _objectSpread;
            _context5.t5 = _objectSpread({}, options);
            _context5.t6 = {};
            _context5.next = 25;
            return getCsrfToken();

          case 25:
            _context5.t7 = _context5.sent;
            _context5.t8 = callbackUrl;
            _context5.t9 = {
              csrfToken: _context5.t7,
              callbackUrl: _context5.t8,
              json: true
            };
            _context5.t10 = (0, _context5.t4)(_context5.t5, _context5.t6, _context5.t9);
            _context5.t11 = new _context5.t3(_context5.t10);
            _context5.t12 = {
              method: "post",
              headers: _context5.t2,
              body: _context5.t11
            };
            _context5.next = 33;
            return (0, _context5.t0)(_context5.t1, _context5.t12);

          case 33:
            res = _context5.sent;
            _context5.next = 36;
            return res.json();

          case 36:
            data = _context5.sent;

            if (!(redirect || !isSupportingReturn)) {
              _context5.next = 42;
              break;
            }

            url = (_data$url = data.url) !== null && _data$url !== void 0 ? _data$url : callbackUrl;
            window.location.href = url;
            if (url.includes("#")) window.location.reload();
            return _context5.abrupt("return");

          case 42:
            error = new URL(data.url).searchParams.get("error");

            if (!res.ok) {
              _context5.next = 46;
              break;
            }

            _context5.next = 46;
            return __NEXTAUTH._getSession({
              event: "storage"
            });

          case 46:
            return _context5.abrupt("return", {
              error: error,
              status: res.status,
              ok: res.ok,
              url: error ? null : data.url
            });

          case 47:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _signIn.apply(this, arguments);
}

function signOut(_x6) {
  return _signOut.apply(this, arguments);
}

function _signOut() {
  _signOut = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee6(options) {
    var _options$redirect;

    var _ref6, _ref6$callbackUrl, callbackUrl, baseUrl, fetchOptions, res, data, _data$url2, url;

    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _ref6 = options !== null && options !== void 0 ? options : {}, _ref6$callbackUrl = _ref6.callbackUrl, callbackUrl = _ref6$callbackUrl === void 0 ? window.location.href : _ref6$callbackUrl;
            baseUrl = (0, _utils.apiBaseUrl)(__NEXTAUTH);
            _context6.t0 = {
              "Content-Type": "application/x-www-form-urlencoded"
            };
            _context6.t1 = URLSearchParams;
            _context6.next = 6;
            return getCsrfToken();

          case 6:
            _context6.t2 = _context6.sent;
            _context6.t3 = callbackUrl;
            _context6.t4 = {
              csrfToken: _context6.t2,
              callbackUrl: _context6.t3,
              json: true
            };
            _context6.t5 = new _context6.t1(_context6.t4);
            fetchOptions = {
              method: "post",
              headers: _context6.t0,
              body: _context6.t5
            };
            _context6.next = 13;
            return fetch("".concat(baseUrl, "/signout"), fetchOptions);

          case 13:
            res = _context6.sent;
            _context6.next = 16;
            return res.json();

          case 16:
            data = _context6.sent;
            broadcast.post({
              event: "session",
              data: {
                trigger: "signout"
              }
            });

            if (!((_options$redirect = options === null || options === void 0 ? void 0 : options.redirect) !== null && _options$redirect !== void 0 ? _options$redirect : true)) {
              _context6.next = 23;
              break;
            }

            url = (_data$url2 = data.url) !== null && _data$url2 !== void 0 ? _data$url2 : callbackUrl;
            window.location.href = url;
            if (url.includes("#")) window.location.reload();
            return _context6.abrupt("return");

          case 23:
            _context6.next = 25;
            return __NEXTAUTH._getSession({
              event: "storage"
            });

          case 25:
            return _context6.abrupt("return", data);

          case 26:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _signOut.apply(this, arguments);
}

function SessionProvider(props) {
  var children = props.children,
      basePath = props.basePath;
  if (basePath) __NEXTAUTH.basePath = basePath;
  var hasInitialSession = props.session !== undefined;
  __NEXTAUTH._lastSync = hasInitialSession ? (0, _utils.now)() : 0;

  var _React$useState = React.useState(function () {
    if (hasInitialSession) __NEXTAUTH._session = props.session;
    return props.session;
  }),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      session = _React$useState2[0],
      setSession = _React$useState2[1];

  var _React$useState3 = React.useState(!hasInitialSession),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      loading = _React$useState4[0],
      setLoading = _React$useState4[1];

  React.useEffect(function () {
    __NEXTAUTH._getSession = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
      var _ref4,
          event,
          storageEvent,
          _args = arguments;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref4 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, event = _ref4.event;
              _context.prev = 1;
              storageEvent = event === "storage";

              if (!(storageEvent || __NEXTAUTH._session === undefined)) {
                _context.next = 10;
                break;
              }

              __NEXTAUTH._lastSync = (0, _utils.now)();
              _context.next = 7;
              return getSession({
                broadcast: !storageEvent
              });

            case 7:
              __NEXTAUTH._session = _context.sent;
              setSession(__NEXTAUTH._session);
              return _context.abrupt("return");

            case 10:
              if (!(!event || __NEXTAUTH._session === null || (0, _utils.now)() < __NEXTAUTH._lastSync)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return");

            case 12:
              __NEXTAUTH._lastSync = (0, _utils.now)();
              _context.next = 15;
              return getSession();

            case 15:
              __NEXTAUTH._session = _context.sent;
              setSession(__NEXTAUTH._session);
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](1);
              logger.error("CLIENT_SESSION_ERROR", _context.t0);

            case 22:
              _context.prev = 22;
              setLoading(false);
              return _context.finish(22);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 19, 22, 25]]);
    }));

    __NEXTAUTH._getSession();

    return function () {
      __NEXTAUTH._lastSync = 0;
      __NEXTAUTH._session = undefined;

      __NEXTAUTH._getSession = function () {};
    };
  }, []);
  React.useEffect(function () {
    var unsubscribe = broadcast.receive(function () {
      return __NEXTAUTH._getSession({
        event: "storage"
      });
    });
    return function () {
      return unsubscribe();
    };
  }, []);
  React.useEffect(function () {
    var _props$refetchOnWindo = props.refetchOnWindowFocus,
        refetchOnWindowFocus = _props$refetchOnWindo === void 0 ? true : _props$refetchOnWindo;

    var visibilityHandler = function visibilityHandler() {
      if (refetchOnWindowFocus && document.visibilityState === "visible") __NEXTAUTH._getSession({
        event: "visibilitychange"
      });
    };

    document.addEventListener("visibilitychange", visibilityHandler, false);
    return function () {
      return document.removeEventListener("visibilitychange", visibilityHandler, false);
    };
  }, [props.refetchOnWindowFocus]);
  React.useEffect(function () {
    var refetchInterval = props.refetchInterval;

    if (refetchInterval) {
      var refetchIntervalTimer = setInterval(function () {
        if (__NEXTAUTH._session) {
          __NEXTAUTH._getSession({
            event: "poll"
          });
        }
      }, refetchInterval * 1000);
      return function () {
        return clearInterval(refetchIntervalTimer);
      };
    }
  }, [props.refetchInterval]);
  var value = React.useMemo(function () {
    return {
      data: session,
      status: loading ? "loading" : session ? "authenticated" : "unauthenticated"
    };
  }, [session, loading]);
  return (0, _jsxRuntime.jsx)(SessionContext.Provider, {
    value: value,
    children: children
  });
}

/***/ }),

/***/ 527:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

/***/ }),

/***/ 6553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4836);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
exports.proxyLogger = proxyLogger;
exports.setLogger = setLogger;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8416));

var _errors = __webpack_require__(6925);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function formatError(o) {
  if (o instanceof Error && !(o instanceof _errors.UnknownError)) {
    return {
      message: o.message,
      stack: o.stack,
      name: o.name
    };
  }

  if (hasErrorProperty(o)) {
    var _o$message;

    o.error = formatError(o.error);
    o.message = (_o$message = o.message) !== null && _o$message !== void 0 ? _o$message : o.error.message;
  }

  return o;
}

function hasErrorProperty(x) {
  return !!(x !== null && x !== void 0 && x.error);
}

var _logger = {
  error: function error(code, metadata) {
    metadata = formatError(metadata);
    console.error("[next-auth][error][".concat(code, "]"), "\nhttps://next-auth.js.org/errors#".concat(code.toLowerCase()), metadata.message, metadata);
  },
  warn: function warn(code) {
    console.warn("[next-auth][warn][".concat(code, "]"), "\nhttps://next-auth.js.org/warnings#".concat(code.toLowerCase()));
  },
  debug: function debug(code, metadata) {
    console.log("[next-auth][debug][".concat(code, "]"), metadata);
  }
};

function setLogger() {
  var newLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var debug = arguments.length > 1 ? arguments[1] : undefined;
  if (!debug) _logger.debug = function () {};
  if (newLogger.error) _logger.error = newLogger.error;
  if (newLogger.warn) _logger.warn = newLogger.warn;
  if (newLogger.debug) _logger.debug = newLogger.debug;
}

var _default = _logger;
exports["default"] = _default;

function proxyLogger() {
  var logger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _logger;
  var basePath = arguments.length > 1 ? arguments[1] : undefined;

  try {
    if (typeof window === "undefined") {
      return logger;
    }

    var clientLogger = {};

    var _loop = function _loop(level) {
      clientLogger[level] = function (code, metadata) {
        _logger[level](code, metadata);

        if (level === "error") {
          metadata = formatError(metadata);
        }

        ;
        metadata.client = true;
        var url = "".concat(basePath, "/_log");
        var body = new URLSearchParams(_objectSpread({
          level: level,
          code: code
        }, metadata));

        if (navigator.sendBeacon) {
          return navigator.sendBeacon(url, body);
        }

        return fetch(url, {
          method: "POST",
          body: body,
          keepalive: true
        });
      };
    };

    for (var level in logger) {
      _loop(level);
    }

    return clientLogger;
  } catch (_unused) {
    return _logger;
  }
}

/***/ }),

/***/ 762:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = parseUrl;

function parseUrl(url) {
  var _url2;

  const defaultUrl = new URL("http://localhost:3000/api/auth");

  if (url && !url.startsWith("http")) {
    url = `https://${url}`;
  }

  const _url = new URL((_url2 = url) !== null && _url2 !== void 0 ? _url2 : defaultUrl);

  const path = (_url.pathname === "/" ? defaultUrl.pathname : _url.pathname).replace(/\/$/, "");
  const base = `${_url.origin}${path}`;
  return {
    origin: _url.origin,
    host: _url.host,
    path,
    base,
    toString: () => base
  };
}

/***/ }),

/***/ 3454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(7663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(2256);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6089);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5711);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7243);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8931);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3793);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_use_blur__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8206);





// Mostly this is copied from the Avatar in 'sparkl-ui'
// but we want to use NextImage at the heart of it
// so we can use the Next.js image optimizer




var defaultProps = {
    stacked: false,
    text: "",
    isSquare: false,
    className: ""
};
var safeText = function(text) {
    if (text.length <= 4) return text;
    return text.slice(0, 3);
};
var AvatarComponent = function(_param) {
    var src = _param.src, _stacked = _param.stacked, stacked = _stacked === void 0 ? false : _stacked, _text = _param.text, text = _text === void 0 ? "" : _text, _isSquare = _param.isSquare, isSquare = _isSquare === void 0 ? false : _isSquare, _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "src",
        "stacked",
        "text",
        "isSquare",
        "className"
    ]);
    var theme = (0,sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var SCALES = (0,sparkl_ui__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)().SCALES;
    var showText = !src;
    var radius = isSquare ? theme.layout.radius : "50%";
    var marginLeft = stacked ? SCALES.ml(-0.625) : SCALES.ml(0);
    var classes = (0,sparkl_ui__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("avatar", className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
            [
                "c18f015469634f94",
                [
                    theme.palette.accents_2,
                    radius,
                    theme.palette.background,
                    SCALES.width(1.75) || SCALES.height(1.75),
                    SCALES.height(1.75) || SCALES.width(1.75),
                    SCALES.pt(0),
                    SCALES.pr(0),
                    SCALES.pb(0),
                    SCALES.pl(0),
                    SCALES.mt(0),
                    SCALES.mr(0),
                    SCALES.mb(0),
                    marginLeft,
                    radius,
                    SCALES.font(1)
                ]
            ]
        ]) + " " + (classes || ""),
        children: [
            !showText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: src,
                placeholder: "blur",
                blurDataURL: (0,_utils_use_blur__WEBPACK_IMPORTED_MODULE_4__/* .shimmerUrl */ .Ej)(200, 200),
                alt: "avatar",
                loading: "eager",
                layout: "fill",
                style: {
                    cursor: "pointer"
                }
            }),
            showText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
                className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "c18f015469634f94",
                        [
                            theme.palette.accents_2,
                            radius,
                            theme.palette.background,
                            SCALES.width(1.75) || SCALES.height(1.75),
                            SCALES.height(1.75) || SCALES.width(1.75),
                            SCALES.pt(0),
                            SCALES.pr(0),
                            SCALES.pb(0),
                            SCALES.pl(0),
                            SCALES.mt(0),
                            SCALES.mr(0),
                            SCALES.mb(0),
                            marginLeft,
                            radius,
                            SCALES.font(1)
                        ]
                    ]
                ]) + " " + (props && props.className != null && props.className || "avatar-text"),
                children: safeText(text)
            })),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "c18f015469634f94",
                dynamic: [
                    theme.palette.accents_2,
                    radius,
                    theme.palette.background,
                    SCALES.width(1.75) || SCALES.height(1.75),
                    SCALES.height(1.75) || SCALES.width(1.75),
                    SCALES.pt(0),
                    SCALES.pr(0),
                    SCALES.pb(0),
                    SCALES.pl(0),
                    SCALES.mt(0),
                    SCALES.mr(0),
                    SCALES.mb(0),
                    marginLeft,
                    radius,
                    SCALES.font(1)
                ],
                children: ".avatar.__jsx-style-dynamic-selector{display:inline-block;position:relative;overflow:hidden;border:1px solid ".concat(theme.palette.accents_2, ";-webkit-border-radius:").concat(radius, ";-moz-border-radius:").concat(radius, ";border-radius:").concat(radius, ";vertical-align:top;background-color:").concat(theme.palette.background, ";-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;width:").concat(SCALES.width(1.75) || SCALES.height(1.75), ";height:").concat(SCALES.height(1.75) || SCALES.width(1.75), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(marginLeft, ";-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}.avatar-img.__jsx-style-dynamic-selector{display:inline-block;-o-object-fit:cover;object-fit:cover;width:100%;height:100%;-webkit-border-radius:").concat(radius, ";-moz-border-radius:").concat(radius, ";border-radius:").concat(radius, ";-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.avatar-text.__jsx-style-dynamic-selector{position:absolute;left:50%;top:50%;font-size:").concat(SCALES.font(1), ";text-align:center;-webkit-transform:translate(-50%,-50%)scale(.65);-moz-transform:translate(-50%,-50%)scale(.65);-ms-transform:translate(-50%,-50%)scale(.65);-o-transform:translate(-50%,-50%)scale(.65);transform:translate(-50%,-50%)scale(.65);white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}")
            })
        ]
    });
};
AvatarComponent.defaultProps = defaultProps;
AvatarComponent.displayName = "GeistAvatar";
var Avatar = (0,sparkl_ui__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(AvatarComponent);
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);


/***/ }),

/***/ 1574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F3": function() { return /* binding */ GenerateButton; },
/* harmony export */   "HE": function() { return /* binding */ disabledForStatus; },
/* harmony export */   "tZ": function() { return /* binding */ imageForStatus; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _geist_ui_icons_check__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8064);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5711);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6293);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5718);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1151);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4952);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);







function disabledForStatus(status) {
    return status !== "not_started";
}
function imageForStatus(status) {
    switch(status){
        case "not_started":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_2__/* .Sparkles */ .P$, {});
        case "requesting":
        case "in_progress":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: "/images/spinner.svg",
                layout: "fill",
                alt: ""
            });
        case "submitted":
        case "done":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_geist_ui_icons_check__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
    }
}
var GenerateButton = function(param) {
    var onClick = param.onClick, text = param.text, creditCost = param.creditCost, timeEstimate = param.timeEstimate, fontSize = param.fontSize, status = param.status;
    // TODO: Remove this once we integrate this change into sparkl-ui
    var theme = (0,sparkl_ui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var disabled = disabledForStatus(status);
    var icon = imageForStatus(status);
    var disabledSuccessStyle = disabled ? {
        backgroundColor: theme.palette.successLight,
        borderColor: theme.palette.successLight,
        color: "#fff"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        xs: 24,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            shadow: true,
            type: "success",
            width: "100%",
            onClick: onClick,
            height: "4rem",
            style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, disabledSuccessStyle), {
                lineHeight: "2rem"
            }),
            disabled: disabled,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Container */ .Z.Container, {
                direction: "column",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Container */ .Z.Container, {
                            direction: "row",
                            alignItems: "center",
                            justify: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    height: "1.7rem",
                                    style: {
                                        width: "1.7rem",
                                        position: "relative"
                                    },
                                    children: icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        font: fontSize !== null && fontSize !== void 0 ? fontSize : "18px",
                                        style: {
                                            paddingRight: "0.5rem"
                                        },
                                        children: text
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Container */ .Z.Container, {
                            direction: "row",
                            alignItems: "center",
                            style: {
                                textTransform: "none"
                            },
                            justify: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        font: "12px",
                                        children: "(".concat(creditCost === 1 ? creditCost + " credit" : creditCost + " credits", ",")
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        font: "12px",
                                        style: {
                                            fontFamily: "serif"
                                        },
                                        children: "~"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        font: "12px",
                                        children: "".concat(timeEstimate, ")")
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 5913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Slider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5711);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1151);
/* harmony import */ var react_range__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4398);
/* harmony import */ var react_range__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_range__WEBPACK_IMPORTED_MODULE_2__);






var Slider = function(param) {
    var value = param.value, onChange = param.onChange, _min = param.min, min = _min === void 0 ? 0 : _min, _max = param.max, max = _max === void 0 ? 100 : _max, _step = param.step, step = _step === void 0 ? 1 : _step, _style = param.style, style = _style === void 0 ? {} : _style, _hideValue = param.hideValue, hideValue = _hideValue === void 0 ? false : _hideValue;
    var ref;
    var theme = (0,sparkl_ui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var decimals = ((ref = step.toString().split(".")[1]) === null || ref === void 0 ? void 0 : ref.length) || 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, style), {
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            width: "100%"
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_range__WEBPACK_IMPORTED_MODULE_2__.Range, {
            values: [
                value
            ],
            step: step,
            min: min,
            max: max,
            onChange: function(values) {
                return onChange(values[0]);
            },
            renderTrack: function(param) {
                var props = param.props, children = param.children;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onMouseDown: props.onMouseDown,
                    onTouchStart: props.onTouchStart,
                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props.style), {
                        width: "100%"
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: props.ref,
                        style: {
                            height: "0.5rem",
                            width: "100%",
                            borderRadius: "0.5rem",
                            background: (0,react_range__WEBPACK_IMPORTED_MODULE_2__.getTrackBackground)({
                                values: [
                                    value
                                ],
                                colors: [
                                    theme.palette.secondary,
                                    theme.palette.accents_5
                                ],
                                min: min,
                                max: max
                            }),
                            alignSelf: "center"
                        },
                        children: children
                    })
                });
            },
            renderThumb: function(param) {
                var props = param.props, isDragged = param.isDragged;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props.style), {
                        borderRadius: "1rem",
                        width: "max-content",
                        padding: "0.12rem",
                        backgroundColor: theme.palette.success,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: theme.palette.accents_1,
                        outlineColor: theme.palette.success
                    }),
                    children: hideValue ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        width: "1.39rem",
                        px: "0.12rem",
                        height: "1rem",
                        small: true
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        px: "0.12rem",
                        b: true,
                        small: true,
                        font: "0.75rem",
                        children: value.toFixed(decimals)
                    })
                }));
            }
        })
    });
};


/***/ }),

/***/ 916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GE": function() { return /* binding */ genieReducer; },
/* harmony export */   "LV": function() { return /* binding */ defaultGenieParams; },
/* harmony export */   "j7": function() { return /* binding */ getSingleModelParams; }
/* harmony export */ });
/* unused harmony export getNewGenieParams */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9396);
/* harmony import */ var _utils_feed_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6967);
/* harmony import */ var _model_generators_model_generation_component_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7982);





var defaultGenieParams = {
    selectedModel: "verdant",
    sharedParams: _model_generators_model_generation_component_types__WEBPACK_IMPORTED_MODULE_0__/* .defaultSharedParams */ .gU,
    allModelsParams: _model_generators_model_generation_component_types__WEBPACK_IMPORTED_MODULE_0__/* .defaultParams */ .Tb,
    remixPromptId: undefined,
    viewProps: {
        mode: "txt2img",
        expanded: false
    }
};
var getNewGenieParams = function() {
    return defaultGenieParams;
};
var getSingleModelParams = function(params) {
    return {
        model: params.selectedModel,
        sharedParams: params.sharedParams,
        modelParams: params.allModelsParams[params.selectedModel],
        remixPromptId: params.remixPromptId
    };
};
// Utility functions
var setModelParams = function(params, model, newParams) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params), {
        allModelsParams: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params.allModelsParams), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, params.selectedModel, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params.allModelsParams[params.selectedModel], newParams)))
    });
};
var getModeFromParams = function(params) {
    if (_utils_feed_types__WEBPACK_IMPORTED_MODULE_4__/* .img2img_models.includes */ .B.includes(params.selectedModel)) {
        if ("init_image" in params.allModelsParams[params.selectedModel]) {
            if (params.allModelsParams[params.selectedModel].init_image !== undefined) {
                return "img2img";
            }
        } else {
            return "txt2img";
        }
    }
    return "txt2img";
};
// What those actions actually do. They all take a GenieParams and return a new
// GenieParams with some transformation
var genieReducer = function(params, action) {
    // console.log("genieReducer", action);
    switch(action.type){
        case "switchModel":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params), {
                    selectedModel: action.model
                });
            }
        case "setMode":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params), {
                    viewProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params.viewProps), {
                        mode: action.mode
                    })
                });
            }
        case "setExpanded":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params), {
                    viewProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params.viewProps), {
                        expanded: action.expanded
                    })
                });
            }
        case "setSharedParams":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params), {
                    sharedParams: action.sharedParams
                });
            }
        case "setText":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params), {
                    sharedParams: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params.sharedParams), {
                        prompts: [
                            {
                                text: action.text,
                                weight: params.sharedParams.prompts[0].weight
                            }, 
                        ]
                    })
                });
            }
        case "setNegativeText":
            {
                return setModelParams(params, params.selectedModel, {
                    negative_prompts: {
                        text: action.text
                    }
                });
            }
        case "remix":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params), {
                    remixPromptId: action.remixPromptId,
                    selectedModel: action.model,
                    sharedParams: action.sharedParams,
                    allModelsParams: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params.allModelsParams), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, action.model, action.modelSpecificParams))
                });
            }
        case "remixSetMode":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params), {
                    viewProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params.viewProps), {
                        mode: getModeFromParams(params)
                    })
                });
            }
        case "setInitImageURL":
            {
                // When we're setting this back to no init image, we need to reset the
                // size params to default
                var rest = typeof action.initImageURL === "undefined" ? defaultGenieParams.allModelsParams[params.selectedModel] : params.allModelsParams[params.selectedModel];
                return setModelParams(params, params.selectedModel, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, rest), {
                    init_image: action.initImageURL
                }));
            }
        case "setInitImageType":
            {
                return setModelParams(params, params.selectedModel, {
                    init_image_type: action.initImageType
                });
            }
        case "setInitImageMask":
            {
                return setModelParams(params, params.selectedModel, {
                    init_image_mask: action.initImageMask
                });
            }
        case "setInitImageStrength":
            {
                return setModelParams(params, params.selectedModel, {
                    strength: action.initImageStrength
                });
            }
        case "setCondScale":
            {
                return setModelParams(params, params.selectedModel, {
                    cond_scale: action.condScale
                });
            }
        case "setSeed":
            {
                return setModelParams(params, params.selectedModel, {
                    seed: action.seed
                });
            }
        case "setScale":
            {
                return setModelParams(params, params.selectedModel, {
                    scale: action.scale
                });
            }
        case "setImageSize":
            {
                return setModelParams(params, params.selectedModel, {
                    width: action.width,
                    height: action.height
                });
            }
        case "setNumImages":
            {
                return setModelParams(params, params.selectedModel, {
                    num_images: action.numImages
                });
            }
        case "setSteps":
            {
                return setModelParams(params, params.selectedModel, {
                    ddim_steps: action.steps
                });
            }
        case "setReactionLoss":
            {
                return setModelParams(params, params.selectedModel, {
                    reaction_loss: action.reactionLoss
                });
            }
        case "setCutPow":
            {
                return setModelParams(params, params.selectedModel, {
                    cut_pow: action.cutPow
                });
            }
        case "reset":
            {
                // return the default params
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultGenieParams);
            }
        case "toggleHidden":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params), {
                    sharedParams: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, params.sharedParams), {
                        hidden: !params.sharedParams.hidden
                    })
                });
            }
    }
};


/***/ }),

/***/ 7982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gy": function() { return /* binding */ defaultVerdantParams; },
/* harmony export */   "Tb": function() { return /* binding */ defaultParams; },
/* harmony export */   "X4": function() { return /* binding */ generateRandomSeed; },
/* harmony export */   "gU": function() { return /* binding */ defaultSharedParams; }
/* harmony export */ });
/* unused harmony exports commonParamsKeys, initImageParamsKeys, defaultInitImageParams, dalleParamsKeys, defaultDalleParams, vqganParamsKeys, defaultVQGANParams, verdantParamsKeys, verdant2ParamsKeys, defaultVerdant2Params, latentParamsKeys, defaultLatentParams, singleModelParamsFromParams, paramsFromSingleModelParams */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9815);


function generateRandomSeed() {
    /* We'd ideally return a random 32 bit int... buuuuut
       it's so much easier to just prevent the text field
       from being longer than 9 digits! */ return Math.floor(Math.random() * 999999999);
}
// And we don't trust the server to not send us additional params that we don't want!
var sharedParamsKeys = (/* unused pure expression or super */ null && ([
    "prompts"
]));
var defaultSharedParams = {
    prompts: [
        {
            text: "",
            weight: 1
        }
    ],
    hidden: false
};
var commonParamsKeys = [
    "num_images",
    "height",
    "width",
    "seed"
];
var initImageParamsKeys = [
    "init_image",
    "init_image_type",
    "init_image_mask",
    "strength", 
];
var defaultInitImageParams = {
    strength: 0.8
};
var dalleParamsKeys = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(commonParamsKeys).concat([
    "gen_top_k",
    "gen_top_p",
    "temperature",
    "cond_scale", 
]);
var defaultDalleParams = {
    num_images: 9,
    height: 256,
    width: 256,
    seed: generateRandomSeed(),
    cond_scale: 10.0
};
var vqganParamsKeys = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(commonParamsKeys).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(initImageParamsKeys), [
    "step_size",
    "cutn",
    "cut_pow",
    "max_iterations",
    "fade",
    "dwell",
    "video",
    "reaction_loss", 
]);
var defaultVQGANParams = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    num_images: 1,
    height: 512,
    width: 512,
    seed: generateRandomSeed(),
    step_size: 0.1,
    cutn: 64,
    cut_pow: 1.0,
    max_iterations: 300,
    fade: 0.0,
    dwell: 0.0,
    video: false,
    reaction_loss: 0.0
}, defaultInitImageParams);
var verdantParamsKeys = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(commonParamsKeys).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(initImageParamsKeys), [
    "ddim_steps",
    "scale",
    "ddim_eta",
    "f", 
]);
var defaultVerdantParams = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    num_images: 1,
    height: 512,
    width: 512,
    seed: generateRandomSeed(),
    ddim_steps: 50,
    scale: 7.5,
    ddim_eta: 0.0,
    f: 8
}, defaultInitImageParams);
var verdant2ParamsKeys = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(commonParamsKeys).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(initImageParamsKeys), [
    "ddim_steps",
    "scale",
    "ddim_eta",
    "f",
    "negative_prompts", 
]);
var defaultVerdant2Params = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    num_images: 1,
    height: 512,
    width: 512,
    seed: generateRandomSeed(),
    ddim_steps: 50,
    scale: 7.5,
    ddim_eta: 0.0,
    f: 8,
    negative_prompts: [
        {
            text: "",
            weight: 1
        }
    ]
}, defaultInitImageParams);
var latentParamsKeys = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(commonParamsKeys).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(initImageParamsKeys), [
    "plms",
    "ddim_eta",
    "n_samples",
    "scale", 
]);
var defaultLatentParams = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    num_images: 1,
    height: 512,
    width: 512,
    seed: generateRandomSeed(),
    plms: false,
    ddim_eta: 0.0,
    scale: 7.5
}, defaultInitImageParams);
var defaultParams = {
    dalle: defaultDalleParams,
    vqgan: defaultVQGANParams,
    diffuse: defaultLatentParams,
    verdant: defaultVerdantParams,
    waifu: defaultVerdantParams,
    verdant2: defaultVerdant2Params
};
// This is used to take the unstructured params array from the server, and
// type it as a model-specific set of params
function addFromObjectToObjectIfInList(obj1, obj2, list) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (key in obj1) {
                obj2[key] = obj1[key];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function singleModelParamsFromParams(p, m) {
    var sharedParams = _object_spread({}, defaultSharedParams);
    addFromObjectToObjectIfInList(p, sharedParams, sharedParamsKeys);
    switch(m){
        case "dalle":
            var dalle = _object_spread({}, defaultDalleParams);
            addFromObjectToObjectIfInList(p, dalle, dalleParamsKeys);
            return {
                model: "dalle",
                sharedParams: sharedParams,
                modelParams: dalle
            };
        case "vqgan":
            var vqgan = _object_spread({}, defaultVQGANParams);
            addFromObjectToObjectIfInList(p, vqgan, vqganParamsKeys);
            return {
                model: "vqgan",
                sharedParams: sharedParams,
                modelParams: vqgan
            };
        case "verdant":
            var verdant = _object_spread({}, defaultVerdantParams);
            addFromObjectToObjectIfInList(p, verdant, verdantParamsKeys);
            return {
                model: "verdant",
                sharedParams: sharedParams,
                modelParams: verdant
            };
        case "waifu":
            var waifu = _object_spread({}, defaultVerdantParams);
            addFromObjectToObjectIfInList(p, waifu, verdantParamsKeys);
            return {
                model: "waifu",
                sharedParams: sharedParams,
                modelParams: waifu
            };
        case "verdant2":
            var verdant2 = _object_spread({}, defaultVerdant2Params);
            addFromObjectToObjectIfInList(p, verdant2, verdantParamsKeys);
            return {
                model: "verdant2",
                sharedParams: sharedParams,
                modelParams: verdant2
            };
        case "diffuse":
            var latent = _object_spread({}, defaultLatentParams);
            addFromObjectToObjectIfInList(p, latent, latentParamsKeys);
            return {
                model: "diffuse",
                sharedParams: sharedParams,
                modelParams: latent
            };
    }
}
function paramsFromSingleModelParams(p) {
    return _object_spread({}, p.sharedParams, p.modelParams);
}


/***/ }),

/***/ 121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nm": function() { return /* binding */ useGenieFocus; },
/* harmony export */   "l9": function() { return /* binding */ useGenie; },
/* harmony export */   "nh": function() { return /* binding */ GenieProvider; },
/* harmony export */   "ps": function() { return /* binding */ useGenieDispatch; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _genie_reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(916);

// This section sets up the context provider (used in _app.tsx)
// and the context hooks, which are used by any component that needs to


// read or set the GenieParams respectively
var GenieContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(_genie_reducer__WEBPACK_IMPORTED_MODULE_2__/* .defaultGenieParams */ .LV);
var GenieDispatchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(function(action) {
    return console.log("no dispatch");
});
var GenieFocusContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(function() {
    return console.log("no focus");
});
function GenieProvider(param) {
    var children = param.children, focusGenie = param.focusGenie;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(_genie_reducer__WEBPACK_IMPORTED_MODULE_2__/* .genieReducer */ .GE, _genie_reducer__WEBPACK_IMPORTED_MODULE_2__/* .defaultGenieParams */ .LV), genie = ref[0], dispatch = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GenieFocusContext.Provider, {
        value: focusGenie,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GenieContext.Provider, {
            value: genie,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GenieDispatchContext.Provider, {
                value: dispatch,
                children: children
            })
        })
    });
}
function useGenie() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(GenieContext);
}
function useGenieDispatch() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(GenieDispatchContext);
}
function useGenieFocus() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(GenieFocusContext);
}


/***/ }),

/***/ 9013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ TwoPaneGrid; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8114);


var getTwoPaneStyle = function(ratio, auto, direction) {
    var smallPaneSize = auto ? "auto" : "1fr";
    switch(direction){
        case "column":
            return {
                gridTemplateRows: "".concat(ratio, "fr ").concat(smallPaneSize),
                gridTemplateColumns: "1fr",
                gridTemplateAreas: "'bigPane' 'smallPane'"
            };
        case "column-reverse":
            return {
                gridTemplateRows: "".concat(smallPaneSize, " ").concat(ratio, "fr"),
                gridTemplateColumns: "1fr",
                gridTemplateAreas: "'smallPane' 'bigPane'"
            };
        case "row":
            return {
                gridTemplateRows: "1fr",
                gridTemplateColumns: "".concat(ratio, "fr ").concat(smallPaneSize),
                gridTemplateAreas: "'bigPane smallPane'"
            };
        case "row-reverse":
            return {
                gridTemplateRows: "1fr",
                gridTemplateColumns: "".concat(smallPaneSize, " ").concat(ratio, "fr"),
                gridTemplateAreas: "'smallPane bigPane'"
            };
        default:
            return {
                gridTemplateRows: "".concat(ratio, "fr ").concat(smallPaneSize),
                gridTemplateColumns: "1fr",
                gridTemplateAreas: "'bigPane smallPane'"
            };
    }
};
var TwoPaneGrid = function(param) {
    var bigPane = param.bigPane, smallPane = param.smallPane, fixedDirection = param.fixedDirection, _ratio = param.ratio, ratio = _ratio === void 0 ? 1.618 : _ratio, _auto = param.auto, auto = _auto === void 0 ? false : _auto;
    // Get the size of the viewport and set our layout direction if it's not set.
    var upMD = (0,sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("md", {
        match: "up"
    });
    var direction = fixedDirection;
    if (fixedDirection === undefined) {
        direction = upMD ? "row" : "column";
    }
    var ref = getTwoPaneStyle(ratio, auto, direction), gridTemplateRows = ref.gridTemplateRows, gridTemplateColumns = ref.gridTemplateColumns, gridTemplateAreas = ref.gridTemplateAreas;
    // This div uses CSS grid to arrange the two panes along the `direction` axis
    // The first pane is the big pane, and the second pane is the small pane. The small pane is collapsable.
    //  The panes are sized using the golden ratio, which means the big pane is 1.618 times the size of the small pane.
    var containerStyle = {
        display: "grid",
        gridTemplateRows: gridTemplateRows,
        gridTemplateColumns: gridTemplateColumns,
        gridTemplateAreas: gridTemplateAreas,
        alignItems: "start",
        width: "100%",
        height: "100%"
    };
    var bigPaneStyle = {
        gridArea: "bigPane",
        width: "100%",
        height: "100%",
        padding: "0"
    };
    var smallPaneStyle = {
        gridArea: "smallPane",
        width: "100%",
        height: "100%",
        padding: "0"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: containerStyle,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: bigPaneStyle,
                children: bigPane
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: smallPaneStyle,
                children: smallPane
            })
        ]
    });
};


/***/ }),

/***/ 4952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gz": function() { return /* binding */ Popular; },
/* harmony export */   "Hi": function() { return /* binding */ Images1; },
/* harmony export */   "IQ": function() { return /* binding */ AspectSquare; },
/* harmony export */   "J1": function() { return /* binding */ New; },
/* harmony export */   "P$": function() { return /* binding */ Sparkles; },
/* harmony export */   "QS": function() { return /* binding */ FilledHeart; },
/* harmony export */   "V0": function() { return /* binding */ EmptyHeart; },
/* harmony export */   "bV": function() { return /* binding */ Dice; },
/* harmony export */   "mB": function() { return /* binding */ Share; },
/* harmony export */   "nJ": function() { return /* binding */ Images4; },
/* harmony export */   "pT": function() { return /* binding */ AspectPortrait; },
/* harmony export */   "yd": function() { return /* binding */ Images9; },
/* harmony export */   "zE": function() { return /* binding */ AspectLandscape; }
/* harmony export */ });
/* unused harmony exports Screenshot_filled, Screenshot, Inpaint, NoImage, InitImage, DiceFill */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var FilledHeart = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        viewBox: "-5 -5 55 55",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            style: {
                fill: "currentColor"
            },
            d: "m24 41.95-2.05-1.85q-5.3-4.85-8.75-8.375-3.45-3.525-5.5-6.3T4.825 20.4Q4 18.15 4 15.85q0-4.5 3.025-7.525Q10.05 5.3 14.5 5.3q2.85 0 5.275 1.35Q22.2 8 24 10.55q2.1-2.7 4.45-3.975T33.5 5.3q4.45 0 7.475 3.025Q44 11.35 44 15.85q0 2.3-.825 4.55T40.3 25.425q-2.05 2.775-5.5 6.3T26.05 40.1Z"
        })
    });
};
var EmptyHeart = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        viewBox: "-5 -5 55 55",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            style: {
                fill: "currentColor"
            },
            d: "m24 41.95-2.05-1.85q-5.3-4.85-8.75-8.375-3.45-3.525-5.5-6.3T4.825 20.4Q4 18.15 4 15.85q0-4.5 3.025-7.525Q10.05 5.3 14.5 5.3q2.85 0 5.275 1.35Q22.2 8 24 10.55q2.1-2.7 4.45-3.975T33.5 5.3q4.45 0 7.475 3.025Q44 11.35 44 15.85q0 2.3-.825 4.55T40.3 25.425q-2.05 2.775-5.5 6.3T26.05 40.1ZM24 38q5.05-4.65 8.325-7.975 3.275-3.325 5.2-5.825 1.925-2.5 2.7-4.45.775-1.95.775-3.9 0-3.3-2.1-5.425T33.5 8.3q-2.55 0-4.75 1.575T25.2 14.3h-2.45q-1.3-2.8-3.5-4.4-2.2-1.6-4.75-1.6-3.3 0-5.4 2.125Q7 12.55 7 15.85q0 1.95.775 3.925.775 1.975 2.7 4.5Q12.4 26.8 15.7 30.1 19 33.4 24 38Zm0-14.85Z"
        })
    });
};
var Sparkles = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 332 270",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M172.4 204.75C172.4 204.75 164.05 163.859 146.077 145.969C128.566 128.538 88.1667 119.25 88.1667 119.25C88.1667 119.25 128.566 109.962 146.077 92.5313C164.05 74.6407 172.4 33.75 172.4 33.75C172.4 33.75 180.75 74.6407 198.723 92.5313C216.234 109.962 256.633 119.25 256.633 119.25C256.633 119.25 216.234 128.538 198.723 145.969C180.75 163.859 172.4 204.75 172.4 204.75Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M85.4 239.792C85.4 239.792 81.7587 220.861 73.9208 212.578C66.2844 204.508 48.6667 200.208 48.6667 200.208C48.6667 200.208 66.2844 195.908 73.9208 187.839C81.7587 179.556 85.4 160.625 85.4 160.625C85.4 160.625 89.0413 179.556 96.8792 187.839C104.516 195.908 122.133 200.208 122.133 200.208C122.133 200.208 104.516 204.508 96.8792 212.578C89.0413 220.861 85.4 239.792 85.4 239.792Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M53.2 105.858C53.2 105.858 49.025 85.7159 40.0386 76.9031C31.283 68.3169 11.0833 63.7417 11.0833 63.7417C11.0833 63.7417 31.283 59.1665 40.0386 50.5802C49.025 41.7675 53.2 21.625 53.2 21.625C53.2 21.625 57.375 41.7675 66.3615 50.5802C75.117 59.1665 95.3167 63.7417 95.3167 63.7417C95.3167 63.7417 75.117 68.3169 66.3615 76.9031C57.375 85.7159 53.2 105.858 53.2 105.858Z",
                fill: "currentColor"
            })
        ]
    });
};
var Share = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        viewBox: "-3 -3 58 58",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            style: {
                fill: "currentColor"
            },
            d: "M11.6 46.65q-1.65 0-2.8-1.175T7.65 42.7V19.05q0-1.65 1.15-2.8t2.8-1.15h7.35v3.95H11.6V42.7h24.8V19.05h-7.45V15.1h7.45q1.65 0 2.825 1.15 1.175 1.15 1.175 2.8V42.7q0 1.6-1.175 2.775Q38.05 46.65 36.4 46.65ZM21.95 31.4V9l-4.4 4.4-2.8-2.8 9.2-9.25 9.2 9.25-2.8 2.8-4.4-4.4v22.4Z"
        })
    });
};
var Screenshot_filled = function() {
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        viewBox: "-3 -3 58 58",
        children: /*#__PURE__*/ _jsx("path", {
            style: {
                fill: "currentColor"
            },
            d: "M24 34.7q3.6 0 6.05-2.45 2.45-2.45 2.45-6.05 0-3.65-2.45-6.075Q27.6 17.7 24 17.7q-3.65 0-6.075 2.425Q15.5 22.55 15.5 26.2q0 3.6 2.425 6.05Q20.35 34.7 24 34.7Zm-16.75 8q-1.6 0-2.775-1.175Q3.3 40.35 3.3 38.75V13.6q0-1.6 1.175-2.8Q5.65 9.6 7.25 9.6h6.95l3.95-4.65H29.9l3.9 4.65h6.95q1.6 0 2.8 1.2 1.2 1.2 1.2 2.8v25.15q0 1.6-1.2 2.775-1.2 1.175-2.8 1.175Z"
        })
    });
};
var Screenshot = function() {
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        viewBox: "-3 -3 58 58",
        children: /*#__PURE__*/ _jsx("path", {
            style: {
                fill: "currentColor"
            },
            d: "M24 34.7q3.6 0 6.05-2.45 2.45-2.45 2.45-6.1 0-3.6-2.45-6.025Q27.6 17.7 24 17.7q-3.65 0-6.075 2.425Q15.5 22.55 15.5 26.15q0 3.65 2.425 6.1Q20.35 34.7 24 34.7Zm0-3q-2.4 0-3.95-1.575-1.55-1.575-1.55-3.975 0-2.35 1.55-3.9Q21.6 20.7 24 20.7q2.35 0 3.925 1.55 1.575 1.55 1.575 3.9 0 2.4-1.575 3.975Q26.35 31.7 24 31.7Zm-16.75 11q-1.6 0-2.775-1.175Q3.3 40.35 3.3 38.75V13.6q0-1.6 1.175-2.8Q5.65 9.6 7.25 9.6h6.95l3.95-4.65H29.9l3.9 4.65h6.95q1.6 0 2.8 1.2 1.2 1.2 1.2 2.8v25.15q0 1.6-1.2 2.775-1.2 1.175-2.8 1.175Zm33.5-3.95V13.6H32l-3.95-4.65h-8.1L16 13.6H7.25v25.15ZM24 26.2Z"
        })
    });
};
var Images1 = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
            width: "100",
            height: "100",
            rx: "10",
            fill: "currentColor"
        })
    });
};
var Images4 = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 214 214",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "114",
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "114",
                y: "114",
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                y: "114",
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            })
        ]
    });
};
var Images9 = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 328 328",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "114",
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "228",
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "114",
                y: "114",
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                y: "114",
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "228",
                y: "114",
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "114",
                y: "228",
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                y: "228",
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "228",
                y: "228",
                width: "100",
                height: "100",
                rx: "10",
                fill: "currentColor"
            })
        ]
    });
};
var Inpaint = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 128 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M93.2102 34.0923C93.0298 34.1955 88.8399 38.4418 83.9409 43.4848C72.9698 54.7849 65.3828 62.9073 61.2832 67.7394C60.6966 68.4331 59.5879 69.811 59.5879 69.8485C59.5879 69.8673 59.8973 69.961 60.2841 70.0641C60.6644 70.1625 61.5088 70.4391 62.1663 70.6781C63.8874 71.3061 64.9574 71.8076 66.6011 72.7685C67.0395 73.0215 67.4069 73.2231 67.4133 73.2137C67.4714 73.1668 68.1031 72.3841 68.6574 71.6764C72.886 66.3052 81.6332 53.5194 92.5076 36.806C93.3069 35.5828 93.9709 34.5001 93.9902 34.4064C94.016 34.2658 93.9967 34.2142 93.8613 34.1158C93.655 33.9705 93.4423 33.9611 93.2102 34.0923Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M58.4663 71.4796C57.4736 73.2043 56.4745 74.8213 54.4504 77.9803C52.7487 80.633 51.8076 82.1656 51.8656 82.1984C51.8785 82.2031 52.0718 82.2359 52.3039 82.2641C53.5609 82.4422 55.0821 83.0983 55.9201 83.8342C56.1006 83.9888 56.2746 84.1248 56.3069 84.1341C56.3842 84.1576 57.5896 82.9999 60.0455 80.5346C62.6239 77.9474 64.1839 76.4195 65.4537 75.2384C66.5882 74.1839 66.556 74.2261 66.382 74.123C66.3046 74.0808 65.9565 73.8746 65.6084 73.6636C63.6489 72.5013 61.4057 71.5592 59.4009 71.0624C59.098 70.9874 58.8401 70.9265 58.8208 70.9265C58.8015 70.9265 58.6403 71.1749 58.4663 71.4796Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M49.1969 82.7609C47.4565 82.9671 45.9159 83.6514 44.8136 84.7059C44.414 85.0856 43.9112 85.8355 43.7372 86.2995C43.1441 87.893 42.8476 88.5304 42.319 89.3178C41.8227 90.0536 41.2619 90.6254 40.5399 91.1551C39.1863 92.144 37.5748 92.7299 35.0608 93.1376C34.4227 93.2454 34.1971 93.3017 34.1133 93.3766C33.9457 93.5266 33.965 93.7328 34.1648 93.8781L34.3324 94L37.4394 93.9719C39.1412 93.9531 41.0492 93.9203 41.668 93.8922C48.8682 93.5969 53.0001 92.6924 55.3206 90.916C56.4616 90.0443 56.9901 89.1163 57.0546 87.8696C57.1255 86.5197 56.6356 85.4746 55.456 84.4341C54.6438 83.717 53.2515 83.089 51.9494 82.8499C51.1307 82.7046 49.9962 82.6624 49.1969 82.7609Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M24.6667 113.867C21.8222 113.867 19.3556 112.822 17.2667 110.733C15.1778 108.644 14.1334 106.178 14.1334 103.333V24.6667C14.1334 21.7333 15.1778 19.2222 17.2667 17.1333C19.3556 15.0444 21.8222 14 24.6667 14H103.333C106.267 14 108.778 15.0444 110.867 17.1333C112.956 19.2222 114 21.7333 114 24.6667V103.333C114 106.178 112.956 108.644 110.867 110.733C108.778 112.822 106.267 113.867 103.333 113.867H24.6667ZM24.6667 103.333H103.333V24.6667H24.6667V103.333Z",
                fill: "currentColor"
            })
        ]
    });
};
var NoImage = function() {
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        viewBox: "0 0 48 48",
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "m42.5 47.05-4.35-4.35H9.25q-1.65 0-2.8-1.15t-1.15-2.8V9.85l-3.85-3.8 2.35-2.4L44.85 44.7Zm-33.25-8.3H34.2L28.45 33H12l6-7 4 5.45 2.25-2.7-15-15v25Zm33.5-.5-4-3.95V9.25H13.7l-3.95-4h29q1.65 0 2.825 1.175Q42.75 7.6 42.75 9.25Zm-16.4-16.3Zm-4.6 4.35Z"
        })
    });
};
var InitImage = function() {
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        viewBox: "0 0 48 48",
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M9.25 42.7q-1.6 0-2.775-1.175Q5.3 40.35 5.3 38.75V9.25q0-1.65 1.175-2.825Q7.65 5.25 9.25 5.25h29.5q1.65 0 2.825 1.175Q42.75 7.6 42.75 9.25v29.5q0 1.6-1.175 2.775Q40.4 42.7 38.75 42.7Zm0-3.95h29.5V9.25H9.25v29.5Zm2.2-4.35H36.6l-7.7-10.45-6.6 8.55-4.65-6.35Zm-2.2 4.35V9.25v29.5Z"
        })
    });
};
var AspectSquare = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "-10 -10 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
            width: "80",
            height: "80",
            rx: "7",
            fill: "currentColor"
        })
    });
};
var AspectLandscape = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 40 30",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
            width: "40",
            height: "30",
            rx: "3",
            fill: "currentColor"
        })
    });
};
var AspectPortrait = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 30 40",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
            width: "30",
            height: "40",
            rx: "3",
            fill: "currentColor"
        })
    });
};
var Dice = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 48 48",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "currentColor",
            d: "M15.2 35.3q1.05 0 1.775-.725.725-.725.725-1.775 0-1.05-.75-1.775-.75-.725-1.8-.725-1 0-1.725.75-.725.75-.725 1.8 0 1 .725 1.725.725.725 1.775.725Zm0-17.6q1.05 0 1.775-.75.725-.75.725-1.8 0-1-.75-1.725-.75-.725-1.8-.725-1 0-1.725.725-.725.725-.725 1.775 0 1.05.725 1.775.725.725 1.775.725Zm8.8 8.8q1.05 0 1.775-.725.725-.725.725-1.775 0-1.05-.725-1.775Q25.05 21.5 24 21.5q-1.05 0-1.775.725Q21.5 22.95 21.5 24q0 1.05.725 1.775.725.725 1.775.725Zm8.85 8.8q1 0 1.725-.725.725-.725.725-1.775 0-1.05-.725-1.775-.725-.725-1.775-.725-1.05 0-1.775.75-.725.75-.725 1.8 0 1 .75 1.725.75.725 1.8.725Zm0-17.6q1 0 1.725-.75.725-.75.725-1.8 0-1-.725-1.725-.725-.725-1.775-.725-1.05 0-1.775.725-.725.725-.725 1.775 0 1.05.75 1.775.75.725 1.8.725ZM9.1 42.3q-1.35 0-2.375-1.025T5.7 38.9V9.1q0-1.4 1.025-2.4t2.375-1h29.8q1.4 0 2.4 1t1 2.4v29.8q0 1.35-1 2.375T38.9 42.3Zm0-3.4h29.8V9.1H9.1v29.8Zm0-29.8v29.8V9.1Z"
        })
    });
};
var DiceFill = function() {
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 48 48",
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M15.75 34.75q1.05 0 1.775-.725.725-.725.725-1.775 0-1.05-.725-1.775-.725-.725-1.775-.725-1.05 0-1.775.725-.725.725-.725 1.775 0 1.05.725 1.775.725.725 1.775.725Zm0-16.5q1.05 0 1.775-.725.725-.725.725-1.775 0-1.05-.725-1.775-.725-.725-1.775-.725-1.05 0-1.775.725-.725.725-.725 1.775 0 1.05.725 1.775.725.725 1.775.725ZM24 26.5q1.05 0 1.775-.725.725-.725.725-1.775 0-1.05-.725-1.775Q25.05 21.5 24 21.5q-1.05 0-1.775.725Q21.5 22.95 21.5 24q0 1.05.725 1.775.725.725 1.775.725Zm8.25 8.25q1.05 0 1.775-.725.725-.725.725-1.775 0-1.05-.725-1.775-.725-.725-1.775-.725-1.05 0-1.775.725-.725.725-.725 1.775 0 1.05.725 1.775.725.725 1.775.725Zm0-16.5q1.05 0 1.775-.725.725-.725.725-1.775 0-1.05-.725-1.775-.725-.725-1.775-.725-1.05 0-1.775.725-.725.725-.725 1.775 0 1.05.725 1.775.725.725 1.775.725Zm-22.8 25q-1.95 0-3.325-1.375Q4.75 40.5 4.75 38.55V9.45q0-1.95 1.375-3.35Q7.5 4.7 9.45 4.7h29.1q1.95 0 3.35 1.4 1.4 1.4 1.4 3.35v29.1q0 1.95-1.4 3.325-1.4 1.375-3.35 1.375Z"
        })
    });
};
var Popular = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 48 48",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "m11.65 44 3.25-14.05L4 20.5l14.4-1.25L24 6l5.6 13.25L44 20.5l-10.9 9.45L36.35 44 24 36.55Z"
        })
    });
};
var New = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 48 48",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M23.85 42q-7.45 0-12.65-5.275T6 23.95h3q0 6.25 4.3 10.65T23.85 39q6.35 0 10.75-4.45t4.4-10.8q0-6.2-4.45-10.475Q30.1 9 23.85 9q-3.4 0-6.375 1.55t-5.175 4.1h5.25v3H7.1V7.25h3v5.3q2.6-3.05 6.175-4.8Q19.85 6 23.85 6q3.75 0 7.05 1.4t5.775 3.825q2.475 2.425 3.9 5.675Q42 20.15 42 23.9t-1.425 7.05q-1.425 3.3-3.9 5.75-2.475 2.45-5.775 3.875Q27.6 42 23.85 42Zm6.4-9.85-7.7-7.6v-10.7h3v9.45L32.4 30Z"
        })
    });
};


/***/ }),

/***/ 5842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ FeatureCalloutCell; },
/* harmony export */   "w": function() { return /* binding */ EmbeddedFeatureCalloutCell; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6293);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7814);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1151);


var FeatureCalloutCell = function(param) {
    var icon = param.icon, title = param.title, text = param.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xs: 24,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Container */ .Z.Container, {
                justify: "center",
                alignContent: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        xs: 4,
                        justify: "flex-start",
                        alignContent: "center",
                        alignItems: "center",
                        children: icon
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        xs: 20,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Container */ .Z.Container, {
                            alignContent: "center",
                            paddingLeft: "15px",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    xs: 24,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        h4: true,
                                        margin: "0px",
                                        style: {
                                            textAlign: "left"
                                        },
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    xs: 24,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        margin: "0px",
                                        style: {
                                            textAlign: "left"
                                        },
                                        children: text
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var EmbeddedFeatureCalloutCell = function(param) {
    var icon = param.icon, title = param.title, text = param.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xs: 12,
        sm: 8,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Container */ .Z.Container, {
                alignContent: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        xs: 24,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Container */ .Z.Container, {
                            justify: "center",
                            alignContent: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    xs: 4,
                                    justify: "flex-start",
                                    alignContent: "center",
                                    alignItems: "center",
                                    children: icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    xs: 20,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        h5: true,
                                        margin: "0px",
                                        style: {
                                            textAlign: "left",
                                            paddingLeft: "15px"
                                        },
                                        children: title
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        xs: 24,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            margin: "0px",
                            style: {
                                textAlign: "left",
                                fontSize: "12px"
                            },
                            children: text
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 9405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useLoginModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _geist_ui_icons_fastForward__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8628);
/* harmony import */ var _geist_ui_icons_gift__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1089);
/* harmony import */ var _geist_ui_icons_save__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4551);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6293);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9768);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9037);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5718);
/* harmony import */ var _feature_cell__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5842);









function LoginAdvert() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .Z.Container, {
        justify: "center",
        alignContent: "center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            xs: 24,
            justify: "center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .Z.Container, {
                justify: "center",
                alignContent: "center",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_feature_cell__WEBPACK_IMPORTED_MODULE_5__/* .FeatureCalloutCell */ .R, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_geist_ui_icons_fastForward__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            color: "blue"
                        }),
                        title: "Blazing fast generations",
                        text: "Results in as little as 15s"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_feature_cell__WEBPACK_IMPORTED_MODULE_5__/* .FeatureCalloutCell */ .R, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_geist_ui_icons_gift__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            color: "blue"
                        }),
                        title: "Free forever",
                        text: "Get 25 free daily credits"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_feature_cell__WEBPACK_IMPORTED_MODULE_5__/* .FeatureCalloutCell */ .R, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_geist_ui_icons_save__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            color: "blue"
                        }),
                        title: "Save & Share",
                        text: "Your generations are saved - showcase your best work"
                    })
                ]
            })
        })
    });
}
var useLoginModal = function(param) {
    var callbackUrl = param.callbackUrl, clearUI = param.clearUI;
    var ref = (0,sparkl_ui__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(), visible = ref.visible, setVisible = ref.setVisible, bindings = ref.bindings;
    var toggleLogin = function() {
        //console.log("Setting login visible to", !visible);
        clearUI && clearUI();
        setVisible(!visible);
    };
    var LoginModal = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            width: "700px"
        }, bindings), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .Z.Container, {
                justify: "center",
                alignContent: "center",
                padding: 2,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        xs: 24,
                        justify: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: "Login to get started"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        sm: 12,
                        justify: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoginAdvert, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        sm: 12,
                        justify: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .Z.Container, {
                            justify: "center",
                            alignContent: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    xs: 24,
                                    justify: "center",
                                    padding: "5px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        type: "success-light",
                                        onClick: function() {
                                            return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_4__.signIn)("google", {
                                                callbackUrl: callbackUrl
                                            });
                                        },
                                        children: "Sign in with Google"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    xs: 24,
                                    justify: "center",
                                    padding: "5px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        style: {
                                            fontSize: "12px"
                                        },
                                        children: [
                                            "By using Sparkl, you agree to our",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                href: "https://docs.sparklpaint.com/terms-of-service",
                                                children: [
                                                    "Terms of Service",
                                                    " "
                                                ]
                                            }),
                                            "and",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "https://docs.sparklpaint.com/privacy-policy",
                                                children: "Privacy Policy"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        }));
    };
    return {
        toggleLogin: toggleLogin,
        LoginModal: LoginModal
    };
};


/***/ }),

/***/ 1123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useUpsellModal; },
/* harmony export */   "l": function() { return /* binding */ UpsellEmbed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _geist_ui_icons_archive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(287);
/* harmony import */ var _geist_ui_icons_fastForward__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8628);
/* harmony import */ var _geist_ui_icons_star__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2607);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6293);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9768);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9037);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5718);
/* harmony import */ var _feature_cell__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5842);
/* harmony import */ var _utils_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8779);









function UpsellAdvert() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .Z.Container, {
        justify: "center",
        alignContent: "center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            xs: 24,
            justify: "center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .Z.Container, {
                justify: "center",
                alignContent: "center",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_feature_cell__WEBPACK_IMPORTED_MODULE_4__/* .FeatureCalloutCell */ .R, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_geist_ui_icons_archive__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            color: "blue"
                        }),
                        title: "Generate more",
                        text: "Get 1000 additional monthly credits"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_feature_cell__WEBPACK_IMPORTED_MODULE_4__/* .FeatureCalloutCell */ .R, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_geist_ui_icons_fastForward__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            color: "blue"
                        }),
                        title: "Priority queueing",
                        text: "Your jobs run first if our servers are overloaded"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_feature_cell__WEBPACK_IMPORTED_MODULE_4__/* .FeatureCalloutCell */ .R, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_geist_ui_icons_star__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            color: "blue"
                        }),
                        title: "Other perks",
                        text: "Get beta access to new features, and more!"
                    })
                ]
            })
        })
    });
}
var UpsellEmbed = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .Z.Container, {
        justify: "center",
        alignContent: "center",
        style: {
            overflowX: "scroll"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            xs: 24,
            justify: "center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .Z.Container, {
                justify: "center",
                alignContent: "center",
                gap: 2,
                direction: "row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_feature_cell__WEBPACK_IMPORTED_MODULE_4__/* .EmbeddedFeatureCalloutCell */ .w, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_geist_ui_icons_archive__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            color: "blue"
                        }),
                        title: "Generate more",
                        text: "Get 1000 additional monthly credits"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_feature_cell__WEBPACK_IMPORTED_MODULE_4__/* .EmbeddedFeatureCalloutCell */ .w, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_geist_ui_icons_fastForward__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            color: "blue"
                        }),
                        title: "Priority queueing",
                        text: "Your jobs run first if our servers are busy"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_feature_cell__WEBPACK_IMPORTED_MODULE_4__/* .EmbeddedFeatureCalloutCell */ .w, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_geist_ui_icons_star__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            color: "blue"
                        }),
                        title: "Other perks",
                        text: "Get beta access to new features, and more!"
                    })
                ]
            })
        })
    });
};
var useUpsellModal = function() {
    var ref = (0,sparkl_ui__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(), visible = ref.visible, setVisible = ref.setVisible, bindings = ref.bindings;
    var toggleUpsell = function() {
        //console.log("Setting upsell visible to", !visible);
        setVisible(!visible);
    };
    var UpsellModal = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            width: "700px"
        }, bindings), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .Z.Container, {
                justify: "center",
                alignContent: "center",
                padding: 2,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        xs: 24,
                        justify: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: "Subscribe to Sparklpaint Plus"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        sm: 12,
                        justify: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UpsellAdvert, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        sm: 12,
                        justify: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .Z.Container, {
                            justify: "center",
                            alignContent: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                xs: 24,
                                justify: "center",
                                padding: "5px",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                    action: "/api/billing/checkout",
                                    method: "POST",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            type: "hidden",
                                            name: "lookup_key",
                                            value: _utils_config__WEBPACK_IMPORTED_MODULE_5__/* .config.subscriptionPriceId */ .v.subscriptionPriceId
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            type: "success-light",
                                            htmlType: "submit",
                                            scale: 2,
                                            shadow: true,
                                            children: "Subscribe ($10/mo)"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        }));
    };
    return {
        toggleUpsell: toggleUpsell,
        UpsellModal: UpsellModal
    };
};


/***/ }),

/***/ 9723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Byline; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5711);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6293);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1151);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _selectors_model_tags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(719);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5591);
/* harmony import */ var _utils_swr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6792);
/* harmony import */ var _avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8063);







var Byline = function(param) {
    var username = param.username, modelName = param.modelName, userId = param.userId;
    var _modelName;
    var modelInfo = (_modelName = _selectors_model_tags__WEBPACK_IMPORTED_MODULE_2__/* .nameToModelTagInfo */ .J1[modelName]) !== null && _modelName !== void 0 ? _modelName : null;
    var fallbackModelInfo = _selectors_model_tags__WEBPACK_IMPORTED_MODULE_2__/* .nameToModelTagInfo.verdant */ .J1.verdant;
    var theme = (0,sparkl_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)("/api/user/".concat(userId, "/avatar"), _utils_swr__WEBPACK_IMPORTED_MODULE_4__/* .fetcher */ ._i, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }), data = ref.data, error = ref.error;
    var ref1;
    var avatarSrc = (ref1 = data === null || data === void 0 ? void 0 : data.src) !== null && ref1 !== void 0 ? ref1 : "/images/default_user.png";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(sparkl_ui__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Container */ .Z.Container, {
        gap: 0,
        justify: "space-between",
        alignItems: "stretch",
        alignContent: "stretch",
        width: "100%",
        height: "100%",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                paddingTop: "0.5rem",
                paddingBottom: "0.2rem",
                style: {
                    width: "60%"
                },
                children: username !== "bot" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/profile/".concat(username),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "row",
                                color: theme.palette.foreground
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: avatarSrc,
                                    alt: "Avatar for " + username
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    style: {
                                        marginLeft: "0.5rem"
                                    },
                                    b: true,
                                    font: "14px",
                                    children: username
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                height: "100%",
                paddingTop: "0.5rem",
                paddingBottom: "0.2rem",
                paddingRight: "0.5rem",
                style: {
                    width: "40%",
                    display: "flex",
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    alt: "Avatar for " + modelInfo.name,
                    src: modelInfo ? modelInfo.avatar.src : fallbackModelInfo.avatar.src,
                    style: {
                        borderRadius: "50%",
                        border: "1px solid ".concat(modelInfo.color)
                    }
                })
            })
        ]
    });
};


/***/ }),

/***/ 7065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ClickableGrid; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8114);
/* harmony import */ var _lightbox_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4584);




var makeGridStyle = function(side_length) {
    // Make a string that repeats "1fr " times per_side
    var gridTemplateColumns = Array(side_length).fill("1fr ").join("");
    var div_style = {
        display: "grid",
        height: "100%",
        width: "100%",
        gridTemplateColumns: gridTemplateColumns,
        gridTemplateRows: gridTemplateColumns,
        gridGap: "0",
        overflow: "hidden",
        cursor: "pointer"
    };
    return div_style;
};
var ClickableGrid = function(param) {
    var prompt = param.prompt, images = param.images;
    var upMD = (0,sparkl_ui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("md", {
        match: "up"
    });
    var openWithLightbox = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lightbox_context__WEBPACK_IMPORTED_MODULE_2__/* .LightboxContext */ .p).openWithLightbox;
    if (images.length > 1) {
        // Just get a square number of images
        var side_length = Math.floor(Math.sqrt(images.length)); // This is the old way
        var sliced_images = images.slice(0, side_length * side_length);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: makeGridStyle(side_length),
            children: sliced_images.map(function(image, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: String(index),
                    onClick: openWithLightbox(prompt, upMD ? 0 : index + 1),
                    children: image
                }, String(index));
            })
        });
    } else {
        var index = 0;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: makeGridStyle(images.length),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: String(index),
                onClick: openWithLightbox(prompt, index),
                children: images
            }, String(index))
        });
    }
};


/***/ }),

/***/ 4584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ LightboxContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var LightboxContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    openWithLightbox: function() {}
});


/***/ }),

/***/ 8736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getSharedImageProp; },
/* harmony export */   "t": function() { return /* binding */ LoadingImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_use_blur__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8206);



var getSharedImageProp = function(prompt, isLightboxPost, isMobile) {
    // We get all the images for the prompt and return an arrayof ImageProps.
    var size;
    var quality;
    if (isLightboxPost) {
        size = "100vw";
        quality = 90;
    } else {
        var gridSize = prompt.outputs.image_urls.length;
        quality = isMobile && gridSize == 1 ? 90 : 75;
        if (gridSize >= 9) {
            size = "(max-width: 768px) 33vw, (max-width: 1280px) 11vw, 8vw";
        } else if (gridSize >= 4) {
            size = "(max-width: 768px) 50vw, (max-width: 1280px) 16vw, 12vw";
        } else {
            size = "(max-width: 768px) 100vw, (max-width: 1280px) 33vw, 25vw";
        }
    }
    var _height, _width;
    return {
        height: (_height = prompt.params.modelParams.height) !== null && _height !== void 0 ? _height : 512,
        width: (_width = prompt.params.modelParams.width) !== null && _width !== void 0 ? _width : 512,
        sizes: size,
        quality: quality,
        priority: isLightboxPost ? true : false
    };
};
var LoadingImage = function(param) {
    var sharedImageProp = param.sharedImageProp, prompt = param.prompt, index = param.index;
    var ref, ref1;
    var image_url = prompt.outputs.image_urls.slice(0, 9)[index];
    var ref2;
    var maybe_blur = ((ref2 = (ref = prompt.outputs) === null || ref === void 0 ? void 0 : (ref1 = ref.blurhashes) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 9)) !== null && ref2 !== void 0 ? ref2 : [])[index];
    var promptText = prompt.params.sharedParams.prompts.map(function(prompt) {
        return prompt.text;
    }).join(", ");
    var alt = promptText + " image #".concat(index);
    var blur_url = (0,_utils_use_blur__WEBPACK_IMPORTED_MODULE_2__/* .useBlur */ .uD)(maybe_blur, sharedImageProp.width, sharedImageProp.height);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: image_url,
        blurDataURL: blur_url,
        alt: alt,
        // shared image attributes
        quality: sharedImageProp.quality,
        sizes: sharedImageProp.sizes,
        priority: sharedImageProp.priority,
        height: sharedImageProp.height,
        width: sharedImageProp.width,
        onClick: sharedImageProp.onClick,
        // static image attributes
        placeholder: "blur",
        layout: "responsive",
        loading: "eager"
    });
};


/***/ }),

/***/ 9105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ Post; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-media-query/index.js + 1 modules
var use_media_query = __webpack_require__(8114);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/card/index.js + 4 modules
var card = __webpack_require__(7814);
// EXTERNAL MODULE: ./components/golden_grid.tsx
var golden_grid = __webpack_require__(9013);
// EXTERNAL MODULE: ./components/prompt_image/byline.tsx
var byline = __webpack_require__(9723);
// EXTERNAL MODULE: ./components/prompt_image/clickable_grid.tsx
var clickable_grid = __webpack_require__(7065);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(615);
;// CONCATENATED MODULE: ./components/prompt_image/image_carousel.tsx



var ImageCarousel = function(param) {
    var images = param.images, selectedIndex = param.selectedIndex, changeIndex = param.changeIndex;
    var theme = (0,use_theme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            backgroundColor: theme.palette.accents_2,
            overflow: "hidden",
            width: "100%",
            height: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, {
            selectedItem: selectedIndex,
            showThumbs: false,
            showStatus: false,
            showArrows: true,
            showIndicators: false,
            width: "100%",
            onChange: changeIndex,
            children: images
        })
    });
};

// EXTERNAL MODULE: ./components/prompt_image/loading_image.tsx
var loading_image = __webpack_require__(8736);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(3299);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-modal/index.js + 1 modules
var use_modal = __webpack_require__(9768);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-toasts/index.js + 1 modules
var use_toasts = __webpack_require__(5668);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/link/index.js + 2 modules
var esm_link = __webpack_require__(5901);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/grid/index.js + 3 modules
var grid = __webpack_require__(6293);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/description/index.js + 1 modules
var description = __webpack_require__(2050);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/button-group/button-group-context.js
var button_group_context = __webpack_require__(2909);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/button-group/button-group.js


var _excluded = ["disabled", "type", "ghost", "vertical", "children", "className"];






var defaultProps = {
  disabled: false,
  vertical: false,
  ghost: false,
  type: 'default',
  className: ''
};

var getGroupBorderColors = function getGroupBorderColors(palette, props) {
  var ghost = props.ghost,
      type = props.type;
  if (!ghost && type !== 'default') return palette.background;
  var colors = {
    "default": palette.border,
    success: palette.success,
    secondary: palette.secondary,
    error: palette.error,
    warning: palette.warning
  };
  var withoutLightType = type.replace('-light', '');
  return colors[withoutLightType] || colors["default"];
};

var ButtonGroupComponent = function ButtonGroupComponent(groupProps) {
  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var disabled = groupProps.disabled,
      type = groupProps.type,
      ghost = groupProps.ghost,
      vertical = groupProps.vertical,
      children = groupProps.children,
      className = groupProps.className,
      props = (0,objectWithoutProperties/* default */.Z)(groupProps, _excluded);

  var initialValue = (0,node_modules_react.useMemo)(function () {
    return {
      disabled: disabled,
      type: type,
      ghost: ghost,
      isButtonGroup: true
    };
  }, [disabled, type]);
  var border = (0,node_modules_react.useMemo)(function () {
    return getGroupBorderColors(theme.palette, groupProps);
  }, [theme, type, disabled, ghost]);
  var classes = (0,use_classes/* default */.Z)('btn-group', {
    vertical: vertical,
    horizontal: !vertical
  }, className);
  return /*#__PURE__*/node_modules_react.createElement(button_group_context/* ButtonGroupContext.Provider */.u.Provider, {
    value: initialValue
  }, /*#__PURE__*/node_modules_react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["139908940", [theme.layout.radius, border, SCALES.width(1, 'auto'), SCALES.height(1, 'min-content'), SCALES.mt(0.313), SCALES.mr(0.313), SCALES.mb(0.313), SCALES.ml(0.313), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), border, border]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), children, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "139908940",
    dynamic: [theme.layout.radius, border, SCALES.width(1, 'auto'), SCALES.height(1, 'min-content'), SCALES.mt(0.313), SCALES.mr(0.313), SCALES.mb(0.313), SCALES.ml(0.313), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), border, border]
  }, ".btn-group.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;border-radius:".concat(theme.layout.radius, ";border:2px solid ").concat(border, ";background-color:transparent;overflow:hidden;width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'min-content'), ";margin:").concat(SCALES.mt(0.313), " ").concat(SCALES.mr(0.313), " ").concat(SCALES.mb(0.313), " ").concat(SCALES.ml(0.313), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";}.vertical.__jsx-style-dynamic-selector{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}.btn-group.__jsx-style-dynamic-selector .btn{border:none;}.btn-group.__jsx-style-dynamic-selector .btn .text{top:0;}.horizontal.__jsx-style-dynamic-selector .btn:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0;border-left:1px solid ").concat(border, ";}.horizontal.__jsx-style-dynamic-selector .btn:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0;}.vertical.__jsx-style-dynamic-selector .btn:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-top:1px solid ").concat(border, ";}.vertical.__jsx-style-dynamic-selector .btn:not(:last-child){border-bottom-left-radius:0;border-bottom-right-radius:0;}"))));
};

ButtonGroupComponent.defaultProps = defaultProps;
ButtonGroupComponent.displayName = 'GeistButtonGroup';
var ButtonGroup = (0,with_scale/* default */.Z)(ButtonGroupComponent);
/* harmony default export */ var button_group = (ButtonGroup);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/button-group/index.js

/* harmony default export */ var esm_button_group = (button_group);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/modal/index.js + 6 modules
var modal = __webpack_require__(9037);
// EXTERNAL MODULE: ./utils/devtools.ts
var devtools = __webpack_require__(8250);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/genie/generate_button.tsx
var generate_button = __webpack_require__(1574);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/download.js
var icons_download = __webpack_require__(4869);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/alertTriangle.js
var alertTriangle = __webpack_require__(4251);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/eye.js
var eye = __webpack_require__(9950);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/eyeOff.js
var eyeOff = __webpack_require__(183);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/star.js
var star = __webpack_require__(2607);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/user.js
var user = __webpack_require__(3685);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/image.js
var icons_image = __webpack_require__(7212);
// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(3162);
// EXTERNAL MODULE: ./node_modules/swr/core/dist/index.mjs
var dist = __webpack_require__(5591);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/text/index.js + 2 modules
var esm_text = __webpack_require__(1151);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/textarea/index.js + 1 modules
var esm_textarea = __webpack_require__(8676);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/button/index.js
var esm_button = __webpack_require__(5718);
;// CONCATENATED MODULE: ./components/prompt_image/report.tsx





var ReportMenu = function(param) {
    var promptId = param.promptId;
    var ref = (0,node_modules_react.useState)(""), message = ref[0], setMessage = ref[1];
    var ref1 = (0,node_modules_react.useState)(false), submitted = ref1[0], setSubmitted = ref1[1];
    var handler = function(e) {
        setMessage(e.target.value);
        console.log(e.target.value);
    };
    function submit() {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSubmitted(true);
                        _ctx.next = 3;
                        return fetch("/api/post/".concat(promptId, "/report"), {
                            method: "POST",
                            body: message
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _submit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                h3: true,
                children: " Report "
            }),
            submitted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                children: " Thank you for your report! "
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                        p: true,
                        children: " Whats wrong with this post? "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_textarea/* default */.Z, {
                        width: "100%",
                        value: message,
                        onChange: handler,
                        marginBottom: "1rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_button/* default */.Z, {
                        type: "success",
                        onClick: submit,
                        disabled: message === "",
                        children: [
                            " ",
                            "Submit",
                            " "
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-avatar-editor/dist/index.js
var react_avatar_editor_dist = __webpack_require__(7011);
var dist_default = /*#__PURE__*/__webpack_require__.n(react_avatar_editor_dist);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/check.js
var check = __webpack_require__(8064);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/plus.js
var plus = __webpack_require__(6247);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/minus.js
var minus = __webpack_require__(6342);
// EXTERNAL MODULE: ./components/genie/generator_subcomponents/slider.tsx
var slider = __webpack_require__(5913);
;// CONCATENATED MODULE: ./components/prompt_image/set_avatar.tsx











var SetAvatarMenu = function(param) {
    var prompt = param.prompt, type = param.type, index = param.index, closeModal = param.closeModal;
    var ref = (0,node_modules_react.useState)(false), submitted = ref[0], setSubmitted = ref[1];
    var ref1 = (0,node_modules_react.useState)(type == "avatar" ? 1.6 : 1.0), scale = ref1[0], setScale = ref1[1];
    var handler = function(val) {
        setScale(val);
    };
    var editor = (0,node_modules_react.useRef)(null);
    var theme = (0,use_theme/* default */.Z)();
    var setToast = (0,use_toasts/* default */.Z)().setToast;
    function submit() {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var canvas, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSubmitted(true);
                        if (editor.current) {
                            canvas = editor.current.getImage();
                            data = canvas.toBlob(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(blob) {
                                    var uuid, file, url, resp;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                if (blob) {
                                                    _ctx.next = 3;
                                                    break;
                                                }
                                                //TODO: handle error
                                                setToast({
                                                    text: "Setting {type} failed: no image data",
                                                    type: "error"
                                                });
                                                return _ctx.abrupt("return");
                                            case 3:
                                                uuid = crypto.randomUUID();
                                                file = new File([
                                                    blob
                                                ], "".concat(uuid, ".png"), {
                                                    type: "image/png"
                                                });
                                                url = "https://user-upload-worker.drysys.workers.dev/".concat(uuid, ".png");
                                                _ctx.prev = 6;
                                                _ctx.next = 9;
                                                return fetch(url, {
                                                    method: "PUT",
                                                    body: file,
                                                    headers: {
                                                        "Access-Control-Allow-Origin": "*"
                                                    }
                                                });
                                            case 9:
                                                resp = _ctx.sent;
                                                if (!(resp.status != 200)) {
                                                    _ctx.next = 13;
                                                    break;
                                                }
                                                setToast({
                                                    text: "Setting {type} failed: image upload failed - ".concat(resp.status, " ").concat(resp.statusText),
                                                    type: "error"
                                                });
                                                return _ctx.abrupt("return");
                                            case 13:
                                                (0,dist/* mutate */.JG)("/api/user/".concat(prompt.user_id, "/avatar"), (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                    var res;
                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                _ctx.next = 2;
                                                                return fetch("/api/user/change_avatar", {
                                                                    method: "POST",
                                                                    body: JSON.stringify({
                                                                        url: url,
                                                                        type: type
                                                                    })
                                                                });
                                                            case 2:
                                                                res = _ctx.sent;
                                                                if (!(res.status == 200)) {
                                                                    _ctx.next = 7;
                                                                    break;
                                                                }
                                                                return _ctx.abrupt("return", {
                                                                    status: "success",
                                                                    src: url
                                                                });
                                                            case 7:
                                                                return _ctx.abrupt("return", {
                                                                    status: "failure",
                                                                    code: "mutate failure"
                                                                });
                                                            case 8:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee);
                                                })), {
                                                    optimisticData: {
                                                        status: "success",
                                                        src: url
                                                    }
                                                });
                                                _ctx.next = 20;
                                                break;
                                            case 16:
                                                _ctx.prev = 16;
                                                _ctx.t0 = _ctx["catch"](6);
                                                setToast({
                                                    text: "Setting {type} failed: image upload failed",
                                                    type: "error"
                                                });
                                                console.log(_ctx.t0);
                                            case 20:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            6,
                                            16
                                        ]
                                    ]);
                                }));
                                return function(blob) {
                                    return _ref.apply(this, arguments);
                                };
                            }(), "image/png");
                        } else {
                            setToast({
                                text: "Setting {type} failed: editor not found",
                                type: "error"
                            });
                        }
                        closeModal();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _submit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* default */.Z, {
                h3: true,
                children: [
                    " ",
                    type == "avatar" ? "Set Avatar" : "Set Profile Banner",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                    image: prompt.outputs.image_urls[index],
                    width: type == "avatar" ? 512 : 1024,
                    height: type == "avatar" ? 512 : 256,
                    border: type == "avatar" ? 50 : 100,
                    borderRadius: type == "avatar" ? 256 : 0,
                    color: [
                        255,
                        255,
                        255,
                        0.8
                    ],
                    scale: scale,
                    rotate: 0,
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    ref: editor,
                    crossOrigin: "anonymous"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    marginTop: "0.6rem"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            width: "60%",
                            gap: "0.5rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(minus/* default */.Z, {
                                type: "success"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(slider/* Slider */.i, {
                                value: 1.2,
                                onChange: handler,
                                width: "80%",
                                step: 0.1,
                                min: 1,
                                max: 2,
                                hideValue: true,
                                style: {
                                    backgroundColor: theme.palette.accents_4
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(plus/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
                        iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(check/* default */.Z, {}),
                        auto: true,
                        type: "success",
                        onClick: submit,
                        loading: submitted
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/modals/login_modal.tsx
var login_modal = __webpack_require__(9405);
// EXTERNAL MODULE: ./utils/swr.ts
var swr = __webpack_require__(6792);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-clipboard/index.js + 1 modules
var use_clipboard = __webpack_require__(7295);
// EXTERNAL MODULE: ./components/icons.tsx
var icons = __webpack_require__(4952);
;// CONCATENATED MODULE: ./components/reactions.tsx









var reactionText = {
    like: "\u2661",
    //sparkling star emoji for masterpiece
    masterpiece: "\uD83D\uDCAB",
    //regular star emoji for curated
    curated: "\u2728",
    //emoji for great
    great: "\u2B50",
    okay: "\uD83D\uDC4D",
    //thumbs down emoji for bad
    bad: "\uD83D\uDC4E",
    //warning emoji for tos
    tos: "\u26A0"
};
var UserReactions = function(param) {
    var prompt = param.prompt, reaction = param.reaction, buttonStyle = param.buttonStyle;
    var session = (0,devtools/* dev_maybeMockSession */.vQ)((0,next_auth_react.useSession)());
    var user_in_passed_reactions = false;
    var num_others_reacted = null;
    var total_reacted = 0;
    if ("reactions" in prompt) {
        if (session && prompt.reactions[session.user_id] == reaction) {
            user_in_passed_reactions = true;
        }
        var users_reacted = Object.keys(prompt.reactions).filter(function(user_id) {
            return prompt.reactions[user_id] == reaction;
        });
        total_reacted = users_reacted.length;
        num_others_reacted = users_reacted.length - Number(user_in_passed_reactions);
    }
    var ref = (0,node_modules_react.useState)(user_in_passed_reactions), hasUserReacted = ref[0], setUserReacted = ref[1];
    // Conceptually, we want the default of userReacted to be user_in_passed_reactions, but practically
    // this is difficult because useSession() is `null` for first render. This is how we get around that.
    (0,node_modules_react.useEffect)(function() {
        setUserReacted(user_in_passed_reactions);
    }, [
        user_in_passed_reactions
    ]);
    var Reaction = /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
        style: buttonStyle,
        className: "reactionButton",
        disabled: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EmptyHeart */.V0, {})
    });
    if (num_others_reacted !== null && session !== null) {
        // we're passed a finishedPrompt with more information instead of a justGeneratedPrompt with less
        var react = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setUserReacted(!hasUserReacted);
                            _ctx.next = 3;
                            return fetch("/api/reactions/".concat(prompt.id, "?reaction=").concat(reaction !== null && reaction !== void 0 ? reaction : "like"), {
                                method: "POST",
                                body: JSON.stringify({
                                    reaction: reaction !== null && reaction !== void 0 ? reaction : "like",
                                    type: hasUserReacted ? "undo" : "do"
                                }),
                                headers: (0,devtools/* dev_mockUserHeader */.OM)()
                            });
                        case 3:
                            (0,swr/* mutateUserLikedFeed */.gU)(session.user_id.toString());
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            // TODO: maybe it would be nice to update what the user has from the server?
            }));
            return function react() {
                return _ref.apply(this, arguments);
            };
        }();
        var reactionNumber = num_others_reacted + Number(hasUserReacted);
        // TODO: would be nice to have an animation here.
        Reaction = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_button/* default */.Z, {
            style: buttonStyle,
            onClick: react,
            className: "reactionButton",
            title: "Like",
            children: [
                !reaction || reaction == "like" ? hasUserReacted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FilledHeart */.QS, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EmptyHeart */.V0, {}) : hasUserReacted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                    b: true,
                    children: reactionText[reaction]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                    children: reactionText[reaction]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                    b: true,
                    children: reactionNumber > 0 ? " " + reactionNumber : ""
                })
            ]
        });
    }
    // Deleted stuff for multi-emoji reacts is deleted
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: Reaction
    });
};

// EXTERNAL MODULE: ./components/genie/use_genie.tsx
var use_genie = __webpack_require__(121);
;// CONCATENATED MODULE: ./components/prompt_image/remix_button.tsx





var RemixButton = function(param) {
    var prompt = param.prompt, style = param.style;
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var focusGenie = (0,use_genie/* useGenieFocus */.Nm)();
    var remixPrompt = function() {
        //console.log("remixing", prompt);
        genieDispatch({
            type: "switchModel",
            model: prompt.params.model
        });
        genieDispatch({
            type: "remix",
            model: prompt.params.model,
            sharedParams: prompt.params.sharedParams,
            modelSpecificParams: prompt.params.modelParams,
            remixPromptId: prompt.id
        });
        genieDispatch({
            type: "remixSetMode"
        });
        focusGenie();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
        style: style,
        auto: true,
        onClick: remixPrompt,
        className: "reactionButton",
        title: "Remix",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Sparkles */.P$, {})
    });
};

;// CONCATENATED MODULE: ./components/prompt_image/button_bar.tsx









var ButtonBar = function(param) {
    var prompt = param.prompt, lightboxIndex = param.lightboxIndex;
    var ref = (0,use_modal/* default */.Z)(), visible = ref.visible, setVisible = ref.setVisible, bindings = ref.bindings;
    var copy = (0,use_clipboard/* default */.Z)().copy;
    var setToast = (0,use_toasts/* default */.Z)().setToast;
    function shareHandler() {
        return _shareHandler.apply(this, arguments);
    }
    function _shareHandler() {
        _shareHandler = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var shareData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        shareData = {
                            title: "Look at this generation on Sparkl",
                            text: prompt.params.sharedParams.prompts.map(function(prompt) {
                                return prompt.text;
                            }).join(", "),
                            url: "".concat(window.location.origin, "/prompt/").concat(prompt.id)
                        };
                        if (!(typeof navigator.canShare == "function" && navigator.canShare(shareData))) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return navigator.share(shareData);
                    case 5:
                        return _ctx.abrupt("return");
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        //The error is mostly an AbortError when the user decides not to share
                        console.log(_ctx.t0);
                    case 11:
                        _ctx.next = 14;
                        break;
                    case 13:
                        {
                            copy("".concat(window.location.origin, "/prompt/").concat(prompt.id));
                            setToast({
                                text: "Link copied to clipboard",
                                type: "success"
                            });
                        //console.log("Couldn't share at all");
                        }
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return _shareHandler.apply(this, arguments);
    }
    var buttonStyle = {
        borderLeft: "0",
        width: "100%",
        height: "100%",
        margin: "0",
        zIndex: "0"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserReactions, {
                prompt: prompt,
                reaction: "like",
                buttonStyle: buttonStyle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RemixButton, {
                prompt: prompt,
                style: buttonStyle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
                style: buttonStyle,
                onClick: shareHandler,
                className: "reactionButton",
                title: "Share",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Share */.mB, {})
            }),
            "remixes" in prompt && prompt.remixes && prompt.remixes.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_button/* default */.Z, {
                        style: buttonStyle,
                        onClick: function() {
                            return setVisible(true);
                        },
                        children: [
                            prompt.remixes.length,
                            " other remix",
                            prompt.remixes.length > 1 ? "es" : ""
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bindings), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: prompt.remixes.map(function(remix) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        " ",
                                        "this should have promptid ",
                                        remix,
                                        " but this is in the middle of a refactor",
                                        " "
                                    ]
                                }, remix);
                            })
                        })
                    }))
                ]
            })
        ]
    });
};
var AdminButtonBar = function(param) {
    var prompt = param.prompt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserReactions, {
                prompt: prompt,
                reaction: "masterpiece"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserReactions, {
                prompt: prompt,
                reaction: "curated"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserReactions, {
                prompt: prompt,
                reaction: "great"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserReactions, {
                prompt: prompt,
                reaction: "okay"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserReactions, {
                prompt: prompt,
                reaction: "bad"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserReactions, {
                prompt: prompt,
                reaction: "tos"
            })
        ]
    });
};

// EXTERNAL MODULE: ./utils/roles.ts
var roles = __webpack_require__(679);
// EXTERNAL MODULE: ./components/genie/model_generators/model_generation_component_types.ts
var model_generation_component_types = __webpack_require__(7982);
;// CONCATENATED MODULE: ./components/prompt_image/post_details.tsx




























// $id-$prompt-$index.png
function promptFileName(prompt, index) {
    var promptText = prompt.params.sharedParams.prompts[0].text;
    promptText = promptText.replace(/ /g, "_");
    promptText = promptText.replace(/[^a-zA-Z0-9_]/g, "");
    promptText = promptText.substring(0, 150);
    var fileName = prompt.id.toString();
    if (promptText.length > 0) {
        fileName += "-" + promptText;
    }
    fileName += "-" + index;
    fileName += ".png";
    return fileName;
}
function upscaleTextForStatus(status) {
    switch(status){
        case "not_started":
        case "requesting":
            return "Upscale";
        case "in_progress":
            return "Upscaling";
        case "submitted":
            return "Submitted";
        case "done":
            return "Upscaled";
    }
}
function upscaleStatusFromPrompt(prompt, index) {
    if (prompt.outputs.upscaled_image_urls) {
        if (prompt.outputs.upscaled_image_urls[index] === "pending") {
            return "in_progress";
        } else if (!prompt.outputs.upscaled_image_urls[index] || prompt.outputs.upscaled_image_urls[index] === "") {
            return "not_started";
        } else {
            return "done";
        }
    }
    return "not_started";
}
// variation status:
// not_started, requesting, submitted
// upscale_status:
// not_started, requesting, submitted, in_progress, done
var PostDetails = function(param) {
    var prompt = param.prompt, lightboxIndex = param.lightboxIndex;
    var togglePrivate = function togglePrivate() {
        setToast({
            text: "Not implemented yet",
            type: "error"
        });
    };
    var useAsInitialImage = function useAsInitialImage() {
        //console.log("remixing", prompt);
        genieDispatch({
            type: "remix",
            model: "verdant",
            sharedParams: model_generation_component_types/* defaultSharedParams */.gU,
            modelSpecificParams: model_generation_component_types/* defaultVerdantParams */.Gy,
            remixPromptId: prompt.id
        });
        genieDispatch({
            type: "setMode",
            mode: "img2img"
        });
        genieDispatch({
            type: "setImageSize",
            height: prompt.params.modelParams.height,
            width: prompt.params.modelParams.width
        });
        genieDispatch({
            type: "setInitImageURL",
            initImageURL: prompt.outputs.image_urls[imageUrlIndex]
        });
        focusGenie();
    };
    var setAsAvatar = function setAsAvatar() {
        setImageType("avatar");
        setAvatarVisible(true);
    };
    var setAsCover = function setAsCover() {
        setImageType("cover");
        setAvatarVisible(true);
    };
    var download = function download() {
        if (isSingleImage) {
            if (upscaleStatus === "done" && prompt.outputs.upscaled_image_urls) {
                (0,FileSaver_min.saveAs)(prompt.outputs.upscaled_image_urls[imageUrlIndex], promptFileName(prompt, imageUrlIndex));
            } else {
                (0,FileSaver_min.saveAs)(prompt.outputs.image_urls[imageUrlIndex], promptFileName(prompt, imageUrlIndex));
            }
        } else {
            prompt.outputs.image_urls.map(function(url, index) {
                (0,FileSaver_min.saveAs)(url, promptFileName(prompt, index));
            });
        }
    };
    var report = function report() {
        setReportVisible(true);
    };
    var session = (0,devtools/* dev_maybeMockSession */.vQ)((0,next_auth_react.useSession)());
    var ref = (0,login_modal/* useLoginModal */.N)({}), toggleLogin = ref.toggleLogin, LoginModal = ref.LoginModal;
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var focusGenie = (0,use_genie/* useGenieFocus */.Nm)();
    var theme = (0,use_theme/* default */.Z)();
    var isAdmin = session && (0,roles/* isModerator */.v)(session);
    var postIsByUser = session && session.user_id == prompt.user_id;
    var isSingleImage = prompt.outputs.image_urls.length === 1 || lightboxIndex > 0;
    var imageUrlIndex = prompt.outputs.image_urls.length === 1 ? 0 : lightboxIndex - 1;
    var upMD = (0,use_media_query/* default */.Z)("md", {
        match: "up"
    });
    var upLg = (0,use_media_query/* default */.Z)("lg", {
        match: "up"
    });
    // VariationStatus is reset whenever you change prompt or image
    var ref1 = (0,node_modules_react.useState)("not_started"), variationStatus = ref1[0], setVariationStatus = ref1[1];
    var ref2 = (0,node_modules_react.useState)(upscaleStatusFromPrompt(prompt, imageUrlIndex)), upscaleStatus = ref2[0], setUpscaleStatus = ref2[1];
    (0,node_modules_react.useEffect)(function() {
        setUpscaleStatus(upscaleStatusFromPrompt(prompt, imageUrlIndex));
    }, [
        prompt,
        imageUrlIndex
    ]);
    //console.log("upscaleStatus", upscaleStatus);
    /* Report Modal */ var ref3 = (0,use_modal/* default */.Z)(), setReportVisible = ref3.setVisible, reportBindings = ref3.bindings;
    var ref4 = (0,use_modal/* default */.Z)(), setAvatarVisible = ref4.setVisible, avatarBindings = ref4.bindings;
    var setToast = (0,use_toasts/* default */.Z)().setToast;
    var ref5 = (0,node_modules_react.useState)("avatar"), imageType = ref5[0], setImageType = ref5[1];
    function variations() {
        return _variations.apply(this, arguments);
    }
    function _variations() {
        _variations = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var body;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            type: "variants",
                            params: prompt.params,
                            originalPromptId: prompt.id,
                            imageIndex: imageUrlIndex,
                            imageURL: prompt.outputs.image_urls[imageUrlIndex]
                        };
                        if (session) {
                            _ctx.next = 4;
                            break;
                        }
                        toggleLogin();
                        return _ctx.abrupt("return");
                    case 4:
                        setVariationStatus("requesting");
                        _ctx.next = 7;
                        return fetch("/api/generate", {
                            method: "POST",
                            body: JSON.stringify(body),
                            headers: (0,devtools/* dev_mockUserHeader */.OM)()
                        }).then(function(r) {
                            return r.json();
                        }).then(function(resp) {
                            if (resp.status === "success") {
                                (0,swr/* mutateQueue */.sb)({
                                    id: resp.prompt_id,
                                    params: body.params,
                                    status: "pending",
                                    date: Date.now() / 1000,
                                    user_id: resp.user_id,
                                    remix_of: body.originalPromptId
                                });
                                (0,dist/* mutate */.JG)("/api/balance");
                            } else {
                                if (resp.overloaded) {
                                // explain we're overloaded and try to upsell
                                }
                                setToast({
                                    text: resp.code,
                                    type: "error"
                                });
                            }
                        });
                    case 7:
                        setVariationStatus("submitted");
                        setTimeout(function() {
                            setVariationStatus("not_started");
                        }, 1000);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _variations.apply(this, arguments);
    }
    function upscale() {
        return _upscale.apply(this, arguments);
    }
    function _upscale() {
        _upscale = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var body;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            type: "upscale",
                            params: prompt.params,
                            originalPromptId: prompt.id,
                            imageIndex: imageUrlIndex,
                            imageURL: prompt.outputs.image_urls[imageUrlIndex]
                        };
                        if (session) {
                            _ctx.next = 4;
                            break;
                        }
                        toggleLogin();
                        return _ctx.abrupt("return");
                    case 4:
                        setUpscaleStatus("requesting");
                        _ctx.next = 7;
                        return fetch("/api/generate", {
                            method: "POST",
                            body: JSON.stringify(body),
                            headers: (0,devtools/* dev_mockUserHeader */.OM)()
                        }).then(function(r) {
                            return r.json();
                        }).then(function(resp) {
                            if (resp.status === "success") {
                                (0,dist/* mutate */.JG)("/api/balance");
                                (0,dist/* mutate */.JG)("/api/prompts?completed=true&id=" + prompt.id.toString);
                            } else {
                                if (resp.overloaded) {
                                // explain we're overloaded and try to upsell
                                }
                                setToast({
                                    text: resp.code,
                                    type: "error"
                                });
                            }
                        });
                    case 7:
                        setUpscaleStatus("submitted");
                        setTimeout(function() {
                            setUpscaleStatus("in_progress");
                        }, 1000);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _upscale.apply(this, arguments);
    }
    function toggleHidden(hidden) {
        return _toggleHidden.apply(this, arguments);
    }
    function _toggleHidden() {
        _toggleHidden = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(hidden) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        response = {
                            status: "success",
                            prompts: [
                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prompt), {
                                    hidden: !hidden
                                }), 
                            ]
                        };
                        (0,dist/* mutate */.JG)("/api/prompts?completed=true&id=".concat(prompt.id), (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return fetch("/api/post/".concat(prompt.id, "/hide?action=").concat(hidden ? "unhide" : "hide"), {
                                            method: "POST"
                                        });
                                    case 2:
                                        return _ctx.abrupt("return", response);
                                    case 3:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })), {
                            optimisticData: response
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _toggleHidden.apply(this, arguments);
    }
    function toggleShowcased(showcased) {
        return _toggleShowcased.apply(this, arguments);
    }
    function _toggleShowcased() {
        _toggleShowcased = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(showcased) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        response = {
                            status: "success",
                            prompts: [
                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prompt), {
                                    showcased: !showcased
                                }), 
                            ]
                        };
                        _ctx.next = 3;
                        return (0,dist/* mutate */.JG)("/api/prompts?completed=true&id=".concat(prompt.id), (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return fetch("/api/post/".concat(prompt.id, "/showcase?action=").concat(showcased ? "unshowcase" : "showcase"), {
                                            method: "POST"
                                        });
                                    case 2:
                                        return _ctx.abrupt("return", response);
                                    case 3:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })), {
                            optimisticData: response
                        });
                    case 3:
                        (0,swr/* mutateShowcasedFeed */.cG)(prompt.user_id.toString());
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _toggleShowcased.apply(this, arguments);
    }
    var linkWithIconStyle = {
        display: "flex",
        alignItems: "center",
        gap: "0.3rem"
    };
    var _hidden, _showcased;
    var myPostInfo = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            gridGap: "1rem",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_link/* default */.Z, {
                href: "javascript:",
                onClick: function() {
                    return toggleHidden((_hidden = prompt.hidden) !== null && _hidden !== void 0 ? _hidden : false);
                },
                color: true,
                children: prompt.hidden ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: linkWithIconStyle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(eyeOff/* default */.Z, {
                            size: "1em"
                        }),
                        " Make public"
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: linkWithIconStyle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(eye/* default */.Z, {
                            size: "1em"
                        }),
                        " Make private"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_link/* default */.Z, {
                href: "javascript:",
                onClick: function() {
                    return toggleShowcased((_showcased = prompt.showcased) !== null && _showcased !== void 0 ? _showcased : false);
                },
                color: true,
                children: prompt.showcased ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: linkWithIconStyle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(star/* default */.Z, {
                            size: "1em"
                        }),
                        " Remove from my showcase"
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: linkWithIconStyle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(star/* default */.Z, {
                            size: "1em"
                        }),
                        " Add to my showcase"
                    ]
                })
            }),
            isSingleImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_link/* default */.Z, {
                href: "javascript:",
                onClick: setAsAvatar,
                color: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: linkWithIconStyle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(user/* default */.Z, {
                            size: "1em"
                        }),
                        " Set as avatar"
                    ]
                })
            }),
            isSingleImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_link/* default */.Z, {
                href: "javascript:",
                onClick: setAsCover,
                color: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: linkWithIconStyle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_image/* default */.Z, {
                            size: "1em"
                        }),
                        " Set as profile banner"
                    ]
                })
            })
        ]
    });
    var thisPostInfo = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            gridGap: "1rem",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default.Container */.Z.Container, {
                gap: 0.2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                        xs: 12,
                        md: 24,
                        lg: 12,
                        children: isSingleImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(generate_button/* GenerateButton */.F3, {
                            onClick: variations,
                            text: variationStatus == "submitted" ? "Submitted!" : "Variations",
                            creditCost: prompt.params.modelParams.height * prompt.params.modelParams.width <= 512 * 512 ? 4 : 8,
                            timeEstimate: prompt.params.modelParams.height * prompt.params.modelParams.width <= 512 * 512 ? "1 min" : "2 mins",
                            fontSize: "16px",
                            status: variationStatus
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                        xs: 12,
                        md: 24,
                        lg: 12,
                        children: isSingleImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(generate_button/* GenerateButton */.F3, {
                            onClick: upscale,
                            text: upscaleTextForStatus(upscaleStatus),
                            creditCost: 2,
                            timeEstimate: "30s",
                            fontSize: "16px",
                            status: upscaleStatus
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_link/* default */.Z, {
                href: "javascript:",
                color: true,
                onClick: download,
                style: {
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0.3rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_download/* default */.Z, {
                            size: "1em"
                        }),
                        isSingleImage ? upscaleStatus == "done" ? "Download image (upscaled)" : "Download image" : "Download all images"
                    ]
                })
            }),
            isSingleImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_link/* default */.Z, {
                href: "javascript:",
                color: true,
                onClick: useAsInitialImage,
                style: {
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0.3rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_image/* default */.Z, {
                            size: "1em"
                        }),
                        "Use as initial image"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_link/* default */.Z, {
                href: "javascript:",
                color: true,
                onClick: report,
                style: {
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0.3rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(alertTriangle/* default */.Z, {
                            size: "1em"
                        }),
                        " Report"
                    ]
                })
            })
        ]
    });
    var initImageUrl = prompt.params.modelParams.init_image;
    var originalImage = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(description/* default */.Z, {
                title: "Original Image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: upMD ? "20vw" : "50vw",
                    width: upMD ? "20vw" : "50vw",
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: initImageUrl,
                    alt: "Initial image",
                    layout: "fill",
                    objectFit: "contain"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            margin: "1rem",
            gridGap: "1rem"
        },
        children: [
            thisPostInfo,
            postIsByUser && myPostInfo,
            initImageUrl && originalImage,
            isAdmin && /* 
        This is some code duplication - TODO: DRY later 
        */ /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(description/* default */.Z, {
                        title: "Admin"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button_group, {
                        type: "success",
                        ghost: true,
                        margin: 0,
                        height: "3rem",
                        width: "100%",
                        style: {
                            color: "".concat(theme.palette.success),
                            justifyContent: "space-evenly",
                            border: "unset"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminButtonBar, {
                            prompt: prompt
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reportBindings), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportMenu, {
                    promptId: prompt.id
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                width: upMD ? upLg ? "35vw" : "45vw" : "90vw"
            }, avatarBindings), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SetAvatarMenu, {
                    prompt: prompt,
                    type: imageType,
                    index: imageUrlIndex,
                    closeModal: function() {
                        return setAvatarVisible(false);
                    }
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModal, {})
        ]
    });
};

;// CONCATENATED MODULE: ./components/prompt_image/tombstone.tsx




var Tombstone = function(param) {
    var prompt = param.prompt, promptText = param.promptText, _hasByline = param.hasByline, hasByline = _hasByline === void 0 ? false : _hasByline, _admin = param.admin, admin = _admin === void 0 ? false : _admin, lightboxIndex = param.lightboxIndex;
    var theme = (0,use_theme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%",
            height: "100%",
            overflowX: "hidden"
        },
        children: [
            hasByline ? /*#__PURE__*/ (0,jsx_runtime.jsx)(byline/* Byline */.Y, {
                username: prompt.username,
                modelName: prompt.params.model,
                userId: prompt.user_id
            }) : "",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                p: true,
                font: "0.82rem",
                px: "1.18rem",
                style: lightboxIndex === undefined ? {
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                } : {
                    overflow: "visible"
                },
                children: promptText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button_group, {
                type: "success",
                ghost: true,
                margin: 0,
                height: "3rem",
                width: "100%",
                style: {
                    color: "".concat(theme.palette.success),
                    justifyContent: "space-evenly",
                    border: "unset"
                },
                children: admin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminButtonBar, {
                    prompt: prompt
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBar, {
                    prompt: prompt,
                    lightboxIndex: lightboxIndex
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/prompt_image/post.tsx












var Post = function(param) {
    var prompt = param.prompt, _carousel = param.carousel, carousel = _carousel === void 0 ? false : _carousel, _wide = param.wide, wide = _wide === void 0 ? false : _wide, _indexForLightbox = param.indexForLightbox, indexForLightbox = _indexForLightbox === void 0 ? 0 : _indexForLightbox, isLightboxPost = param.isLightboxPost, admin = param.admin, _className = param.className, className = _className === void 0 ? "" : _className, _style = param.style, style = _style === void 0 ? {} : _style;
    var ref;
    var promptText = prompt.params.sharedParams.prompts.map(function(prompt) {
        return prompt.text;
    }).join(", ");
    var theme = (0,use_theme/* default */.Z)();
    var upMD = (0,use_media_query/* default */.Z)("md", {
        match: "up"
    });
    var sharedImageProp = (0,loading_image/* getSharedImageProp */.U)(prompt, isLightboxPost, !upMD);
    var ref1;
    var image_urls = (ref1 = prompt === null || prompt === void 0 ? void 0 : (ref = prompt.outputs) === null || ref === void 0 ? void 0 : ref.image_urls) !== null && ref1 !== void 0 ? ref1 : [];
    var indexes = image_urls.slice(0, 9).map(function(image_url, index) {
        return index;
    });
    var images = indexes.map(function(index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_image/* LoadingImage */.t, {
            sharedImageProp: sharedImageProp,
            prompt: prompt,
            index: index
        }, index);
    });
    var imageGrid = /*#__PURE__*/ (0,jsx_runtime.jsx)(clickable_grid/* ClickableGrid */.E, {
        prompt: prompt,
        images: images
    });
    var ref2 = (0,node_modules_react.useState)(indexForLightbox), lightboxIndex = ref2[0], setLightboxIndex = ref2[1];
    var content = carousel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCarousel, {
        images: images.length > 1 ? [
            imageGrid
        ].concat((0,_to_consumable_array/* default */.Z)(images)) : images,
        selectedIndex: indexForLightbox,
        changeIndex: setLightboxIndex
    }) : imageGrid;
    var caption = function(hasByline) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tombstone, {
                    prompt: prompt,
                    promptText: promptText,
                    admin: admin,
                    hasByline: hasByline,
                    lightboxIndex: isLightboxPost ? lightboxIndex : undefined
                }),
                isLightboxPost && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetails, {
                    prompt: prompt,
                    lightboxIndex: lightboxIndex
                })
            ]
        });
    };
    var postStyle = (0,_object_spread/* default */.Z)({
        padding: "0",
        border: "0",
        borderTop: "1px solid ".concat(theme.palette.accents_1),
        borderLeft: "1px solid ".concat(theme.palette.accents_1),
        borderBottom: "1px solid ".concat(theme.palette.accents_2),
        borderRight: "1px solid ".concat(theme.palette.accents_2),
        width: "100%",
        height: "fit-content",
        overflowX: "hidden"
    }, style);
    var postCard = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(byline/* Byline */.Y, {
                username: prompt.username,
                modelName: prompt.params.model,
                userId: prompt.user_id
            }),
            content,
            caption(false)
        ]
    });
    var postDisplay = /*#__PURE__*/ (0,jsx_runtime.jsx)(golden_grid/* TwoPaneGrid */.k, {
        bigPane: content,
        smallPane: caption(true),
        fixedDirection: "row"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: postStyle,
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Content */.Z.Content, {
            width: "auto",
            padding: 0,
            children: wide ? postDisplay : postCard
        })
    });
};


/***/ }),

/***/ 7744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ GenericSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var sparkl_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1278);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);




var GenericSelector = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sparkl_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        dropdownStyle: {
            zIndex: -1
        },
        style: {
            padding: "0 1.5rem 0 1rem",
            maxWidth: "fit-content",
            minWidth: "fit-content",
            width: "100%"
        },
        type: "success",
        disableMatchWidth: true
    }, props));
};


/***/ }),

/***/ 6508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ ModelSelector; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/selectors/generic_selector.tsx
var generic_selector = __webpack_require__(7744);
// EXTERNAL MODULE: ./components/selectors/model_tags.tsx + 7 modules
var model_tags = __webpack_require__(719);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/select/index.js + 12 modules
var esm_select = __webpack_require__(1278);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/text/index.js + 2 modules
var esm_text = __webpack_require__(1151);
// EXTERNAL MODULE: ./components/avatar.tsx
var avatar = __webpack_require__(8063);
;// CONCATENATED MODULE: ./components/selectors/labeled_model.tsx





var LabeledModel = function(param) {
    var model = param.model, _short = param.short, short = _short === void 0 ? false : _short;
    var theme = (0,use_theme/* default */.Z)();
    var ref = (0,react.useState)(false), hover = ref[0], setHover = ref[1];
    var size = short ? "1.75rem" : "2.75rem";
    var scaleStyle = hover ? {
        transform: "scale(1.21)",
        transformOrigin: "center",
        transition: "0.12s ease-out"
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            width: "100%",
            maxWidth: "100vw"
        },
        onMouseOver: function() {
            // use a scale transform to make the avatar grow
            setHover(true);
        },
        onMouseOut: function() {
            setHover(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                justifyItems: "space-between",
                alignItems: "center",
                wordBreak: "break-word",
                height: "100%",
                paddingTop: "0.38rem",
                paddingBottom: "0.38rem",
                gap: "0.38rem"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: (0,_object_spread/* default */.Z)({
                        minWidth: size
                    }, scaleStyle),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.Z, {
                        alt: "Avatar for " + model.name,
                        src: model.avatar.src,
                        height: size,
                        width: size,
                        marginLeft: 0,
                        style: {
                            borderRadius: "50%",
                            border: "2px solid ".concat(model.color)
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "0.38rem"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                    font: "1rem",
                                    b: true,
                                    children: model.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                    style: {
                                        opacity: 0.5,
                                        paddingRight: "0.5rem"
                                    },
                                    i: true,
                                    children: model.popularName
                                })
                            ]
                        }),
                        !short ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                            font: "14px",
                            small: true,
                            color: theme.palette.secondary,
                            children: model.text
                        }) : ""
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/selectors/model_selector.tsx








var ModelSelector = function(_param) {
    var value = _param.value, onChange = _param.onChange, _models = _param.models, models = _models === void 0 ? model_tags/* generatorWhiteList */.Zp : _models, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange",
        "models"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(generic_selector/* GenericSelector */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        value: value,
        placeholder: "Model",
        onChange: onChange
    }, props), {
        children: models.map(function(model) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_select/* default.Option */.Z.Option, {
                value: model.modelName,
                displayName: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabeledModel, {
                    model: model,
                    short: true
                }),
                height: "100%",
                width: "100%",
                ellipsis: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabeledModel, {
                    model: model
                })
            }, model.modelName);
        })
    }));
};



/***/ }),

/***/ 719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zp": function() { return /* binding */ generatorWhiteList; },
  "J1": function() { return /* binding */ nameToModelTagInfo; },
  "VP": function() { return /* binding */ selectorWhiteList; }
});

;// CONCATENATED MODULE: ./public/images/model_avatars/knight-face.png
/* harmony default export */ var knight_face = ({"src":"/_next/static/media/knight-face.327e8a4d.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAilBMVEVMaXG0mmwde8YffZnn8e+du8yQy+avzdUxhbCUw9hpgpeIs8Y9gLr/qk2WVgKlytUHb9hluOBqaG92hH5HotLoxYinmnlytNfdml251uOsyM6vl3jJuYZ4uN+GuNWdbTVKg6Zni6K+oXCn0Oq5axiygzm43+zvsWzAl1PDo3yBg4F+laT1xoqwvcHx6pj/AAAAIXRSTlMA/RbD/vrCvpMi3f2iSv5tfGr3s5v95r391MH92/j+lv5Z5keyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAR0lEQVQImQXBBQKAIAAEsENJuzsAu/7/PTfECpAuAKFS7nsOIIqd0kUCojaM6QDo+E2uLAHa0TRHlYcYPv2Qc1sxv/1kbRn9eOAEnqTX/ZQAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/model_avatars/chevalier-face.png
/* harmony default export */ var chevalier_face = ({"src":"/_next/static/media/chevalier-face.1c16c23a.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEVMaXFqZmdaXmNLVWuUnKFnSTZsX2E7PD7726u7ws6BalaXlJmcobKQjoh7gJIjFAxSSzlgZHZITV6jqL7Lp4CEfYN0WEbhyqZcY3beuX/25sEhMTt6f5VyeY2qscGIdGXGqIN/hpx1c3ycijCyAAAAHXRSTlMA80HvIIgHFPhX/onN9OZl+ILGkdK84v73/vzBmIcRDccAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABESURBVAiZFcZHEoAgEADBAZRFzDkC6v8fadmnBumbqgDsEJ4QC5Dt9V0qQYzf3Z2DNWk9/si5ODe1IPpS85gBWoVYZ3x6YQM/MOkfjQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/model_avatars/maiden-face.png
/* harmony default export */ var maiden_face = ({"src":"/_next/static/media/maiden-face.caf31999.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAh1BMVEUAAAVjQBhCgV0/WkGqkTddhzyumTg/OiJJVSQxcUF4bDW3jCbax2GBamXd0F0sTjwACAwdgFEAAACwrTdQYypMaXEFAAA3JROTeDHiq4IOAACTeGDdt5ZSOB+BVj7/4r7iw6RKfTuFZVEDUTpdVj6biipcekCQij9SmlDEvjWteSh5TCaIZSNPQQ7hAAAAHHRSTlM1+P7+/ur8b0b0/v3+/v7+O/4V/fcAG4P+/l+0fUwQ7wAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEpJREFUCJkFwQUCgCAABLCTELE7QRA7/v8+NzQBXxYeAK28KnZIoKzvNI50DuH7SrGnw34mxrj+gxdaq4bXw7xlbqbrCKELQlY6/a98BSQgca1uAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/model_avatars/bard-face.png
/* harmony default export */ var bard_face = ({"src":"/_next/static/media/bard-face.05ee12f2.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAclBMVEVMaXHNe0zYq5JfVlEgbUZ1QCeVTCgWLyMBRDgoLTyVWkYOb1MkTywPc1c4ORdqSyRrXVdmLx1xEwDwky2HUkGwYieNTg7rrphiSzOpVRagbTmcXiaIeGVzOydOiUq5lTRdHAGueBhKej+GXEaZQwvVfhjJHuHkAAAAG3RSTlMA+v147U73JDwP25nxmLvUvNFm+fLasP3C4EnWcnLBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVQImQXBBQKAIBAAwQXBA7sLO/7/RWcASXMBcGa/jQPJjlZdBfjyUzoMgH31GBrA9083L0C0xvFUAZJsZ235AWZzAxPAPNgRAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/model_avatars/mage-face.png
/* harmony default export */ var mage_face = ({"src":"/_next/static/media/mage-face.f0dba15c.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAYFBMVEVMaXGAIUszFn95PMEUC19CIX2BGN01DHASTDtiGbNxOLXtvZ2MYIxcJH99XHpfHbCCQXFuR55sMYKqf4uyg4tpQ5qXF/mLGud5GVazZ3GXUGpxDsxRHpB0M3B5Nm9VIZVrFizoAAAAFnRSTlMAbIP+H0jvMAa6/v39zXKehbzl/f637HsuPgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAENJREFUCJkVyscRgCAAAMEDJIpZETD136XDvhecP42lmc7kHdCZlC4L+ghKhUUjn7rt9ZUgSt8XAdgcY55bHr57HfkBXK8C1GRL7zwAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/model_avatars/squire-face.png
/* harmony default export */ var squire_face = ({"src":"/_next/static/media/squire-face.fa22bb68.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAhFBMVEVMaXFaLx5iVEQAAABnXV55VTj6wWUkJyR7clekdBdoamuGaiV2Wlf/2TB7NlGOaRr7tRQKCAm3fjlZVXLx4bqEQyHx2qH/8KgAAgCjHyKsLyVGVEayADB1Mz9SLUNqViuBFi57bWPiwT6IWz/cvlzctkHJt5W+b0M+FgnIk3NsSBqyK1qYXmreAAAAIHRSTlMA/gIW4fL+QYr+Zeb3/O75/dL6/f78/v1V/P0a+s182l7yr1kAAAAJcEhZcwAACxMAAAsTAQCanBgAAABISURBVAiZBcEFAoAgEATARYEDuzsAW///P2cwzuZLCB4WM/U69IHVDK49CHjZ01QnAfV9SbkTwMoii10A5Jan2iqgE4JHm8IPsNUEbJ4UusMAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/model_avatars/sparky.png
/* harmony default export */ var sparky = ({"src":"/_next/static/media/sparky.49e63a0c.png","height":687,"width":687,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAATlBMVEVMaXHtqR/pqid2ZyIAABp9WRWukSwFBxiwoUP6tyJnWCKngymZcx+SbR0nHROKfS//xCf/2R+ShEW4eBWtnT7fwDfnqEC5nEru1ka/oivvuKD2AAAAFXRSTlMAJkaWDIrQGPw2cOZ6sDrSUhukOqii4P4GAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQElEQVQImRWKyRGAMAzEBCSxzRUuB+i/UfBnRyMtgCQA26hDwH4ej4/hr1v1nUFKU20ZSMU99xZxWrAu/qv8+wFFYgHbrr6yUwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./components/selectors/model_tags.tsx







var VerdantInfo = {
    modelName: "verdant",
    value: "verdant",
    name: "Knight",
    popularName: "Stable Diffusion",
    avatar: knight_face,
    text: "General powerful model, does well with style prompts",
    color: "#0058B4"
};
var Verdant2Info = {
    modelName: "verdant2",
    value: "verdant2",
    name: "Chevalier",
    popularName: "Stable Diffusion 2",
    avatar: chevalier_face,
    text: "New general powerful model, does well with style prompts",
    color: "#0058B4"
};
var WaifuInfo = {
    modelName: "waifu",
    value: "waifu",
    name: "Maiden",
    popularName: "Waifu Diffusion",
    avatar: maiden_face,
    text: "A finetuned model that generates anime-style images",
    color: "#FDFE01"
};
var DalleInfo = {
    modelName: "dalle",
    value: "dalle",
    name: "Bard",
    popularName: "Dalle-mini",
    avatar: bard_face,
    text: "Excels at mixing unrelated concepts, great for memes.",
    color: "#2CB87F"
};
var VQGANInfo = {
    modelName: "vqgan",
    value: "vqgan",
    name: "Mage",
    popularName: "VQGAN+CLIP",
    avatar: mage_face,
    text: "Generates less realistic, but more psychedelic visuals",
    color: "#961BF5"
};
var DiffuseInfo = {
    modelName: "diffuse",
    value: "diffuse",
    name: "Squire",
    popularName: "Latent Diffusion",
    avatar: squire_face,
    text: "A predecessor of Knight, less powerful but similar in capabilities",
    color: "#CA0640"
};
var AllModels = {
    modelName: "all",
    value: "all",
    name: "All Models",
    popularName: "",
    avatar: sparky,
    text: "See generations from all models",
    color: "#F9965A"
};
var generatorWhiteList = [
    VerdantInfo,
    Verdant2Info,
    WaifuInfo,
    DalleInfo,
    VQGANInfo,
    DiffuseInfo, 
];
var selectorWhiteList = [
    AllModels,
    VerdantInfo,
    Verdant2Info,
    WaifuInfo,
    DalleInfo,
    VQGANInfo,
    DiffuseInfo, 
];
var nameToModelTagInfo = {
    verdant: VerdantInfo,
    verdant2: Verdant2Info,
    dalle: DalleInfo,
    vqgan: VQGANInfo,
    diffuse: DiffuseInfo,
    waifu: WaifuInfo
};


/***/ }),

/***/ 64:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fe": function() { return /* binding */ mauve; },
/* harmony export */   "Q6": function() { return /* binding */ red; },
/* harmony export */   "WH": function() { return /* binding */ greenA; },
/* harmony export */   "Wl": function() { return /* binding */ crimson; },
/* harmony export */   "er": function() { return /* binding */ yellow; },
/* harmony export */   "ht": function() { return /* binding */ violet; },
/* harmony export */   "iN": function() { return /* binding */ blue; },
/* harmony export */   "vd": function() { return /* binding */ plum; }
/* harmony export */ });
/* unused harmony exports mauveA, plumA, crimsonA, blueA, green, yellowA, mintA, mint, violetA, redA, mauveDarkA, plumDarkA, crimsonDarkA, blueDarkA, greenDarkA, yellowDarkA, mintDarkA, violetDarkA */
var mauve = {
    mauve1: "hsl(300, 20.0%, 99.0%)",
    mauve2: "hsl(300, 7.7%, 97.5%)",
    mauve3: "hsl(294, 5.5%, 95.3%)",
    mauve4: "hsl(289, 4.7%, 93.3%)",
    mauve5: "hsl(283, 4.4%, 91.3%)",
    mauve6: "hsl(278, 4.1%, 89.1%)",
    mauve7: "hsl(271, 3.9%, 86.3%)",
    mauve8: "hsl(255, 3.7%, 78.8%)",
    mauve9: "hsl(252, 4.0%, 57.3%)",
    mauve10: "hsl(253, 3.5%, 53.5%)",
    mauve11: "hsl(252, 4.0%, 44.8%)",
    mauve12: "hsl(260, 25.0%, 11.0%)"
};
var mauveA = {
    mauveA1: "hsla(300, 89.3%, 18.3%, 0.012)",
    mauveA2: "hsla(300, 78.1%, 9.0%, 0.028)",
    mauveA3: "hsla(300, 99.5%, 7.7%, 0.051)",
    mauveA4: "hsla(270, 90.5%, 6.1%, 0.071)",
    mauveA5: "hsla(270, 83.0%, 5.2%, 0.091)",
    mauveA6: "hsla(300, 93.5%, 3.7%, 0.114)",
    mauveA7: "hsla(270, 82.6%, 3.3%, 0.142)",
    mauveA8: "hsla(255, 95.2%, 3.7%, 0.220)",
    mauveA9: "hsla(255, 94.8%, 3.7%, 0.444)",
    mauveA10: "hsla(253, 96.5%, 3.8%, 0.483)",
    mauveA11: "hsla(247, 97.9%, 3.2%, 0.569)",
    mauveA12: "hsla(261, 98.7%, 3.0%, 0.918)"
};
var plumA = {
    plumA1: "hsla(280, 100%, 51.0%, 0.012)",
    plumA2: "hsla(300, 100%, 51.0%, 0.028)",
    plumA3: "hsla(300, 99.0%, 40.9%, 0.063)",
    plumA4: "hsla(300, 99.9%, 38.5%, 0.102)",
    plumA5: "hsla(298, 98.2%, 35.9%, 0.150)",
    plumA6: "hsla(297, 99.6%, 33.7%, 0.216)",
    plumA7: "hsla(295, 99.7%, 32.6%, 0.314)",
    plumA8: "hsla(292, 99.6%, 32.4%, 0.432)",
    plumA9: "hsla(292, 99.9%, 31.0%, 0.710)",
    plumA10: "hsla(292, 99.9%, 30.8%, 0.765)",
    plumA11: "hsla(292, 99.8%, 30.7%, 0.832)",
    plumA12: "hsla(291, 99.9%, 9.7%, 0.953)"
};
var plum = {
    plum1: "hsl(292, 90.0%, 99.4%)",
    plum2: "hsl(300, 100%, 98.6%)",
    plum3: "hsl(299, 71.2%, 96.4%)",
    plum4: "hsl(299, 62.0%, 93.8%)",
    plum5: "hsl(298, 56.1%, 90.5%)",
    plum6: "hsl(296, 51.3%, 85.8%)",
    plum7: "hsl(295, 48.2%, 78.9%)",
    plum8: "hsl(292, 47.7%, 70.8%)",
    plum9: "hsl(292, 45.0%, 51.0%)",
    plum10: "hsl(292, 50.2%, 46.9%)",
    plum11: "hsl(292, 60.0%, 42.5%)",
    plum12: "hsl(291, 66.0%, 14.0%)"
};
var crimsonA = {
    crimsonA1: "hsla(340, 100%, 51.0%, 0.012)",
    crimsonA2: "hsla(330, 100%, 51.0%, 0.032)",
    crimsonA3: "hsla(332, 99.1%, 47.1%, 0.063)",
    crimsonA4: "hsla(331, 99.9%, 44.3%, 0.102)",
    crimsonA5: "hsla(333, 99.9%, 42.3%, 0.153)",
    crimsonA6: "hsla(333, 99.5%, 40.5%, 0.224)",
    crimsonA7: "hsla(335, 99.7%, 39.1%, 0.322)",
    crimsonA8: "hsla(336, 99.5%, 38.5%, 0.440)",
    crimsonA9: "hsla(336, 99.9%, 44.3%, 0.761)",
    crimsonA10: "hsla(336, 100%, 42.5%, 0.808)",
    crimsonA11: "hsla(336, 99.8%, 40.3%, 0.883)",
    crimsonA12: "hsla(340, 99.0%, 10.0%, 0.950)"
};
var crimson = {
    crimson1: "hsl(332, 100%, 99.4%)",
    crimson2: "hsl(330, 100%, 98.4%)",
    crimson3: "hsl(331, 85.6%, 96.6%)",
    crimson4: "hsl(331, 78.1%, 94.2%)",
    crimson5: "hsl(332, 72.1%, 91.1%)",
    crimson6: "hsl(333, 67.0%, 86.7%)",
    crimson7: "hsl(335, 63.5%, 80.4%)",
    crimson8: "hsl(336, 62.3%, 72.9%)",
    crimson9: "hsl(336, 80.0%, 57.8%)",
    crimson10: "hsl(336, 73.7%, 53.5%)",
    crimson11: "hsl(336, 75.0%, 47.2%)",
    crimson12: "hsl(340, 65.0%, 14.5%)"
};
var blueA = {
    blueA1: "hsla(210, 100%, 51.0%, 0.016)",
    blueA2: "hsla(210, 100%, 51.0%, 0.040)",
    blueA3: "hsla(210, 100%, 50.3%, 0.071)",
    blueA4: "hsla(210, 100%, 50.1%, 0.118)",
    blueA5: "hsla(208, 99.1%, 47.1%, 0.189)",
    blueA6: "hsla(209, 99.5%, 45.3%, 0.283)",
    blueA7: "hsla(208, 99.9%, 43.8%, 0.412)",
    blueA8: "hsla(206, 99.8%, 45.1%, 0.632)",
    blueA9: "hsla(206, 100%, 50.0%, 0.980)",
    blueA10: "hsla(208, 100%, 47.2%, 0.980)",
    blueA11: "hsla(212, 100%, 43.0%, 0.980)",
    blueA12: "hsla(213, 100%, 14.4%, 0.980)"
};
var blue = {
    blue1: "hsl(206, 100%, 99.2%)",
    blue2: "hsl(210, 100%, 98.0%)",
    blue3: "hsl(209, 100%, 96.5%)",
    blue4: "hsl(210, 98.8%, 94.0%)",
    blue5: "hsl(209, 95.0%, 90.1%)",
    blue6: "hsl(209, 81.2%, 84.5%)",
    blue7: "hsl(208, 77.5%, 76.9%)",
    blue8: "hsl(206, 81.9%, 65.3%)",
    blue9: "hsl(206, 100%, 50.0%)",
    blue10: "hsl(208, 100%, 47.3%)",
    blue11: "hsl(211, 100%, 43.2%)",
    blue12: "hsl(211, 100%, 15.0%)"
};
var greenA = {
    greenA1: "hsla(140, 94.9%, 38.7%, 0.016)",
    greenA2: "hsla(138, 99.9%, 38.5%, 0.051)",
    greenA3: "hsla(139, 97.7%, 36.9%, 0.087)",
    greenA4: "hsla(139, 98.5%, 32.7%, 0.134)",
    greenA5: "hsla(141, 100%, 30.4%, 0.200)",
    greenA6: "hsla(142, 99.0%, 28.9%, 0.295)",
    greenA7: "hsla(146, 99.5%, 27.6%, 0.428)",
    greenA8: "hsla(151, 99.5%, 28.8%, 0.644)",
    greenA9: "hsla(151, 99.9%, 28.0%, 0.812)",
    greenA10: "hsla(152, 99.6%, 25.8%, 0.840)",
    greenA11: "hsla(153, 99.9%, 21.0%, 0.906)",
    greenA12: "hsla(155, 99.4%, 6.2%, 0.918)"
};
var green = {
    green1: "hsl(136, 50.0%, 98.9%)",
    green2: "hsl(138, 62.5%, 96.9%)",
    green3: "hsl(139, 55.2%, 94.5%)",
    green4: "hsl(140, 48.7%, 91.0%)",
    green5: "hsl(141, 43.7%, 86.0%)",
    green6: "hsl(143, 40.3%, 79.0%)",
    green7: "hsl(146, 38.5%, 69.0%)",
    green8: "hsl(151, 40.2%, 54.1%)",
    green9: "hsl(151, 55.0%, 41.5%)",
    green10: "hsl(152, 57.5%, 37.6%)",
    green11: "hsl(153, 67.0%, 28.5%)",
    green12: "hsl(155, 40.0%, 14.0%)"
};
var yellowA = {
    yellowA1: "hsla(60, 94.3%, 34.6%, 0.024)",
    yellowA2: "hsla(52, 100%, 50.4%, 0.091)",
    yellowA3: "hsla(55, 100%, 50.2%, 0.181)",
    yellowA4: "hsla(54, 100%, 50.1%, 0.267)",
    yellowA5: "hsla(52, 99.9%, 49.5%, 0.357)",
    yellowA6: "hsla(50, 100%, 47.4%, 0.451)",
    yellowA7: "hsla(47, 99.8%, 44.6%, 0.577)",
    yellowA8: "hsla(48, 100%, 46.0%, 0.980)",
    yellowA9: "hsla(53, 100%, 48.0%, 0.961)",
    yellowA10: "hsla(50, 100%, 48.4%, 0.980)",
    yellowA11: "hsla(42, 100%, 28.6%, 0.980)",
    yellowA12: "hsla(41, 98.9%, 8.0%, 0.942)"
};
var yellow = {
    yellow1: "hsl(60, 54.0%, 98.5%)",
    yellow2: "hsl(52, 100%, 95.5%)",
    yellow3: "hsl(55, 100%, 90.9%)",
    yellow4: "hsl(54, 100%, 86.6%)",
    yellow5: "hsl(52, 97.9%, 82.0%)",
    yellow6: "hsl(50, 89.4%, 76.1%)",
    yellow7: "hsl(47, 80.4%, 68.0%)",
    yellow8: "hsl(48, 100%, 46.1%)",
    yellow9: "hsl(53, 92.0%, 50.0%)",
    yellow10: "hsl(50, 100%, 48.5%)",
    yellow11: "hsl(42, 100%, 29.0%)",
    yellow12: "hsl(40, 55.0%, 13.5%)"
};
var mintA = {
    mintA1: "hsla(168, 95.4%, 42.8%, 0.024)",
    mintA2: "hsla(164, 99.1%, 47.1%, 0.063)",
    mintA3: "hsla(164, 99.3%, 43.5%, 0.118)",
    mintA4: "hsla(164, 99.3%, 41.3%, 0.177)",
    mintA5: "hsla(165, 99.0%, 37.5%, 0.248)",
    mintA6: "hsla(165, 100%, 35.0%, 0.353)",
    mintA7: "hsla(166, 99.9%, 33.5%, 0.510)",
    mintA8: "hsla(168, 99.6%, 34.6%, 0.750)",
    mintA9: "hsla(167, 99.9%, 39.5%, 0.561)",
    mintA10: "hsla(167, 99.7%, 37.4%, 0.589)",
    mintA11: "hsla(172, 99.8%, 22.4%, 0.922)",
    mintA12: "hsla(172, 99.7%, 8.8%, 0.965)"
};
var mint = {
    mint1: "hsl(165, 80.0%, 98.8%)",
    mint2: "hsl(164, 88.2%, 96.7%)",
    mint3: "hsl(164, 76.6%, 93.3%)",
    mint4: "hsl(165, 68.8%, 89.5%)",
    mint5: "hsl(165, 60.6%, 84.5%)",
    mint6: "hsl(165, 53.5%, 76.9%)",
    mint7: "hsl(166, 50.7%, 66.1%)",
    mint8: "hsl(168, 52.8%, 51.0%)",
    mint9: "hsl(167, 65.0%, 66.0%)",
    mint10: "hsl(167, 59.3%, 63.1%)",
    mint11: "hsl(172, 72.0%, 28.5%)",
    mint12: "hsl(172, 70.0%, 12.0%)"
};
var violetA = {
    violetA1: "hsla(270, 94.3%, 34.6%, 0.012)",
    violetA2: "hsla(252, 100%, 51.0%, 0.020)",
    violetA3: "hsla(254, 100%, 50.0%, 0.051)",
    violetA4: "hsla(251, 98.3%, 48.2%, 0.087)",
    violetA5: "hsla(252, 99.0%, 45.7%, 0.130)",
    violetA6: "hsla(251, 99.1%, 44.0%, 0.189)",
    violetA7: "hsla(252, 99.5%, 41.7%, 0.279)",
    violetA8: "hsla(252, 100%, 40.7%, 0.400)",
    violetA9: "hsla(252, 99.9%, 35.8%, 0.663)",
    violetA10: "hsla(251, 99.6%, 32.5%, 0.691)",
    violetA11: "hsla(250, 99.8%, 28.4%, 0.726)",
    violetA12: "hsla(254, 99.5%, 11.9%, 0.926)"
};
var violet = {
    violet1: "hsl(255, 65.0%, 99.4%)",
    violet2: "hsl(252, 100%, 99.0%)",
    violet3: "hsl(252, 96.9%, 97.4%)",
    violet4: "hsl(252, 91.5%, 95.5%)",
    violet5: "hsl(252, 85.1%, 93.0%)",
    violet6: "hsl(252, 77.8%, 89.4%)",
    violet7: "hsl(252, 71.0%, 83.7%)",
    violet8: "hsl(252, 68.6%, 76.3%)",
    violet9: "hsl(252, 56.0%, 57.5%)",
    violet10: "hsl(251, 48.1%, 53.5%)",
    violet11: "hsl(250, 43.0%, 48.0%)",
    violet12: "hsl(254, 60.0%, 18.5%)"
};
var redA = {
    redA1: "hsla(0, 100%, 51.0%, 0.012)",
    redA2: "hsla(0, 100%, 51.0%, 0.032)",
    redA3: "hsla(0, 100%, 50.2%, 0.063)",
    redA4: "hsla(0, 100%, 50.0%, 0.102)",
    redA5: "hsla(0, 99.9%, 47.5%, 0.153)",
    redA6: "hsla(0, 99.5%, 44.9%, 0.224)",
    redA7: "hsla(359, 99.7%, 42.7%, 0.318)",
    redA8: "hsla(359, 99.6%, 41.1%, 0.436)",
    redA9: "hsla(358, 99.9%, 42.9%, 0.718)",
    redA10: "hsla(358, 99.9%, 41.0%, 0.761)",
    redA11: "hsla(358, 99.8%, 38.3%, 0.832)",
    redA12: "hsla(355, 99.3%, 7.9%, 0.926)"
};
var red = {
    red1: "hsl(359, 100%, 99.4%)",
    red2: "hsl(359, 100%, 98.6%)",
    red3: "hsl(360, 100%, 96.8%)",
    red4: "hsl(360, 97.9%, 94.8%)",
    red5: "hsl(360, 90.2%, 91.9%)",
    red6: "hsl(360, 81.7%, 87.8%)",
    red7: "hsl(359, 74.2%, 81.7%)",
    red8: "hsl(359, 69.5%, 74.3%)",
    red9: "hsl(358, 75.0%, 59.0%)",
    red10: "hsl(358, 69.4%, 55.2%)",
    red11: "hsl(358, 65.0%, 48.7%)",
    red12: "hsl(354, 50.0%, 14.6%)"
};
//
var mauveDarkA = {
    mauveA1: "hsla(0, 0%, 0%, 0)",
    mauveA2: "hsla(240, 76.7%, 91.2%, 0.031)",
    mauveA3: "hsla(240, 86.0%, 95.8%, 0.061)",
    mauveA4: "hsla(240, 91.8%, 94.7%, 0.087)",
    mauveA5: "hsla(240, 91.5%, 95.8%, 0.113)",
    mauveA6: "hsla(240, 92.0%, 93.8%, 0.148)",
    mauveA7: "hsla(240, 94.8%, 95.3%, 0.191)",
    mauveA8: "hsla(249, 98.1%, 95.2%, 0.273)",
    mauveA9: "hsla(248, 97.6%, 96.2%, 0.416)",
    mauveA10: "hsla(248, 95.5%, 96.6%, 0.477)",
    mauveA11: "hsla(250, 98.0%, 98.0%, 0.615)",
    mauveA12: "hsla(240, 93.9%, 99.6%, 0.931)"
};
var plumDarkA = {
    plumA1: "hsla(0, 0%, 0%, 0)",
    plumA2: "hsla(300, 96.4%, 58.4%, 0.036)",
    plumA3: "hsla(300, 99.4%, 67.1%, 0.102)",
    plumA4: "hsla(295, 99.8%, 66.3%, 0.155)",
    plumA5: "hsla(295, 99.4%, 67.1%, 0.204)",
    plumA6: "hsla(294, 99.0%, 67.8%, 0.262)",
    plumA7: "hsla(294, 99.9%, 67.7%, 0.363)",
    plumA8: "hsla(292, 99.8%, 67.5%, 0.527)",
    plumA9: "hsla(292, 99.9%, 69.2%, 0.695)",
    plumA10: "hsla(295, 99.9%, 70.8%, 0.748)",
    plumA11: "hsla(300, 99.8%, 72.9%, 0.828)",
    plumA12: "hsla(300, 100%, 97.1%, 0.980)"
};
var crimsonDarkA = {
    crimsonA1: "hsla(0, 0%, 0%, 0)",
    crimsonA2: "hsla(336, 96.8%, 53.2%, 0.045)",
    crimsonA3: "hsla(335, 98.7%, 59.3%, 0.138)",
    crimsonA4: "hsla(336, 99.1%, 59.9%, 0.191)",
    crimsonA5: "hsla(335, 99.4%, 59.4%, 0.244)",
    crimsonA6: "hsla(335, 99.4%, 59.4%, 0.315)",
    crimsonA7: "hsla(336, 99.5%, 57.8%, 0.439)",
    crimsonA8: "hsla(336, 99.9%, 55.4%, 0.642)",
    crimsonA9: "hsla(336, 99.9%, 62.8%, 0.903)",
    crimsonA10: "hsla(339, 99.9%, 66.3%, 0.934)",
    crimsonA11: "hsla(341, 99.9%, 69.5%, 0.965)",
    crimsonA12: "hsla(327, 100%, 97.1%, 0.980)"
};
var blueDarkA = {
    blueA1: "hsla(0, 0%, 0%, 0)",
    blueA2: "hsla(221, 97.8%, 52.4%, 0.059)",
    blueA3: "hsla(215, 99.3%, 54.2%, 0.135)",
    blueA4: "hsla(215, 99.3%, 53.8%, 0.198)",
    blueA5: "hsla(213, 99.4%, 52.8%, 0.252)",
    blueA6: "hsla(212, 99.9%, 51.7%, 0.323)",
    blueA7: "hsla(211, 100%, 50.7%, 0.435)",
    blueA8: "hsla(211, 99.8%, 50.9%, 0.597)",
    blueA9: "hsla(205, 100%, 50.0%, 0.980)",
    blueA10: "hsla(208, 100%, 60.7%, 0.980)",
    blueA11: "hsla(209, 100%, 66.3%, 0.980)",
    blueA12: "hsla(196, 100%, 96.8%, 0.980)"
};
var greenDarkA = {
    greenA1: "hsla(0, 0%, 0%, 0)",
    greenA2: "hsla(169, 100%, 48.5%, 0.027)",
    greenA3: "hsla(162, 98.7%, 57.9%, 0.070)",
    greenA4: "hsla(158, 98.6%, 59.7%, 0.105)",
    greenA5: "hsla(158, 98.6%, 60.7%, 0.140)",
    greenA6: "hsla(156, 99.9%, 62.0%, 0.187)",
    greenA7: "hsla(154, 99.5%, 63.1%, 0.257)",
    greenA8: "hsla(152, 99.7%, 64.2%, 0.370)",
    greenA9: "hsla(151, 99.7%, 63.8%, 0.605)",
    greenA10: "hsla(152, 99.9%, 66.5%, 0.661)",
    greenA11: "hsla(151, 99.7%, 69.2%, 0.740)",
    greenA12: "hsla(137, 100%, 95.8%, 0.980)"
};
var yellowDarkA = {
    yellowA1: "hsla(0, 0%, 0%, 0)",
    yellowA2: "hsla(49, 100%, 49.1%, 0.027)",
    yellowA3: "hsla(45, 100%, 49.7%, 0.071)",
    yellowA4: "hsla(46, 100%, 49.7%, 0.111)",
    yellowA5: "hsla(47, 100%, 49.9%, 0.150)",
    yellowA6: "hsla(51, 100%, 49.8%, 0.199)",
    yellowA7: "hsla(51, 99.8%, 53.6%, 0.269)",
    yellowA8: "hsla(51, 100%, 49.9%, 0.371)",
    yellowA9: "hsla(53, 100%, 52.0%, 0.956)",
    yellowA10: "hsla(56, 100%, 68.4%, 0.980)",
    yellowA11: "hsla(48, 100%, 50.0%, 0.934)",
    yellowA12: "hsla(60, 100%, 91.8%, 0.980)"
};
var mintDarkA = {
    mintA1: "hsla(0, 0%, 0%, 0)",
    mintA2: "hsla(180, 100%, 49.2%, 0.031)",
    mintA3: "hsla(176, 100%, 49.7%, 0.070)",
    mintA4: "hsla(173, 100%, 49.7%, 0.105)",
    mintA5: "hsla(173, 100%, 49.8%, 0.144)",
    mintA6: "hsla(172, 100%, 49.8%, 0.192)",
    mintA7: "hsla(171, 100%, 49.9%, 0.266)",
    mintA8: "hsla(169, 100%, 49.9%, 0.366)",
    mintA9: "hsla(167, 99.8%, 75.0%, 0.870)",
    mintA10: "hsla(163, 99.9%, 80.7%, 0.948)",
    mintA11: "hsla(167, 99.9%, 58.7%, 0.796)",
    mintA12: "hsla(169, 100%, 96.2%, 0.980)"
};
var violetDarkA = {
    violetA1: "hsla(0, 0%, 0%, 0)",
    violetA2: "hsla(258, 98.2%, 61.0%, 0.054)",
    violetA3: "hsla(252, 98.8%, 65.8%, 0.148)",
    violetA4: "hsla(253, 99.7%, 65.7%, 0.219)",
    violetA5: "hsla(252, 99.7%, 66.4%, 0.286)",
    violetA6: "hsla(251, 99.7%, 66.2%, 0.371)",
    violetA7: "hsla(250, 99.7%, 66.3%, 0.514)",
    violetA8: "hsla(250, 99.7%, 66.1%, 0.733)",
    violetA9: "hsla(252, 99.9%, 70.3%, 0.786)",
    violetA10: "hsla(251, 99.9%, 72.9%, 0.844)",
    violetA11: "hsla(250, 100%, 77.9%, 0.980)",
    violetA12: "hsla(254, 100%, 97.5%, 0.980)"
};


/***/ }),

/***/ 1210:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 8045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _define_property = (__webpack_require__(9361)/* ["default"] */ .Z);
var _sliced_to_array = (__webpack_require__(4941)/* ["default"] */ .Z);
var _to_consumable_array = (__webpack_require__(3929)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _react = _interopRequireWildcard(__webpack_require__(7294));
var _head = _interopRequireDefault(__webpack_require__(5443));
var _imageConfig = __webpack_require__(9309);
var _useIntersection = __webpack_require__(7190);
var _imageConfigContext = __webpack_require__(9977);
var _utils = __webpack_require__(3794);
var _normalizeTrailingSlash = __webpack_require__(2392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _objectWithoutPropertiesLoose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _to_consumable_array(c.deviceSizes).concat(_to_consumable_array(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _objectWithoutPropertiesLoose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (experimentalUnoptimized) {
        unoptimized = true;
    }
    var ref = _sliced_to_array((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _sliced_to_array((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _define_property(_obj, imageSrcSetPropName, imgAttributes.srcSet), _define_property(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ref = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default"} || {}, _experimentalRemotePatterns = ref.experimentalRemotePatterns, experimentalRemotePatterns = _experimentalRemotePatterns === void 0 ? [] : _experimentalRemotePatterns, experimentalUnoptimized = ref.experimentalUnoptimized;
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default"};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _to_consumable_array(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _to_consumable_array(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _objectWithoutPropertiesLoose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    params.set("auto", params.get("auto") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 8418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _sliced_to_array = (__webpack_require__(4941)/* ["default"] */ .Z);
var _type_of = (__webpack_require__(5753)["default"]);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(7294));
var _router = __webpack_require__(6273);
var _addLocale = __webpack_require__(2725);
var _routerContext = __webpack_require__(3462);
var _appRouterContext = __webpack_require__(1018);
var _useIntersection = __webpack_require__(7190);
var _getDomainLocale = __webpack_require__(1210);
var _addBasePath = __webpack_require__(8684);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// @ts-ignore useTransition exist
var hasUseTransition = typeof _react.default.useTransition !== "undefined";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, startTransition) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // replace state instead of push if prop is present
        router[replace ? "replace" : "push"](href, as, {
            shallow: shallow,
            locale: locale,
            scroll: scroll
        });
    };
    if (startTransition) {
        startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _objectWithoutPropertiesLoose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var ref = _sliced_to_array(hasUseTransition ? // @ts-ignore useTransition exists
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.default.useTransition() : [], 2), /* isPending */ startTransition = ref[1];
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref1 = _react.default.useMemo(function() {
        var ref = _sliced_to_array((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref1.href, as = ref1.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref2 = _sliced_to_array((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref2[0], isVisible = ref2[1], resetVisible = ref2[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, appRouter ? startTransition : undefined);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 7190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _sliced_to_array = (__webpack_require__(4941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(7294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _sliced_to_array((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _sliced_to_array((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (unobserve.current) {
                unobserve.current();
                unobserve.current = undefined;
            }
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                unobserve.current = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
            }
            return function() {
                unobserve.current == null ? void 0 : unobserve.current();
                unobserve.current = undefined;
            };
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 1018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.FullAppTreeContext = exports.AppTreeContext = exports.AppRouterContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(7294));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var AppTreeContext = _react.default.createContext(null);
exports.AppTreeContext = AppTreeContext;
var FullAppTreeContext = _react.default.createContext(null);
exports.FullAppTreeContext = FullAppTreeContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 6089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(5988); //# sourceMappingURL=styled-jsx.js.map


/***/ }),

/***/ 2256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ App; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@yaireo/tagify/dist/tagify.css
var tagify = __webpack_require__(8535);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(3299);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/universal-cookie/node_modules/cookie/index.js
var cookie = __webpack_require__(8087);
;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie/* parse */.Q(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie/* parse */.Q(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/Cookies.js

/* harmony default export */ var react_cookie_es6_Cookies = (es6);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/CookiesContext.js


var CookiesContext = node_modules_react.createContext(new react_cookie_es6_Cookies());
var Provider = CookiesContext.Provider, Consumer = CookiesContext.Consumer;
/* harmony default export */ var es6_CookiesContext = (CookiesContext);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/CookiesProvider.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var CookiesProvider = /** @class */ (function (_super) {
    __extends(CookiesProvider, _super);
    function CookiesProvider(props) {
        var _this = _super.call(this, props) || this;
        if (props.cookies) {
            _this.cookies = props.cookies;
        }
        else {
            _this.cookies = new es6();
        }
        return _this;
    }
    CookiesProvider.prototype.render = function () {
        return node_modules_react.createElement(Provider, { value: this.cookies }, this.props.children);
    };
    return CookiesProvider;
}(node_modules_react.Component));
/* harmony default export */ var es6_CookiesProvider = (CookiesProvider);

// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(6703);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-geist-ui-context.js
var use_geist_ui_context = __webpack_require__(1108);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/themes/index.js
var esm_themes = __webpack_require__(6454);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/theme-context.js
var theme_context = __webpack_require__(3932);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/themes/themes.js + 3 modules
var themes = __webpack_require__(5736);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-all-themes/all-themes-context.js


var defaultAllThemesConfig = {
  themes: themes/* default.getPresets */.ZP.getPresets()
};
var AllThemesContext = /*#__PURE__*/node_modules_react.createContext(defaultAllThemesConfig);
var useAllThemes = function useAllThemes() {
  return React.useContext(AllThemesContext);
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/geist-provider/theme-provider.js







var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      themeType = _ref.themeType,
      _ref$themes = _ref.themes,
      themes = _ref$themes === void 0 ? [] : _ref$themes;

  var _useState = (0,node_modules_react.useState)({
    themes: esm_themes/* default.getPresets */.Z.getPresets()
  }),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      allThemes = _useState2[0],
      setAllThemes = _useState2[1];

  var currentTheme = (0,node_modules_react.useMemo)(function () {
    var theme = allThemes.themes.find(function (item) {
      return item.type === themeType;
    });
    if (theme) return theme;
    return esm_themes/* default.getPresetStaticTheme */.Z.getPresetStaticTheme();
  }, [allThemes, themeType]);
  (0,node_modules_react.useEffect)(function () {
    if (!(themes !== null && themes !== void 0 && themes.length)) return;
    setAllThemes(function (last) {
      var safeThemes = themes.filter(function (item) {
        return esm_themes/* default.isAvailableThemeType */.Z.isAvailableThemeType(item.type);
      });
      var nextThemes = esm_themes/* default.getPresets */.Z.getPresets().concat(safeThemes);
      return (0,esm_extends/* default */.Z)({}, last, {
        themes: nextThemes
      });
    });
  }, [themes]);
  return /*#__PURE__*/node_modules_react.createElement(AllThemesContext.Provider, {
    value: allThemes
  }, /*#__PURE__*/node_modules_react.createElement(theme_context/* ThemeContext.Provider */.N.Provider, {
    value: currentTheme
  }, children));
};

/* harmony default export */ var theme_provider = (ThemeProvider);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-current-state.js + 2 modules
var use_current_state = __webpack_require__(1052);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-portal.js + 1 modules
var use_portal = __webpack_require__(4123);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/shared/css-transition.js
var css_transition = __webpack_require__(1777);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/button/index.js
var esm_button = __webpack_require__(5718);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/prop-types.js
var prop_types = __webpack_require__(1139);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-toasts/helpers.js



var makeToastActions = function makeToastActions(actions, cancelHandle) {
  var handler = function handler(event, userHandler) {
    userHandler && userHandler(event, cancelHandle);
  };

  if (!actions || !actions.length) return null;
  return actions.map(function (action, index) {
    return /*#__PURE__*/node_modules_react.createElement(esm_button/* default */.Z, {
      auto: true,
      scale: 1 / 3,
      font: "13px",
      type: action.passive ? 'default' : 'secondary',
      key: "action-".concat(index),
      onClick: function onClick(event) {
        return handler(event, action.handler);
      }
    }, action.name);
  });
};
var getColors = function getColors(palette, type) {
  var colors = {
    "default": palette.background,
    secondary: palette.secondary,
    success: palette.success,
    warning: palette.warning,
    error: palette.error
  };
  var isDefault = !type || type === 'default';
  if (isDefault) return {
    bgColor: colors["default"],
    color: palette.foreground
  };
  /**
   * Prevent main color change in special types.
   * The color will only follow the theme when it is in the default type.
   */

  return {
    bgColor: colors[type],
    color: 'white'
  };
};
var toastPlacement = (0,prop_types/* tuple */.b)('topLeft', 'topRight', 'bottomLeft', 'bottomRight');
var isTopPlacement = function isTopPlacement(placement) {
  return "".concat(placement).toLowerCase().startsWith('top');
};
var isLeftPlacement = function isLeftPlacement(placement) {
  return "".concat(placement).toLowerCase().endsWith('left');
};
var getTranslateByPlacement = function getTranslateByPlacement(placement) {
  var translateInByPlacement = {
    topLeft: 'translate(-60px, -60px)',
    topRight: 'translate(60px, -60px)',
    bottomLeft: 'translate(-60px, 60px)',
    bottomRight: 'translate(60px, 60px)'
  };
  var translateOutByPlacement = {
    topLeft: 'translate(-50px, 15px) scale(0.85)',
    topRight: 'translate(50px, 15px) scale(0.85)',
    bottomLeft: 'translate(-50px, -15px) scale(0.85)',
    bottomRight: 'translate(50px, -15px) scale(0.85)'
  };
  return {
    enter: translateInByPlacement[placement],
    leave: translateOutByPlacement[placement]
  };
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-toasts/toast-item.js





var ToastItem = /*#__PURE__*/node_modules_react.memo(function (_ref) {
  var toast = _ref.toast,
      layout = _ref.layout;
  var theme = (0,use_theme/* default */.Z)();

  var _useMemo = (0,node_modules_react.useMemo)(function () {
    return getColors(theme.palette, toast.type);
  }, [theme.palette, toast.type]),
      color = _useMemo.color,
      bgColor = _useMemo.bgColor;

  var isReactNode = typeof toast.text !== 'string';
  var padding = layout.padding,
      margin = layout.margin,
      maxHeight = layout.maxHeight,
      maxWidth = layout.maxWidth,
      width = layout.width,
      placement = layout.placement;

  var _useMemo2 = (0,node_modules_react.useMemo)(function () {
    return getTranslateByPlacement(placement);
  }, [placement]),
      enter = _useMemo2.enter,
      leave = _useMemo2.leave;

  return /*#__PURE__*/node_modules_react.createElement(css_transition/* default */.Z, {
    name: "toast",
    visible: toast.visible,
    clearTime: 350
  }, /*#__PURE__*/node_modules_react.createElement("div", {
    key: toast.id,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1407001838", [width, maxWidth, maxHeight, theme.palette.foreground, bgColor, color, theme.layout.radius, theme.expressiveness.shadowSmall, theme.layout.gapHalf, enter, margin, padding, margin, padding, leave]]]) + " " + "toast"
  }, isReactNode ? toast.text : /*#__PURE__*/node_modules_react.createElement(node_modules_react.Fragment, null, /*#__PURE__*/node_modules_react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1407001838", [width, maxWidth, maxHeight, theme.palette.foreground, bgColor, color, theme.layout.radius, theme.expressiveness.shadowSmall, theme.layout.gapHalf, enter, margin, padding, margin, padding, leave]]]) + " " + "message"
  }, toast.text), /*#__PURE__*/node_modules_react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1407001838", [width, maxWidth, maxHeight, theme.palette.foreground, bgColor, color, theme.layout.radius, theme.expressiveness.shadowSmall, theme.layout.gapHalf, enter, margin, padding, margin, padding, leave]]]) + " " + "action"
  }, makeToastActions(toast.actions, toast.cancel))), /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "1407001838",
    dynamic: [width, maxWidth, maxHeight, theme.palette.foreground, bgColor, color, theme.layout.radius, theme.expressiveness.shadowSmall, theme.layout.gapHalf, enter, margin, padding, margin, padding, leave]
  }, ".toast.__jsx-style-dynamic-selector{width:".concat(width, ";max-width:").concat(maxWidth, ";max-height:").concat(maxHeight, ";display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:").concat(theme.palette.foreground, ";background-color:").concat(bgColor, ";color:").concat(color, ";border:0;border-radius:").concat(theme.layout.radius, ";opacity:1;box-shadow:").concat(theme.expressiveness.shadowSmall, ";-webkit-transition:all 350ms cubic-bezier(0.1,0.2,0.1,1);transition:all 350ms cubic-bezier(0.1,0.2,0.1,1);overflow:hidden;}.message.__jsx-style-dynamic-selector{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%;font-size:0.875em;display:-webkit-box;word-break:break-all;padding-right:").concat(theme.layout.gapHalf, ";overflow:hidden;max-height:100%;text-overflow:ellipsis;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-height:1.1rem;}.toast-enter.__jsx-style-dynamic-selector{opacity:0;height:0;padding:0;margin:0;-webkit-transform:").concat(enter, ";-ms-transform:").concat(enter, ";transform:").concat(enter, ";}.toast-enter-active.__jsx-style-dynamic-selector{opacity:1;height:auto;margin:").concat(margin, ";padding:").concat(padding, ";-webkit-transform:translate(0,0);-ms-transform:translate(0,0);transform:translate(0,0);}.toast-leave.__jsx-style-dynamic-selector{opacity:1;-webkit-transform:translate(0,0);-ms-transform:translate(0,0);transform:translate(0,0);height:auto;margin:").concat(margin, ";padding:").concat(padding, ";}.toast-leave-active.__jsx-style-dynamic-selector{opacity:0;-webkit-transform:").concat(leave, ";-ms-transform:").concat(leave, ";transform:").concat(leave, ";}"))));
});
/* harmony default export */ var toast_item = (ToastItem);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-toasts/toast-container.js













var ToastContainer = function ToastContainer() {
  var theme = (0,use_theme/* default */.Z)();
  var portal = (0,use_portal/* default */.Z)('toast');

  var _useCurrentState = (0,use_current_state/* default */.Z)(false),
      _useCurrentState2 = (0,slicedToArray/* default */.Z)(_useCurrentState, 3),
      setHovering = _useCurrentState2[1],
      hoveringRef = _useCurrentState2[2];

  var _useGeistUIContext = (0,use_geist_ui_context/* useGeistUIContext */.kW)(),
      toasts = _useGeistUIContext.toasts,
      updateToasts = _useGeistUIContext.updateToasts,
      toastLayout = _useGeistUIContext.toastLayout,
      lastUpdateToastId = _useGeistUIContext.lastUpdateToastId;

  var memoizedLayout = (0,node_modules_react.useMemo)(function () {
    return toastLayout;
  }, [toastLayout]);
  var toastElements = (0,node_modules_react.useMemo)(function () {
    return toasts.map(function (toast) {
      return /*#__PURE__*/node_modules_react.createElement(toast_item, {
        toast: toast,
        layout: memoizedLayout,
        key: toast._internalIdent
      });
    });
  }, [toasts, memoizedLayout]);
  var classNames = (0,node_modules_react.useMemo)(function () {
    return (0,use_classes/* default */.Z)('toasts', {
      top: isTopPlacement(toastLayout.placement),
      left: isLeftPlacement(toastLayout.placement)
    });
  }, [memoizedLayout]);

  var hoverHandler = function hoverHandler(isHovering) {
    setHovering(isHovering);

    if (isHovering) {
      return updateToasts(function (last) {
        return last.map(function (toast) {
          if (!toast.visible) return toast;
          toast._timeout && window.clearTimeout(toast._timeout);
          return (0,esm_extends/* default */.Z)({}, toast, {
            timeout: null
          });
        });
      });
    }

    updateToasts(function (last) {
      return last.map(function (toast, index) {
        if (!toast.visible) return toast;
        toast._timeout && window.clearTimeout(toast._timeout);
        return (0,esm_extends/* default */.Z)({}, toast, {
          _timeout: function () {
            var timer = window.setTimeout(function () {
              toast.cancel();
              window.clearTimeout(timer);
            }, toast.delay + index * 100);
            return timer;
          }()
        });
      });
    });
  };

  (0,node_modules_react.useEffect)(function () {
    var index = toasts.findIndex(function (r) {
      return r._internalIdent === lastUpdateToastId;
    });
    var toast = toasts[index];
    if (!toast || toast.visible || !hoveringRef.current) return;
    var hasVisible = toasts.find(function (r, i) {
      return i < index && r.visible;
    });
    if (hasVisible || !hoveringRef.current) return;
    hoverHandler(false);
  }, [toasts, lastUpdateToastId]);
  (0,node_modules_react.useEffect)(function () {
    var timeout = null;
    var timer = window.setInterval(function () {
      if (toasts.length === 0) return;
      timeout = window.setTimeout(function () {
        var allInvisible = !toasts.find(function (r) {
          return r.visible;
        });
        allInvisible && updateToasts(function () {
          return [];
        });
        timeout && clearTimeout(timeout);
      }, 350);
    }, 5000);
    return function () {
      timer && clearInterval(timer);
      timeout && clearTimeout(timeout);
    };
  }, [toasts]);
  if (!portal) return null;
  if (!toasts || toasts.length === 0) return null;
  return /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/node_modules_react.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return hoverHandler(true);
    },
    onMouseLeave: function onMouseLeave() {
      return hoverHandler(false);
    },
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["622610754", [theme.layout.gap, theme.layout.gap, theme.layout.gap, theme.layout.gap]]]) + " " + (classNames || "")
  }, toastElements, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "622610754",
    dynamic: [theme.layout.gap, theme.layout.gap, theme.layout.gap, theme.layout.gap]
  }, ".toasts.__jsx-style-dynamic-selector{position:fixed;width:auto;max-width:100%;right:".concat(theme.layout.gap, ";bottom:").concat(theme.layout.gap, ";z-index:2000;-webkit-transition:all 400ms ease;transition:all 400ms ease;box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}.top.__jsx-style-dynamic-selector{bottom:unset;-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;top:").concat(theme.layout.gap, ";}.left.__jsx-style-dynamic-selector{right:unset;left:").concat(theme.layout.gap, ";}"))), portal);
};

/* harmony default export */ var toast_container = (ToastContainer);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/geist-provider/geist-provider.js







var GeistProvider = function GeistProvider(_ref) {
  var themes = _ref.themes,
      themeType = _ref.themeType,
      children = _ref.children;

  var _useState = (0,node_modules_react.useState)(null),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      lastUpdateToastId = _useState2[0],
      setLastUpdateToastId = _useState2[1];

  var _useCurrentState = (0,use_current_state/* default */.Z)([]),
      _useCurrentState2 = (0,slicedToArray/* default */.Z)(_useCurrentState, 3),
      toasts = _useCurrentState2[0],
      setToasts = _useCurrentState2[1],
      toastsRef = _useCurrentState2[2];

  var _useCurrentState3 = (0,use_current_state/* default */.Z)(use_geist_ui_context/* defaultToastLayout */.TP),
      _useCurrentState4 = (0,slicedToArray/* default */.Z)(_useCurrentState3, 3),
      toastLayout = _useCurrentState4[0],
      setToastLayout = _useCurrentState4[1],
      toastLayoutRef = _useCurrentState4[2];

  var updateToasts = function updateToasts(fn) {
    var nextToasts = fn(toastsRef.current);
    setToasts(nextToasts);
  };

  var updateToastLayout = function updateToastLayout(fn) {
    var nextLayout = fn(toastLayoutRef.current);
    setToastLayout(nextLayout);
  };

  var updateLastToastId = function updateLastToastId(fn) {
    setLastUpdateToastId(fn());
  };

  var initialValue = (0,node_modules_react.useMemo)(function () {
    return {
      toasts: toasts,
      toastLayout: toastLayout,
      updateToasts: updateToasts,
      lastUpdateToastId: lastUpdateToastId,
      updateToastLayout: updateToastLayout,
      updateLastToastId: updateLastToastId
    };
  }, [toasts, toastLayout, lastUpdateToastId]);
  return /*#__PURE__*/node_modules_react.createElement(use_geist_ui_context/* GeistUIContent.Provider */.b2.Provider, {
    value: initialValue
  }, /*#__PURE__*/node_modules_react.createElement(theme_provider, {
    themes: themes,
    themeType: themeType
  }, children, /*#__PURE__*/node_modules_react.createElement(toast_container, null)));
};

/* harmony default export */ var geist_provider = (GeistProvider);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/geist-provider/index.js

/* harmony default export */ var esm_geist_provider = (geist_provider);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/styled-jsx-server.es.js

const { flushToHTML } = styled_jsx_es/* server */.fw


/* harmony default export */ var styled_jsx_server_es = (styled_jsx_es/* server */.fw);

;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/css-baseline/css-baseline.js





var CssBaseline = function CssBaseline(_ref) {
  var children = _ref.children;
  var theme = (0,use_theme/* default */.Z)();
  return /*#__PURE__*/node_modules_react.createElement(node_modules_react.Fragment, null, children, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "1357910706",
    dynamic: [theme.palette.background, theme.palette.foreground, theme.palette.background, theme.font.sans, theme.font.sans, theme.palette.link, theme.expressiveness.linkStyle, theme.expressiveness.linkHoverStyle, theme.layout.gapHalf, theme.layout.gapHalf, theme.layout.gapHalf, theme.layout.gap, theme.palette.foreground, theme.palette.accents_4, theme.palette.code, theme.font.mono, theme.layout.gap, theme.layout.gap, theme.layout.gap, theme.palette.accents_2, theme.layout.radius, theme.font.mono, theme.palette.foreground, theme.palette.accents_2, theme.palette.accents_1, theme.layout.gap, theme.layout.gap, theme.palette.accents_5, theme.palette.accents_1, theme.layout.radius, theme.palette.border, theme.palette.selection, theme.palette.foreground]
  }, "html,body{background-color:".concat(theme.palette.background, ";color:").concat(theme.palette.foreground, ";}html{font-size:16px;--geist-icons-background:").concat(theme.palette.background, ";}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility;font-size:1rem;line-height:1.5;margin:0;padding:0;min-height:100%;position:relative;overflow-x:hidden;font-family:").concat(theme.font.sans, ";}#__next{overflow-x:hidden;}*,*:before,*:after{box-sizing:inherit;text-rendering:geometricPrecision;-webkit-tap-highlight-color:transparent;}p,small{font-weight:400;color:inherit;-webkit-letter-spacing:-0.005625em;-moz-letter-spacing:-0.005625em;-ms-letter-spacing:-0.005625em;letter-spacing:-0.005625em;font-family:").concat(theme.font.sans, ";}p{margin:1em 0;font-size:1em;line-height:1.625em;}small{margin:0;line-height:1.5;font-size:0.875em;}b{font-weight:600;}span{font-size:inherit;color:inherit;font-weight:inherit;}img{max-width:100%;}a{cursor:pointer;font-size:inherit;-webkit-touch-callout:none;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-box-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:").concat(theme.palette.link, ";-webkit-text-decoration:").concat(theme.expressiveness.linkStyle, ";text-decoration:").concat(theme.expressiveness.linkStyle, ";}a:hover{-webkit-text-decoration:").concat(theme.expressiveness.linkHoverStyle, ";text-decoration:").concat(theme.expressiveness.linkHoverStyle, ";}ul,ol{padding:0;list-style-type:none;margin:").concat(theme.layout.gapHalf, " ").concat(theme.layout.gapHalf, " ").concat(theme.layout.gapHalf, " ").concat(theme.layout.gap, ";color:").concat(theme.palette.foreground, ";}ol{list-style-type:decimal;}li{margin-bottom:0.625em;font-size:1em;line-height:1.625em;}ul li:before{content:'\u2013';display:inline-block;color:").concat(theme.palette.accents_4, ";position:absolute;margin-left:-0.9375em;}h1,h2,h3,h4,h5,h6{color:inherit;margin:0 0 0.7rem 0;}h1{font-size:3rem;-webkit-letter-spacing:-0.02em;-moz-letter-spacing:-0.02em;-ms-letter-spacing:-0.02em;letter-spacing:-0.02em;line-height:1.5;font-weight:700;}h2{font-size:2.25rem;-webkit-letter-spacing:-0.02em;-moz-letter-spacing:-0.02em;-ms-letter-spacing:-0.02em;letter-spacing:-0.02em;font-weight:600;}h3{font-size:1.5rem;-webkit-letter-spacing:-0.02em;-moz-letter-spacing:-0.02em;-ms-letter-spacing:-0.02em;letter-spacing:-0.02em;font-weight:600;}h4{font-size:1.25rem;-webkit-letter-spacing:-0.02em;-moz-letter-spacing:-0.02em;-ms-letter-spacing:-0.02em;letter-spacing:-0.02em;font-weight:600;}h5{font-size:1rem;-webkit-letter-spacing:-0.01em;-moz-letter-spacing:-0.01em;-ms-letter-spacing:-0.01em;letter-spacing:-0.01em;font-weight:600;}h6{font-size:0.875rem;-webkit-letter-spacing:-0.005em;-moz-letter-spacing:-0.005em;-ms-letter-spacing:-0.005em;letter-spacing:-0.005em;font-weight:600;}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit;color:inherit;margin:0;}button:focus,input:focus,select:focus,textarea:focus{outline:none;}code{color:").concat(theme.palette.code, ";font-family:").concat(theme.font.mono, ";font-size:0.9em;white-space:pre-wrap;}code:before,code:after{content:'\\`';}pre{padding:calc(").concat(theme.layout.gap, " * 0.9) ").concat(theme.layout.gap, ";margin:").concat(theme.layout.gap, " 0;border:1px solid ").concat(theme.palette.accents_2, ";border-radius:").concat(theme.layout.radius, ";font-family:").concat(theme.font.mono, ";white-space:pre;overflow:auto;line-height:1.5;text-align:left;font-size:14px;-webkit-overflow-scrolling:touch;}pre code{color:").concat(theme.palette.foreground, ";font-size:1em;line-height:1.25em;white-space:pre;}pre code:before,pre code:after{display:none;}pre p{margin:0;}pre::-webkit-scrollbar{display:none;width:0;height:0;background:transparent;}hr{border-color:").concat(theme.palette.accents_2, ";}details{background-color:").concat(theme.palette.accents_1, ";border:none;}details:focus,details:hover,details:active{outline:none;}summary{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;list-style:none;outline:none;}summary::marker,summary::before,summary::-webkit-details-marker{display:none;}summary::-moz-list-bullet{font-size:0;}summary:focus,summary:hover,summary:active{outline:none;list-style:none;}blockquote{padding:calc(0.667 * ").concat(theme.layout.gap, ") ").concat(theme.layout.gap, ";color:").concat(theme.palette.accents_5, ";background-color:").concat(theme.palette.accents_1, ";border-radius:").concat(theme.layout.radius, ";margin:1.5em 0;border:1px solid ").concat(theme.palette.border, ";}blockquote *:first-child{margin-top:0;}blockquote *:last-child{margin-bottom:0;}::selection{background-color:").concat(theme.palette.selection, ";color:").concat(theme.palette.foreground, ";}")));
};

var MemoCssBaseline = /*#__PURE__*/node_modules_react.memo(CssBaseline);
MemoCssBaseline.flush = styled_jsx_server_es;
MemoCssBaseline.flushToHTML = flushToHTML;
/* harmony default export */ var css_baseline = (MemoCssBaseline);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-media-query/index.js + 1 modules
var use_media_query = __webpack_require__(8114);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/page/page-content.js


var _excluded = ["className", "children"];



var defaultProps = {
  className: ''
};

var PageContentComponent = function PageContentComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  return /*#__PURE__*/node_modules_react.createElement("main", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3887979816", [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, '100%'), SCALES.pt(3.125), SCALES.pr(0), SCALES.pb(3.125), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + (props && props.className != null && props.className || className || "")
  }), children, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3887979816",
    dynamic: [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, '100%'), SCALES.pt(3.125), SCALES.pr(0), SCALES.pb(3.125), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]
  }, "main.__jsx-style-dynamic-selector{font-size:".concat(SCALES.font(1), ";width:").concat(SCALES.width(1, '100%'), ";height:").concat(SCALES.height(1, '100%'), ";padding:").concat(SCALES.pt(3.125), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(3.125), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}")));
};

PageContentComponent.defaultProps = defaultProps;
PageContentComponent.displayName = 'GeistPageContent';
var PageContent = (0,with_scale/* default */.Z)(PageContentComponent);
/* harmony default export */ var page_content = (PageContent);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/collections.js
var collections = __webpack_require__(9265);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/page/page.js



var page_excluded = ["children", "render", "dotBackdrop", "className", "dotSize", "dotSpace"];







var renderMode = (0,prop_types/* tuple */.b)('default', 'effect', 'effect-seo');
var page_defaultProps = {
  render: 'default',
  dotBackdrop: false,
  dotSize: '1px',
  dotSpace: 1
};

var DotStyles = function DotStyles(_ref) {
  var dotSpace = _ref.dotSpace,
      dotSize = _ref.dotSize;
  var background = (0,node_modules_react.useMemo)(function () {
    return {
      position: "calc(".concat(dotSpace, " * 25px)"),
      size: "calc(".concat(dotSpace, " * 50px)")
    };
  }, [dotSpace]);
  return /*#__PURE__*/node_modules_react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["934717826", [dotSize, dotSize, background.position, background.position, background.size, background.size]]])
  }, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "934717826",
    dynamic: [dotSize, dotSize, background.position, background.position, background.size, background.size]
  }, "body{background-image:radial-gradient(#e3e3e3 ".concat(dotSize, ",transparent 0), radial-gradient(#e3e3e3 ").concat(dotSize, ",transparent 0);background-position:0 0,").concat(background.position, " ").concat(background.position, ";background-attachment:fixed;background-size:").concat(background.size, " ").concat(background.size, ";}")));
};

var PageComponent = function PageComponent(_ref2) {
  var children = _ref2.children,
      render = _ref2.render,
      dotBackdrop = _ref2.dotBackdrop,
      className = _ref2.className,
      dotSize = _ref2.dotSize,
      dotSpace = _ref2.dotSpace,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, page_excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var showDot = (0,node_modules_react.useMemo)(function () {
    if (theme.type === 'dark') return false;
    return dotBackdrop;
  }, [dotBackdrop, theme.type]);

  var _useState = (0,node_modules_react.useState)(render !== 'default'),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      preventRender = _useState2[0],
      setPreventRender = _useState2[1];

  (0,node_modules_react.useEffect)(function () {
    setPreventRender(false);
  }, []);

  if (preventRender) {
    var renderSEO = render === 'effect-seo';
    if (!renderSEO) return null;
    return /*#__PURE__*/node_modules_react.createElement("div", {
      "aria-hidden": "true",
      className: "jsx-3942095687" + " " + "hidden"
    }, children, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
      id: "3942095687"
    }, ".hidden.jsx-3942095687{opacity:0;display:none;}"));
  }

  var hasContent = (0,collections/* hasChild */.bJ)(children, page_content);
  return /*#__PURE__*/node_modules_react.createElement("section", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1515698274", [SCALES.font(1), SCALES.width(1, 'calc(100% - 100pt)'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(1.34), SCALES.pb(0), SCALES.pl(1.34), SCALES.mt(0), SCALES.mr(0, 'auto'), SCALES.mb(0), SCALES.ml(0, 'auto')]]]) + " " + (props && props.className != null && props.className || className || "")
  }), hasContent ? children : /*#__PURE__*/node_modules_react.createElement(page_content, null, children), showDot && /*#__PURE__*/node_modules_react.createElement(DotStyles, {
    dotSize: dotSize,
    dotSpace: dotSpace
  }), /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "1515698274",
    dynamic: [SCALES.font(1), SCALES.width(1, 'calc(100% - 100pt)'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(1.34), SCALES.pb(0), SCALES.pl(1.34), SCALES.mt(0), SCALES.mr(0, 'auto'), SCALES.mb(0), SCALES.ml(0, 'auto')]
  }, "section.__jsx-style-dynamic-selector{max-width:100vw;min-height:100vh;box-sizing:border-box;position:relative;font-size:".concat(SCALES.font(1), ";width:").concat(SCALES.width(1, 'calc(100% - 100pt)'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(1.34), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(1.34), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0, 'auto'), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0, 'auto'), ";}")));
};

PageComponent.defaultProps = page_defaultProps;
PageComponent.displayName = 'GeistPage';
var Page = (0,with_scale/* default */.Z)(PageComponent);
/* harmony default export */ var page = (Page);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/page/page-header.js


var page_header_excluded = ["children", "center", "className"];




var page_header_defaultProps = {
  center: false,
  className: ''
};

var PageHeaderComponent = function PageHeaderComponent(_ref) {
  var children = _ref.children,
      center = _ref.center,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, page_header_excluded);

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var classes = (0,use_classes/* default */.Z)({
    center: center
  }, className);
  return /*#__PURE__*/node_modules_react.createElement("header", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3053482948", [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), children, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3053482948",
    dynamic: [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]
  }, "header.__jsx-style-dynamic-selector{font-size:".concat(SCALES.font(1), ";width:").concat(SCALES.width(1, '100%'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.center.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}")));
};

PageHeaderComponent.defaultProps = page_header_defaultProps;
PageHeaderComponent.displayName = 'GeistPageHeader';
var PageHeader = (0,with_scale/* default */.Z)(PageHeaderComponent);
/* harmony default export */ var page_header = (PageHeader);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/page/page-footer.js


var page_footer_excluded = ["children"];



var page_footer_defaultProps = {
  className: ''
};

var PageFooterComponent = function PageFooterComponent(_ref) {
  var children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, page_footer_excluded);

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  return /*#__PURE__*/node_modules_react.createElement("footer", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3447440073", [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + (props && props.className != null && props.className || "")
  }), children, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3447440073",
    dynamic: [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]
  }, "footer.__jsx-style-dynamic-selector{position:absolute;bottom:0;font-size:".concat(SCALES.font(1), ";width:").concat(SCALES.width(1, '100%'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}")));
};

PageFooterComponent.defaultProps = page_footer_defaultProps;
PageFooterComponent.displayName = 'GeistPageFooter';
var PageFooter = (0,with_scale/* default */.Z)(PageFooterComponent);
/* harmony default export */ var page_footer = (PageFooter);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/page/index.js




page.Header = page_header;
page.Content = page_content;
page.Body = page_content;
page.Footer = page_footer;
/* harmony default export */ var esm_page = (page);
// EXTERNAL MODULE: ./components/genie/use_genie.tsx
var use_genie = __webpack_require__(121);
// EXTERNAL MODULE: ./pages/permalink_metadata.tsx
var permalink_metadata = __webpack_require__(8067);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-toasts/index.js + 1 modules
var use_toasts = __webpack_require__(5668);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/collapse/index.js + 5 modules
var collapse = __webpack_require__(9236);
// EXTERNAL MODULE: ./node_modules/swr/core/dist/index.mjs
var dist = __webpack_require__(5591);
;// CONCATENATED MODULE: ./utils/credit_calculation.ts
function timeEstimate(m) {
    var t = _timeEstimate(m);
    if (t < 60) {
        return "".concat(Math.round(t), " seconds");
    } else if (t < 60 * 60) {
        var _$m = "".concat(Math.round((t + 20) / 60));
        return _$m !== "1" ? "".concat(_$m, " minutes") : "".concat(_$m, " minute");
    } else {
        var h = "".concat(Math.round(t / 3600));
        return h !== "1" ? "".concat(h, " hours") : "".concat(h, " hour");
    }
}
function _timeEstimate(m) {
    switch(m.model){
        case "dalle":
            return 30;
        case "vqgan":
            return 100;
        case "diffuse":
            var _num_images;
            // We expect this to always be cold
            return 20 + 10 * ((_num_images = m.modelParams.num_images) !== null && _num_images !== void 0 ? _num_images : 1);
        case "verdant":
        case "waifu":
        case "verdant2":
            return 4 + 6 * verdantCreditCost(m);
    }
}
function creditCost(m) {
    switch(m.model){
        case "dalle":
            return 1;
        case "vqgan":
            return 10;
        case "diffuse":
            return latentCreditCost(m);
        case "verdant":
        case "verdant2":
        case "waifu":
            return verdantCreditCost(m);
    }
}
function latentCreditCost(m) {
    var _num_images;
    return 2 * ((_num_images = m.modelParams.num_images) !== null && _num_images !== void 0 ? _num_images : 1);
}
function verdantCreditCost(m) {
    var verdantParams = m.modelParams;
    var cost = 1;
    if (verdantParams.width == 768 && verdantParams.height == 576 || verdantParams.width == 576 && verdantParams.height == 768) {
        cost = 2;
    }
    var _num_images;
    cost *= (_num_images = verdantParams.num_images) !== null && _num_images !== void 0 ? _num_images : 1;
    cost *= verdantParams.ddim_steps / 50;
    return Math.round(cost * 10) / 10;
}

// EXTERNAL MODULE: ./utils/devtools.ts
var devtools = __webpack_require__(8250);
// EXTERNAL MODULE: ./utils/swr.ts
var swr = __webpack_require__(6792);
// EXTERNAL MODULE: ./components/modals/login_modal.tsx
var login_modal = __webpack_require__(9405);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/textarea/index.js + 1 modules
var esm_textarea = __webpack_require__(8676);
// EXTERNAL MODULE: ./utils/feed_types.ts
var feed_types = __webpack_require__(6967);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./components/genie/use_upload_image.tsx






function resizedSize(w, h) {
    var max_size = 704;
    var min_size = 512;
    var resize_mult = 64;
    // Downscale if needed
    // If the larger side is >704, find the scaling factor that makes it 704
    var scaling = max_size / (h > w ? h : w);
    if (scaling < 1) {
        h = h * scaling;
        w = w * scaling;
    }
    // Upscale if needed
    // If the larger side is <512, find the scaling factor that makes it 512
    var upscale_scaling = min_size / (h > w ? h : w);
    if (upscale_scaling > 1) {
        h = h * upscale_scaling;
        w = w * upscale_scaling;
    }
    return [
        Math.round(w / resize_mult) * resize_mult,
        Math.round(h / resize_mult) * resize_mult, 
    ];
}
var useUploadImage = function() {
    var ref = (0,node_modules_react.useState)(false), isUploading = ref[0], setIsUploading = ref[1];
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var setToast = (0,use_toasts/* default */.Z)().setToast;
    var uploadImage = (0,node_modules_react.useCallback)(function() {
        var _uploadImage = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(file) {
            var ext, uuid, url, image, objectUrl, promise;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        console.log(file);
                        if (file) {
                            _ctx.next = 4;
                            break;
                        }
                        genieDispatch({
                            type: "setInitImageURL",
                            initImageURL: undefined
                        });
                        return _ctx.abrupt("return");
                    case 4:
                        setIsUploading(true);
                        ext = file.name.split(".").pop();
                        uuid = crypto.randomUUID();
                        url = "https://user-upload-worker.drysys.workers.dev/".concat(uuid, ".").concat(ext);
                        image = new Image();
                        objectUrl = URL.createObjectURL(file);
                        image.src = objectUrl;
                        promise = new Promise(function(resolve, reject) {
                            image.onload = function() {
                                // Natural size is the actual image size regardless of rendering.
                                // The 'normal' `width`/`height` are for the **rendered** size.
                                var width = image.naturalWidth;
                                var height = image.naturalHeight;
                                // Resolve promise with the width and height
                                resolve({
                                    width: width,
                                    height: height
                                });
                            };
                        });
                        _ctx.prev = 12;
                        _ctx.next = 15;
                        return fetch(url, {
                            method: "PUT",
                            body: file,
                            headers: {
                                "Access-Control-Allow-Origin": "*"
                            }
                        }).then(function() {
                            genieDispatch({
                                type: "setInitImageURL",
                                initImageURL: url
                            });
                            setIsUploading(false);
                        });
                    case 15:
                        _ctx.next = 17;
                        return promise.then(function(param) {
                            var width = param.width, height = param.height;
                            var ref = (0,_sliced_to_array/* default */.Z)(resizedSize(width, height), 2), w = ref[0], h = ref[1];
                            genieDispatch({
                                type: "setImageSize",
                                height: h,
                                width: w
                            });
                        });
                    case 17:
                        _ctx.next = 25;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](12);
                        genieDispatch({
                            type: "setInitImageURL",
                            initImageURL: undefined
                        });
                        setIsUploading(false);
                        setToast({
                            text: "Failed to upload image",
                            type: "error"
                        });
                        console.log(_ctx.t0);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    12,
                    19
                ]
            ]);
        }));
        function uploadImage(file) {
            return _uploadImage.apply(this, arguments);
        }
        return uploadImage;
    }(), [
        genieDispatch,
        setToast,
        setIsUploading
    ]);
    return {
        uploadImage: uploadImage,
        isUploading: isUploading
    };
};

;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/promptbox.tsx






var PromptBox = function() {
    var params = (0,use_genie/* useGenie */.l9)();
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var ref = useUploadImage(), uploadImage = ref.uploadImage, isUploading = ref.isUploading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_textarea/* default */.Z, {
        width: "100%",
        height: "15vh",
        scale: 1.3,
        autoComplete: "off",
        placeholder: "What do you wish to see?",
        name: "prompt",
        value: params.sharedParams.prompts[0].text,
        onChange: function(e) {
            genieDispatch({
                type: "setText",
                text: e.target.value
            });
        },
        // Want to make it possible to paste an image in the prompt box
        // if the most recent clipboard item is an image
        // and have the genie switch to img2img mode and upload the image
        // but still paste text as normal if there isn't an image
        onPaste: function(e) {
            // Check to see if the most recent clipboard item is an image
            var item = e.clipboardData.items[0];
            if (item.type.indexOf("image") === 0) {
                e.preventDefault();
                if (params.selectedModel in feed_types/* img2img_models */.B) {
                    genieDispatch({
                        type: "setMode",
                        mode: "img2img"
                    });
                } else {
                    genieDispatch({
                        type: "switchModel",
                        model: feed_types/* img2img_models.0 */.B[0]
                    });
                    genieDispatch({
                        type: "setMode",
                        mode: "img2img"
                    });
                }
                // upload the image using the image picker
                uploadImage(item.getAsFile());
            }
        }
    });
};

// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/text/index.js + 2 modules
var esm_text = __webpack_require__(1151);
// EXTERNAL MODULE: ./components/genie/generate_button.tsx
var generate_button = __webpack_require__(1574);
// EXTERNAL MODULE: ./components/genie/genie_reducer.tsx
var genie_reducer = __webpack_require__(916);
;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/smart_button.tsx








var SmartButton = function(param) {
    var onClick = param.onClick, status = param.status;
    var genieParams = (0,use_genie/* useGenie */.l9)();
    var creditCostNum = creditCost((0,genie_reducer/* getSingleModelParams */.j7)(genieParams));
    var timeEstimateText = timeEstimate((0,genie_reducer/* getSingleModelParams */.j7)(genieParams));
    var theme = (0,use_theme/* default */.Z)();
    var disabled = (0,generate_button/* disabledForStatus */.HE)(status);
    var icon = (0,generate_button/* imageForStatus */.tZ)(status);
    var disabledSuccessStyle = disabled ? {
        backgroundColor: theme.palette.successLight,
        borderColor: theme.palette.successLight,
        color: "#fff"
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
        shadow: true,
        title: "Generate",
        type: "success",
        onClick: onClick,
        height: "4rem",
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, disabledSuccessStyle), {
            height: "4rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "none",
            width: "100%"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
                lineHeight: "1rem"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: "3rem",
                        width: "3rem",
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: icon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* default */.Z, {
                    font: "1.5rem",
                    pb: "0.3rem",
                    pr: "1rem",
                    children: [
                        "Generate",
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                            small: true,
                            children: "".concat(creditCostNum === 1 ? creditCostNum + " credit" : creditCostNum + " credits")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            style: {
                                display: "flex",
                                flexDirection: "row"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                    style: {
                                        fontFamily: "serif",
                                        height: "100%"
                                    },
                                    children: "~"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                    small: true,
                                    children: "".concat(timeEstimateText)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/description/index.js + 1 modules
var description = __webpack_require__(2050);
;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/labeled_param.tsx


var LabeledParam = function(param) {
    var label = param.label, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            width: "auto",
            minHeight: "4rem",
            display: "grid",
            gridTemplateAreas: '"description description" "content content"',
            gridTemplateRows: "auto 1fr",
            gridTemplateColumns: "auto auto",
            alignItems: "start",
            padding: "0.12rem",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    gridArea: "description",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    lineHeight: "1rem",
                    height: "2rem"
                },
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    gridArea: "content",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    height: "100%"
                },
                children: children && node_modules_react.Children.map(children, function(child) {
                    return child;
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/params_grid.tsx


var ParamsGrid = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            display: "grid",
            gridGap: "1rem",
            gridTemplateColumns: "repeat(auto-fit, minmax(12rem, 1fr))",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            height: "100%",
            paddingLeft: "0.5rem",
            paddingRight: "0.5rem"
        },
        children: children
    });
};

// EXTERNAL MODULE: ./components/genie/generator_subcomponents/slider.tsx
var slider = __webpack_require__(5913);
;// CONCATENATED MODULE: ./components/genie/model_generators/dalle_mini.tsx







var DalleMini = function() {
    // Individual model components like this one should grab params and pass down
    // primitive types to the subcomponents. Subcomponents are responsible for
    // dispatching actions to the store.
    // https://github.com/dryadsystems/sprkpnt/blob/main/api/params.md#dalle
    var params = (0,use_genie/* useGenie */.l9)();
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var dalleParams = params.allModelsParams[params.selectedModel];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ParamsGrid, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabeledParam, {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(description/* default */.Z, {
                title: "Guidance"
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slider/* Slider */.i, {
                value: dalleParams.cond_scale,
                min: 1.0,
                max: 12.0,
                step: 0.1,
                onChange: function(e) {
                    return genieDispatch({
                        type: "setCondScale",
                        condScale: e
                    });
                }
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/grid/index.js + 3 modules
var grid = __webpack_require__(6293);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/infoFill.js
var infoFill = __webpack_require__(5359);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-modal/index.js + 1 modules
var use_modal = __webpack_require__(9768);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-resize.js
var use_resize = __webpack_require__(6134);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-click-anywhere.js
var use_click_anywhere = __webpack_require__(895);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/tooltip/styles.js
var styles_getColors = function getColors(type, palette) {
  var colors = {
    "default": palette.background,
    success: palette.success,
    warning: palette.warning,
    error: palette.error,
    secondary: palette.secondary,
    dark: palette.foreground,
    lite: palette.background
  };
  var color = type === 'lite' || type === 'default' ? palette.foreground : palette.background;
  return {
    color: color,
    bgColor: colors[type]
  };
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/tooltip/placement.js
var defaultTooltipPosition = {
  top: '-1000px',
  left: '-1000px',
  transform: 'none'
};
var getPosition = function getPosition(placement, rect, offset) {
  var positions = {
    top: {
      top: "".concat(rect.top - offset, "px"),
      left: "".concat(rect.left + rect.width / 2, "px"),
      transform: 'translate(-50%, -100%)'
    },
    topStart: {
      top: "".concat(rect.top - offset, "px"),
      left: "".concat(rect.left, "px"),
      transform: 'translate(0, -100%)'
    },
    topEnd: {
      top: "".concat(rect.top - offset, "px"),
      left: "".concat(rect.left + rect.width, "px"),
      transform: 'translate(-100%, -100%)'
    },
    bottom: {
      top: "".concat(rect.bottom + offset, "px"),
      left: "".concat(rect.left + rect.width / 2, "px"),
      transform: 'translate(-50%, 0)'
    },
    bottomStart: {
      top: "".concat(rect.bottom + offset, "px"),
      left: "".concat(rect.left, "px"),
      transform: 'translate(0, 0)'
    },
    bottomEnd: {
      top: "".concat(rect.bottom + offset, "px"),
      left: "".concat(rect.left + rect.width, "px"),
      transform: 'translate(-100%, 0)'
    },
    left: {
      top: "".concat(rect.top + rect.height / 2, "px"),
      left: "".concat(rect.left - offset, "px"),
      transform: 'translate(-100%, -50%)'
    },
    leftStart: {
      top: "".concat(rect.top, "px"),
      left: "".concat(rect.left - offset, "px"),
      transform: 'translate(-100%, 0)'
    },
    leftEnd: {
      top: "".concat(rect.top + rect.height, "px"),
      left: "".concat(rect.left - offset, "px"),
      transform: 'translate(-100%, -100%)'
    },
    right: {
      top: "".concat(rect.top + rect.height / 2, "px"),
      left: "".concat(rect.right + offset, "px"),
      transform: 'translate(0, -50%)'
    },
    rightStart: {
      top: "".concat(rect.top, "px"),
      left: "".concat(rect.right + offset, "px"),
      transform: 'translate(0, 0)'
    },
    rightEnd: {
      top: "".concat(rect.top + rect.height, "px"),
      left: "".concat(rect.right + offset, "px"),
      transform: 'translate(0, -100%)'
    }
  };
  return positions[placement] || positions.top;
};
var getIconPosition = function getIconPosition(placement, offsetX, offsetY) {
  var offsetAbsolute = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '3px';
  var positions = {
    top: {
      top: 'auto',
      right: 'auto',
      left: '50%',
      bottom: "".concat(offsetAbsolute),
      transform: 'translate(-50%, 100%) rotate(-90deg)'
    },
    topStart: {
      top: 'auto',
      right: 'auto',
      left: "".concat(offsetX),
      bottom: "".concat(offsetAbsolute),
      transform: 'translate(0, 100%) rotate(-90deg)'
    },
    topEnd: {
      top: 'auto',
      right: "".concat(offsetX),
      left: 'auto',
      bottom: "".concat(offsetAbsolute),
      transform: 'translate(0, 100%) rotate(-90deg)'
    },
    bottom: {
      top: "".concat(offsetAbsolute),
      right: 'auto',
      left: '50%',
      bottom: 'auto',
      transform: 'translate(-50%, -100%) rotate(90deg)'
    },
    bottomStart: {
      top: "".concat(offsetAbsolute),
      right: 'auto',
      left: "".concat(offsetX),
      bottom: 'auto',
      transform: 'translate(0, -100%) rotate(90deg)'
    },
    bottomEnd: {
      top: "".concat(offsetAbsolute),
      right: "".concat(offsetX),
      left: 'auto',
      bottom: 'auto',
      transform: 'translate(0, -100%) rotate(90deg)'
    },
    left: {
      top: '50%',
      right: '0',
      left: 'auto',
      bottom: 'auto',
      transform: 'translate(100%, -50%) rotate(180deg)'
    },
    leftStart: {
      top: "".concat(offsetY),
      right: '0',
      left: 'auto',
      bottom: 'auto',
      transform: 'translate(100%, -50%) rotate(180deg)'
    },
    leftEnd: {
      top: 'auto',
      right: '0',
      left: 'auto',
      bottom: "".concat(offsetY),
      transform: 'translate(100%, 50%) rotate(180deg)'
    },
    right: {
      top: '50%',
      right: 'auto',
      left: '0',
      bottom: 'auto',
      transform: 'translate(-100%, -50%) rotate(0deg)'
    },
    rightStart: {
      top: "".concat(offsetY),
      right: 'auto',
      left: '0',
      bottom: 'auto',
      transform: 'translate(-100%, -50%) rotate(0deg)'
    },
    rightEnd: {
      top: 'auto',
      right: 'auto',
      left: '0',
      bottom: "".concat(offsetY),
      transform: 'translate(-100%, 50%) rotate(0deg)'
    }
  };
  return positions[placement] || positions.top;
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/tooltip/tooltip-icon.js





var TooltipIcon = function TooltipIcon(_ref) {
  var placement = _ref.placement,
      shadow = _ref.shadow;
  var theme = (0,use_theme/* default */.Z)();

  var _useMemo = (0,node_modules_react.useMemo)(function () {
    return getIconPosition(placement, 'var(--tooltip-icon-offset-x)', 'var(--tooltip-icon-offset-y)');
  }, [placement]),
      transform = _useMemo.transform,
      top = _useMemo.top,
      left = _useMemo.left,
      right = _useMemo.right,
      bottom = _useMemo.bottom;

  var bgColorWithDark = (0,node_modules_react.useMemo)(function () {
    if (!shadow || theme.type !== 'dark') return 'var(--tooltip-content-bg)';
    return theme.palette.accents_2;
  }, [theme.type, shadow]);
  return /*#__PURE__*/node_modules_react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2440507693", [bgColorWithDark, left, top, right, bottom, transform]]])
  }, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2440507693",
    dynamic: [bgColorWithDark, left, top, right, bottom, transform]
  }, "span.__jsx-style-dynamic-selector{width:0;height:0;border-style:solid;border-width:6px 7px 6px 0;border-color:transparent ".concat(bgColorWithDark, " transparent transparent;position:absolute;left:").concat(left, ";top:").concat(top, ";right:").concat(right, ";bottom:").concat(bottom, ";-webkit-transform:").concat(transform, ";-ms-transform:").concat(transform, ";transform:").concat(transform, ";}")));
};

/* harmony default export */ var tooltip_icon = (TooltipIcon);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/tooltip/helper.js

var defaultRect = {
  top: -1000,
  left: -1000,
  right: -1000,
  bottom: -1000,
  width: 0,
  height: 0
};
var getRect = function getRect(ref) {
  if (!ref || !ref.current) return defaultRect;
  var rect = ref.current.getBoundingClientRect();
  return (0,esm_extends/* default */.Z)({}, rect, {
    width: rect.width || rect.right - rect.left,
    height: rect.height || rect.bottom - rect.top,
    top: rect.top + document.documentElement.scrollTop,
    bottom: rect.bottom + document.documentElement.scrollTop,
    left: rect.left + document.documentElement.scrollLeft,
    right: rect.right + document.documentElement.scrollLeft
  });
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/tooltip/tooltip-content.js
















var TooltipContent = function TooltipContent(_ref) {
  var children = _ref.children,
      parent = _ref.parent,
      visible = _ref.visible,
      offset = _ref.offset,
      iconOffset = _ref.iconOffset,
      placement = _ref.placement,
      type = _ref.type,
      className = _ref.className,
      hideArrow = _ref.hideArrow;
  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var el = (0,use_portal/* default */.Z)('tooltip');
  var selfRef = (0,node_modules_react.useRef)(null);

  var _useState = (0,node_modules_react.useState)(defaultTooltipPosition),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      rect = _useState2[0],
      setRect = _useState2[1];

  var colors = (0,node_modules_react.useMemo)(function () {
    return styles_getColors(type, theme.palette);
  }, [type, theme.palette]);
  var hasShadow = type === 'default';
  var classes = (0,use_classes/* default */.Z)('tooltip-content', className);
  if (!parent) return null;

  var updateRect = function updateRect() {
    var position = getPosition(placement, getRect(parent), offset);
    setRect(position);
  };

  (0,use_resize/* default */.Z)(updateRect);
  (0,use_click_anywhere/* default */.Z)(function () {
    return updateRect();
  });
  (0,node_modules_react.useEffect)(function () {
    updateRect();
  }, [visible]);

  var preventHandler = function preventHandler(event) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  };

  if (!el) return null;
  return /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/node_modules_react.createElement(css_transition/* default */.Z, {
    visible: visible
  }, /*#__PURE__*/node_modules_react.createElement("div", {
    ref: selfRef,
    onClick: preventHandler,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2901945249", [iconOffset.x, iconOffset.y, colors.bgColor, rect.top, rect.left, rect.transform, colors.color, theme.layout.radius, theme.palette.border, hasShadow ? theme.expressiveness.shadowMedium : 'none', SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.font(1), SCALES.pt(0.65), SCALES.pr(0.9), SCALES.pb(0.65), SCALES.pl(0.9)]]]) + " " + (classes || "")
  }, /*#__PURE__*/node_modules_react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2901945249", [iconOffset.x, iconOffset.y, colors.bgColor, rect.top, rect.left, rect.transform, colors.color, theme.layout.radius, theme.palette.border, hasShadow ? theme.expressiveness.shadowMedium : 'none', SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.font(1), SCALES.pt(0.65), SCALES.pr(0.9), SCALES.pb(0.65), SCALES.pl(0.9)]]]) + " " + "inner"
  }, !hideArrow && /*#__PURE__*/node_modules_react.createElement(tooltip_icon, {
    placement: placement,
    shadow: hasShadow
  }), children), /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2901945249",
    dynamic: [iconOffset.x, iconOffset.y, colors.bgColor, rect.top, rect.left, rect.transform, colors.color, theme.layout.radius, theme.palette.border, hasShadow ? theme.expressiveness.shadowMedium : 'none', SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.font(1), SCALES.pt(0.65), SCALES.pr(0.9), SCALES.pb(0.65), SCALES.pl(0.9)]
  }, ".tooltip-content.__jsx-style-dynamic-selector{--tooltip-icon-offset-x:".concat(iconOffset.x, ";--tooltip-icon-offset-y:").concat(iconOffset.y, ";--tooltip-content-bg:").concat(colors.bgColor, ";box-sizing:border-box;position:absolute;top:").concat(rect.top, ";left:").concat(rect.left, ";-webkit-transform:").concat(rect.transform, ";-ms-transform:").concat(rect.transform, ";transform:").concat(rect.transform, ";background-color:var(--tooltip-content-bg);color:").concat(colors.color, ";border-radius:").concat(theme.layout.radius, ";border:1px solid ").concat(theme.palette.border, ";padding:0;z-index:1000;box-shadow:").concat(hasShadow ? theme.expressiveness.shadowMedium : 'none', ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";}.inner.__jsx-style-dynamic-selector{box-sizing:border-box;position:relative;font-size:").concat(SCALES.font(1), ";padding:").concat(SCALES.pt(0.65), " ").concat(SCALES.pr(0.9), " ").concat(SCALES.pb(0.65), " ").concat(SCALES.pl(0.9), ";height:100%;}")))), el);
};

/* harmony default export */ var tooltip_content = (TooltipContent);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-click-away/use-click-away.js


var useClickAway = function useClickAway(ref, handler) {
  var handlerRef = (0,node_modules_react.useRef)(handler);
  (0,node_modules_react.useEffect)(function () {
    handlerRef.current = handler;
  }, [handler]);
  (0,node_modules_react.useEffect)(function () {
    var callback = function callback(event) {
      var el = ref.current;
      if (!event || !el || el.contains(event.target)) return;
      handlerRef.current(event);
    };

    document.addEventListener('click', callback);
    return function () {
      return document.removeEventListener('click', callback);
    };
  }, [ref]);
};

/* harmony default export */ var use_click_away = (useClickAway);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-click-away/index.js

/* harmony default export */ var esm_use_click_away = (use_click_away);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/utils/use-click-away.js

/* harmony default export */ var utils_use_click_away = (esm_use_click_away);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/tooltip/tooltip.js



var tooltip_excluded = ["children", "initialVisible", "text", "offset", "placement", "portalClassName", "enterDelay", "leaveDelay", "trigger", "type", "className", "onVisibleChange", "hideArrow", "visible"];







var tooltip_defaultProps = {
  initialVisible: false,
  hideArrow: false,
  type: 'default',
  trigger: 'hover',
  placement: 'top',
  enterDelay: 100,
  leaveDelay: 150,
  offset: 12,
  className: '',
  portalClassName: '',
  onVisibleChange: function () {}
};

var TooltipComponent = function TooltipComponent(_ref) {
  var children = _ref.children,
      initialVisible = _ref.initialVisible,
      text = _ref.text,
      offset = _ref.offset,
      placement = _ref.placement,
      portalClassName = _ref.portalClassName,
      enterDelay = _ref.enterDelay,
      leaveDelay = _ref.leaveDelay,
      trigger = _ref.trigger,
      type = _ref.type,
      className = _ref.className,
      onVisibleChange = _ref.onVisibleChange,
      hideArrow = _ref.hideArrow,
      customVisible = _ref.visible,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, tooltip_excluded);

  var timer = (0,node_modules_react.useRef)();
  var ref = (0,node_modules_react.useRef)(null);

  var _useState = (0,node_modules_react.useState)(initialVisible),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var iconOffset = (0,node_modules_react.useMemo)(function () {
    if (!(ref !== null && ref !== void 0 && ref.current)) return {
      x: '0.75em',
      y: '0.75em'
    };
    var rect = getRect(ref);
    return {
      x: "".concat(rect.width ? rect.width / 2 : 0, "px"),
      y: "".concat(rect.height ? rect.height / 2 : 0, "px")
    };
  }, [ref === null || ref === void 0 ? void 0 : ref.current]);
  var contentProps = {
    type: type,
    visible: visible,
    offset: offset,
    placement: placement,
    hideArrow: hideArrow,
    iconOffset: iconOffset,
    parent: ref,
    className: portalClassName
  };

  var changeVisible = function changeVisible(nextState) {
    var clear = function clear() {
      clearTimeout(timer.current);
      timer.current = undefined;
    };

    var handler = function handler(nextState) {
      setVisible(nextState);
      onVisibleChange(nextState);
      clear();
    };

    clear();

    if (nextState) {
      timer.current = window.setTimeout(function () {
        return handler(true);
      }, enterDelay);
      return;
    }

    var leaveDelayWithoutClick = trigger === 'click' ? 0 : leaveDelay;
    timer.current = window.setTimeout(function () {
      return handler(false);
    }, leaveDelayWithoutClick);
  };

  var mouseEventHandler = function mouseEventHandler(next) {
    return trigger === 'hover' && changeVisible(next);
  };

  var clickEventHandler = function clickEventHandler() {
    return trigger === 'click' && changeVisible(!visible);
  };

  utils_use_click_away(ref, function () {
    return trigger === 'click' && changeVisible(false);
  });
  (0,node_modules_react.useEffect)(function () {
    if (customVisible === undefined) return;
    changeVisible(customVisible);
  }, [customVisible]);
  return /*#__PURE__*/node_modules_react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: ref,
    onClick: clickEventHandler,
    onMouseEnter: function onMouseEnter() {
      return mouseEventHandler(true);
    },
    onMouseLeave: function onMouseLeave() {
      return mouseEventHandler(false);
    }
  }, props, {
    className: "jsx-418573366" + " " + (props && props.className != null && props.className || (0,use_classes/* default */.Z)('tooltip', className) || "")
  }), children, /*#__PURE__*/node_modules_react.createElement(tooltip_content, contentProps, text), /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "418573366"
  }, ".tooltip.jsx-418573366{width:-webkit-max-content;width:-moz-max-content;width:max-content;display:inline-block;}"));
};

TooltipComponent.defaultProps = tooltip_defaultProps;
TooltipComponent.displayName = 'GeistTooltip';
var Tooltip = (0,with_scale/* default */.Z)(TooltipComponent);
/* harmony default export */ var tooltip = (Tooltip);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/popover/popover-context.js

var defaultContext = {
  disableItemsAutoClose: false,
  onItemClick: function onItemClick() {}
};
var PopoverContext = /*#__PURE__*/node_modules_react.createContext(defaultContext);
var usePopoverContext = function usePopoverContext() {
  return (0,node_modules_react.useContext)(PopoverContext);
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/popover/popover.js



var popover_excluded = ["content", "children", "trigger", "placement", "initialVisible", "portalClassName", "disableItemsAutoClose", "onVisibleChange", "visible"];







var popover_defaultProps = {
  disableItemsAutoClose: false,
  trigger: 'click',
  placement: 'bottom',
  portalClassName: '',
  initialVisible: false,
  hideArrow: false,
  type: 'default',
  enterDelay: 100,
  leaveDelay: 150,
  offset: 12,
  className: '',
  onVisibleChange: function () {}
};

var PopoverComponent = function PopoverComponent(_ref) {
  var content = _ref.content,
      children = _ref.children,
      trigger = _ref.trigger,
      placement = _ref.placement,
      initialVisible = _ref.initialVisible,
      portalClassName = _ref.portalClassName,
      disableItemsAutoClose = _ref.disableItemsAutoClose,
      onVisibleChange = _ref.onVisibleChange,
      customVisible = _ref.visible,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, popover_excluded);

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var _useState = (0,node_modules_react.useState)(initialVisible),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var textNode = (0,node_modules_react.useMemo)(function () {
    return (0,collections/* getReactNode */.P4)(content);
  }, [content]);

  var onChildClick = function onChildClick() {
    onPopoverVisibleChange(false);
  };

  var value = (0,node_modules_react.useMemo)(function () {
    return {
      onItemClick: onChildClick,
      disableItemsAutoClose: disableItemsAutoClose
    };
  }, [disableItemsAutoClose]);
  var classes = (0,use_classes/* default */.Z)('popover', portalClassName);

  var onPopoverVisibleChange = function onPopoverVisibleChange(next) {
    setVisible(next);
    onVisibleChange(next);
  };

  (0,node_modules_react.useEffect)(function () {
    if (customVisible === undefined) return;
    onPopoverVisibleChange(customVisible);
  }, [customVisible]);
  return /*#__PURE__*/node_modules_react.createElement(PopoverContext.Provider, {
    value: value
  }, /*#__PURE__*/node_modules_react.createElement(tooltip, (0,esm_extends/* default */.Z)({
    text: textNode,
    trigger: trigger,
    placement: placement,
    portalClassName: classes,
    visible: visible,
    onVisibleChange: onPopoverVisibleChange
  }, props), children, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "622655983",
    dynamic: [SCALES.pt(0.9), SCALES.pr(0), SCALES.pb(0.9), SCALES.pl(0)]
  }, ".tooltip-content.popover > .inner{padding:".concat(SCALES.pt(0.9), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0.9), " ").concat(SCALES.pl(0), ";}"))));
};

PopoverComponent.defaultProps = popover_defaultProps;
PopoverComponent.displayName = 'GeistPopover';
var Popover = (0,with_scale/* default */.Z)(PopoverComponent);
/* harmony default export */ var popover = (Popover);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/popover/popover-item.js


var popover_item_excluded = ["children", "line", "title", "className", "onClick", "disableAutoClose"];






var popover_item_defaultProps = {
  line: false,
  title: false,
  disableAutoClose: false,
  className: ''
};

var PopoverItemComponent = function PopoverItemComponent(_ref) {
  var children = _ref.children,
      line = _ref.line,
      title = _ref.title,
      className = _ref.className,
      onClick = _ref.onClick,
      disableAutoClose = _ref.disableAutoClose,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, popover_item_excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var _usePopoverContext = usePopoverContext(),
      disableItemsAutoClose = _usePopoverContext.disableItemsAutoClose,
      onItemClick = _usePopoverContext.onItemClick;

  var hasHandler = Boolean(onClick);
  var dontCloseByClick = disableAutoClose || disableItemsAutoClose || title || line;
  var classes = (0,use_classes/* default */.Z)('item', {
    line: line,
    title: title
  }, className);

  var clickHandler = function clickHandler(event) {
    onClick && onClick(event);

    if (dontCloseByClick) {
      return event.stopPropagation();
    }

    onItemClick(event);
  };

  return /*#__PURE__*/node_modules_react.createElement(node_modules_react.Fragment, null, /*#__PURE__*/node_modules_react.createElement("div", (0,esm_extends/* default */.Z)({
    onClick: clickHandler
  }, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["190621384", [theme.palette.accents_5, SCALES.font(0.875), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.pt(0.5), SCALES.pr(0.75), SCALES.pb(0.5), SCALES.pl(0.75), hasHandler ? 'pointer' : 'default', theme.palette.foreground, theme.palette.border, SCALES.height(0.0625), SCALES.mt(0.35), SCALES.mr(0), SCALES.mb(0.35), SCALES.ml(0), SCALES.width(1, '100%'), SCALES.font(0.925), theme.palette.foreground]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), children, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "190621384",
    dynamic: [theme.palette.accents_5, SCALES.font(0.875), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.pt(0.5), SCALES.pr(0.75), SCALES.pb(0.5), SCALES.pl(0.75), hasHandler ? 'pointer' : 'default', theme.palette.foreground, theme.palette.border, SCALES.height(0.0625), SCALES.mt(0.35), SCALES.mr(0), SCALES.mb(0.35), SCALES.ml(0), SCALES.width(1, '100%'), SCALES.font(0.925), theme.palette.foreground]
  }, ".item.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;box-sizing:border-box;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:".concat(theme.palette.accents_5, ";-webkit-transition:color,background-color 150ms linear;transition:color,background-color 150ms linear;line-height:1.25em;font-size:").concat(SCALES.font(0.875), ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";padding:").concat(SCALES.pt(0.5), " ").concat(SCALES.pr(0.75), " ").concat(SCALES.pb(0.5), " ").concat(SCALES.pl(0.75), ";cursor:").concat(hasHandler ? 'pointer' : 'default', ";}.item.__jsx-style-dynamic-selector:hover{color:").concat(theme.palette.foreground, ";}.item.line.__jsx-style-dynamic-selector{line-height:0;padding:0;background-color:").concat(theme.palette.border, ";height:").concat(SCALES.height(0.0625), ";margin:").concat(SCALES.mt(0.35), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0.35), " ").concat(SCALES.ml(0), ";width:").concat(SCALES.width(1, '100%'), ";}.item.title.__jsx-style-dynamic-selector{font-weight:500;font-size:").concat(SCALES.font(0.925), ";color:").concat(theme.palette.foreground, ";}"))), title && /*#__PURE__*/node_modules_react.createElement(PopoverItem, {
    line: true,
    title: false
  }));
};

PopoverItemComponent.defaultProps = popover_item_defaultProps;
PopoverItemComponent.displayName = 'GeistPopoverItem';
var PopoverItem = (0,with_scale/* default */.Z)(PopoverItemComponent);
/* harmony default export */ var popover_item = (PopoverItem);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/popover/index.js


popover.Item = popover_item;
popover.Option = popover_item;
/* harmony default export */ var esm_popover = (popover);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/modal/index.js + 6 modules
var modal = __webpack_require__(9037);
;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/info_popup.tsx





var InfoPopup = function(param) {
    var content = param.content, width = param.width;
    //const [aspectRatio, setAspectRatio] = useState<AspectRatio>(params.aspect_ratio as AspectRatio);
    var upMD = (0,use_media_query/* default */.Z)("md", {
        match: "up"
    });
    var ref = (0,use_modal/* default */.Z)(), visible = ref.visible, setVisible = ref.setVisible, bindings = ref.bindings;
    var popoverContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_popover.Item, {
        width: width !== null && width !== void 0 ? width : "20vw",
        children: content
    });
    if (upMD) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_popover, {
                content: popoverContent,
                trigger: "hover",
                placement: "right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(infoFill/* default */.Z, {
                    color: "grey",
                    size: 18
                })
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(infoFill/* default */.Z, {
                    onClick: function() {
                        return setVisible(true);
                    },
                    color: "grey",
                    size: 18
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bindings), {
                    children: content
                }))
            ]
        });
    }
};

;// CONCATENATED MODULE: ./public/images/examples/scale/1.png
/* harmony default export */ var _1 = ({"src":"/_next/static/media/1.73353f1a.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEV6ZkxFNymJc15sWUSgf16AZkqUeV+RclJQQC9hUkB0W0OsiWaKb1OliGs5Kxq2lHRZRzOSgG5iSS+YdlB6N/GpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVQImQXBiQHAIAgAsUNBwL/t/rs24ZkU1hkUWitnKJiuNtXBfLRwh5C3iyspe8v9jH4joqpjtWZm9h8//QHUCDk00QAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/examples/scale/5.png
/* harmony default export */ var _5 = ({"src":"/_next/static/media/5.e888441a.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAWlBMVEVXQB5SPiKyfERvUzVkSBy7fDpMOh+md0OvdCtzSxtGOhvSiEs/JQ5bPylBNx/Ij11zYxqWYiSIZTWSaEHlkVQuKRt0Ogrqomk6Pz9oPxOGWx97aVWcbjRzTCuU+BBWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVQImQXBBwKAIAwEsAMKbdnDrf9/pwleR2u1c4OjybalBNLPWu896BnChQVd78NdLIh5z2VKR4g1QIcCBjChmh9oXgKerdvzUQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/examples/scale/10.png
/* harmony default export */ var _10 = ({"src":"/_next/static/media/10.95fca59d.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAflBMVEVBNw2dZxbvlD4+HxL4iDiSWSNwSAvIeyhhOQtWPwjeijhyPhZXSw+zhDtMSRdAPg1GTQ5kZQdbRjJcPyJSOxf3nE2AWA2vZCm6dDC6eBfShilwMQGsfDYtKBxsSTHjhixoEABLS0mif08rNQ2FPguAhA+tfQ+uo1R9XCGIZC5kHP4DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARklEQVQImQXBhQGAMAADsI654+7O/w+SIC8Ub0zFUCreyiRh0IJI2ZsFuibdOHuJTNjBbv5GSie67s8FAEGd3wvAuRCP+AN/owPsxjJkRwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/examples/scale/15.png
/* harmony default export */ var _15 = ({"src":"/_next/static/media/15.ce0d60f4.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAhFBMVEVtMAOfXAb7kyn/pzVGLghTNwWcRwhRYQdCTA4vRAjynC9BLyXNcxBcVQWefxQ6OQc6IwhWKgZ3QAdrRAV9TAbCUxHDXg1LIgfgbxrrdCBEWAjCcwfgfx69gSzdkCdvOh50UTRCVCS2gTfuih9mV1VSCwOUdUm0kTyWmzthewBsWwOQPgsnh4vJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAR0lEQVQImQXBAwLAMAAEsOtqzbb5//8tQZxAFA01YBBlHdAAPCWuH80GnpNumFcHmQHTfoWQlbXHeT9QTC3+C19EuvVSa/UDiIcENL4dG0QAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/condition_scale.tsx












var GuidanceScaleParam = function(param) {
    var scale = param.scale;
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var imgSrcs = [
        _1,
        _5,
        _10,
        _15
    ];
    var values = [
        1,
        5,
        10,
        15
    ];
    // The following four images are generated with the same prompt and seed,
    // but ascending guidances:
    var descriptionContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default.Container */.Z.Container, {
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                children: "Guidance controls how strongly the image tries to match your text"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                children: '"A tiger in a beautiful forest at sunset" with the same seed and guidance values of 1, 5, 10, or 15:'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Container */.Z.Container, {
                    gap: 0.3,
                    children: imgSrcs.map(function(src, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                            xs: 12,
                            justify: "space-around",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: "160px",
                                height: "160px",
                                src: src,
                                style: {
                                    borderRadius: "3px"
                                },
                                alt: "'a tiger in a beautiful forest at sunset' with guidance ".concat(values[i]),
                                placeholder: "blur"
                            })
                        }, i);
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabeledParam, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(description/* default */.Z, {
                    title: "Guidance"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPopup, {
                    content: descriptionContent
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slider/* Slider */.i, {
            value: scale !== null && scale !== void 0 ? scale : 0,
            onChange: function(e) {
                return genieDispatch({
                    type: "setScale",
                    scale: e
                });
            },
            min: 2,
            max: 32,
            step: 0.5
        })
    });
};

;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/button_select.tsx

// This component wraps the Button components from sparkl-ui with some state logic
// to keep track of which button is selected. Only one button can be selected
// at a time. The selected button is highlighted and the callback is called
// when the button is clicked. The button remains selected until changed again.
// Really this is a radio button component but visualized in the form of a multi-button toggle.


var ButtonSelect = function(param) {
    var options = param.options, selectedKey = param.selectedKey;
    // console.log(selectedKey);
    var theme = (0,use_theme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            width: "100%",
            display: "flex",
            flexDirection: "row"
        },
        children: options.map(function(option, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
                auto: true,
                scale: 1.62,
                type: "success-light",
                ghost: true,
                style: {
                    backgroundColor: selectedKey === option.key ? theme.palette.successLight : "",
                    color: selectedKey !== option.key ? "".concat(theme.palette.secondary) : "",
                    borderColor: selectedKey !== option.key ? "".concat(theme.palette.secondary) : "",
                    width: "100%",
                    padding: "0",
                    // Make the button look "indented" when pressed
                    borderTop: option.key === selectedKey ? ".12rem solid" : ".08rem solid",
                    borderLeft: option.key === selectedKey ? ".12rem solid" : ".08rem solid",
                    borderRight: option.key === selectedKey ? ".08rem solid" : ".12rem solid",
                    borderBottom: option.key === selectedKey ? ".08rem solid" : ".12rem solid",
                    boxShadow: selectedKey === option.key ? "inset .08rem .08rem 0 0 1 ".concat(theme.palette.border) : ".08rem .08rem 0 0 1 ".concat(theme.palette.border),
                    // Make the buttons look like they're connected
                    borderTopLeftRadius: index === 0 ? theme.layout.radius : "0",
                    borderBottomLeftRadius: index === 0 ? theme.layout.radius : "0",
                    borderTopRightRadius: index === options.length - 1 ? theme.layout.radius : "0",
                    borderBottomRightRadius: index === options.length - 1 ? theme.layout.radius : "0"
                },
                onClick: function() {
                    option.callback();
                },
                icon: option.icon,
                children: option.label ? option.label : null
            }, option.key);
        })
    });
};

// EXTERNAL MODULE: ./components/icons.tsx
var icons = __webpack_require__(4952);
;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/image_size.tsx







var ImageSizeParam = function(param) {
    var width = param.width, height = param.height;
    var setImageSize = function setImageSize(imageSize) {
        //console.log("Setting to " + imageSize);
        var w = Number(imageSize.split("x")[0]);
        var h = Number(imageSize.split("x")[1]);
        if (isNaN(w) || isNaN(h)) {
            console.log("Invalid image size");
        }
        genieDispatch({
            type: "setImageSize",
            width: w,
            height: h
        });
    };
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var imageSize = width + "x" + height;
    var imageSizeOptions = [
        {
            key: "512x512",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AspectSquare */.IQ, {}),
            callback: function() {
                return setImageSize("512x512");
            }
        },
        {
            key: "768x576",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AspectLandscape */.zE, {}),
            callback: function() {
                return setImageSize("768x576");
            }
        },
        {
            key: "576x768",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AspectPortrait */.pT, {}),
            callback: function() {
                return setImageSize("576x768");
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabeledParam, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(description/* default */.Z, {
            title: "Image Shape (".concat(imageSize, ")")
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSelect, {
            options: imageSizeOptions,
            selectedKey: imageSize
        })
    });
};

;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/num_images.tsx






var NumImagesParam = function(param) {
    var num = param.num;
    var setNumImages = function setNumImages(n) {
        //console.log("Setting to " + n);
        genieDispatch({
            type: "setNumImages",
            numImages: n
        });
    };
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var numImageOptions = [
        {
            key: "1",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Images1 */.Hi, {}),
            callback: function() {
                return setNumImages(1);
            }
        },
        {
            key: "4",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Images4 */.nJ, {}),
            callback: function() {
                return setNumImages(4);
            }
        },
        {
            key: "9",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Images9 */.yd, {}),
            callback: function() {
                return setNumImages(9);
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabeledParam, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(description/* default */.Z, {
            title: "".concat(num, " images")
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSelect, {
            options: numImageOptions,
            selectedKey: String(num)
        })
    });
};

// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/input/index.js + 8 modules
var input = __webpack_require__(6358);
// EXTERNAL MODULE: ./components/genie/model_generators/model_generation_component_types.ts
var model_generation_component_types = __webpack_require__(7982);
;// CONCATENATED MODULE: ./public/images/examples/seed/bear.png
/* harmony default export */ var bear = ({"src":"/_next/static/media/bear.89ea5bd4.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAS1BMVEV1XC7hr01nUR5qVTSZditSPiOeekNtVilHOyA8NBfMr4KEaDtaRhi+mFO0ikL54JzksTaSbzu8kybpyHv/9L3Up1KJcTDRoTqJcjJUuEmMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQUlEQVQImRXGRxLAMAgEsAVjint6/v/STHQS3FLVUhQObIN6RwaU5nH9kXVOQjaTfT0DYYZb5EVjhnBN8Iho7vEBShICFwFHJAkAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/examples/seed/tiger.png
/* harmony default export */ var tiger = ({"src":"/_next/static/media/tiger.cfb1ea81.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAgVBMVEVmWhxBOiLhozJxZjZ9SiDkmWLRiDNEMBVNOxhuVx6lYSKSiBljUjJKRyBmW1aRgmpmQB1sTBybWih+WCLEczetciideR/omjfKe0b60FzcpSHUkEZcWBjsukY1OA19eBy8qRL43HrTtnPEqDnGoESVcDuJZEqihT5XShNbVCqHemLIXI7LAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAR0lEQVQImQXBAwLAMAAEsGtXa7aN/z9wCWTCsoLzBjJlRtSih9J5SduRQmlddet2QAF22a8YEpjtHQJcNESniT8QMvn3cf4HhgoEGMxH7b4AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/examples/seed/sunrise.png
/* harmony default export */ var sunrise = ({"src":"/_next/static/media/sunrise.658a5989.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAbFBMVEVrTyKDZSHivGY7LQ+5k0ODXx4wJw5cRCEnIQtPOxHxy0jGl0pKOhiviV6hdjCshyqTdS12WStSPR+FZT+OazrTqEK5iyrw2pz+/MTasmSzl3/Ipnf655WcfygXGgfislvVrYretjDvx2RsUxWbnKEVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARklEQVQImQXBhwGAIBAEsAOeKtLtXfff0QSl6trfaw/fdOsu2qATwrvzBaAc3TxxZEJ83EAoSbNjDAz2U1ZKeAhzGiuU+QGIEANlMpA4RwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/examples/seed/sunset.png
/* harmony default export */ var sunset = ({"src":"/_next/static/media/sunset.1e31f05b.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEU/MBGPaC4fIAqmcBouKQ16WhdlRhdOORdrSxqJYRbZsFXInHPeqkNYQRijdxWziCViQSKIYT4wKhLjsxrFjx6ph3LSpBX9+6zu0Xujelesfjr25IXuxjNtVBRGMxHtwlWxg1TIk0egbzHrsfI5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAARElEQVQImQXBBQLAIAwEsENbHOZu/3/kElCr7QnjChJVvHELSIK/e/cetnA+5iWCi81TPyjAkHHKMa5TkzMWgJY6oZM/g5sDJKFH5hoAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/seed.tsx













var SeedParam = function(param) {
    var seed = param.seed;
    var setSeed = function setSeed(newSeed) {
        console.log("Setting seed to " + newSeed);
        genieDispatch({
            type: "setSeed",
            seed: newSeed
        });
    };
    var textChangeHandler = function textChangeHandler(e) {
        setTextField(e.target.value);
        if (isTextValid()) {
            setSeed(parseInt(e.target.value));
        }
        setSeedIsRandom(false);
    };
    var isTextValid = function isTextValid() {
        return !isNaN(Number(textField));
    };
    var setRandomSeed = function setRandomSeed() {
        var randomSeed = (0,model_generation_component_types/* generateRandomSeed */.X4)();
        setTextField(randomSeed.toString());
        setSeed(randomSeed);
        setSeedIsRandom(true);
    };
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var upMd = (0,use_media_query/* default */.Z)("md", {
        match: "up"
    });
    var xs = (0,use_media_query/* default */.Z)("xs", {
        match: "down"
    });
    var textScale = upMd ? 2.0 : xs ? 1.0 : 1.5;
    var inputWidth = xs ? "100px" : "150px";
    var currentSeed = seed !== null && seed !== void 0 ? seed : (0,model_generation_component_types/* generateRandomSeed */.X4)();
    var ref = (0,node_modules_react.useState)(currentSeed.toString()), textField = ref[0], setTextField = ref[1];
    var ref1 = (0,node_modules_react.useState)(true), seedIsRandom = ref1[0], setSeedIsRandom = ref1[1];
    var imgSrcs = [
        bear,
        tiger,
        sunrise,
        sunset
    ];
    var descriptionContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default.Container */.Z.Container, {
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* default */.Z, {
                children: [
                    " ",
                    "Seeds control the initial noise pattern. Keeping the same seed while you slightly change the prompt can allow you to tune details in a high-level structure that you like",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* default */.Z, {
                children: [
                    " ",
                    "The following four images are generated with the same seed, but slightly different prompts:"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Container */.Z.Container, {
                    gap: 0.3,
                    children: imgSrcs.map(function(src, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                            xs: 12,
                            justify: "space-around",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: "160px",
                                height: "160px",
                                src: src,
                                style: {
                                    borderRadius: "3px"
                                },
                                alt: "Images generated with the same seed but slightly different prompts",
                                placeholder: "blur"
                            })
                        }, i);
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabeledParam, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(description/* default */.Z, {
                    title: "Seed"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPopup, {
                    content: descriptionContent
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
                auto: true,
                ghost: true,
                type: "success",
                scale: 1.62,
                onClick: function() {
                    setRandomSeed();
                },
                style: {
                    padding: "0"
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Dice */.bV, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                type: isTextValid() ? "success" : "error",
                width: inputWidth,
                maxLength: 9,
                paddingLeft: "5px",
                value: String(currentSeed),
                onChange: textChangeHandler,
                scale: textScale,
                style: {
                    height: "100%"
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/genie/model_generators/diffusion.tsx








var Diffusion = function() {
    // Individual model components like this one should grab params and pass down
    // primitive types to the subcomponents. Subcomponents are responsible for
    // dispatching actions to the store.
    // Model specifics can be found at
    // https://github.com/dryadsystems/sprkpnt/blob/main/api/params.md#diffuse
    var params = (0,use_genie/* useGenie */.l9)();
    var diffuseParams = params.allModelsParams.diffuse;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ParamsGrid, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumImagesParam, {
                num: diffuseParams.num_images
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSizeParam, {
                width: diffuseParams.width,
                height: diffuseParams.height
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeedParam, {
                seed: diffuseParams.seed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GuidanceScaleParam, {
                scale: diffuseParams.scale
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/card/index.js + 4 modules
var card = __webpack_require__(7814);
;// CONCATENATED MODULE: ./components/genie/model_generators/generator_card.tsx



var GeneratorCard = function(_param) {
    var children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var theme = (0,use_theme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        id: props.id ? props.id : "card",
        hoverable: true,
        width: "100%",
        className: "no-scroll",
        style: {
            border: "0",
            borderTop: "1px solid ".concat(theme.palette.accents_1),
            borderLeft: "1px solid ".concat(theme.palette.accents_1),
            borderBottom: "1px solid ".concat(theme.palette.accents_2),
            borderRight: "1px solid ".concat(theme.palette.accents_2),
            width: "100%",
            height: "fit-content",
            overflowX: "clip",
            display: "flex",
            flexDirection: "column"
        },
        children: children
    });
};

var GeneratorCardContent = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Card.Content, {
        padding: 0,
        children: children
    });
};


;// CONCATENATED MODULE: ./public/images/examples/steps/03.png
/* harmony default export */ var _03 = ({"src":"/_next/static/media/03.513e3acb.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAXVBMVEVdYlpsf3ltbW2BjH95iH5SWFVdbWlmaGdmYl5qallgYk5yk35jVT90dXKJg3lrbVB4d1hocGaTjIJwfnBRY2lycV6AfW6VgUZJNy83UV6ys4pvd2xudl94Zkd5h273IaQrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVQImQXBBQLAIAwEsIMCLW5z+/8zl8AUPUgPjbwJKeYM7uiGb4E4+0w3BRYpfq/yiPthqbgGv57pMrUhYFGhevxfFwLM07E+9wAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/examples/steps/20.png
/* harmony default export */ var _20 = ({"src":"/_next/static/media/20.998c73d5.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAWlBMVEVbV08xKil3dyBXVCVsXkFUTkhralxJRTxmZCRiXjdMSx4+MChzZSutljBgXld4aUiKe0hwWTa0mVFiVUODa0Ntbi2toi5hXCecjy+PhD9sdlFaWyRwbD5IODKDYgJRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVQImQXBBwKAIAwEsAOBtuzlRP//TROYOfqk/sEUW4dqBLIWUCAgZ+cUADHF1SCClNpzhU0jvnQfO2v4dUbm5X9fEALUkmvvaQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/examples/steps/50.png
/* harmony default export */ var _50 = ({"src":"/_next/static/media/50.6f519f79.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAUVBMVEVdVC5oXkNAOjFRSDpbWRZ2XyyDazJUTkBoVDFTThctJR1jXRpzchZqYSGUhiVMPiY/MCBGQTa3mT5JRhetoSdeTCB6TiC8gx99YTh+djSOdjzWx5fqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQElEQVQImQXBhQGAMBAAsat+3bDC/oOSEDzL9zUI23ykoNFziiSjERGlkhhQO7wDaM9N67Hg3OXPagvR2ppzPH5V0AJyflu1bwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/examples/steps/75.png
/* harmony default export */ var _75 = ({"src":"/_next/static/media/75.03db087b.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAXVBMVEVsWjpJRT9HPzR2dhxaWRpcWjRcWVBWUUgxKCFSTxtjXR5ORyFiYCp1ZSuajy5FNymQfD+xkkRjUzu0qTBvZkCHYTx7PxmCfD9uYk+CaT1YTD5pZ1h2ZEC8nEOBbDtt9gFTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVQImQXBhQEAIQwEsCvW4vKu+49JAlzj+1WvwHu3IVAgImZhBXbufMQx7LrhEJtQ+m5L9RoZsS3JaHhjcgg+TmmdAr3JtldlAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/steps.tsx












var StepsParam = function(param) {
    var steps = param.steps;
    //const [aspectRatio, setAspectRatio] = useState<AspectRatio>(params.aspect_ratio as AspectRatio);
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var imgSrcs = [
        _03,
        _20,
        _50,
        _75
    ];
    var values = [
        3,
        20,
        50,
        75
    ];
    // The following four images are generated with the same prompt and seed,
    // but ascending steps:
    var descriptionContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default.Container */.Z.Container, {
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                children: "Use fewer steps to try things out quickly, and more steps to expand upon something you like and get more details in!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                children: '"A tiger in a beautiful forest at sunset" with the same seed and 3, 30, 50, or 75 steps:'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Container */.Z.Container, {
                    gap: 0.3,
                    children: imgSrcs.map(function(src, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                            xs: 12,
                            justify: "space-around",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: "160px",
                                height: "160px",
                                src: src,
                                style: {
                                    borderRadius: "3px"
                                },
                                alt: "'a tiger in a beautiful forest at sunset' with ".concat(values[i], " steps"),
                                placeholder: "blur"
                            })
                        }, i);
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabeledParam, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(description/* default */.Z, {
                    title: "Steps"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPopup, {
                    content: descriptionContent
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slider/* Slider */.i, {
            min: 1,
            max: 100,
            value: steps,
            onChange: function(e) {
                return genieDispatch({
                    type: "setSteps",
                    steps: e
                });
            }
        })
    });
};

;// CONCATENATED MODULE: ./components/genie/model_generators/verdant.tsx

// This component composes the inputs with the specific params for this model








var Verdant = function() {
    // Individual model components like this one should grab params and pass down
    // primitive types to the subcomponents. Subcomponents are responsible for
    // dispatching actions to the store.
    // Model specifics can be found at
    // https://github.com/dryadsystems/sprkpnt/blob/main/api/params.md#diffuse
    var params = (0,use_genie/* useGenie */.l9)();
    var verdantParams = params.allModelsParams.verdant;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ParamsGrid, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumImagesParam, {
                num: verdantParams.num_images
            }),
            params.viewProps.mode !== "img2img" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSizeParam, {
                width: verdantParams.width,
                height: verdantParams.height
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeedParam, {
                seed: verdantParams.seed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GuidanceScaleParam, {
                scale: verdantParams.scale
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsParam, {
                steps: verdantParams.ddim_steps
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/genie/model_generators/verdant2.tsx

// This component composes the inputs with the specific params for this model








var Verdant2 = function() {
    var params = (0,use_genie/* useGenie */.l9)();
    var verdant2Params = params.allModelsParams.verdant2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ParamsGrid, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumImagesParam, {
                num: verdant2Params.num_images
            }),
            params.viewProps.mode !== "img2img" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSizeParam, {
                width: verdant2Params.width,
                height: verdant2Params.height
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeedParam, {
                seed: verdant2Params.seed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GuidanceScaleParam, {
                scale: verdant2Params.scale
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsParam, {
                steps: verdant2Params.ddim_steps
            })
        ]
    });
};

;// CONCATENATED MODULE: ./public/images/examples/aesthetic_vqgan/0.png
/* harmony default export */ var _0 = ({"src":"/_next/static/media/0.cc1a3940.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAgVBMVEWhs7XPsr6uqp3Dp57FrKuWrdCvsceYom2mroGqr66erI6qjHiOimyioovEcWiZrai2rqe8uNTOurOzsZPNwMGtprCkstF+q9GQoKeNn6CNnsCBgmq7nYyntqSqmXyen5eXmY2jyb5rckuArJeYttDCmpySjL+coIDIc4LcTFe2YHH9wQcFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASElEQVQImQXBBQKAIAAEsBNpCQu7W///QDdkZTXKNI3AVT3fnnHEAs9rfUC36ORz7kTTWrEeV4yAITFql2Ag/WYmiryQQhMa/aF7BDStx/EFAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/examples/aesthetic_vqgan/33.png
/* harmony default export */ var _33 = ({"src":"/_next/static/media/33.7d0b24ac.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAh1BMVEWSk5F5pLSqfnx5hodMdohWT1KctJFPR0uHhZZwkpWBqIhzfYxwZ2aTr6yWdGdrc2toaXhOb6mKm6uwxKumrq26wbfFl46Mu9HtX1PIv8Xeh32wzcqPppa0n5e1QTSpcGPQi3xmjKFKTF9SnKB6nKmqvsRghJVvrp6hm5dWhbW7YG6zYWqChY1SVgfbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAR0lEQVQImQXBAwLAMAAEsOtqzbb5//8tQVZU1up+gBB+mQN9Izemm8bjAgkcwpBoMFW32J8XSVo2oNsJFivq4BUiLqXk6/cDnrMENFxM23kAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/examples/aesthetic_vqgan/66.png
/* harmony default export */ var _66 = ({"src":"/_next/static/media/66.4d9e3e3b.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAjVBMVEVCQF+XmmZNbU9HUoicemlvhXhSbWNnb0qiUVJvd1OImXFweoBtb2e/rqmJh3ZSTm5ugGxTU1xfbGFzalppc258hmRjQV84a2jj1tpaWIKymHihiWfHh2WaOzCfsbasmrnKhZmZX3+AfGd4XYFyZD/Oale3j5TTZmjqyMO0sGaxqpq+fohJX0Q7TFSueHcqJllrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASklEQVQImQXBBQKAIAAEsFNKBOzubv3/89wQJMobCaOwH8/cikewpXVsTZfDPV3jrIWFV1dXu/cUZPjEUqcCyOaJxUIiRKk5fOcHq2cEqk9QOu8AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/examples/aesthetic_vqgan/99.png
/* harmony default export */ var _99 = ({"src":"/_next/static/media/99.abd70859.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAkFBMVEU9UH+rmX0yXGJodWm7vLOzVlGNllGgXEtMWlQVRWdSf2GJkYxFamdVaJFyTGOEZn7Ws6+bmqwlP3x4TkQhMpGDhJHd1NIXX2BfWUmvVTSNb1pMNYVMdFa7NGCunXcxUF2lr6SPqWpohmM8bHtwpXJGO0SkfnJvZlh3mcc4ZIKWlZ+Ib3qGXV6ksLqXwLlGd5EgCiEbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAS0lEQVQImQXBBQKAIAAEsBMEVMDu7o7//84N1nZAf47AaJjnLV8Khw9SiEdhKmm/Mk1gJ2baGvuFOPBZwWeFEF6U190CywXJ7Kr5AbJgBMvcIwBuAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/aesthetic.tsx












var AestheticParam = function(param) {
    var reaction_loss = param.reaction_loss;
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var imgSrcs = [
        _0,
        _33,
        _66,
        _99
    ];
    var values = [
        0.0,
        0.33,
        0.66,
        1.0
    ];
    // The following four images are generated with the same prompt and seed,
    // but ascending aesthetic values:
    var descriptionContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default.Container */.Z.Container, {
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                children: "Aesthetic makes the image more similar to prompts others liked, resulting in more colorful, abstract images"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                children: '"Moomin revolution" with aesthetic values 0, 0.3, 0.7, and 1:'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Container */.Z.Container, {
                    gap: 0.3,
                    children: imgSrcs.map(function(src, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                            xs: 12,
                            justify: "space-around",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: "160px",
                                height: "160px",
                                src: src,
                                style: {
                                    borderRadius: "3px"
                                },
                                alt: "'moomin revolution' with aesthetic ".concat(values[i]),
                                placeholder: "blur"
                            })
                        }, i);
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabeledParam, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(description/* default */.Z, {
                    title: "Aesthetic"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPopup, {
                    content: descriptionContent
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slider/* Slider */.i, {
            value: reaction_loss !== null && reaction_loss !== void 0 ? reaction_loss : 0,
            onChange: function(e) {
                return genieDispatch({
                    type: "setReactionLoss",
                    reactionLoss: e
                });
            },
            min: 0.0,
            max: 1.0,
            step: 0.1
        })
    });
};

;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/cut_power.tsx






var CutPowParam = function(param) {
    var cut_pow = param.cut_pow;
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    // unfortunately this isn't very clear
    /*let imgSrcs = [
    "/images/examples/cut_pow/08.png",
    "/images/examples/cut_pow/09.png",
    "/images/examples/cut_pow/11.png",
    "/images/examples/cut_pow/12.png",
  ];
  let values = [0.8, 0.9, 1.1, 1.2];
  const descriptionContent = (
    <Grid.Container direction="column">
      <Text>Patch size influences how patch-y the image looks.</Text>
      <Text>
        {" "}
        The following four images are generated with the same prompt and seed,
        but ascending patch sizes:
      </Text>

      <Grid>
        <Grid.Container gap={0.3}>
          {imgSrcs.map((src, i) => {
            return (
              <Grid xs={12} key={src} justify="space-around">
                <Image
                  width="160px"
                  height="160px"
                  src={src}
                  style={{ borderRadius: "3px" }}
                  alt={`'a tiger in a beautiful forest at sunset' with patch size  ${values[i]}`}
                  placeholder="blur"
                />
              </Grid>
            );
          })}
        </Grid.Container>
      </Grid>
    </Grid.Container>
  );*/ return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabeledParam, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(description/* default */.Z, {
                title: "Patch size"
            })
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slider/* Slider */.i, {
            value: cut_pow !== null && cut_pow !== void 0 ? cut_pow : 0,
            onChange: function(e) {
                return genieDispatch({
                    type: "setCutPow",
                    cutPow: e
                });
            },
            min: 0.5,
            max: 1.5,
            step: 0.01
        })
    });
};

;// CONCATENATED MODULE: ./components/genie/model_generators/vqgan.tsx






var Vqgan = function() {
    // Individual model components like this one should grab params and pass down
    // primitive types to the subcomponents. Subcomponents are responsible for
    // dispatching actions to the store.
    // Model specifics can be found at
    // https://github.com/dryadsystems/sprkpnt/blob/main/api/params.md#vqgan
    var params = (0,use_genie/* useGenie */.l9)();
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var vqganParams = params.allModelsParams.vqgan;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ParamsGrid, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSizeParam, {
                width: vqganParams.width,
                height: vqganParams.height
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AestheticParam, {
                reaction_loss: vqganParams.reaction_loss
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CutPowParam, {
                cut_pow: vqganParams.cut_pow
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/genie/model_generators/waifu.tsx

// This component composes the inputs with the specific params for this model








var Waifu = function() {
    var params = (0,use_genie/* useGenie */.l9)();
    var verdantParams = params.allModelsParams.waifu;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ParamsGrid, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumImagesParam, {
                num: verdantParams.num_images
            }),
            params.viewProps.mode !== "img2img" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSizeParam, {
                width: verdantParams.width,
                height: verdantParams.height
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeedParam, {
                seed: verdantParams.seed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GuidanceScaleParam, {
                scale: verdantParams.scale
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsParam, {
                steps: verdantParams.ddim_steps
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/x.js
var x = __webpack_require__(756);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var node_modules_prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(node_modules_prop_types);
;// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function tslib_es6_extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_es6_assign = function() {
    tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return tslib_es6_assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/file.js
var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}
//# sourceMappingURL=file.js.map
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/file-selector.js


var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spreadArray(__spreadArray([], __read(acc), false), __read((Array.isArray(files) ? flatten(files) : [files])), false); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject("".concat(item, " is not a File"));
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}
//# sourceMappingURL=file-selector.js.map
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/attr-accept/dist/es/index.js
var es = __webpack_require__(8363);
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/utils/index.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // Error codes

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var ErrorCode = {
  FileInvalidType: FILE_INVALID_TYPE,
  FileTooLarge: FILE_TOO_LARGE,
  FileTooSmall: FILE_TOO_SMALL,
  TooManyFiles: TOO_MANY_FILES
}; // File Errors

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || (0,es/* default */.Z)(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */


function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}
function isKindFile(item) {
  return _typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

      var ok = true;

      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }

      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }

      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

      return _objectSpread(_objectSpread({}, agg), {}, _defineProperty({}, mimeType, ext));
    }, {});
    return [{
      accept: acceptForPicker
    }];
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

      return [].concat(_toConsumableArray(a), [mimeType], _toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/index.js
var es_excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function es_toConsumableArray(arr) { return es_arrayWithoutHoles(arr) || es_iterableToArray(arr) || es_unsupportedIterableToArray(arr) || es_nonIterableSpread(); }

function es_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function es_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function es_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return es_arrayLikeToArray(arr); }

function es_slicedToArray(arr, i) { return es_arrayWithHoles(arr) || es_iterableToArrayLimit(arr, i) || es_unsupportedIterableToArray(arr, i) || es_nonIterableRest(); }

function es_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function es_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return es_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return es_arrayLikeToArray(o, minLen); }

function es_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function es_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function es_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function es_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function es_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? es_ownKeys(Object(source), !0).forEach(function (key) { es_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : es_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function es_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint prefer-template: 0 */




/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/(0,node_modules_react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, es_excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  (0,node_modules_react.useImperativeHandle)(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/node_modules_react.createElement(node_modules_react.Fragment, null, children(es_objectSpread(es_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

var es_defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone.defaultProps = es_defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: (prop_types_default()).func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: prop_types_default().objectOf(prop_types_default().arrayOf((prop_types_default()).string)),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: (prop_types_default()).bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: (prop_types_default()).bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: (prop_types_default()).bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: (prop_types_default()).bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: (prop_types_default()).bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: (prop_types_default()).bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: (prop_types_default()).number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: (prop_types_default()).number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: (prop_types_default()).number,

  /**
   * Enable/disable the dropzone
   */
  disabled: (prop_types_default()).bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: (prop_types_default()).func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: (prop_types_default()).func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: (prop_types_default()).func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: (prop_types_default()).bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: (prop_types_default()).bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: (prop_types_default()).func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: (prop_types_default()).func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: (prop_types_default()).func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: (prop_types_default()).func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: (prop_types_default()).func
};
/* harmony default export */ var dist_es = ((/* unused pure expression or super */ null && (Dropzone)));
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = es_objectSpread(es_objectSpread({}, es_defaultProps), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;

  var acceptAttr = (0,node_modules_react.useMemo)(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = (0,node_modules_react.useMemo)(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = (0,node_modules_react.useMemo)(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = (0,node_modules_react.useMemo)(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = (0,node_modules_react.useRef)(null);
  var inputRef = (0,node_modules_react.useRef)(null);

  var _useReducer = (0,node_modules_react.useReducer)(reducer, initialState),
      _useReducer2 = es_slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = (0,node_modules_react.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  (0,node_modules_react.useEffect)(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = (0,node_modules_react.useRef)([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  (0,node_modules_react.useEffect)(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Auto focus the root when autoFocus is true

  (0,node_modules_react.useEffect)(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }

    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = (0,node_modules_react.useCallback)(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = (0,node_modules_react.useCallback)(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(es_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = (0,node_modules_react.useCallback)(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = (0,node_modules_react.useCallback)(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = (0,node_modules_react.useCallback)(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = es_slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = es_slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = (0,node_modules_react.useCallback)(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = (0,node_modules_react.useCallback)(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = (0,node_modules_react.useCallback)(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = (0,node_modules_react.useCallback)(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = (0,node_modules_react.useCallback)(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = (0,node_modules_react.useCallback)(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = (0,node_modules_react.useMemo)(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return es_objectSpread(es_objectSpread(es_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = (0,node_modules_react.useCallback)(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = (0,node_modules_react.useMemo)(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = es_defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);

      return es_objectSpread(es_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return es_objectSpread(es_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return es_objectSpread(es_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });

    case "setFiles":
      return es_objectSpread(es_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case "reset":
      return es_objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}


// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/image/index.js + 6 modules
var esm_image = __webpack_require__(9918);
;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/image_picker.tsx









// have to import Image from sparkl-ui
// as SparklImage to avoid conflict
// with next/image


var ImagePicker = function(param) {
    var _initImage = param.initImage, initImage = _initImage === void 0 ? "" : _initImage;
    var ref = (0,use_modal/* default */.Z)(), visible = ref.visible, setVisible = ref.setVisible, bindings = ref.bindings;
    var toggleVisible = (0,node_modules_react.useCallback)(function() {
        return setVisible(function(v) {
            return !v;
        });
    }, [
        setVisible
    ]);
    var ref1 = useUploadImage(), uploadImage = ref1.uploadImage, isUploading = ref1.isUploading;
    var onDrop = (0,node_modules_react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(acceptedFiles, rejectedFiles) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        uploadImage(acceptedFiles[0]);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(acceptedFiles, rejectedFiles) {
            return _ref.apply(this, arguments);
        };
    }(), [
        uploadImage
    ]);
    var ref2 = useDropzone({
        onDrop: onDrop,
        accept: {
            "image/png": [
                ".png"
            ],
            "image/jpeg": [
                ".jpg",
                ".jpeg"
            ],
            "image/webp": [
                ".webp"
            ]
        },
        multiple: false,
        maxFiles: 1,
        useFsAccessApi: false
    }), getRootProps = ref2.getRootProps, getInputProps = ref2.getInputProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        type: "secondary",
        hoverable: true,
        style: {
            width: "100%",
            height: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Content */.Z.Content, {
            padding: 0,
            height: "100%",
            children: !initImage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRootProps()), {
                style: {
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                    margin: 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({}, getInputProps())),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            flexDirection: "column"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                            width: "50%",
                            padding: "0.12rem",
                            children: isUploading ? "Uploading..." : "Drag or click to select an image..."
                        })
                    })
                ]
            })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    justifyItems: "start",
                    height: "100%",
                    width: "100%",
                    backgroundImage: "url(".concat(initImage, ")"),
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    padding: "0.12rem"
                },
                onClick: function() {
                    toggleVisible();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column-reverse",
                            alignItems: "end",
                            justifySelf: "end",
                            bottom: "-100%",
                            height: "19%",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
                            type: "success",
                            scale: 0.38,
                            ghost: true,
                            onClick: function() {
                                uploadImage(null);
                            },
                            auto: true,
                            height: "100%",
                            iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(x/* default */.Z, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bindings), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_image/* default */.Z, {
                            src: initImage,
                            alt: "User-uploaded initial image"
                        })
                    }))
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./utils/config.ts
var utils_config = __webpack_require__(8779);
;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/descriptions.tsx






var imgSrcImg2Img = (/* unused pure expression or super */ null && ([
    "/images/examples/seed/bear.png",
    "/images/examples/seed/tiger.png",
    "/images/examples/seed/sunrise.png",
    "/images/examples/seed/sunset.png", 
]));
var imgSrcInpaint = (/* unused pure expression or super */ null && ([
    "/images/examples/seed/bear.png",
    "/images/examples/seed/tiger.png",
    "/images/examples/seed/sunrise.png",
    "/images/examples/seed/sunset.png", 
]));
var initImageDescription = function() {
    return /*#__PURE__*/ _jsxs(Grid.Container, {
        gap: 1,
        direction: "row",
        children: [
            /*#__PURE__*/ _jsx(Grid, {
                xs: 24,
                md: config.allowNonfunctionalUI ? 12 : 24,
                children: /*#__PURE__*/ _jsxs(Grid.Container, {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ _jsx(Grid, {
                            children: /*#__PURE__*/ _jsxs(Grid.Container, {
                                direction: "row",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            height: "30px"
                                        },
                                        children: /*#__PURE__*/ _jsx(InitImage, {})
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        h4: true,
                                        children: "Transformation"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            children: /*#__PURE__*/ _jsx(Text, {
                                children: "Pass in an initial image, and a prompt to spice it up with!"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            paddingBottom: "20px",
                            children: /*#__PURE__*/ _jsx(Grid.Container, {
                                gap: 0.3,
                                children: imgSrcImg2Img.map(function(src, i) {
                                    return /*#__PURE__*/ _jsx(Grid, {
                                        xs: 12,
                                        justify: "space-around",
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            width: "160px",
                                            height: "160px",
                                            src: src,
                                            style: {
                                                borderRadius: "3px"
                                            },
                                            alt: "Images generated as transformations of an initial image"
                                        })
                                    }, src);
                                })
                            })
                        })
                    ]
                })
            }),
            config.allowNonfunctionalUI && /*#__PURE__*/ _jsx(Grid, {
                xs: 24,
                md: 12,
                children: /*#__PURE__*/ _jsxs(Grid.Container, {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ _jsx(Grid, {
                            children: /*#__PURE__*/ _jsxs(Grid.Container, {
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            height: "30px"
                                        },
                                        children: /*#__PURE__*/ _jsx(Inpaint, {})
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        h4: true,
                                        children: "Inpainting"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            children: /*#__PURE__*/ _jsx(Text, {
                                children: "Select a region to replace, and tell us what goes in there!"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Grid, {
                            children: /*#__PURE__*/ _jsx(Grid.Container, {
                                gap: 0.3,
                                children: imgSrcInpaint.map(function(src, i) {
                                    return /*#__PURE__*/ _jsx(Grid, {
                                        xs: 12,
                                        justify: "space-around",
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            width: "160px",
                                            height: "160px",
                                            src: src,
                                            style: {
                                                borderRadius: "3px"
                                            },
                                            alt: "Images generated via inpainting"
                                        })
                                    }, src);
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var imgNoiseImgs = [
    "/images/examples/seed/bear.png",
    "/images/examples/seed/tiger.png",
    "/images/examples/seed/sunrise.png",
    "/images/examples/seed/sunset.png", 
];
var ImgNoiseDescription = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                children: "Control how strongly your input image affects the output"
            }),
            imgNoiseImgs.map(function(src, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default */.Z, {
                    xs: 12,
                    justify: "space-around",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: "160px",
                            height: "160px",
                            src: src,
                            style: {
                                borderRadius: "3px"
                            },
                            alt: "Images generated with different image strength values"
                        })
                    ]
                }, src);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/init_image.tsx










// type InitImageType = "none" | "init" | "inpaint";
var InitImageParam = function() {
    var setToast = (0,use_toasts/* default */.Z)().setToast;
    var params = (0,use_genie/* useGenie */.l9)();
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    // Currently we don't use this but will later
    // function setInitImageType(initImage: InitImageType) {
    //   console.log("Setting to " + initImage);
    //   setInitImageParams({ ...imageParams, init_image_type: initImage });
    // }
    if (params.viewProps.mode !== "img2img") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var imageParams = params.allModelsParams[params.selectedModel];
    var _strength;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "grid",
            gridGap: "1rem",
            gridTemplateColumns: "repeat(auto-fit, minmax(12rem, 1fr))",
            gridTemplateRows: "repeat(auto-fit, minmax(12rem, 1fr))",
            alignItems: "stretch",
            justifyContent: "space-between",
            width: "100%",
            height: "100%",
            paddingLeft: "0.5rem",
            paddingRight: "0.5rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabeledParam, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(description/* default */.Z, {
                    title: "Upload Image"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePicker, {
                    initImage: feed_types/* img2img_models.includes */.B.includes(params.selectedModel) ? imageParams.init_image : undefined
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabeledParam, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(description/* default */.Z, {
                            title: "Image strength"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPopup, {
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgNoiseDescription, {})
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slider/* Slider */.i, {
                    min: 0,
                    max: 0.6,
                    step: 0.02,
                    value: Number((1 - ((_strength = imageParams.strength) !== null && _strength !== void 0 ? _strength : 0.8)).toFixed(2)),
                    onChange: function(e) {
                        genieDispatch({
                            type: "setInitImageStrength",
                            initImageStrength: Number((1 - e).toFixed(2))
                        });
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/modals/no_credits_modal.tsx





var useNoCreditsModal = function() {
    var ref = (0,use_modal/* default */.Z)(), visible = ref.visible, setVisible = ref.setVisible, bindings = ref.bindings;
    var toggleModal = function() {
        setVisible(!visible);
    };
    var NoCreditsModal = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            width: "700px"
        }, bindings), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default.Container */.Z.Container, {
                justify: "center",
                alignContent: "center",
                padding: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                        xs: 24,
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                            h2: true,
                            children: "Insufficient credits"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* default */.Z, {
                        p: true,
                        width: "80%",
                        children: [
                            " ",
                            "You have run out of credits - head to the credits page to get some more, or come back tomorrow.",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.Z, {
                        xs: 24,
                        justify: "center",
                        padding: "5px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/profile?tab=credits",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_button/* default */.Z, {
                                type: "success-light",
                                onClick: toggleModal,
                                children: [
                                    " ",
                                    "Get more credits",
                                    " "
                                ]
                            })
                        })
                    })
                ]
            })
        }));
    };
    return {
        toggleModal: toggleModal,
        NoCreditsModal: NoCreditsModal
    };
};

;// CONCATENATED MODULE: ./components/genie/generator_subcomponents/button_toggle.tsx


// This component wraps the Button components from sparkl-ui with some state logic
// to keep track of which button is selected. Only one button can be selected
// at a time. The selected button is highlighted and the callback is called
// when the button is clicked. The button remains selected until changed again.
// Really this is a radio button component but visualized in the form of a multi-button toggle.

var ButtonToggle = function(param) {
    var value = param.value, callback = param.callback, icon = param.icon, label = param.label, _style = param.style, style = _style === void 0 ? {} : _style;
    // console.log(selectedKey);
    var theme = (0,use_theme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
        auto: true,
        scale: 0.38,
        type: "success-light",
        ghost: true,
        style: (0,_object_spread/* default */.Z)({
            backgroundColor: value ? theme.palette.successLight : "",
            color: !value ? "".concat(theme.palette.secondary) : "",
            borderColor: !value ? "".concat(theme.palette.secondary) : "",
            width: "fit-content",
            height: "100%",
            padding: "0",
            // Make the button look "indented" when pressed
            borderTop: value ? ".12rem solid" : ".08rem solid",
            borderLeft: value ? ".12rem solid" : ".08rem solid",
            borderRight: value ? ".08rem solid" : ".12rem solid",
            borderBottom: value ? ".08rem solid" : ".12rem solid",
            boxShadow: value === true ? "inset .08rem .08rem 0 0 1 ".concat(theme.palette.border) : ".08rem .08rem 0 0 1 ".concat(theme.palette.border)
        }, style),
        onClick: function() {
            callback();
        },
        icon: icon,
        children: label ? label : null
    });
};

// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/eye.js
var eye = __webpack_require__(9950);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/eyeOff.js
var eyeOff = __webpack_require__(183);
;// CONCATENATED MODULE: ./components/genie/generator.tsx




























var modelsToComponent = {
    dalle: DalleMini,
    diffuse: Diffusion,
    //disco: Disco,
    vqgan: Vqgan,
    verdant: Verdant,
    waifu: Waifu,
    verdant2: Verdant2,
    "": function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
};
var Generator = function(param) {
    var fixedModel = param.fixedModel;
    var genieParams = (0,use_genie/* useGenie */.l9)();
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var setToast = (0,use_toasts/* default */.Z)().setToast;
    var session = (0,devtools/* dev_maybeMockSession */.vQ)((0,react.useSession)());
    var ref = (0,login_modal/* useLoginModal */.N)({
        callbackUrl: genieParams.sharedParams.prompts[0].text != "" ? "/?text=" + genieParams.sharedParams.prompts[0].text : undefined
    }), toggleLogin = ref.toggleLogin, LoginModal = ref.LoginModal;
    var ref1 = useNoCreditsModal(), toggleModal = ref1.toggleModal, NoCreditsModal = ref1.NoCreditsModal;
    var ref2 = (0,node_modules_react.useState)("not_started"), submitStatus = ref2[0], setSubmitStatus = ref2[1];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var params, body;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(genieParams.sharedParams.prompts[0].text === "")) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        params = {
                            modelParams: genieParams.allModelsParams[genieParams.selectedModel],
                            sharedParams: genieParams.sharedParams,
                            model: genieParams.selectedModel,
                            hidden: genieParams.sharedParams.hidden
                        };
                        body = {
                            params: params
                        };
                        if (session) {
                            _ctx.next = 7;
                            break;
                        }
                        toggleLogin();
                        return _ctx.abrupt("return");
                    case 7:
                        if (genieParams.remixPromptId) {
                            body.originalPromptId = genieParams.remixPromptId;
                        }
                        setSubmitStatus("in_progress");
                        _ctx.next = 11;
                        return fetch("/api/generate", {
                            method: "POST",
                            body: JSON.stringify(body),
                            headers: (0,devtools/* dev_mockUserHeader */.OM)()
                        }).then(function(r) {
                            return r.json();
                        }).then(function(resp) {
                            if (resp.status === "success") {
                                (0,swr/* mutateQueue */.sb)({
                                    id: resp.prompt_id,
                                    params: params,
                                    status: "pending",
                                    date: Date.now() / 1000,
                                    user_id: resp.user_id,
                                    remix_of: genieParams.remixPromptId
                                });
                                (0,dist/* mutate */.JG)(function(key) {
                                    return key == "/api/balance";
                                }, function(data) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                        balance: data.balance - creditCost(params)
                                    });
                                }, false);
                                setSubmitStatus("submitted");
                                setTimeout(function() {
                                    setSubmitStatus("not_started");
                                }, 1000);
                            } else {
                                if (resp.code === "insufficent_credits") {
                                    toggleModal();
                                } else {
                                    setToast({
                                        text: resp.code,
                                        type: "error"
                                    });
                                }
                                setSubmitStatus("not_started");
                            }
                        //console.log("response from generate API call is", resp);
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var Component = modelsToComponent[genieParams.selectedModel];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            width: "100%",
            height: "fit-content",
            overflowX: "clip",
            display: "flex",
            flexDirection: "column",
            gap: "1rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoCreditsModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GeneratorCard, {
                id: "generator-card",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PromptBox, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InitImageParam, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(collapse/* default */.Z, {
                        title: " ",
                        initialVisible: genieParams.viewProps.expanded,
                        style: {
                            width: "100%",
                            border: "none",
                            height: "100%",
                            paddingTop: ".62rem",
                            paddingBottom: ".62rem"
                        },
                        onClick: function() {
                            return genieDispatch({
                                type: "setExpanded",
                                expanded: !genieParams.viewProps.expanded
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "0.38rem",
                    placeContent: "center",
                    placeItems: "center",
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonToggle, {
                        value: genieParams.sharedParams.hidden ? true : false,
                        callback: function() {
                            return genieDispatch({
                                type: "toggleHidden"
                            });
                        },
                        icon: genieParams.sharedParams.hidden ? /*#__PURE__*/ (0,jsx_runtime.jsx)(eyeOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(eye/* default */.Z, {}),
                        style: {
                            width: "4rem",
                            height: "4rem",
                            border: "none",
                            borderColor: "none",
                            borderTop: "none",
                            borderBottom: "none",
                            borderLeft: "none",
                            borderRight: "none",
                            boxShadow: "none"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartButton, {
                        onClick: handleSubmit,
                        status: submitStatus
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/select/index.js + 12 modules
var esm_select = __webpack_require__(1278);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/tooltip/index.js

/* harmony default export */ var esm_tooltip = (tooltip);
// EXTERNAL MODULE: ./components/selectors/generic_selector.tsx
var generic_selector = __webpack_require__(7744);
// EXTERNAL MODULE: ./components/selectors/model_selector.tsx + 1 modules
var model_selector = __webpack_require__(6508);
;// CONCATENATED MODULE: ./components/selectors/generator_bar.tsx







var GeneratorBar = function() {
    var params = (0,use_genie/* useGenie */.l9)();
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var ref = (0,node_modules_react.useState)("txt2img"), lastUsedMode = ref[0], setLastUsedMode = ref[1];
    var setModel = function(model) {
        genieDispatch({
            type: "switchModel",
            model: model
        });
    };
    var setMode = function(mode) {
        genieDispatch({
            type: "setMode",
            mode: mode
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "generator-bar",
        className: "no-scroll",
        style: {
            position: "absolute",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "0.38rem 1rem",
            zIndex: 10,
            paddingTop: "0.38rem",
            paddingBottom: "0.38rem",
            backgroundColor: "rgba(0,0,0,0.0)"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(model_selector/* ModelSelector */.O, {
                getPopupContainer: function() {
                    return document.getElementById("generator-bar");
                },
                value: params.selectedModel,
                onChange: function(value) {
                    setModel(value);
                    if (!feed_types/* img2img_models.includes */.B.includes(value)) {
                        setLastUsedMode(params.viewProps.mode);
                        setMode("txt2img");
                    } else {
                        setMode(lastUsedMode);
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(generic_selector/* GenericSelector */.r, {
                value: params.viewProps.mode,
                getPopupContainer: function() {
                    return document.getElementById("generator-bar");
                },
                placeholder: "Mode",
                //@ts-ignore
                onChange: function(value) {
                    genieDispatch({
                        type: "setMode",
                        mode: value
                    });
                },
                disabled: !feed_types/* img2img_models.includes */.B.includes(params.selectedModel),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_select/* default.Option */.Z.Option, {
                        value: "txt2img",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                            font: "1rem",
                            b: true,
                            children: "Text to Image"
                        })
                    }, "txt2img"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_select/* default.Option */.Z.Option, {
                        value: "img2img",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                            font: "1rem",
                            b: true,
                            children: "Image to Image"
                        })
                    }, "img2img"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_select/* default.Option */.Z.Option, {
                        disabled: true,
                        value: "img2vid",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_tooltip, {
                            text: "Coming soon!",
                            placement: "bottomEnd",
                            width: "14ch",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                font: "1rem",
                                b: true,
                                children: "Video"
                            })
                        })
                    }, "img2vid")
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js
var resizeObservers = [];


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/hasActiveObservations.js

var hasActiveObservations = function () {
    return resizeObservers.some(function (ro) { return ro.activeTargets.length > 0; });
};


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/hasSkippedObservations.js

var hasSkippedObservations = function () {
    return resizeObservers.some(function (ro) { return ro.skippedTargets.length > 0; });
};


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/deliverResizeLoopError.js
var msg = 'ResizeObserver loop completed with undelivered notifications.';
var deliverResizeLoopError = function () {
    var event;
    if (typeof ErrorEvent === 'function') {
        event = new ErrorEvent('error', {
            message: msg
        });
    }
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = msg;
    }
    window.dispatchEvent(event);
};


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObserverBoxOptions.js
var ResizeObserverBoxOptions;
(function (ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/freeze.js
var freeze = function (obj) { return Object.freeze(obj); };

;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObserverSize.js

var ResizeObserverSize = (function () {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        freeze(this);
    }
    return ResizeObserverSize;
}());


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/DOMRectReadOnly.js

var DOMRectReadOnly = (function () {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return freeze(this);
    }
    DOMRectReadOnly.prototype.toJSON = function () {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return { x: x, y: y, top: top, right: right, bottom: bottom, left: left, width: width, height: height };
    };
    DOMRectReadOnly.fromRect = function (rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}());


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/element.js
var isSVG = function (target) { return target instanceof SVGElement && 'getBBox' in target; };
var isHidden = function (target) {
    if (isSVG(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isElement = function (obj) {
    var _a;
    if (obj instanceof Element) {
        return true;
    }
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var isReplacedElement = function (target) {
    switch (target.tagName) {
        case 'INPUT':
            if (target.type !== 'image') {
                break;
            }
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/global.js
var global = typeof window !== 'undefined' ? window : {};

;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/calculateBoxSize.js






var cache = new WeakMap();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = (/msie|trident/i).test(global.navigator && global.navigator.userAgent);
var parseDimension = function (pixel) { return parseFloat(pixel || '0'); };
var size = function (inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) { inlineSize = 0; }
    if (blockSize === void 0) { blockSize = 0; }
    if (switchSizes === void 0) { switchSizes = false; }
    return new ResizeObserverSize((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var zeroBoxes = freeze({
    devicePixelContentBoxSize: size(),
    borderBoxSize: size(),
    contentBoxSize: size(),
    contentRect: new DOMRectReadOnly(0, 0, 0, 0)
});
var calculateBoxSizes = function (target, forceRecalculation) {
    if (forceRecalculation === void 0) { forceRecalculation = false; }
    if (cache.has(target) && !forceRecalculation) {
        return cache.get(target);
    }
    if (isHidden(target)) {
        cache.set(target, zeroBoxes);
        return zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = isSVG(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !IE && cs.boxSizing === 'border-box';
    var switchSizes = verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = freeze({
        devicePixelContentBoxSize: size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: size(contentWidth, contentHeight, switchSizes),
        contentRect: new DOMRectReadOnly(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    cache.set(target, boxes);
    return boxes;
};
var calculateBoxSize = function (target, observedBox, forceRecalculation) {
    var _a = calculateBoxSizes(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch (observedBox) {
        case ResizeObserverBoxOptions.DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case ResizeObserverBoxOptions.BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObserverEntry.js


var ResizeObserverEntry = (function () {
    function ResizeObserverEntry(target) {
        var boxes = calculateBoxSizes(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = freeze([boxes.borderBoxSize]);
        this.contentBoxSize = freeze([boxes.contentBoxSize]);
        this.devicePixelContentBoxSize = freeze([boxes.devicePixelContentBoxSize]);
    }
    return ResizeObserverEntry;
}());


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/calculateDepthForNode.js

var calculateDepthForNode = function (node) {
    if (isHidden(node)) {
        return Infinity;
    }
    var depth = 0;
    var parent = node.parentNode;
    while (parent) {
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/broadcastActiveObservations.js




var broadcastActiveObservations = function () {
    var shallowestDepth = Infinity;
    var callbacks = [];
    resizeObservers.forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) {
            return;
        }
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new ResizeObserverEntry(ot.target);
            var targetDepth = calculateDepthForNode(ot.target);
            entries.push(entry);
            ot.lastReportedSize = calculateBoxSize(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) {
                shallowestDepth = targetDepth;
            }
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for (var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++) {
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/algorithms/gatherActiveObservationsAtDepth.js


var gatherActiveObservationsAtDepth = function (depth) {
    resizeObservers.forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if (calculateDepthForNode(ot.target) > depth) {
                    ro.activeTargets.push(ot);
                }
                else {
                    ro.skippedTargets.push(ot);
                }
            }
        });
    });
};


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/process.js





var process = function () {
    var depth = 0;
    gatherActiveObservationsAtDepth(depth);
    while (hasActiveObservations()) {
        depth = broadcastActiveObservations();
        gatherActiveObservationsAtDepth(depth);
    }
    if (hasSkippedObservations()) {
        deliverResizeLoopError();
    }
    return depth > 0;
};


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/queueMicroTask.js
var trigger;
var callbacks = [];
var notify = function () { return callbacks.splice(0).forEach(function (cb) { return cb(); }); };
var queueMicroTask = function (callback) {
    if (!trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = { characterData: true };
        new MutationObserver(function () { return notify(); }).observe(el_1, config);
        trigger = function () { el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++); };
    }
    callbacks.push(callback);
    trigger();
};


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/queueResizeObserver.js

var queueResizeObserver = function (cb) {
    queueMicroTask(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/utils/scheduler.js



var watching = 0;
var isWatching = function () { return !!watching; };
var CATCH_PERIOD = 250;
var observerConfig = { attributes: true, characterData: true, childList: true, subtree: true };
var events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var time = function (timeout) {
    if (timeout === void 0) { timeout = 0; }
    return Date.now() + timeout;
};
var scheduled = false;
var Scheduler = (function () {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function () { return _this.schedule(); };
    }
    Scheduler.prototype.run = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = CATCH_PERIOD; }
        if (scheduled) {
            return;
        }
        scheduled = true;
        var until = time(timeout);
        queueResizeObserver(function () {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = process();
            }
            finally {
                scheduled = false;
                timeout = until - time();
                if (!isWatching()) {
                    return;
                }
                if (elementsHaveResized) {
                    _this.run(1000);
                }
                else if (timeout > 0) {
                    _this.run(timeout);
                }
                else {
                    _this.start();
                }
            }
        });
    };
    Scheduler.prototype.schedule = function () {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function () {
        var _this = this;
        var cb = function () { return _this.observer && _this.observer.observe(document.body, observerConfig); };
        document.body ? cb() : global.addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function () {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            events.forEach(function (name) { return global.addEventListener(name, _this.listener, true); });
        }
    };
    Scheduler.prototype.stop = function () {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            events.forEach(function (name) { return global.removeEventListener(name, _this.listener, true); });
            this.stopped = true;
        }
    };
    return Scheduler;
}());
var scheduler = new Scheduler();
var updateCount = function (n) {
    !watching && n > 0 && scheduler.start();
    watching += n;
    !watching && scheduler.stop();
};


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObservation.js



var skipNotifyOnElement = function (target) {
    return !isSVG(target)
        && !isReplacedElement(target)
        && getComputedStyle(target).display === 'inline';
};
var ResizeObservation = (function () {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || ResizeObserverBoxOptions.CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function () {
        var size = calculateBoxSize(this.target, this.observedBox, true);
        if (skipNotifyOnElement(this.target)) {
            this.lastReportedSize = size;
        }
        if (this.lastReportedSize.inlineSize !== size.inlineSize
            || this.lastReportedSize.blockSize !== size.blockSize) {
            return true;
        }
        return false;
    };
    return ResizeObservation;
}());


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObserverDetail.js
var ResizeObserverDetail = (function () {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}());


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObserverController.js




var observerMap = new WeakMap();
var getObservationIndex = function (observationTargets, target) {
    for (var i = 0; i < observationTargets.length; i += 1) {
        if (observationTargets[i].target === target) {
            return i;
        }
    }
    return -1;
};
var ResizeObserverController = (function () {
    function ResizeObserverController() {
    }
    ResizeObserverController.connect = function (resizeObserver, callback) {
        var detail = new ResizeObserverDetail(resizeObserver, callback);
        observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function (resizeObserver, target, options) {
        var detail = observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if (getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && resizeObservers.push(detail);
            detail.observationTargets.push(new ResizeObservation(target, options && options.box));
            updateCount(1);
            scheduler.schedule();
        }
    };
    ResizeObserverController.unobserve = function (resizeObserver, target) {
        var detail = observerMap.get(resizeObserver);
        var index = getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && resizeObservers.splice(resizeObservers.indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            updateCount(-1);
        }
    };
    ResizeObserverController.disconnect = function (resizeObserver) {
        var _this = this;
        var detail = observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function (ot) { return _this.unobserve(resizeObserver, ot.target); });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}());


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/ResizeObserver.js


var ResizeObserver = (function () {
    function ResizeObserver(callback) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (typeof callback !== 'function') {
            throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        }
        ResizeObserverController.connect(this, callback);
    }
    ResizeObserver.prototype.observe = function (target, options) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (!isElement(target)) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        ResizeObserverController.observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function (target) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (!isElement(target)) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        ResizeObserverController.unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function () {
        ResizeObserverController.disconnect(this);
    };
    ResizeObserver.toString = function () {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}());


;// CONCATENATED MODULE: ./node_modules/@juggle/resize-observer/lib/exports/resize-observer.js




;// CONCATENATED MODULE: ./node_modules/@react-hook/passive-layout-effect/dist/module/index.js

const usePassiveLayoutEffect = node_modules_react[typeof document !== 'undefined' && document.createElement !== void 0 ? 'useLayoutEffect' : 'useEffect'];
/* harmony default export */ var dist_module = (usePassiveLayoutEffect);
;// CONCATENATED MODULE: ./node_modules/@react-hook/latest/dist/module/index.js


const useLatest = current => {
  const storedValue = node_modules_react.useRef(current);
  node_modules_react.useEffect(() => {
    storedValue.current = current;
  });
  return storedValue;
};

/* harmony default export */ var latest_dist_module = (useLatest);
;// CONCATENATED MODULE: ./node_modules/@react-hook/resize-observer/dist/module/index.js
/* eslint-disable no-return-assign */

/* eslint-disable no-underscore-dangle */



const module_ResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window ? // @ts-ignore
window.ResizeObserver : ResizeObserver;
/**
 * A React hook that fires a callback whenever ResizeObserver detects a change to its size
 *
 * @param target A React ref created by `useRef()` or an HTML element
 * @param callback Invoked with a single `ResizeObserverEntry` any time
 *   the `target` resizes
 */

function _ref() {}

function useResizeObserver(target, callback) {
  const resizeObserver = getResizeObserver();
  const storedCallback = latest_dist_module(callback);
  dist_module(() => {
    let didUnsubscribe = false;
    const targetEl = target && 'current' in target ? target.current : target;
    if (!targetEl) return _ref;

    function cb(entry, observer) {
      if (didUnsubscribe) return;
      storedCallback.current(entry, observer);
    }

    resizeObserver.subscribe(targetEl, cb);
    return () => {
      didUnsubscribe = true;
      resizeObserver.unsubscribe(targetEl, cb);
    };
  }, [target, resizeObserver, storedCallback]);
  return resizeObserver.observer;
}

function createResizeObserver() {
  let ticking = false;
  let allEntries = [];
  const callbacks = new Map();
  const observer = new module_ResizeObserver((entries, obs) => {
    allEntries = allEntries.concat(entries);

    function _ref2() {
      const triggered = new Set();

      for (let i = 0; i < allEntries.length; i++) {
        if (triggered.has(allEntries[i].target)) continue;
        triggered.add(allEntries[i].target);
        const cbs = callbacks.get(allEntries[i].target);
        cbs === null || cbs === void 0 ? void 0 : cbs.forEach(cb => cb(allEntries[i], obs));
      }

      allEntries = [];
      ticking = false;
    }

    if (!ticking) {
      window.requestAnimationFrame(_ref2);
    }

    ticking = true;
  });
  return {
    observer,

    subscribe(target, callback) {
      var _callbacks$get;

      observer.observe(target);
      const cbs = (_callbacks$get = callbacks.get(target)) !== null && _callbacks$get !== void 0 ? _callbacks$get : [];
      cbs.push(callback);
      callbacks.set(target, cbs);
    },

    unsubscribe(target, callback) {
      var _callbacks$get2;

      const cbs = (_callbacks$get2 = callbacks.get(target)) !== null && _callbacks$get2 !== void 0 ? _callbacks$get2 : [];

      if (cbs.length === 1) {
        observer.unobserve(target);
        callbacks.delete(target);
        return;
      }

      const cbIndex = cbs.indexOf(callback);
      if (cbIndex !== -1) cbs.splice(cbIndex, 1);
      callbacks.set(target, cbs);
    }

  };
}

let _resizeObserver;

const getResizeObserver = () => !_resizeObserver ? _resizeObserver = createResizeObserver() : _resizeObserver;

/* harmony default export */ var resize_observer_dist_module = (useResizeObserver);
;// CONCATENATED MODULE: ./utils/use_size.ts


//https://github.com/jaredLunde/react-hook/issues/165
var useSize = function(param) {
    var initialRef = param.initialRef, _initialSize = param.initialSize, initialSize = _initialSize === void 0 ? undefined : _initialSize;
    var ref = (0,node_modules_react.useState)(), size = ref[0], setSize = ref[1];
    var ref1 = (0,node_modules_react.useState)(null), node = ref1[0], ref2 = ref1[1];
    (0,node_modules_react.useLayoutEffect)(function() {
        node !== null && setSize(node.getBoundingClientRect());
    }, [
        node
    ]);
    // Where the magic happens
    resize_observer_dist_module(node, function(entry) {
        setSize(entry.contentRect);
    });
    return {
        ref: ref2,
        size: size
    }; // this is also a little wierd since ref isn't a ref object but a setter function, but works if using it in the context of <div ref={ref}>
};

// EXTERNAL MODULE: ./components/prompt_image/lightbox_context.tsx
var lightbox_context = __webpack_require__(4584);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
function _throw(e) {
    throw e;
}
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/link/index.js + 2 modules
var esm_link = __webpack_require__(5901);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
;// CONCATENATED MODULE: ./components/layouts/tabnav.tsx






var defaultTabState = {
    selectedTab: "0",
    scrollStates: {}
};
var scrollReducer = function(state, action) {
    switch(action.type){
        case "switchTab":
            var currentTab = state.selectedTab;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                selectedTab: action.tab,
                scrollStates: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.scrollStates), (0,_define_property/* default */.Z)({}, currentTab, action.scroll))
            });
        default:
            return state;
    }
};
var TabNav = function(param) {
    var children = param.children;
    var tabState = useTabNav();
    var tabDispatch = useTabDispatch();
    (0,node_modules_react.useEffect)(function() {
        var currentTab = tabState.selectedTab;
        var currentScroll = tabState.scrollStates[currentTab];
        if (currentScroll) {
            // console.log("scrolling to", currentScroll);
            window.scrollTo(0, currentScroll);
        }
    }, [
        tabState.selectedTab,
        tabState.scrollStates
    ]);
    var switchTab = function(tab) {
        // console.log(tab);
        tabDispatch({
            type: "switchTab",
            tab: tab,
            scroll: window.scrollY
        });
    };
    var theme = (0,use_theme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "1fr",
            gridTemplateRows: "1fr 4rem",
            gridTemplateAreas: '"content" "tab-nav"',
            width: "100vw",
            backgroundColor: theme.palette.accents_1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                style: {
                    gridArea: "tab-nav",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "4rem",
                    width: "100%",
                    backgroundColor: theme.palette.background,
                    borderTop: "1px solid ".concat(theme.palette.accents_2),
                    position: "fixed",
                    bottom: 0,
                    zIndex: 3
                },
                children: children && children.map(function(child, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            cursor: "pointer"
                        },
                        onClick: function(e) {
                            if (tabState.selectedTab !== index.toString()) {
                                switchTab(index.toString());
                            } else {
                                if (child.onSecondClick) {
                                    child.onSecondClick();
                                }
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
                            auto: true,
                            type: "abort",
                            style: {
                                color: tabState.selectedTab === index.toString() ? theme.palette.success : theme.palette.accents_5
                            },
                            children: child.label
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    gridArea: "content",
                    overflow: "clip"
                },
                children: children && children.map(function(child, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "tab-".concat(index),
                        style: {
                            display: tabState.selectedTab === index.toString() ? "flex" : "none",
                            flexDirection: "column",
                            height: "100%",
                            width: "100%"
                        },
                        children: child.content
                    }, index);
                })
            })
        ]
    });
};
var TabNavContext = /*#__PURE__*/ (0,node_modules_react.createContext)(defaultTabState);
var TabDispatchContext = /*#__PURE__*/ (0,node_modules_react.createContext)(function(action) {});
function TabNavProvider(param) {
    var children = param.children;
    var ref = (0,node_modules_react.useReducer)(scrollReducer, defaultTabState), tabState = ref[0], tabDispatch = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabNavContext.Provider, {
        value: tabState,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabDispatchContext.Provider, {
            value: tabDispatch,
            children: children
        })
    });
}
function useTabNav() {
    return (0,node_modules_react.useContext)(TabNavContext);
}
function useTabDispatch() {
    return (0,node_modules_react.useContext)(TabDispatchContext);
}

;// CONCATENATED MODULE: ./components/layouts/profile_link.tsx








var ProfileLink = function(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    var session = (0,devtools/* dev_maybeMockSession */.vQ)((0,react.useSession)());
    var tabDispatch = useTabDispatch();
    var ProfileLink = /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/profile/?tab=recents",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_link/* default */.Z, {
            color: true,
            onClick: function() {
                return tabDispatch({
                    type: "switchTab",
                    tab: "1",
                    scroll: 0
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    textAlign: "center"
                },
                children: [
                    "More",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Recent",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Images"
                ]
            })
        })
    });
    //only return link if session is defined
    if (session) {
        return ProfileLink;
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
};

;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/fieldset/fieldset-title.js


var fieldset_title_excluded = ["className", "children"];



var fieldset_title_defaultProps = {
  className: ''
};

var FieldsetTitle = function FieldsetTitle(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, fieldset_title_excluded);

  var classes = (0,use_classes/* default */.Z)('title', className);
  return /*#__PURE__*/node_modules_react.createElement(node_modules_react.Fragment, null, /*#__PURE__*/node_modules_react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: "jsx-4105044205" + " " + (props && props.className != null && props.className || classes || "")
  }), children), /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "4105044205"
  }, ".title.jsx-4105044205{line-height:1.5;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;word-break:break-word;font-weight:600;-webkit-letter-spacing:-0.020625em;-moz-letter-spacing:-0.020625em;-ms-letter-spacing:-0.020625em;letter-spacing:-0.020625em;font-size:1.25em;width:auto;}"));
};

FieldsetTitle.defaultProps = fieldset_title_defaultProps;
FieldsetTitle.displayName = 'GeistFieldsetTitle';
/* harmony default export */ var fieldset_title = (FieldsetTitle);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/fieldset/fieldset-subtitle.js


var fieldset_subtitle_excluded = ["className", "children"];


var fieldset_subtitle_defaultProps = {
  className: ''
};

var FieldsetSubtitle = function FieldsetSubtitle(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, fieldset_subtitle_excluded);

  return /*#__PURE__*/node_modules_react.createElement(node_modules_react.Fragment, null, /*#__PURE__*/node_modules_react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: "jsx-2265168013" + " " + (props && props.className != null && props.className || className || "")
  }), children), /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2265168013"
  }, "div.jsx-2265168013{font-size:0.875em;line-height:1.6;-webkit-letter-spacing:-0.005625em;-moz-letter-spacing:-0.005625em;-ms-letter-spacing:-0.005625em;letter-spacing:-0.005625em;margin:0.75em 0;}"));
};

FieldsetSubtitle.defaultProps = fieldset_subtitle_defaultProps;
FieldsetSubtitle.displayName = 'GeistFieldsetSubtitle';
/* harmony default export */ var fieldset_subtitle = (FieldsetSubtitle);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/fieldset/fieldset-footer.js


var fieldset_footer_excluded = ["className", "children"];




var fieldset_footer_defaultProps = {
  className: ''
};

var FieldsetFooterComponent = function FieldsetFooterComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, fieldset_footer_excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  return /*#__PURE__*/node_modules_react.createElement("footer", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["325810729", [theme.palette.accents_1, theme.palette.border, theme.layout.radius, theme.layout.radius, theme.palette.accents_6, theme.layout.gapHalf, theme.layout.gap, SCALES.font(0.875), SCALES.width(1, 'auto'), SCALES.height(2.875), SCALES.pt(0.625), SCALES.pr(1.31), SCALES.pb(0.625), SCALES.pl(1.31), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + (props && props.className != null && props.className || className || "")
  }), children, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "325810729",
    dynamic: [theme.palette.accents_1, theme.palette.border, theme.layout.radius, theme.layout.radius, theme.palette.accents_6, theme.layout.gapHalf, theme.layout.gap, SCALES.font(0.875), SCALES.width(1, 'auto'), SCALES.height(2.875), SCALES.pt(0.625), SCALES.pr(1.31), SCALES.pb(0.625), SCALES.pl(1.31), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]
  }, "footer.__jsx-style-dynamic-selector{background-color:".concat(theme.palette.accents_1, ";border-top:1px dashed ").concat(theme.palette.border, ";border-bottom-left-radius:").concat(theme.layout.radius, ";border-bottom-right-radius:").concat(theme.layout.radius, ";display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow:hidden;color:").concat(theme.palette.accents_6, ";padding:").concat(theme.layout.gapHalf, " ").concat(theme.layout.gap, ";box-sizing:border-box;font-size:").concat(SCALES.font(0.875), ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(2.875), ";padding:").concat(SCALES.pt(0.625), " ").concat(SCALES.pr(1.31), " ").concat(SCALES.pb(0.625), " ").concat(SCALES.pl(1.31), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}")));
};

FieldsetFooterComponent.defaultProps = fieldset_footer_defaultProps;
FieldsetFooterComponent.displayName = 'GeistFieldsetFooter';
var FieldsetFooter = (0,with_scale/* default */.Z)(FieldsetFooterComponent);
/* harmony default export */ var fieldset_footer = (FieldsetFooter);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/fieldset/fieldset-content.js


var fieldset_content_excluded = ["className", "children"];




var fieldset_content_defaultProps = {
  className: ''
};

var FieldsetContentComponent = function FieldsetContentComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, fieldset_content_excluded);

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var classes = (0,use_classes/* default */.Z)('content', className);
  return /*#__PURE__*/node_modules_react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2403982542", [SCALES.width(1, '100%'), SCALES.height(1, 'auto'), SCALES.pt(1.3), SCALES.pr(1.3), SCALES.pb(1.3), SCALES.pl(1.3), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), children, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2403982542",
    dynamic: [SCALES.width(1, '100%'), SCALES.height(1, 'auto'), SCALES.pt(1.3), SCALES.pr(1.3), SCALES.pb(1.3), SCALES.pl(1.3), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]
  }, ".content.__jsx-style-dynamic-selector{width:".concat(SCALES.width(1, '100%'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(1.3), " ").concat(SCALES.pr(1.3), " ").concat(SCALES.pb(1.3), " ").concat(SCALES.pl(1.3), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.content.__jsx-style-dynamic-selector > *:first-child{margin-top:0;}.content.__jsx-style-dynamic-selector > *:last-child{margin-bottom:0;}")));
};

FieldsetContentComponent.defaultProps = fieldset_content_defaultProps;
FieldsetContentComponent.displayName = 'GeistFieldsetContent';
var FieldsetContent = (0,with_scale/* default */.Z)(FieldsetContentComponent);
/* harmony default export */ var fieldset_content = (FieldsetContent);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/fieldset/fieldset-context.js

var fieldset_context_defaultContext = {
  inGroup: false,
  currentValue: ''
};
var FieldsetContext = /*#__PURE__*/node_modules_react.createContext(fieldset_context_defaultContext);
var useFieldset = function useFieldset() {
  return node_modules_react.useContext(FieldsetContext);
};
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-warning.js
var use_warning = __webpack_require__(1421);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/fieldset/fieldset.js



var fieldset_excluded = ["className", "title", "subtitle", "children", "value", "label"];












var fieldset_defaultProps = {
  value: '',
  label: '',
  disabled: false,
  title: '',
  subtitle: '',
  className: ''
};

var FieldsetComponent = function FieldsetComponent(_ref) {
  var className = _ref.className,
      title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children,
      value = _ref.value,
      label = _ref.label,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, fieldset_excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var _useFieldset = useFieldset(),
      inGroup = _useFieldset.inGroup,
      currentValue = _useFieldset.currentValue,
      register = _useFieldset.register;

  var _useState = (0,node_modules_react.useState)(inGroup),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      hidden = _useState2[0],
      setHidden = _useState2[1];

  var classes = (0,use_classes/* default */.Z)('fieldset', className);

  var _pickChild = (0,collections/* pickChild */.xC)(children, fieldset_footer),
      _pickChild2 = (0,slicedToArray/* default */.Z)(_pickChild, 2),
      withoutFooterChildren = _pickChild2[0],
      FooterChildren = _pickChild2[1];

  var hasTitle = (0,collections/* hasChild */.bJ)(withoutFooterChildren, fieldset_title);
  var hasSubtitle = (0,collections/* hasChild */.bJ)(withoutFooterChildren, fieldset_subtitle);
  var hasContent = (0,collections/* hasChild */.bJ)(withoutFooterChildren, fieldset_content);

  if (inGroup) {
    if (!label) {
      (0,use_warning/* default */.Z)('Props "label" is required when in a group.', 'Fieldset Group');
    }

    if (!value || value === '') {
      value = label;
    }

    (0,node_modules_react.useEffect)(function () {
      register && register({
        value: value,
        label: label
      });
    }, []);
    (0,node_modules_react.useEffect)(function () {
      // In a few cases, the user will set Fieldset state manually.
      // If the user incorrectly set the state, Group component should ignore it.

      /* istanbul ignore if */
      if (!currentValue || currentValue === '') return;
      setHidden(currentValue !== value);
    }, [currentValue]);
  }

  var content = (0,node_modules_react.useMemo)(function () {
    return /*#__PURE__*/node_modules_react.createElement(node_modules_react.Fragment, null, withoutFooterChildren, !hasTitle && title && /*#__PURE__*/node_modules_react.createElement(fieldset_title, null, title), !hasSubtitle && subtitle && /*#__PURE__*/node_modules_react.createElement(fieldset_subtitle, null, subtitle));
  }, [withoutFooterChildren, hasTitle, hasSubtitle, title, subtitle]);
  return /*#__PURE__*/node_modules_react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3658101885", [theme.palette.background, theme.palette.border, theme.layout.radius, hidden ? 'none' : 'block', SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), hasContent ? content : /*#__PURE__*/node_modules_react.createElement(fieldset_content, null, content), FooterChildren && FooterChildren, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3658101885",
    dynamic: [theme.palette.background, theme.palette.border, theme.layout.radius, hidden ? 'none' : 'block', SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]
  }, ".fieldset.__jsx-style-dynamic-selector{background-color:".concat(theme.palette.background, ";border:1px dashed ").concat(theme.palette.border, ";border-radius:").concat(theme.layout.radius, ";overflow:hidden;display:").concat(hidden ? 'none' : 'block', ";font-size:").concat(SCALES.font(1), ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}")));
};

FieldsetComponent.defaultProps = fieldset_defaultProps;
FieldsetComponent.displayName = 'GeistFieldset';
var Fieldset = (0,with_scale/* default */.Z)(FieldsetComponent);
/* harmony default export */ var fieldset = (Fieldset);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(1451);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/fieldset/fieldset-group.js




var fieldset_group_excluded = ["className", "children", "value", "onChange"];








var fieldset_group_defaultProps = {
  className: ''
};

var FieldsetGroupComponent = function FieldsetGroupComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      value = _ref.value,
      onChange = _ref.onChange,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, fieldset_group_excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var _useState = (0,node_modules_react.useState)(value),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selfVal = _useState2[0],
      setSelfVal = _useState2[1];

  var _useCurrentState = (0,use_current_state/* default */.Z)([]),
      _useCurrentState2 = (0,slicedToArray/* default */.Z)(_useCurrentState, 3),
      items = _useCurrentState2[0],
      setItems = _useCurrentState2[1],
      ref = _useCurrentState2[2];

  var classes = (0,use_classes/* default */.Z)('group', className);

  var register = function register(newItem) {
    var hasItem = ref.current.find(function (item) {
      return item.value === newItem.value;
    });

    if (hasItem) {
      (0,use_warning/* default */.Z)('The "value" of each "Fieldset" must be unique.', 'Fieldset');
    }

    setItems([].concat((0,toConsumableArray/* default */.Z)(ref.current), [newItem]));
  };

  var providerValue = (0,node_modules_react.useMemo)(function () {
    return {
      currentValue: selfVal,
      inGroup: true,
      register: register
    };
  }, [selfVal]);
  var clickHandle = (0,node_modules_react.useCallback)(function (nextValue) {
    setSelfVal(nextValue);
    onChange && onChange(nextValue);
  }, [onChange]);
  return /*#__PURE__*/node_modules_react.createElement(FieldsetContext.Provider, {
    value: providerValue
  }, /*#__PURE__*/node_modules_react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1359959305", [SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0, 0), SCALES.ml(0), SCALES.font(1), theme.palette.accents_3, theme.palette.accents_1, theme.palette.border, theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.layout.radius]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), /*#__PURE__*/node_modules_react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1359959305", [SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0, 0), SCALES.ml(0), SCALES.font(1), theme.palette.accents_3, theme.palette.accents_1, theme.palette.border, theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.layout.radius]]]) + " " + "group-tabs"
  }, items.map(function (item) {
    return /*#__PURE__*/node_modules_react.createElement("button", {
      onClick: function onClick() {
        return clickHandle(item.value);
      },
      key: item.value,
      className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1359959305", [SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0, 0), SCALES.ml(0), SCALES.font(1), theme.palette.accents_3, theme.palette.accents_1, theme.palette.border, theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.layout.radius]]]) + " " + ((selfVal === item.value ? 'active' : '') || "")
    }, item.label);
  })), /*#__PURE__*/node_modules_react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1359959305", [SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0, 0), SCALES.ml(0), SCALES.font(1), theme.palette.accents_3, theme.palette.accents_1, theme.palette.border, theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.layout.radius]]]) + " " + "group-content"
  }, children), /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "1359959305",
    dynamic: [SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0, 0), SCALES.ml(0), SCALES.font(1), theme.palette.accents_3, theme.palette.accents_1, theme.palette.border, theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.layout.radius]
  }, ".group.__jsx-style-dynamic-selector{width:".concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0, 0), " ").concat(SCALES.ml(0), ";}.group-tabs.__jsx-style-dynamic-selector{white-space:nowrap;overflow-y:hidden;overflow-x:auto;font-size:").concat(SCALES.font(1), ";margin-bottom:-1px;}.group-content.__jsx-style-dynamic-selector{border-top-left-radius:0;overflow:hidden;}.group-content.__jsx-style-dynamic-selector .fieldset{border-top-left-radius:0;}button.__jsx-style-dynamic-selector{height:2.7em;line-height:2.7em;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:").concat(theme.palette.accents_3, ";background-color:").concat(theme.palette.accents_1, ";font-size:0.875em;white-space:nowrap;text-transform:capitalize;-webkit-appearance:none;cursor:pointer;margin:0;padding:0 1.45em;overflow:hidden;-webkit-transition:all 0.2s ease 0s;transition:all 0.2s ease 0s;border-radius:0;border:2px solid ").concat(theme.palette.border, ";-webkit-text-decoration:none;text-decoration:none;outline:none;}button.active.__jsx-style-dynamic-selector{border-bottom-color:transparent;background-color:").concat(theme.palette.background, ";color:").concat(theme.palette.foreground, ";cursor:default;}button.__jsx-style-dynamic-selector:first-of-type{border-top-left-radius:").concat(theme.layout.radius, ";}button.__jsx-style-dynamic-selector:last-of-type{border-top-right-radius:").concat(theme.layout.radius, ";}button.__jsx-style-dynamic-selector+button.__jsx-style-dynamic-selector{border-left:0;}"))));
};

FieldsetGroupComponent.defaultProps = fieldset_group_defaultProps;
FieldsetGroupComponent.displayName = 'GeistFieldsetGroup';
var FieldsetGroup = (0,with_scale/* default */.Z)(FieldsetGroupComponent);
/* harmony default export */ var fieldset_group = (FieldsetGroup);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/fieldset/index.js






fieldset.Title = fieldset_title;
fieldset.Subtitle = fieldset_subtitle;
fieldset.Footer = fieldset_footer;
fieldset.Group = fieldset_group;
fieldset.Content = fieldset_content;
fieldset.Body = fieldset_content;
/* harmony default export */ var esm_fieldset = (fieldset);
// EXTERNAL MODULE: ./utils/use_blur.ts + 1 modules
var use_blur = __webpack_require__(8206);
;// CONCATENATED MODULE: ./components/layouts/recents_grid/queue_item.tsx




// FIXME: pass meaningful alt text here
var QueueItem = function(param) {
    var maybe_blur = param.maybe_blur, maybe_image_url = param.maybe_image_url, status = param.status, openLightboxCallback = param.openLightboxCallback;
    var theme = (0,use_theme/* default */.Z)();
    // is 200x200 right? should it be 100%x100%?
    var blur_url = (0,use_blur/* useBlur */.uD)(maybe_blur, 200, 200);
    // causes a render loop
    // const [img_url, setImgUrl] = useState(blur_url);
    // if (maybe_image_url) {
    //   // not sure if this is executed at the right time?
    //   // otherwise this can cause a small flicker when image_url becomes set
    //   // src={maybe_image_url ?? blur_url}
    //   setImgUrl(maybe_image_url);
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            padding: 0,
            margin: 0,
            border: 0,
            height: "100%",
            width: "100%",
            borderRadius: "0.5rem",
            cursor: "pointer",
            baselineShift: "sub"
        },
        children: maybe_blur || maybe_image_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: maybe_image_url !== null && maybe_image_url !== void 0 ? maybe_image_url : blur_url,
            className: maybe_image_url || maybe_blur ? "" : "loadingDiv",
            width: "100%",
            height: "100%",
            style: {
                borderRadius: "0.5rem"
            },
            alt: "Generated image",
            onClick: openLightboxCallback,
            placeholder: "blur",
            blurDataURL: blur_url,
            loading: "eager"
        }) : status === "assigned" || status === "pending" || status === "uploading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                width: "100%",
                height: "100%",
                borderRadius: "0.5rem",
                padding: "0"
            },
            className: "loadingDiv"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_fieldset, {
            style: {
                height: "100%",
                background: "inherit",
                borderColor: theme.palette.error,
                color: theme.palette.error,
                borderRadius: "0.5rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                style: {
                    textAlign: "center",
                    wordBreak: "break-word"
                },
                type: "error",
                children: "Failed"
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/layouts/recents_grid/recents_grid.tsx










var RecentsGrid = function() {
    var initialRef = (0,node_modules_react.useRef)(null);
    var ref = useSize({
        initialRef: initialRef
    }), ref1 = ref.ref, size = ref.size;
    var session = (0,devtools/* dev_maybeMockSession */.vQ)((0,react.useSession)());
    var ref2 = (0,node_modules_react.useState)(0), numImages = ref2[0], setNumImages = ref2[1];
    var openWithLightbox = (0,node_modules_react.useContext)(lightbox_context/* LightboxContext */.p).openWithLightbox;
    (0,node_modules_react.useLayoutEffect)(function() {
        setNumImages(size ? Math.floor(size.width / 102) - 1 : 3);
    }, [
        size,
        numImages
    ]);
    var ref3 = (0,dist/* default */.ZP)(function() {
        return session ? "/api/prompts?user_id=".concat(session.user_id, "&limit=", 9, "&queue=true") : null;
    }, swr/* fetcher */._i, {
        refreshInterval: function(data) {
            // console.log("refreshInterval data is", data);
            if (!data) {
                // console.log("refreshInterval data is", data);
                return 500;
            }
            // console.log("refreshInterval data is finally not none!!!");
            // Need to understand what causes a failure better - as this seems to happen often
            // @ts-ignore
            if (data.status === "failure") {
                console.log("failure, waiting 10s:", data);
                return 10 * 1000;
            }
            //check if any prompt has a status of "in progress"
            var promptsInProgress = data.prompts.some(function(prompt) {
                return prompt.status === "uploading" || prompt.status === "assigned" || prompt.status === "pending";
            });
            //console.log("Prompts in progress: ", promptsInProgress);
            // TODO: We should perhaps stop polling every 0.5s after a certain amount of time
            // Maybe like 2 minutes or so?
            // Need to mostly figure out/test how date works on prompts
            var wait = promptsInProgress ? 500 : 180 * 1000;
            // console.log(`waiting ${wait}`);
            return wait;
        },
        // Need to see if the 500ms will actually work
        // These defaults might stop it:
        dedupingInterval: 500,
        focusThrottleInterval: 500
    }), data = ref3.data, error = ref3.error;
    if (error || !data || !data.prompts) {
        //console.log("data is", data);
        //console.log("error", error);
        return null;
    } else {
        //console.log("data", data);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: ref1,
            style: {
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, 6rem)",
                gridTemplateRows: "repeat(auto-fit, 6rem)",
                gap: "0.5rem",
                paddingTop: "1rem",
                width: "100%",
                maxWidth: "100%",
                placeContent: "center",
                placeItems: "center",
                alignmentBaseline: "middle"
            },
            children: [
                data.prompts.slice(0, numImages).map(function(prompt, index) {
                    var ref, ref1, ref2, ref3;
                    var maybe_blur = (ref = prompt.outputs) === null || ref === void 0 ? void 0 : (ref1 = ref.blurhashes) === null || ref1 === void 0 ? void 0 : ref1[0];
                    var maybe_image_url = (ref2 = prompt.outputs) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image_urls) === null || ref3 === void 0 ? void 0 : ref3[0];
                    var openLightboxCallback = openWithLightbox(prompt, 0);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QueueItem, {
                        status: prompt.status,
                        maybe_blur: maybe_blur,
                        maybe_image_url: maybe_image_url,
                        openLightboxCallback: openLightboxCallback
                    }, prompt.id);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        minHeight: "96px",
                        display: "flex",
                        flexDirection: "column",
                        placeContent: "center",
                        placeItems: "center"
                    },
                    children: data.prompts.length >= numImages && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileLink, {})
                })
            ]
        });
    }
};

;// CONCATENATED MODULE: ./components/layouts/generator_area.tsx








// @ts-ignore
var GeneratorArea = function(param) {
    var topNavHeight = param.topNavHeight, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    var initialRef = (0,node_modules_react.useRef)(null);
    var ref = useSize({
        initialRef: initialRef
    }), ref1 = ref.ref, size = ref.size;
    var commonAreaStyles = {
        position: "sticky",
        top: topNavHeight
    };
    var areaStyle = fullWidth ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonAreaStyles), {
        height: "100%",
        display: "grid",
        alignContent: "start",
        paddingBottom: "4rem"
    }) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonAreaStyles), {
        overflowY: "auto",
        maxWidth: "100%",
        paddingLeft: "0.685rem",
        paddingRight: "0.685rem"
    });
    var commonFormStyles = {
        //@ts-ignore
        paddingTop: size ? size.width > 436.6 ? "3.1rem" : "6.2rem" : 0,
        paddingBottom: "4rem"
    };
    var formStyle = fullWidth ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFormStyles), {
        width: "100%",
        height: "100%",
        minHeight: "1vw"
    }) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFormStyles), {
        position: "sticky",
        top: topNavHeight,
        zIndex: -1,
        overflowY: "auto",
        maxWidth: "100%",
        maxHeight: "calc(100vh - ".concat(topNavHeight, ")")
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref1,
        id: "generator-area",
        className: "no-scroll",
        style: areaStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneratorBar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "generator-form",
                className: "no-scroll",
                style: formStyle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Generator, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentsGrid, {})
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/menu.js
var menu = __webpack_require__(4083);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-body-scroll.js + 2 modules
var use_body_scroll = __webpack_require__(6121);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-keyboard/index.js + 2 modules
var use_keyboard = __webpack_require__(2631);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-keyboard/codes.js
var codes = __webpack_require__(7513);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/shared/backdrop.js
var backdrop = __webpack_require__(4552);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/drawer/helper.js

var drawerPlacement = (0,prop_types/* tuple */.b)('top', 'right', 'bottom', 'left');
var getDrawerTransform = function getDrawerTransform(placement) {
  var translates = {
    top: {
      initial: 'translate3d(0, -100%, 0)',
      hidden: 'translate3d(0, -100%, 0)',
      visible: 'translate3d(0, 0, 0)'
    },
    left: {
      initial: 'translate3d(-100%, 0, 0)',
      hidden: 'translate3d(-100%, 0, 0)',
      visible: 'translate3d(0, 0, 0)'
    },
    bottom: {
      initial: 'translate3d(0, 100%, 0)',
      hidden: 'translate3d(0, 100%, 0)',
      visible: 'translate3d(0, 0, 0)'
    },
    right: {
      initial: 'translate3d(100%, 0, 0)',
      hidden: 'translate3d(100%, 0, 0)',
      visible: 'translate3d(0, 0, 0)'
    }
  };
  return translates[placement];
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/drawer/drawer-wrapper.js


var drawer_wrapper_excluded = ["className", "children", "visible", "placement"];








var drawer_wrapper_defaultProps = {
  className: '',
  visible: false
};

var DrawerWrapper = function DrawerWrapper(_ref) {
  var className = _ref.className,
      children = _ref.children,
      visible = _ref.visible,
      placement = _ref.placement,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, drawer_wrapper_excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var modalContent = (0,node_modules_react.useRef)(null);
  var tabStart = (0,node_modules_react.useRef)(null);
  var tabEnd = (0,node_modules_react.useRef)(null);
  var transform = (0,node_modules_react.useMemo)(function () {
    return getDrawerTransform(placement);
  }, [placement]);
  var classes = (0,use_classes/* default */.Z)('wrapper', placement, className);
  (0,node_modules_react.useEffect)(function () {
    if (!visible) return;
    var activeElement = document.activeElement;
    var isChild = (0,collections/* isChildElement */.Tv)(modalContent.current, activeElement);
    if (isChild) return;
    tabStart.current && tabStart.current.focus();
  }, [visible]);

  var onKeyDown = function onKeyDown(event) {
    var isTabDown = event.keyCode === 9;
    if (!visible || !isTabDown) return;
    var activeElement = document.activeElement;

    if (event.shiftKey) {
      if (activeElement === tabStart.current) {
        tabEnd.current && tabEnd.current.focus();
      }
    } else {
      if (activeElement === tabEnd.current) {
        tabStart.current && tabStart.current.focus();
      }
    }
  };

  return /*#__PURE__*/node_modules_react.createElement(css_transition/* default */.Z, {
    name: "wrapper",
    visible: visible,
    clearTime: 300
  }, /*#__PURE__*/node_modules_react.createElement("div", (0,esm_extends/* default */.Z)({
    role: "dialog",
    tabIndex: -1,
    onKeyDown: onKeyDown,
    ref: modalContent
  }, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["611376462", [theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.expressiveness.shadowLarge, transform.initial, SCALES.font(1), SCALES.pl(1.3125), SCALES.pr(1.3125), SCALES.pt(1.3125), SCALES.pb(1.3125), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.width(1, '100%'), SCALES.height(1, 'auto'), SCALES.width(1, 'auto'), SCALES.height(1, '100%'), transform.hidden, transform.visible, transform.visible, transform.hidden]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), /*#__PURE__*/node_modules_react.createElement("div", {
    tabIndex: 0,
    "aria-hidden": "true",
    ref: tabStart,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["611376462", [theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.expressiveness.shadowLarge, transform.initial, SCALES.font(1), SCALES.pl(1.3125), SCALES.pr(1.3125), SCALES.pt(1.3125), SCALES.pb(1.3125), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.width(1, '100%'), SCALES.height(1, 'auto'), SCALES.width(1, 'auto'), SCALES.height(1, '100%'), transform.hidden, transform.visible, transform.visible, transform.hidden]]]) + " " + "hide-tab start"
  }), children, /*#__PURE__*/node_modules_react.createElement("div", {
    tabIndex: 0,
    "aria-hidden": "true",
    ref: tabEnd,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["611376462", [theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.expressiveness.shadowLarge, transform.initial, SCALES.font(1), SCALES.pl(1.3125), SCALES.pr(1.3125), SCALES.pt(1.3125), SCALES.pb(1.3125), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.width(1, '100%'), SCALES.height(1, 'auto'), SCALES.width(1, 'auto'), SCALES.height(1, '100%'), transform.hidden, transform.visible, transform.visible, transform.hidden]]]) + " " + "hide-tab end"
  }), /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "611376462",
    dynamic: [theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.expressiveness.shadowLarge, transform.initial, SCALES.font(1), SCALES.pl(1.3125), SCALES.pr(1.3125), SCALES.pt(1.3125), SCALES.pb(1.3125), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.width(1, '100%'), SCALES.height(1, 'auto'), SCALES.width(1, 'auto'), SCALES.height(1, '100%'), transform.hidden, transform.visible, transform.visible, transform.hidden]
  }, ".wrapper.__jsx-style-dynamic-selector{position:fixed;top:0;left:0;right:0;bottom:0;max-width:100%;vertical-align:middle;overflow:auto;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;box-sizing:border-box;background-color:".concat(theme.palette.background, ";color:").concat(theme.palette.foreground, ";border-radius:calc(2 * ").concat(theme.layout.radius, ");box-shadow:").concat(theme.expressiveness.shadowLarge, ";opacity:0;outline:none;-webkit-transform:").concat(transform.initial, ";-ms-transform:").concat(transform.initial, ";transform:").concat(transform.initial, ";-webkit-transition:opacity,-webkit-transform 400ms cubic-bezier(0.1,0.6,0.1,1);-webkit-transition:opacity,transform 400ms cubic-bezier(0.1,0.6,0.1,1);transition:opacity,transform 400ms cubic-bezier(0.1,0.6,0.1,1);font-size:").concat(SCALES.font(1), ";--modal-wrapper-padding-left:").concat(SCALES.pl(1.3125), ";--modal-wrapper-padding-right:").concat(SCALES.pr(1.3125), ";padding:").concat(SCALES.pt(1.3125), " var(--modal-wrapper-padding-right) ").concat(SCALES.pb(1.3125), " var(--modal-wrapper-padding-left);margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.top.__jsx-style-dynamic-selector,.bottom.__jsx-style-dynamic-selector{width:").concat(SCALES.width(1, '100%'), ";height:").concat(SCALES.height(1, 'auto'), ";}.left.__jsx-style-dynamic-selector,.right.__jsx-style-dynamic-selector{width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, '100%'), ";}.top.__jsx-style-dynamic-selector{bottom:auto;border-top-left-radius:0;border-top-right-radius:0;}.left.__jsx-style-dynamic-selector{right:auto;border-top-left-radius:0;border-bottom-left-radius:0;}.bottom.__jsx-style-dynamic-selector{top:auto;border-bottom-left-radius:0;border-bottom-right-radius:0;}.right.__jsx-style-dynamic-selector{left:auto;border-top-right-radius:0;border-bottom-right-radius:0;}.wrapper-enter.__jsx-style-dynamic-selector{opacity:0;-webkit-transform:").concat(transform.hidden, ";-ms-transform:").concat(transform.hidden, ";transform:").concat(transform.hidden, ";}.wrapper-enter-active.__jsx-style-dynamic-selector{opacity:1;-webkit-transform:").concat(transform.visible, ";-ms-transform:").concat(transform.visible, ";transform:").concat(transform.visible, ";}.wrapper-leave.__jsx-style-dynamic-selector{opacity:1;-webkit-transform:").concat(transform.visible, ";-ms-transform:").concat(transform.visible, ";transform:").concat(transform.visible, ";-webkit-transition:opacity,-webkit-transform 400ms cubic-bezier(0.1,0.2,0.1,1);-webkit-transition:opacity,transform 400ms cubic-bezier(0.1,0.2,0.1,1);transition:opacity,transform 400ms cubic-bezier(0.1,0.2,0.1,1);}.wrapper-leave-active.__jsx-style-dynamic-selector{opacity:0.4;-webkit-transform:").concat(transform.hidden, ";-ms-transform:").concat(transform.hidden, ";transform:").concat(transform.hidden, ";}.hide-tab.__jsx-style-dynamic-selector{outline:none;overflow:hidden;width:0;height:0;opacity:0;}"))));
};

DrawerWrapper.defaultProps = drawer_wrapper_defaultProps;
DrawerWrapper.displayName = 'GeistDrawerWrapper';
/* harmony default export */ var drawer_wrapper = (DrawerWrapper);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/drawer/drawer.js



var drawer_excluded = ["visible", "keyboard", "disableBackdropClick", "onClose", "onContentClick", "wrapClassName", "children"];








var drawer_defaultProps = {
  wrapClassName: '',
  keyboard: true,
  disableBackdropClick: false,
  placement: 'right'
};

var DrawerComponent = function DrawerComponent(_ref) {
  var customVisible = _ref.visible,
      keyboard = _ref.keyboard,
      disableBackdropClick = _ref.disableBackdropClick,
      onClose = _ref.onClose,
      onContentClick = _ref.onContentClick,
      wrapClassName = _ref.wrapClassName,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, drawer_excluded);

  var portal = (0,use_portal/* default */.Z)('drawer');

  var _useState = (0,node_modules_react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useBodyScroll = (0,use_body_scroll/* default */.Z)(null, {
    delayReset: 300
  }),
      _useBodyScroll2 = (0,slicedToArray/* default */.Z)(_useBodyScroll, 2),
      setBodyHidden = _useBodyScroll2[1];

  var closeDrawer = function closeDrawer() {
    onClose && onClose();
    setVisible(false);
    setBodyHidden(false);
  };

  (0,node_modules_react.useEffect)(function () {
    if (typeof customVisible === 'undefined') return;
    setVisible(customVisible);
    setBodyHidden(customVisible);
  }, [customVisible]);

  var _useKeyboard = (0,use_keyboard/* default */.ZP)(function () {
    keyboard && closeDrawer();
  }, codes/* KeyCode.Escape */.V.Escape, {
    disableGlobalEvent: true
  }),
      bindings = _useKeyboard.bindings;

  var closeFromBackdrop = function closeFromBackdrop() {
    if (disableBackdropClick) return;
    closeDrawer();
  };

  if (!portal) return null;
  return /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/node_modules_react.createElement(backdrop/* default */.Z, (0,esm_extends/* default */.Z)({
    onClick: closeFromBackdrop,
    onContentClick: onContentClick,
    visible: visible,
    width: "100%"
  }, bindings), /*#__PURE__*/node_modules_react.createElement(drawer_wrapper, (0,esm_extends/* default */.Z)({
    visible: visible,
    className: wrapClassName
  }, props), children)), portal);
};

DrawerComponent.defaultProps = drawer_defaultProps;
DrawerComponent.displayName = 'GeistDrawer';
var Drawer = (0,with_scale/* default */.Z)(DrawerComponent);
/* harmony default export */ var drawer = (Drawer);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/modal/modal-title.js
var modal_title = __webpack_require__(9129);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/modal/modal-subtitle.js
var modal_subtitle = __webpack_require__(7528);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/modal/modal-content.js
var modal_content = __webpack_require__(7489);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/drawer/index.js




drawer.Title = modal_title/* default */.Z;
drawer.Subtitle = modal_subtitle/* default */.Z;
drawer.Content = modal_content/* default */.Z;
/* harmony default export */ var esm_drawer = (drawer);
// EXTERNAL MODULE: ./components/modals/upsell_modal.tsx
var upsell_modal = __webpack_require__(1123);
// EXTERNAL MODULE: ./components/avatar.tsx
var avatar = __webpack_require__(8063);
;// CONCATENATED MODULE: ./components/login.tsx








var Login = function(param) {
    var toggleLogin = param.toggleLogin;
    var session = (0,devtools/* dev_maybeMockSession */.vQ)((0,react.useSession)());
    var ref;
    var data = (0,dist/* default */.ZP)(function() {
        if (!session || !(session === null || session === void 0 ? void 0 : session.user_id)) {
            return null;
        }
        return "/api/user/".concat(session === null || session === void 0 ? void 0 : session.user_id, "/avatar");
    }, swr/* fetcher */._i, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        fallbackData: {
            src: (ref = session === null || session === void 0 ? void 0 : session.picture) !== null && ref !== void 0 ? ref : "",
            status: "success"
        }
    }).data;
    if (session) {
        var _src;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                alignSelf: "stretch"
            },
            children: [
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/profile?tab=recents",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.Z, {
                            alt: "Profile",
                            src: !data ? undefined : (_src = data.src) !== null && _src !== void 0 ? _src : "/images/default_user.png",
                            scale: 2,
                            text: session.username
                        })
                    })
                }),
                " "
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            alignSelf: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
            type: "success",
            onClick: function() {
                return toggleLogin();
            },
            children: "Sign in"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/tool.js
var tool = __webpack_require__(5840);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/radio/radio-context.js

var radio_context_defaultContext = {
  disabledAll: false,
  inGroup: false
};
var RadioContext = /*#__PURE__*/node_modules_react.createContext(radio_context_defaultContext);
var useRadioContext = function useRadioContext() {
  return node_modules_react.useContext(RadioContext);
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/radio/radio-description.js


var radio_description_excluded = ["className", "children"];




var radio_description_defaultProps = {
  className: ''
};

var RadioDescriptionComponent = function RadioDescriptionComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, radio_description_excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  return /*#__PURE__*/node_modules_react.createElement("span", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2489497926", [theme.palette.accents_3, SCALES.font(0.85, 'calc(var(--radio-size) * 0.85)'), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0, 'calc(var(--radio-size) + var(--radio-size) * 0.375)')]]]) + " " + (props && props.className != null && props.className || className || "")
  }), children, /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2489497926",
    dynamic: [theme.palette.accents_3, SCALES.font(0.85, 'calc(var(--radio-size) * 0.85)'), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0, 'calc(var(--radio-size) + var(--radio-size) * 0.375)')]
  }, "span.__jsx-style-dynamic-selector{color:".concat(theme.palette.accents_3, ";font-size:").concat(SCALES.font(0.85, 'calc(var(--radio-size) * 0.85)'), ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0, 'calc(var(--radio-size) + var(--radio-size) * 0.375)'), ";}")));
};

RadioDescriptionComponent.defaultProps = radio_description_defaultProps;
RadioDescriptionComponent.displayName = 'GeistRadioDescription';
var RadioDescription = (0,with_scale/* default */.Z)(RadioDescriptionComponent);
/* harmony default export */ var radio_description = (RadioDescription);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/radio/styles.js
var radio_styles_getColors = function getColors(palette, status) {
  var colors = {
    "default": {
      label: palette.foreground,
      border: palette.border,
      bg: palette.foreground
    },
    secondary: {
      label: palette.foreground,
      border: palette.border,
      bg: palette.foreground
    },
    success: {
      label: palette.success,
      border: palette.success,
      bg: palette.success
    },
    warning: {
      label: palette.warning,
      border: palette.warning,
      bg: palette.warning
    },
    error: {
      label: palette.error,
      border: palette.error,
      bg: palette.error
    }
  };
  if (!status) return colors["default"];
  return colors[status];
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/radio/radio.js



var radio_excluded = ["className", "checked", "onChange", "disabled", "type", "value", "children"];










var radio_defaultProps = {
  type: 'default',
  disabled: false,
  className: ''
};

var RadioComponent = function RadioComponent(_ref) {
  var className = _ref.className,
      checked = _ref.checked,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      type = _ref.type,
      radioValue = _ref.value,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, radio_excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var _useState = (0,node_modules_react.useState)(!!checked),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selfChecked = _useState2[0],
      setSelfChecked = _useState2[1];

  var _useRadioContext = useRadioContext(),
      groupValue = _useRadioContext.value,
      disabledAll = _useRadioContext.disabledAll,
      inGroup = _useRadioContext.inGroup,
      updateState = _useRadioContext.updateState;

  var _pickChild = (0,collections/* pickChild */.xC)(children, radio_description),
      _pickChild2 = (0,slicedToArray/* default */.Z)(_pickChild, 2),
      withoutDescChildren = _pickChild2[0],
      DescChildren = _pickChild2[1];

  if (inGroup) {
    if (checked !== undefined) {
      (0,use_warning/* default */.Z)('Remove props "checked" if in the Radio.Group.', 'Radio');
    }

    if (radioValue === undefined) {
      (0,use_warning/* default */.Z)('Props "value" must be deinfed if in the Radio.Group.', 'Radio');
    }

    (0,node_modules_react.useEffect)(function () {
      setSelfChecked(groupValue === radioValue);
    }, [groupValue, radioValue]);
  }

  var _useMemo = (0,node_modules_react.useMemo)(function () {
    return radio_styles_getColors(theme.palette, type);
  }, [theme.palette, type]),
      label = _useMemo.label,
      border = _useMemo.border,
      bg = _useMemo.bg;

  var isDisabled = (0,node_modules_react.useMemo)(function () {
    return disabled || disabledAll;
  }, [disabled, disabledAll]);

  var changeHandler = function changeHandler(event) {
    if (isDisabled) return;
    var selfEvent = {
      target: {
        checked: !selfChecked
      },
      stopPropagation: event.stopPropagation,
      preventDefault: event.preventDefault,
      nativeEvent: event
    };
    setSelfChecked(!selfChecked);

    if (inGroup) {
      updateState && updateState(radioValue);
    }

    onChange && onChange(selfEvent);
  };

  (0,node_modules_react.useEffect)(function () {
    if (checked === undefined) return;
    setSelfChecked(Boolean(checked));
  }, [checked]);
  return /*#__PURE__*/node_modules_react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2664604043", [SCALES.font(1), SCALES.width(1, 'initial'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), isDisabled ? theme.palette.accents_4 : label, isDisabled ? 'not-allowed' : 'pointer', border, isDisabled ? theme.palette.accents_4 : bg]]]) + " " + ((0,use_classes/* default */.Z)('radio', className) || "")
  }, /*#__PURE__*/node_modules_react.createElement("label", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2664604043", [SCALES.font(1), SCALES.width(1, 'initial'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), isDisabled ? theme.palette.accents_4 : label, isDisabled ? 'not-allowed' : 'pointer', border, isDisabled ? theme.palette.accents_4 : bg]]])
  }, /*#__PURE__*/node_modules_react.createElement("input", (0,esm_extends/* default */.Z)({
    type: "radio",
    value: radioValue,
    checked: selfChecked,
    onChange: changeHandler
  }, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2664604043", [SCALES.font(1), SCALES.width(1, 'initial'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), isDisabled ? theme.palette.accents_4 : label, isDisabled ? 'not-allowed' : 'pointer', border, isDisabled ? theme.palette.accents_4 : bg]]]) + " " + (props && props.className != null && props.className || "")
  })), /*#__PURE__*/node_modules_react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2664604043", [SCALES.font(1), SCALES.width(1, 'initial'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), isDisabled ? theme.palette.accents_4 : label, isDisabled ? 'not-allowed' : 'pointer', border, isDisabled ? theme.palette.accents_4 : bg]]]) + " " + "name"
  }, /*#__PURE__*/node_modules_react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2664604043", [SCALES.font(1), SCALES.width(1, 'initial'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), isDisabled ? theme.palette.accents_4 : label, isDisabled ? 'not-allowed' : 'pointer', border, isDisabled ? theme.palette.accents_4 : bg]]]) + " " + ((0,use_classes/* default */.Z)('point', {
      active: selfChecked
    }) || "")
  }), withoutDescChildren), DescChildren && DescChildren), /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2664604043",
    dynamic: [SCALES.font(1), SCALES.width(1, 'initial'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), isDisabled ? theme.palette.accents_4 : label, isDisabled ? 'not-allowed' : 'pointer', border, isDisabled ? theme.palette.accents_4 : bg]
  }, "input.__jsx-style-dynamic-selector{opacity:0;visibility:hidden;overflow:hidden;width:1px;height:1px;top:-1000px;right:-1000px;position:fixed;font-size:0;}.radio.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;position:relative;--radio-size:".concat(SCALES.font(1), ";width:").concat(SCALES.width(1, 'initial'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}label.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;color:").concat(isDisabled ? theme.palette.accents_4 : label, ";cursor:").concat(isDisabled ? 'not-allowed' : 'pointer', ";}.name.__jsx-style-dynamic-selector{font-size:var(--radio-size);font-weight:bold;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}.point.__jsx-style-dynamic-selector{height:var(--radio-size);width:var(--radio-size);border-radius:50%;border:1px solid ").concat(border, ";-webkit-transition:all 0.2s ease 0s;transition:all 0.2s ease 0s;position:relative;display:inline-block;-webkit-transform:scale(0.875);-ms-transform:scale(0.875);transform:scale(0.875);margin-right:calc(var(--radio-size) * 0.375);}.point.__jsx-style-dynamic-selector:before{content:'';position:absolute;left:-1px;top:-1px;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);height:var(--radio-size);width:var(--radio-size);border-radius:50%;background-color:").concat(isDisabled ? theme.palette.accents_4 : bg, ";}.active.__jsx-style-dynamic-selector:before{-webkit-transform:scale(0.875);-ms-transform:scale(0.875);transform:scale(0.875);-webkit-transition:all 0.2s ease 0s;transition:all 0.2s ease 0s;}")));
};

RadioComponent.defaultProps = radio_defaultProps;
RadioComponent.displayName = 'GeistRadio';
var Radio = (0,with_scale/* default */.Z)(RadioComponent);
/* harmony default export */ var radio_radio = (Radio);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/radio/radio-group.js



var radio_group_excluded = ["disabled", "onChange", "value", "children", "className", "initialValue", "useRow"];





var radio_group_defaultProps = {
  disabled: false,
  className: '',
  useRow: false
};

var RadioGroupComponent = function RadioGroupComponent(_ref) {
  var disabled = _ref.disabled,
      onChange = _ref.onChange,
      value = _ref.value,
      children = _ref.children,
      className = _ref.className,
      initialValue = _ref.initialValue,
      useRow = _ref.useRow,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, radio_group_excluded);

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var _useState = (0,node_modules_react.useState)(initialValue),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selfVal = _useState2[0],
      setSelfVal = _useState2[1];

  var updateState = function updateState(nextValue) {
    setSelfVal(nextValue);
    onChange && onChange(nextValue);
  };

  var providerValue = (0,node_modules_react.useMemo)(function () {
    return {
      updateState: updateState,
      disabledAll: disabled,
      inGroup: true,
      value: selfVal
    };
  }, [disabled, selfVal]);
  (0,node_modules_react.useEffect)(function () {
    if (value === undefined) return;
    setSelfVal(value);
  }, [value]);
  return /*#__PURE__*/node_modules_react.createElement(RadioContext.Provider, {
    value: providerValue
  }, /*#__PURE__*/node_modules_react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1223822443", [useRow ? 'col' : 'column', SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), useRow ? 0 : 'var(--radio-group-gap)', useRow ? 'var(--radio-group-gap)' : 0, SCALES.font(1)]]]) + " " + (props && props.className != null && props.className || (0,use_classes/* default */.Z)('radio-group', className) || "")
  }), children), /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "1223822443",
    dynamic: [useRow ? 'col' : 'column', SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), useRow ? 0 : 'var(--radio-group-gap)', useRow ? 'var(--radio-group-gap)' : 0, SCALES.font(1)]
  }, ".radio-group.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:".concat(useRow ? 'col' : 'column', ";-ms-flex-direction:").concat(useRow ? 'col' : 'column', ";flex-direction:").concat(useRow ? 'col' : 'column', ";--radio-group-gap:").concat(SCALES.font(1), ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.radio-group.__jsx-style-dynamic-selector .radio{margin-top:").concat(useRow ? 0 : 'var(--radio-group-gap)', ";margin-left:").concat(useRow ? 'var(--radio-group-gap)' : 0, ";--radio-size:").concat(SCALES.font(1), ";}.radio-group.__jsx-style-dynamic-selector .radio:first-of-type{margin:0;}")));
};

RadioGroupComponent.defaultProps = radio_group_defaultProps;
RadioGroupComponent.displayName = 'GeistRadioGroup';
var RadioGroup = (0,with_scale/* default */.Z)(RadioGroupComponent);
/* harmony default export */ var radio_group = (RadioGroup);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/radio/index.js



radio_radio.Group = radio_group;
radio_radio.Description = radio_description;
radio_radio.Desc = radio_description;
/* harmony default export */ var esm_radio = (radio_radio);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/spacer/spacer.js


var spacer_excluded = ["inline", "className"];



var spacer_defaultProps = {
  inline: false,
  className: ''
};

var SpacerComponent = function SpacerComponent(_ref) {
  var inline = _ref.inline,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, spacer_excluded);

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  return /*#__PURE__*/node_modules_react.createElement("span", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1994396435", [inline ? 'inline-block' : 'block', SCALES.width(1), SCALES.height(1), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + (props && props.className != null && props.className || className || "")
  }), /*#__PURE__*/node_modules_react.createElement(styled_jsx_es/* default */.ZP, {
    id: "1994396435",
    dynamic: [inline ? 'inline-block' : 'block', SCALES.width(1), SCALES.height(1), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]
  }, "span.__jsx-style-dynamic-selector{display:".concat(inline ? 'inline-block' : 'block', ";width:").concat(SCALES.width(1), ";height:").concat(SCALES.height(1), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}")));
};

SpacerComponent.defaultProps = spacer_defaultProps;
SpacerComponent.displayName = 'GeistSpacer';
var Spacer = (0,with_scale/* default */.Z)(SpacerComponent);
/* harmony default export */ var spacer = (Spacer);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/spacer/index.js

/* harmony default export */ var esm_spacer = (spacer);
// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/power.js
var power = __webpack_require__(1614);
;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/utils.js
function isInBrowser() {
    return (typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        typeof window.document.createElement !== 'undefined');
}

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/useCookies.js



function useCookies(dependencies) {
    var cookies = (0,node_modules_react.useContext)(es6_CookiesContext);
    if (!cookies) {
        throw new Error('Missing <CookiesProvider>');
    }
    var initialCookies = cookies.getAll();
    var _a = (0,node_modules_react.useState)(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = (0,node_modules_react.useRef)(allCookies);
    if (isInBrowser()) {
        (0,node_modules_react.useLayoutEffect)(function () {
            function onChange() {
                var newCookies = cookies.getAll();
                if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
                    setCookies(newCookies);
                }
                previousCookiesRef.current = newCookies;
            }
            cookies.addChangeListener(onChange);
            return function () {
                cookies.removeChangeListener(onChange);
            };
        }, [cookies]);
    }
    var setCookie = (0,node_modules_react.useMemo)(function () { return cookies.set.bind(cookies); }, [cookies]);
    var removeCookie = (0,node_modules_react.useMemo)(function () { return cookies.remove.bind(cookies); }, [cookies]);
    return [allCookies, setCookie, removeCookie];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) {
        return true;
    }
    for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) {
            return true;
        }
    }
    return false;
}

;// CONCATENATED MODULE: ./components/devtools.tsx




//import { dev_getLocalStorageState, dev_setLocalStorageState } from "../utils/devtools"




function DevTools() {
    var setMockUser = function setMockUser(user) {
        if (user == "unset") {
            //delete cookie by setting the expiration date in the past
            setCookies("DryadDevTools_mockUser", "", {
                path: "/",
                expires: new Date(0)
            });
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = devtools/* mockUsers */.bs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mockUser = _step.value;
                if (mockUser.user.username === user) {
                    setCookies("DryadDevTools_mockUser", mockUser.encoded, {
                        path: "/",
                        sameSite: true
                    });
                    return;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var getCurrentlySelected = function getCurrentlySelected() {
        if (cookies["DryadDevTools_mockUser"]) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = devtools/* mockUsers */.bs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var mockUser = _step.value;
                    // 1.5 to 3 string comparisons is prooobably faster than a parse? idk
                    if (mockUser.encoded === cookies["DryadDevTools_mockUser"]) {
                        return mockUser.user.username;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };
    var ref = (0,_sliced_to_array/* default */.Z)(useCookies([
        "DryadDevTools_mockUser"
    ]), 2), cookies = ref[0], setCookies = ref[1];
    var genieParams = (0,use_genie/* useGenie */.l9)();
    var ref1;
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            padding: "1rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                h4: true,
                children: " Mock user "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_radio.Group, {
                value: (ref1 = getCurrentlySelected()) !== null && ref1 !== void 0 ? ref1 : "unset",
                onChange: function(k) {
                    return setMockUser(k);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_radio, {
                        value: "unset",
                        type: "success",
                        children: "None"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_radio, {
                        value: "mock_admin",
                        type: "success",
                        children: "Admin"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_radio, {
                        value: "mock_user",
                        type: "success",
                        children: "User"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_radio, {
                        value: "mock_subscriber",
                        type: "success",
                        children: "Subscriber"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_spacer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                h4: true,
                children: " Log current model parameters "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
                auto: true,
                iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(power/* default */.Z, {}),
                // TODO: thread genieParams through from index to here
                onClick: function() {
                    var records = genieParams.allModelsParams[genieParams.selectedModel];
                    Object.entries(records).forEach(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                        console.log(key, value);
                    });
                }
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_popover, {
        content: content,
        style: {
            zIndex: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(tool/* default */.Z, {}),
            auto: true,
            ghost: true,
            type: "success",
            title: "DevTools"
        })
    });
};

;// CONCATENATED MODULE: ./components/layouts/navbar/credits.tsx




var Credits = function() {
    var ref = (0,dist/* default */.ZP)("/api/balance", swr/* fetcher */._i), data = ref.data, error = ref.error;
    var credits = (data === null || data === void 0 ? void 0 : data.balance) > 0 ? data.balance : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            credits.toFixed(1),
            " Credits"
        ]
    });
};

;// CONCATENATED MODULE: ./components/layouts/navbar/menu_links.tsx








var MenuLink = function(param) {
    var href = param.href, children = param.children;
    var upMD = (0,use_media_query/* default */.Z)("md", {
        match: "up"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_link/* default */.Z, {
            font: upMD ? "1rem" : "1.38rem",
            color: true,
            width: upMD ? "auto" : "100%",
            style: {
                wordBreak: "keep-all"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    padding: upMD ? "0 1rem" : "0.5rem 1rem",
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "end"
                },
                children: children
            })
        })
    });
};
var MenuLinks = function() {
    var upMD = (0,use_media_query/* default */.Z)("md", {
        match: "up"
    });
    var session = (0,devtools/* dev_maybeMockSession */.vQ)((0,react.useSession)());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: upMD ? "row" : "column",
            width: upMD ? "fit-content" : "100%",
            height: upMD ? "100%" : "fit-content",
            alignItems: upMD ? "center" : "end",
            alignContent: "stretch",
            alignSelf: "center",
            gap: "0.5rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                href: "https://docs.sparklpaint.com/",
                children: "Docs"
            }),
            session && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                href: "/profile?tab=credits",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Credits, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/layouts/navbar/hud.tsx








var HeadsUpDisplay = function(param) {
    var style = param.style, toggleLogin = param.toggleLogin;
    var upMD = (0,use_media_query/* default */.Z)("md", {
        match: "up"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: (0,_object_spread/* default */.Z)({
            display: "flex",
            flexDirection: upMD ? "row-reverse" : "column",
            width: upMD ? "fit-content" : "auto",
            height: upMD ? "fit-content" : "100%",
            alignItems: "stretch",
            alignContent: "center",
            gap: "1rem"
        }, style),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row-reverse",
                    flexWrap: "wrap",
                    width: "auto",
                    height: "fit-content",
                    gap: "0.62rem 1rem",
                    justifyContent: "end",
                    alignItems: "end",
                    paddingRight: "1.5rem"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
                        toggleLogin: toggleLogin
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem"
                        },
                        children: devtools/* ALLOW_DEV */.Sq && /*#__PURE__*/ (0,jsx_runtime.jsx)(DevTools, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLinks, {})
        ]
    });
};

;// CONCATENATED MODULE: ./public/images/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.a57a0d8e.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJ1BMVEUgE0y+uNY5KXUeEUkhFE0aDEYqHVZJPm5AL4I7L2FLN5dYQ6s3KWcEpYjjAAAAA3RSTlPy/v6cDHBIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVQImQXBiQGAQBACMXSAvcf+6zWRMFAJZ6YvctLvGGUPt7Foz9pFcFafiVjXbCMZHPQDLMcBQFbsbO8AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./components/layouts/navbar/sparkl_logo.tsx



// Using both xs and upMD to have different performance on mobile and iPad
// Specifically - the navbar should be much smaller on mobile, but looks quite nice as-is on iPad
var SparklLogo = function() {
    var xs = (0,use_media_query/* default */.Z)("xs");
    // why is this using geist Image?
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "1rem",
            cursor: "pointer"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_image/* default */.Z, {
                src: logo.src,
                draggable: false,
                alt: "sparkl logo",
                title: "Logo",
                style: {
                    borderRadius: "48%",
                    maxHeight: xs ? "1.62rem" : "3rem",
                    minHeight: "1rem",
                    verticalAlign: "middle"
                },
                marginLeft: xs ? ".32rem" : ".68rem",
                marginRight: "-.32rem"
            }),
            xs && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                h4: true,
                margin: 0,
                children: "Sparkl"
            }),
            !xs && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                h2: true,
                margin: 0,
                children: "Sparkl"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/layouts/navbar/navbar.tsx













var Navbar = function(param) {
    var style = param.style;
    var ref = (0,upsell_modal/* useUpsellModal */.T)(), toggleUpsell = ref.toggleUpsell, UpsellModal = ref.UpsellModal;
    var session = (0,devtools/* dev_maybeMockSession */.vQ)((0,react.useSession)());
    var ref1 = (0,node_modules_react.useState)(false), drawerOpen = ref1[0], setDrawerOpen = ref1[1];
    var genieParams = (0,use_genie/* useGenie */.l9)();
    var ref2 = (0,login_modal/* useLoginModal */.N)({
        callbackUrl: genieParams.sharedParams.prompts[0].text != "" ? "/?text=" + genieParams.sharedParams.prompts[0].text : undefined,
        clearUI: function() {
            return setDrawerOpen(false);
        }
    }), toggleLogin = ref2.toggleLogin, LoginModal = ref2.LoginModal;
    var upMD = (0,use_media_query/* default */.Z)("md", {
        match: "up"
    });
    // fix SSR
    // https://github.com/geist-org/geist-ui/issues/258
    if (false) {}
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: (0,_object_spread/* default */.Z)({
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            height: "100%",
            width: "100%",
            paddingRight: "0 1.5rem",
            zIndex: 1
        }, style),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsellModal, {}),
            !upMD && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_drawer, {
                width: "62vw",
                placement: "right",
                visible: drawerOpen,
                onClose: function() {
                    setDrawerOpen(false);
                },
                style: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadsUpDisplay, {
                    toggleLogin: toggleLogin
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_link/* default */.Z, {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SparklLogo, {})
                })
            }),
            upMD && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadsUpDisplay, {
                toggleLogin: toggleLogin
            }),
            !upMD && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.Z, {
                onClick: function() {
                    return setDrawerOpen(true);
                },
                scale: 0.62,
                auto: true,
                type: "abort",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModal, {})
        ]
    });
};

;// CONCATENATED MODULE: ./components/layouts/landscape_grid.tsx




var LandscapeGrid = function(param) {
    var topNavHeight = param.topNavHeight, children = param.children;
    var theme = (0,use_theme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "minmax(0,1fr) minmax(0,1.618fr)",
            gridTemplateRows: "".concat(topNavHeight, " 1fr"),
            gridTemplateAreas: '"header header" "generator content"',
            gridGap: "0 1rem",
            width: "100vw",
            backgroundColor: theme.palette.accents_1,
            alignItems: "start"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                style: {
                    gridArea: "header",
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    backgroundColor: theme.palette.background,
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    gridArea: "generator",
                    height: "100%",
                    display: "grid",
                    alignContent: "start"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneratorArea, {
                    topNavHeight: topNavHeight
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    gridArea: "content",
                    paddingRight: "1rem"
                },
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/layouts/no_generator_layout.tsx



var NoGeneratorLayout = function(param) {
    var topNavHeight = param.topNavHeight, children = param.children;
    var theme = (0,use_theme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "minmax(0,1fr)",
            gridTemplateRows: "".concat(topNavHeight, " 1fr"),
            gridTemplateAreas: '"header" "content"',
            gridGap: "0 1rem",
            width: "100vw",
            backgroundColor: theme.palette.accents_1,
            alignItems: "start"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                style: {
                    gridArea: "header",
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    backgroundColor: theme.palette.background,
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    gridArea: "content",
                    paddingRight: "1rem"
                },
                children: children
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@geist-ui/icons/home.js
var home = __webpack_require__(5628);
;// CONCATENATED MODULE: ./components/layouts/tabnav_button.tsx

var TabButton = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            width: "100%",
            height: "2rem",
            display: "flex",
            alignItems: "center"
        },
        children: label
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/layouts/portrait_grid.tsx










var PortraitGrid = function(param) {
    var topNavHeight = param.topNavHeight, children = param.children;
    var router = (0,next_router.useRouter)();
    var genieDispatch = (0,use_genie/* useGenieDispatch */.ps)();
    var theme = (0,use_theme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "1fr",
            gridTemplateRows: "".concat(topNavHeight, " 1fr"),
            gridTemplateAreas: '"header" "content"',
            width: "100vw",
            backgroundColor: theme.palette.accents_1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                style: {
                    gridArea: "header",
                    position: "sticky",
                    top: 0,
                    zIndex: 3,
                    backgroundColor: theme.palette.background,
                    height: topNavHeight
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    gridArea: "content",
                    backgroundColor: theme.palette.background,
                    maxWidth: "100vw"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabNav, {
                    children: [
                        {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabButton, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Sparkles */.P$, {})
                            }),
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneratorArea, {
                                topNavHeight: topNavHeight
                            }),
                            onSecondClick: function() {
                                genieDispatch({
                                    type: "reset"
                                });
                            }
                        },
                        {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabButton, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(home/* default */.Z, {})
                            }),
                            content: children,
                            onSecondClick: function() {
                                router.push("/");
                            }
                        }
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/prompt_image/post.tsx + 10 modules
var post = __webpack_require__(9105);
;// CONCATENATED MODULE: ./components/prompt_image/lightbox_post.tsx




var LightboxPost = function(param) {
    var prompt = param.prompt, wide = param.wide, indexForLightbox = param.indexForLightbox;
    //completed: "true", id: prompt_id.toString(),
    var ref = (0,dist/* default */.ZP)(function() {
        if (!prompt.id) {
            return null;
        }
        return "/api/prompts?completed=true&id=" + prompt.id.toString();
    }, swr/* fetcher */._i, {
        fallbackData: {
            status: "success",
            prompts: [
                prompt
            ]
        },
        revalidateIfStale: false,
        revalidateOnFocus: false,
        refreshWhenHidden: false,
        refreshInterval: function refreshInterval(latestData) {
            //console.log("Refreshing post info...");
            if (!latestData) {
                return 10000;
            }
            var prompt = latestData.prompts[0];
            /* Check if any upscaled image is == "pending" */ if (prompt.outputs.upscaled_image_urls && prompt.outputs.upscaled_image_urls.some(function(url) {
                return url === "pending";
            })) {
                //console.log("Refreshing now, because we're waiting on an upscale!");
                return 1000;
            }
            return 10000;
        }
    }), data = ref.data, error = ref.error;
    // console.log("data", data);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(post/* Post */.S, {
        prompt: !data || data.status !== "success" //Fallback to init prompt if error
         ? prompt : data === null || data === void 0 ? void 0 : data.prompts[0],
        wide: wide,
        carousel: true,
        indexForLightbox: indexForLightbox,
        isLightboxPost: true
    });
};

;// CONCATENATED MODULE: ./components/prompt_image/use_lightbox.tsx



// Extracting the lightbox to its own component
// it will be owned by the Feed and passed down to each child component as a prop.
// The lightbox is a modal that opens when the user clicks on the image.




var useLightbox = function() {
    var onClose = function onClose() {
        if (router.query.noback !== "true") {
            //if router.back would make us leave the website, we want to not do that
            router.back();
        } else {
            router.replace("/", undefined, {
                shallow: true
            }).then(function() {
            // This hack was needed in the past - if pages get stuck when lightbox happens, know that this was a workaround that used to work
            //router.reload();
            });
        }
    };
    var router = (0,next_router.useRouter)();
    var ref = (0,node_modules_react.useState)(), lightboxPrompt = ref[0], setLightboxPrompt = ref[1];
    var ref1 = (0,node_modules_react.useState)(0), slideIndex = ref1[0], setSlideIndex = ref1[1];
    var ref2 = (0,use_modal/* default */.Z)(), visible = ref2.visible, setVisible = ref2.setVisible, bindings = ref2.bindings;
    var upMD = (0,use_media_query/* default */.Z)("md", {
        match: "up"
    });
    var closeLightbox = function() {
        if (visible) {
            setVisible(false);
            onClose();
        }
    };
    (0,node_modules_react.useEffect)(function() {
        setVisible(router.query.prompt !== undefined);
    }, [
        setVisible,
        router.query.prompt
    ]);
    // this function is weird, because it does two disparate things:
    // - set the URL + route to the prompt
    // - set the modal to the right state
    // it has the if condition in it, because in some contexts
    // the former is unneccessary
    var openWithLightbox = function(prompt, index) {
        return function() {
            var asPath = index === 0 ? "/prompt/".concat(prompt.id) : "/prompt/".concat(prompt.id, "/").concat(index);
            if (router.asPath !== asPath) {
                router.push({
                    pathname: router.pathname,
                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                        prompt: prompt.id,
                        image: index
                    })
                }, asPath, {
                    shallow: true,
                    scroll: false
                });
            }
            setLightboxPrompt(prompt);
            setSlideIndex(index);
        };
    };
    var modalWidth = upMD ? "75vw" : "100vw";
    var modalHeight = upMD ? "auto" : "100%";
    var Lightbox = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            width: modalWidth,
            height: modalHeight,
            padding: 0
        }, bindings), {
            onClose: onClose,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default.Content */.Z.Content, {
                height: "100%",
                width: "100%",
                padding: 0,
                children: lightboxPrompt && /*#__PURE__*/ (0,jsx_runtime.jsx)(LightboxPost, {
                    prompt: lightboxPrompt,
                    wide: upMD ? true : false,
                    indexForLightbox: slideIndex
                })
            })
        }));
    };
    return {
        openWithLightbox: openWithLightbox,
        closeLightbox: closeLightbox,
        Lightbox: Lightbox
    };
};

;// CONCATENATED MODULE: ./components/layout.tsx










function Layout(param) {
    var layoutType = param.layoutType, children = param.children;
    var theme = (0,use_theme/* default */.Z)();
    var tabDispatch = useTabDispatch();
    var ref = useLightbox(), openWithLightbox = ref.openWithLightbox, closeLightbox = ref.closeLightbox, Lightbox = ref.Lightbox;
    var focusGenie = function() {
        //console.log("Calling focusGenie");
        closeLightbox();
        tabDispatch({
            type: "switchTab",
            tab: "0",
            scroll: window.scrollY
        });
    };
    var upMD = (0,use_media_query/* default */.Z)("md", {
        match: "up"
    });
    // fix SSR issues https://github.com/geist-org/geist-ui/issues/258
    if (false) {}
    //console.log("Redoing Grid");
    var isXS = (0,use_media_query/* default */.Z)("xs");
    var topNavHeight = upMD ? "5rem" : isXS ? "2rem" : "3rem";
    var layoutContent;
    switch(layoutType){
        case "no-generator":
            layoutContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(NoGeneratorLayout, {
                topNavHeight: topNavHeight,
                children: children
            });
            break;
        case "default":
        default:
            if (upMD) {
                layoutContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(LandscapeGrid, {
                    topNavHeight: topNavHeight,
                    children: children
                });
            } else {
                layoutContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(PortraitGrid, {
                    topNavHeight: topNavHeight,
                    children: children
                });
            }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(use_genie/* GenieProvider */.nh, {
        focusGenie: focusGenie,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lightbox_context/* LightboxContext.Provider */.p.Provider, {
            value: {
                openWithLightbox: openWithLightbox
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                    style: {
                        backgroundColor: theme.palette.accents_1
                    },
                    children: [
                        children && typeof children === "object" && "props" in children && "permalinkMetadata" in children.props && children.props.permalinkMetadata && /*#__PURE__*/ (0,jsx_runtime.jsx)(permalink_metadata.PermalinkHead, {
                            permalinkMetadata: children.props.permalinkMetadata
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_page, {
                            width: "100%",
                            height: "100vh",
                            padding: 0,
                            className: "page",
                            render: "effect",
                            children: layoutContent
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Lightbox, {})
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/sparkl-theme/radix-colors.ts
var radix_colors = __webpack_require__(64);
;// CONCATENATED MODULE: ./components/sparkl-theme/index.ts


var breakpoints = {
    xs: {
        min: "0",
        max: "650px"
    },
    sm: {
        min: "650px",
        max: "900px"
    },
    md: {
        min: "900px",
        max: "1280px"
    },
    lg: {
        min: "1280px",
        max: "1920px"
    },
    xl: {
        min: "1920px",
        max: "10000px"
    }
};
var layout = {
    gap: "16pt",
    gapNegative: "-16pt",
    gapHalf: "8pt",
    gapHalfNegative: "-8pt",
    gapQuarter: "4pt",
    gapQuarterNegative: "-4pt",
    pageMargin: "16pt",
    pageWidth: "750pt",
    pageWidthWithMargin: "782pt",
    breakpointMobile: breakpoints.xs.max,
    breakpointTablet: breakpoints.sm.max,
    radius: ".25rem",
    unit: "16px"
};
var expressiveness = {
    linkStyle: "none",
    linkHoverStyle: "underline",
    scrollerStart: "rgba(255, 255, 255, 1)",
    scrollerEnd: "rgba(255, 255, 255, 0)",
    dropdownBoxShadow: "",
    shadowSmall: "",
    shadowMedium: "",
    shadowLarge: "",
    portalOpacity: 0.25
};
var palette = {
    accents_1: radix_colors/* mauve.mauve2 */.Fe.mauve2,
    accents_2: radix_colors/* mauve.mauve6 */.Fe.mauve6,
    accents_3: radix_colors/* mauve.mauve7 */.Fe.mauve7,
    accents_4: radix_colors/* mauve.mauve8 */.Fe.mauve8,
    accents_5: radix_colors/* mauve.mauve9 */.Fe.mauve9,
    accents_6: radix_colors/* mauve.mauve10 */.Fe.mauve10,
    accents_7: radix_colors/* mauve.mauve11 */.Fe.mauve11,
    accents_8: radix_colors/* mauve.mauve12 */.Fe.mauve12,
    background: radix_colors/* mauve.mauve1 */.Fe.mauve1,
    foreground: radix_colors/* mauve.mauve12 */.Fe.mauve12,
    selection: radix_colors/* yellow.yellow5 */.er.yellow5,
    secondary: radix_colors/* mauve.mauve11 */.Fe.mauve11,
    code: radix_colors/* crimson.crimson10 */.Wl.crimson10,
    border: radix_colors/* mauve.mauve9 */.Fe.mauve9,
    error: radix_colors/* red.red9 */.Q6.red9,
    errorLight: radix_colors/* red.red7 */.Q6.red7,
    errorLighter: radix_colors/* red.red5 */.Q6.red5,
    errorDark: radix_colors/* red.red11 */.Q6.red11,
    success: radix_colors/* violet.violet9 */.ht.violet9,
    successLight: radix_colors/* violet.violet7 */.ht.violet7,
    successLighter: radix_colors/* violet.violet5 */.ht.violet5,
    successDark: radix_colors/* violet.violet11 */.ht.violet11,
    warning: radix_colors/* yellow.yellow9 */.er.yellow9,
    warningLight: radix_colors/* yellow.yellow6 */.er.yellow6,
    warningLighter: radix_colors/* yellow.yellow4 */.er.yellow4,
    warningDark: radix_colors/* yellow.yellow11 */.er.yellow11,
    cyan: radix_colors/* blue.blue7 */.iN.blue7,
    cyanLighter: radix_colors/* blue.blue5 */.iN.blue5,
    cyanLight: radix_colors/* blue.blue6 */.iN.blue6,
    cyanDark: radix_colors/* blue.blue8 */.iN.blue8,
    violet: radix_colors/* plum.plum9 */.vd.plum9,
    violetLighter: radix_colors/* plum.plum6 */.vd.plum6,
    violetLight: radix_colors/* plum.plum8 */.vd.plum8,
    violetDark: radix_colors/* plum.plum11 */.vd.plum11,
    purple: radix_colors/* crimson.crimson8 */.Wl.crimson8,
    alert: radix_colors/* crimson.crimson9 */.Wl.crimson9,
    magenta: radix_colors/* crimson.crimson10 */.Wl.crimson10,
    link: radix_colors/* violet.violet11 */.ht.violet11
};
var font = {
    sans: '"Moriston", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    mono: "Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace",
    prism: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,"Liberation Mono", "Courier New", monospace'
};
var SparklTheme = esm_themes/* default.createFromLight */.Z.createFromLight({
    type: "sparkl",
    palette: palette,
    font: font,
    layout: layout,
    expressiveness: expressiveness
});

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/_app/analytics.tsx


var GoogleAnalytics = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=G-CB708L7SZ8",
                strategy: "afterInteractive"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "google-analytics",
                strategy: "afterInteractive",
                children: "\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n          gtag('config', 'G-CB708L7SZ8', {\n            page_path: window.location.pathname,\n          });\n        "
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/_app/head.tsx



// Always prefetch feeds
// Should ruminate more on whether this is the right call at some point.
var prefetchUrls = [];
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = feed_types/* models_with_feeds */.Hz[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var model = _step.value;
        prefetchUrls.push("/api/prompts?model=".concat(model, "&completed=true&type=New"));
        prefetchUrls.push("/api/curated?model=".concat(model, "&completed=true&type=Popular"));
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
prefetchUrls.push("/api/prompts?completed=true&type=New");
prefetchUrls.push("/api/curated?completed=true&type=Popular");
var SparklHead = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Sparkl - Generate Images with AI"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: "usah intaface,"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "application-name",
                content: "Sparkl"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-mobile-web-app-status-bar-style",
                content: "default"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-mobile-web-app-title",
                content: "Sparkl"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: "Sparkl AI Art Generator"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "format-detection",
                content: "telephone=no"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                href: "/icons/touch-icon-iphone.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "152x152",
                href: "/icons/touch-icon-ipad.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/icons/touch-icon-iphone-retina.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "167x167",
                href: "/icons/touch-icon-ipad-retina.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/icons/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/icons/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "mask-icon",
                href: "/icons/safari-pinned-tab.svg",
                color: "#20134B"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: "/favicon.ico"
            }),
            prefetchUrls.map(function(url) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "prefetch",
                    href: url,
                    as: "fetch",
                    crossOrigin: "anonymous"
                }, url);
            })
        ]
    });
};

// EXTERNAL MODULE: ./public/fonts/moriston.css
var moriston = __webpack_require__(9626);
// EXTERNAL MODULE: ./styles/globals.css
var globals = __webpack_require__(906);
// EXTERNAL MODULE: ./styles/tagify.css
var styles_tagify = __webpack_require__(7005);
;// CONCATENATED MODULE: ./pages/_app.tsx







 // requires a loader









function App(_param) {
    var Component = _param.Component, session = _param.pageProps.session, pageProps = (0,src_object_without_properties/* default */.Z)(_param.pageProps, [
        "session"
    ]);
    var ref = (0,node_modules_react.useState)("sparkl"), themeType = ref[0], setThemeType = ref[1];
    var ref1 = (0,node_modules_react.useState)(SparklTheme), customTheme = ref1[0], setCustomTheme = ref1[1];
    var layoutType = "layoutType" in Component ? Component.layoutType : "default";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es6_CookiesProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.SessionProvider, {
            session: session,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_geist_provider, {
                themeType: themeType,
                themes: [
                    customTheme
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(css_baseline, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SparklHead, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAnalytics, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabNavProvider, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                            layoutType: layoutType,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 8067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PermalinkHead": function() { return /* binding */ PermalinkHead; },
/* harmony export */   "getPermalinkMetadataForPrompt": function() { return /* binding */ getPermalinkMetadataForPrompt; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);



function slice_and_ellipse(str, length) {
    if (str.length > length) {
        return str.slice(0, length) + "...";
    } else {
        return str;
    }
}
function getPermalinkMetadataForPrompt(prompt) {
    var prompt_text = prompt.params.sharedParams.prompts[0].text;
    var _combined_image, _combined_image1, _combined_image2;
    return {
        title: '"'.concat(slice_and_ellipse(prompt_text, 80), '" via Sparkl \u2728\uD83C\uDFA8'),
        description: '"'.concat(slice_and_ellipse(prompt_text, 200), '" via Sparkl \u2728\uD83C\uDFA8'),
        "twitter:card": "summary_large_image",
        "twitter:title": '"'.concat(prompt_text.slice(0, 100), '" via Sparkl \u2728\uD83C\uDFA8'),
        "twitter:description": '"'.concat(prompt_text.slice(0, 500), '" via Sparkl \u2728\uD83C\uDFA8'),
        "og:image": (_combined_image = prompt.outputs.combined_image) !== null && _combined_image !== void 0 ? _combined_image : prompt.outputs.image_urls[0],
        "twitter:image": (_combined_image1 = prompt.outputs.combined_image) !== null && _combined_image1 !== void 0 ? _combined_image1 : prompt.outputs.image_urls[0],
        "twitter:image:src": (_combined_image2 = prompt.outputs.combined_image) !== null && _combined_image2 !== void 0 ? _combined_image2 : prompt.outputs.image_urls[0],
        "twitter:image:alt": "Synthesized image by Sparkl for ".concat(slice_and_ellipse(prompt_text, 300))
    };
}
var PermalinkHead = function(param) {
    var permalinkMetadata = param.permalinkMetadata;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            "title" in permalinkMetadata && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: permalinkMetadata["title"]
            }),
            Object.entries(permalinkMetadata).map(function(param) {
                var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
                if (key.startsWith("og")) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: key,
                        content: value
                    }, key);
                } else {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: key,
                        content: value
                    }, key);
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PermalinkHead);


/***/ }),

/***/ 8779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ config; }
/* harmony export */ });
// To change which config is active, just change the following line
// TODO: maybe this checks for dev/prod in process.ENV
// and falls back to this string iff not?
var currentEnv = "prod";
var devConfig = {
    allowDev: true,
    restrictWebsite: false,
    allowNonfunctionalUI: false,
    subscriptionPriceId: "price_1LJg85DdKMl1S7gsRisFniYy"
};
var prodConfig = {
    allowDev: false,
    restrictWebsite: false,
    allowNonfunctionalUI: false,
    subscriptionPriceId: "price_1LnuLvDdKMl1S7gs7KU43n1W"
};
var configs = {
    dev: devConfig,
    prod: prodConfig
};
var config = configs[currentEnv];


/***/ }),

/***/ 8250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OM": function() { return /* binding */ dev_mockUserHeader; },
/* harmony export */   "Sq": function() { return /* binding */ ALLOW_DEV; },
/* harmony export */   "bs": function() { return /* binding */ mockUsers; },
/* harmony export */   "vQ": function() { return /* binding */ dev_maybeMockSession; }
/* harmony export */ });
/* unused harmony exports parseCookies, dev_getDevCookie, dev_mockToken */
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6489);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8779);
/* provided dependency */ var Buffer = __webpack_require__(8764)["Buffer"];


// TODO: Move this to a config somewhere
// This should _not_ be the same as checking if node env is "development"
// Because that says "false" for a deploy to fly, whereas we want to have
// dev instances on fly as well.
// Ideally this should be a per-branch thing, ie: some branches are just _always_ dev
// and have security backdoors + additional utilities exposed
var ALLOW_DEV = _config__WEBPACK_IMPORTED_MODULE_1__/* .config.allowDev */ .v.allowDev;
// Gates whether this file is noisy or not
// Would be nice to do this better in the long run?
var VERBOSE_DEV_LOGGING = false;
function parseCookies(req) {
    return cookie__WEBPACK_IMPORTED_MODULE_0__.parse(req ? req.headers.cookie || "" : typeof document !== "undefined" ? document.cookie : "");
}
function dev_getDevCookie(key) {
    if (!ALLOW_DEV) {
        return undefined;
    }
    var cookies = parseCookies(null);
    return cookies["DryadDevTools_" + key];
}
var getMockSession = function() {
    if (!ALLOW_DEV) {
        return null;
    }
    var mockUser = dev_getDevCookie("mockUser");
    if (mockUser !== undefined) {
        return JSON.parse(Buffer.from(mockUser, "base64").toString());
    } else {
        VERBOSE_DEV_LOGGING && console.log("Didn't find mockUser in cookie, returning null");
    }
    return null;
};
var dev_maybeMockSession = function(useSessionReturn) {
    var session = useSessionReturn.data;
    if (!ALLOW_DEV) {
        return session;
    }
    var ref;
    return (ref = getMockSession()) !== null && ref !== void 0 ? ref : session;
};
var dev_mockUserHeader = function() {
    if (!ALLOW_DEV) {
        return undefined;
    }
    var mockSession = getMockSession();
    if (mockSession !== null) {
        var mockSessionBase64 = Buffer.from(JSON.stringify(mockSession)).toString("base64");
        console.log("Setting header cookie with", mockSessionBase64);
        return new Headers({
            cookie: "DryadDevTools_mockUser=".concat(mockSessionBase64)
        });
    }
    return undefined;
};
var dev_mockToken = function(req) {
    if (!ALLOW_DEV) {
        return undefined;
    }
    //Check if a mock user cookie is present
    var mockUserCookie = parseCookies(req)["DryadDevTools_mockUser"];
    VERBOSE_DEV_LOGGING && console.log("Mock userCookie", mockUserCookie);
    if (mockUserCookie !== undefined) {
        //base 64 decode mockHeader
        var mockSession = Buffer.from(mockUserCookie, "base64").toString();
        VERBOSE_DEV_LOGGING && console.log("Mocking token with", mockSession);
        VERBOSE_DEV_LOGGING && console.log("Mocking token for", req.url);
        return JSON.parse(mockSession);
    }
    VERBOSE_DEV_LOGGING && console.log("Not mocking token for ", req.url);
    return undefined;
};
function mockUserFor(user_id, username, role, is_subscriber) {
    var obj = {
        user_id: user_id,
        username: username,
        picture: "",
        is_subscriber: is_subscriber,
        role: role,
        stripe_id: null,
        expires: ""
    };
    return {
        encoded: Buffer.from(JSON.stringify(obj)).toString("base64"),
        user: obj
    };
}
var mockAdmin = mockUserFor(38, "mock_admin", "admin", false);
var mockSubscriber = mockUserFor(39, "mock_subscriber", "alpha", true);
var mockUser = mockUserFor(41, "mock_user", null, false);
var mockUsers = [
    mockAdmin,
    mockSubscriber,
    mockUser
];


/***/ }),

/***/ 6967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ img2img_models; },
/* harmony export */   "Hz": function() { return /* binding */ models_with_feeds; }
/* harmony export */ });
/* unused harmony exports adminReactions, models */
var adminReactions = (/* unused pure expression or super */ null && ([
    "masterpiece",
    "curated",
    "great",
    "okay",
    "bad",
    "tos", 
]));
var models = (/* unused pure expression or super */ null && ([
    "dalle",
    "vqgan",
    "diffuse",
    "verdant",
    "waifu",
    "verdant2"
]));
var img2img_models = [
    "verdant",
    "waifu",
    "verdant2"
];
var models_with_feeds = [
    "verdant",
    "dalle",
    "diffuse",
    "vqgan",
    "waifu",
    "verdant2"
]; // models we display in main feed


/***/ }),

/***/ 679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ hasAlphaAccess; },
/* harmony export */   "v": function() { return /* binding */ isModerator; }
/* harmony export */ });
function getRole(token) {
    return token.role;
}
function isModerator(token) {
    var role = getRole(token);
    return role === "admin" || role === "mod";
}
function hasAlphaAccess(token) {
    var role = getRole(token);
    return role === "admin" || role === "mod" || role === "alpha";
}


/***/ }),

/***/ 6792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_i": function() { return /* binding */ fetcher; },
/* harmony export */   "cG": function() { return /* binding */ mutateShowcasedFeed; },
/* harmony export */   "gU": function() { return /* binding */ mutateUserLikedFeed; },
/* harmony export */   "sb": function() { return /* binding */ mutateQueue; }
/* harmony export */ });
/* unused harmony exports queueSWRConfig, FEED_PAGE_SIZE */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9815);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5591);
/* harmony import */ var swr_infinite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4593);








/*
TODO: Debug this, it's being triggered wayy too often
*/ var queueSWRConfig = {
    refreshInterval: function(data) {
        // console.log("refreshInterval data is", data)
        if (!data) {
            // console.log("refreshInterval data is", data);
            return 500;
        }
        console.log("refreshInterval data is finally not none!!!");
        // Need to understand what causes a failure better - as this seems to happen often
        if (data.status === "failure") {
            console.log("failure, waiting 10s:", data);
            return 10 * 1000;
        }
        //check if any prompt has a status of "in progress"
        var promptsInProgress = data.prompts.some(function(prompt) {
            return prompt.status === "uploading" || prompt.status === "assigned" || prompt.status === "pending";
        });
        //console.log("Prompts in progress: ", promptsInProgress);
        // TODO: We should perhaps stop polling every 0.5s after a certain amount of time
        // Maybe like 2 minutes or so?
        // Need to mostly figure out/test how date works on prompts
        var wait = promptsInProgress ? 500 : 180 * 1000;
        console.log("waiting ".concat(wait));
        return wait;
    },
    // refreshInterval: (data) => {
    //   console.log("refreshInterval data is", data);
    //   if (!data) {
    //       console.log("not data")
    //       return 501;
    //   }
    //   return 100;
    // },
    // Need to see if the 500ms will actually work
    // These defaults might stop it:
    dedupingInterval: 500,
    focusThrottleInterval: 500
};
function queueKeyMatcher(key) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(key.split("?"), 2), path = ref[0], query = ref[1];
    //use query parser to check if there's a queue query
    var queryObj = new URLSearchParams(query);
    return path === "/api/prompts" && queryObj.has("queue");
}
var mutateQueue = function(newPrompt) {
    // does this trigger checking refreshInterval?
    var mutatorCallback = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (data) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", data);
                    case 4:
                        return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
                            prompts: [
                                newPrompt
                            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data.prompts))
                        }));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function mutatorCallback(data) {
            return _ref.apply(this, arguments);
        };
    }();
    // not sure if revalidate is appropriate - hope was to reset refreshInterval after mutating
    (0,swr__WEBPACK_IMPORTED_MODULE_1__/* .mutate */ .JG)(queueKeyMatcher, mutatorCallback, {
        revalidate: true
    });
};
function mutateShowcasedFeed(userId) {
    // This is a weird workaround due to swr's poor support of mutation for
    // SWRInfinite, see: https://github.com/vercel/swr/issues/1670
    (0,swr__WEBPACK_IMPORTED_MODULE_1__/* .mutate */ .JG)(function(key) {
        if (typeof key === "string" && key.startsWith("/api/prompts?")) {
            var params = new URLSearchParams(key.split("?")[1]);
            if (params.get("showcased") === "true" && params.get("user_id") == userId) {
                (0,swr__WEBPACK_IMPORTED_MODULE_1__/* .mutate */ .JG)((0,swr_infinite__WEBPACK_IMPORTED_MODULE_2__/* .unstable_serialize */ .wE)(function(index, prevPageData) {
                    return key;
                }));
                return true;
            } else {
                return false;
            }
        }
        return false;
    });
}
function mutateUserLikedFeed(userId) {
    // This is a weird workaround due to swr's poor support of mutation for
    // SWRInfinite, see: https://github.com/vercel/swr/issues/1670
    (0,swr__WEBPACK_IMPORTED_MODULE_1__/* .mutate */ .JG)(function(key) {
        if (typeof key === "string" && key.startsWith("/api/prompts?")) {
            var params = new URLSearchParams(key.split("?")[1]);
            if (params.get("user_likes") === userId) {
                (0,swr__WEBPACK_IMPORTED_MODULE_1__/* .mutate */ .JG)((0,swr_infinite__WEBPACK_IMPORTED_MODULE_2__/* .unstable_serialize */ .wE)(function(index, prevPageData) {
                    return key;
                }));
                return true;
            } else {
                return false;
            }
        }
        return false;
    });
}
var fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
var FEED_PAGE_SIZE = "15";


/***/ }),

/***/ 8206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ej": function() { return /* binding */ shimmerUrl; },
  "uD": function() { return /* binding */ useBlur; }
});

// UNUSED EXPORTS: getBlurCanvas

;// CONCATENATED MODULE: ./node_modules/blurhash/dist/esm/index.js
var q=["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z","#","$","%","*","+",",","-",".",":",";","=","?","@","[","]","^","_","{","|","}","~"],x=t=>{let e=0;for(let r=0;r<t.length;r++){let n=t[r],l=q.indexOf(n);e=e*83+l}return e},p=(t,e)=>{var r="";for(let n=1;n<=e;n++){let l=Math.floor(t)/Math.pow(83,e-n)%83;r+=q[Math.floor(l)]}return r};var f=t=>{let e=t/255;return e<=.04045?e/12.92:Math.pow((e+.055)/1.055,2.4)},h=t=>{let e=Math.max(0,Math.min(1,t));return e<=.0031308?Math.trunc(e*12.92*255+.5):Math.trunc((1.055*Math.pow(e,.4166666666666667)-.055)*255+.5)},F=t=>t<0?-1:1,M=(t,e)=>F(t)*Math.pow(Math.abs(t),e);var d=class extends Error{constructor(e){super(e),this.name="ValidationError",this.message=e}};var C=t=>{if(!t||t.length<6)throw new d("The blurhash string must be at least 6 characters");let e=x(t[0]),r=Math.floor(e/9)+1,n=e%9+1;if(t.length!==4+2*n*r)throw new d(`blurhash length mismatch: length is ${t.length} but it should be ${4+2*n*r}`)},N=t=>{try{C(t)}catch(e){return{result:!1,errorReason:e.message}}return{result:!0}},z=t=>{let e=t>>16,r=t>>8&255,n=t&255;return[f(e),f(r),f(n)]},L=(t,e)=>{let r=Math.floor(t/361),n=Math.floor(t/19)%19,l=t%19;return[M((r-9)/9,2)*e,M((n-9)/9,2)*e,M((l-9)/9,2)*e]},U=(t,e,r,n)=>{C(t),n=n|1;let l=x(t[0]),m=Math.floor(l/9)+1,b=l%9+1,i=(x(t[1])+1)/166,u=new Array(b*m);for(let o=0;o<u.length;o++)if(o===0){let a=x(t.substring(2,6));u[o]=z(a)}else{let a=x(t.substring(4+o*2,6+o*2));u[o]=L(a,i*n)}let c=e*4,s=new Uint8ClampedArray(c*r);for(let o=0;o<r;o++)for(let a=0;a<e;a++){let y=0,B=0,R=0;for(let w=0;w<m;w++)for(let P=0;P<b;P++){let G=Math.cos(Math.PI*a*P/e)*Math.cos(Math.PI*o*w/r),T=u[P+w*b];y+=T[0]*G,B+=T[1]*G,R+=T[2]*G}let V=h(y),I=h(B),E=h(R);s[4*a+0+o*c]=V,s[4*a+1+o*c]=I,s[4*a+2+o*c]=E,s[4*a+3+o*c]=255}return s},j=U;var A=4,D=(t,e,r,n)=>{let l=0,m=0,b=0,g=e*A;for(let u=0;u<e;u++){let c=A*u;for(let s=0;s<r;s++){let o=c+s*g,a=n(u,s);l+=a*f(t[o]),m+=a*f(t[o+1]),b+=a*f(t[o+2])}}let i=1/(e*r);return[l*i,m*i,b*i]},$=t=>{let e=h(t[0]),r=h(t[1]),n=h(t[2]);return(e<<16)+(r<<8)+n},H=(t,e)=>{let r=Math.floor(Math.max(0,Math.min(18,Math.floor(M(t[0]/e,.5)*9+9.5)))),n=Math.floor(Math.max(0,Math.min(18,Math.floor(M(t[1]/e,.5)*9+9.5)))),l=Math.floor(Math.max(0,Math.min(18,Math.floor(M(t[2]/e,.5)*9+9.5))));return r*19*19+n*19+l},O=(t,e,r,n,l)=>{if(n<1||n>9||l<1||l>9)throw new d("BlurHash must have between 1 and 9 components");if(e*r*4!==t.length)throw new d("Width and height must match the pixels array");let m=[];for(let s=0;s<l;s++)for(let o=0;o<n;o++){let a=o==0&&s==0?1:2,y=D(t,e,r,(B,R)=>a*Math.cos(Math.PI*o*B/e)*Math.cos(Math.PI*s*R/r));m.push(y)}let b=m[0],g=m.slice(1),i="",u=n-1+(l-1)*9;i+=p(u,1);let c;if(g.length>0){let s=Math.max(...g.map(a=>Math.max(...a))),o=Math.floor(Math.max(0,Math.min(82,Math.floor(s*166-.5))));c=(o+1)/166,i+=p(o,1)}else c=1,i+=p(0,1);return i+=p($(b),4),g.forEach(s=>{i+=p(H(s,c),2)}),i},S=(/* unused pure expression or super */ null && (O));
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./utils/use_blur.ts
// This is a custom hook that does the logic for blurhashes in images


var shimmer = function(w, h) {
    return '\n<svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n  <defs>\n    <linearGradient id="g" x1="0%" y1="0%" x2="0%" y2="100%">\n      <stop stop-color="#f4f2f4" offset="20%" />\n      <stop stop-color="#dcdbdd" offset="50%" />  \n      <stop stop-color="#f4f2f4" offset="70%" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="#f4f2f4" />\n  <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" />\n  <animate xlink:href="#r" attributeName="y" from="-').concat(h, '" to="').concat(h, '" dur="1s" repeatCount="indefinite"  />\n</svg>');
};
var toBase64 = function(str) {
    return  false ? 0 : window.btoa(str);
};
var shimmerUrl = function(w, h) {
    return "data:image/svg+xml;base64,".concat(toBase64(shimmer(w, h)));
};
var getBlurCanvas = function(blur) {
    var BLURHASH_DIM = 16;
    // punch adjusts the contrast on the decoded blur image.
    // 1 means normal, smaller values will make the effect more subtle, and larger values will make it stronger.
    // Technically, what it does is scale the AC components up or down.
    var punch = 1;
    // decode hash
    var pixels = j(blur, BLURHASH_DIM, BLURHASH_DIM, punch);
    // temporary canvas to create a blob from decoded ImageData
    var canvas = document.createElement("canvas");
    canvas.width = BLURHASH_DIM;
    canvas.height = BLURHASH_DIM;
    var context = canvas.getContext("2d");
    var imageData = context.createImageData(BLURHASH_DIM, BLURHASH_DIM);
    imageData.data.set(pixels);
    context.putImageData(imageData, 0, 0);
    return canvas;
};
var useBlur = function(maybe_blur, w, h) {
    var ref = (0,react.useState)(shimmerUrl(w, h)), blur_url = ref[0], setBlurUrl = ref[1];
    (0,react.useLayoutEffect)(function() {
        var isCancelled = false;
        if (window === undefined || maybe_blur === undefined) {
            return;
        }
        try {
            var canvas = getBlurCanvas(maybe_blur);
            canvas.toBlob(function(blob) {
                if (!isCancelled && blob) {
                    setBlurUrl(function(oldUrl) {
                        if (oldUrl) {
                            URL.revokeObjectURL(oldUrl);
                        }
                        return URL.createObjectURL(blob);
                    });
                }
            });
        } catch (error) {
            var message = "".concat(error, " (blurhash: ").concat(maybe_blur, ")");
            fetch("/api/admin", {
                method: "POST",
                body: message
            });
        }
        return function cleanupBlurhash() {
            isCancelled = true;
            setBlurUrl(function(oldUrl) {
                if (oldUrl) {
                    URL.revokeObjectURL(oldUrl);
                }
                return oldUrl; // maybe this should be null or shimmer instead?
            });
        };
    }, [
        maybe_blur
    ]);
    return blur_url;
};


/***/ }),

/***/ 8535:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6703:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9626:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 906:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7005:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={308:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(308);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 5675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8045)


/***/ }),

/***/ 1664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8418)


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(699)


/***/ }),

/***/ 2703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 5697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2703)();
}


/***/ }),

/***/ 414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 7011:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(5697),__webpack_require__(7294)):0}(this,function(e,t){"use strict";function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var n=o(e),i=o(t);function r(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function s(e,t,o){return t in e?Object.defineProperty(e,t,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[t]=o,e}function u(){return(u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n])}return e}).apply(this,arguments)}function a(t,e){var o,n=Object.keys(t);return Object.getOwnPropertySymbols&&(o=Object.getOwnPropertySymbols(t),e&&(o=o.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),n.push.apply(n,o)),n}function y(t){for(var e=1;e<arguments.length;e++){var o=null!=arguments[e]?arguments[e]:{};e%2?a(Object(o),!0).forEach(function(e){s(t,e,o[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(o)):a(Object(o)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(o,e))})}return t}function h(e){return(h=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function c(e,t){return(c=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function l(e,t){if(null==e)return{};var o,n=function(e,t){if(null==e)return{};for(var o,n={},a=Object.keys(e),r=0;r<a.length;r++)o=a[r],0<=t.indexOf(o)||(n[o]=e[o]);return n}(e,t);if(Object.getOwnPropertySymbols)for(var a=Object.getOwnPropertySymbols(e),r=0;r<a.length;r++)o=a[r],0<=t.indexOf(o)||Object.prototype.propertyIsEnumerable.call(e,o)&&(n[o]=e[o]);return n}function d(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function p(r){var i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],function(){})),!0}catch(e){return!1}}();return function(){var e,t,o,n,a=h(r);return t=i?(e=h(this).constructor,Reflect.construct(a,arguments,e)):a.apply(this,arguments),o=this,!(n=t)||"object"!=typeof n&&"function"!=typeof n?d(o):n}}function m(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(e)))return;var o=[],n=!0,a=!1,r=void 0;try{for(var i,s=e[Symbol.iterator]();!(n=(i=s.next()).done)&&(o.push(i.value),!t||o.length!==t);n=!0);}catch(e){a=!0,r=e}finally{try{n||null==s.return||s.return()}finally{if(a)throw r}}return o}(e,t)||g(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function g(e,t){if(e){if("string"==typeof e)return f(e,t);var o=Object.prototype.toString.call(e).slice(8,-1);return"Object"===o&&e.constructor&&(o=e.constructor.name),"Map"===o||"Set"===o?Array.from(e):"Arguments"===o||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)?f(e,t):void 0}}function f(e,t){(null==t||t>e.length)&&(t=e.length);for(var o=0,n=new Array(t);o<t;o++)n[o]=e[o];return n}function v(a,r){return new Promise(function(e,t){var o,n=new Image;n.onload=function(){return e(n)},n.onerror=t,!1==(null!==(o=a)&&!!o.match(/^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*+;=\-._~:@/?%\s]*\s*$/i))&&r&&(n.crossOrigin=r),n.src=a})}var b,w=!("undefined"==typeof window||"undefined"==typeof navigator||!("ontouchstart"in window||0<navigator.msMaxTouchPoints)),M="undefined"!=typeof File,O={touch:{react:{down:"onTouchStart",mouseDown:"onMouseDown",drag:"onTouchMove",move:"onTouchMove",mouseMove:"onMouseMove",up:"onTouchEnd",mouseUp:"onMouseUp"},native:{down:"touchstart",mouseDown:"mousedown",drag:"touchmove",move:"touchmove",mouseMove:"mousemove",up:"touchend",mouseUp:"mouseup"}},desktop:{react:{down:"onMouseDown",drag:"onDragOver",move:"onMouseMove",up:"onMouseUp"},native:{down:"mousedown",drag:"dragStart",move:"mousemove",up:"mouseup"}}},I=w?O.touch:O.desktop,P="undefined"!=typeof window&&window.devicePixelRatio?window.devicePixelRatio:1,C={x:.5,y:.5},x=function(){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&c(e,t)}(a,i["default"].Component);var e,t,o,n=p(a);function a(e){var v;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,a),s(d(v=n.call(this,e)),"state",{drag:!1,my:null,mx:null,image:C}),s(d(v),"handleImageReady",function(e){var t=v.getInitialSize(e.width,e.height);t.resource=e,t.x=.5,t.y=.5,t.backgroundColor=v.props.backgroundColor,v.setState({drag:!1,image:t},v.props.onImageReady),v.props.onLoadSuccess(t)}),s(d(v),"clearImage",function(){v.canvas.getContext("2d").clearRect(0,0,v.canvas.width,v.canvas.height),v.setState({image:C})}),s(d(v),"handleMouseDown",function(e){(e=e||window.event).preventDefault(),v.setState({drag:!0,mx:null,my:null})}),s(d(v),"handleMouseUp",function(){v.state.drag&&(v.setState({drag:!1}),v.props.onMouseUp())}),s(d(v),"handleMouseMove",function(e){var t,o,n,a,r,i,s,u,h,c,l,d,p,g,f,m;e=e||window.event,!1!==v.state.drag&&(e.preventDefault(),n={mx:t=e.targetTouches?e.targetTouches[0].pageX:e.clientX,my:o=e.targetTouches?e.targetTouches[0].pageY:e.clientY},m=v.props.rotate,m=(m%=360)<0?m+360:m,v.state.mx&&v.state.my&&(a=v.state.mx-t,r=v.state.my-o,i=v.state.image.width*v.props.scale,s=v.state.image.height*v.props.scale,h=(u=v.getCroppingRect()).x,c=u.y,h*=i,c*=s,l=function(e){return e*(Math.PI/180)},d=Math.cos(l(m)),g=c+-a*(p=Math.sin(l(m)))+r*d,f={x:(h+a*d+r*p)/i+1/v.props.scale*v.getXScale()/2,y:g/s+1/v.props.scale*v.getYScale()/2},v.props.onPositionChange(f),n.image=y(y({},v.state.image),f)),v.setState(n),v.props.onMouseMove(e))}),s(d(v),"setCanvas",function(e){v.canvas=e}),v.canvas=null,v}return e=a,(t=[{key:"componentDidMount",value:function(){this.props.disableHiDPIScaling&&(P=1);var e,t,o=this.canvas.getContext("2d");this.props.image&&this.loadImage(this.props.image),this.paint(o),document&&(e=!!function(){var t=!1;try{var e=Object.defineProperty({},"passive",{get:function(){t=!0}});window.addEventListener("test",e,e),window.removeEventListener("test",e,e)}catch(e){t=!1}return t}()&&{passive:!1},t=I.native,document.addEventListener(t.move,this.handleMouseMove,e),document.addEventListener(t.up,this.handleMouseUp,e),w&&(document.addEventListener(t.mouseMove,this.handleMouseMove,e),document.addEventListener(t.mouseUp,this.handleMouseUp,e)))}},{key:"componentDidUpdate",value:function(e,t){this.props.image&&this.props.image!==e.image||this.props.width!==e.width||this.props.height!==e.height||this.props.backgroundColor!==e.backgroundColor?this.loadImage(this.props.image):this.props.image||t.image===C||this.clearImage();var o=this.canvas.getContext("2d");o.clearRect(0,0,this.canvas.width,this.canvas.height),this.paint(o),this.paintImage(o,this.state.image,this.props.border),e.image===this.props.image&&e.width===this.props.width&&e.height===this.props.height&&e.position===this.props.position&&e.scale===this.props.scale&&e.rotate===this.props.rotate&&t.my===this.state.my&&t.mx===this.state.mx&&t.image.x===this.state.image.x&&t.image.y===this.state.image.y&&t.backgroundColor===this.state.backgroundColor||this.props.onImageChange()}},{key:"componentWillUnmount",value:function(){var e;document&&(e=I.native,document.removeEventListener(e.move,this.handleMouseMove,!1),document.removeEventListener(e.up,this.handleMouseUp,!1),w&&(document.removeEventListener(e.mouseMove,this.handleMouseMove,!1),document.removeEventListener(e.mouseUp,this.handleMouseUp,!1)))}},{key:"isVertical",value:function(){return!this.props.disableCanvasRotation&&this.props.rotate%180!=0}},{key:"getBorders",value:function(e){var t=0<arguments.length&&void 0!==e?e:this.props.border;return Array.isArray(t)?t:[t,t]}},{key:"getDimensions",value:function(){var e=this.props,t=e.width,o=e.height,n=e.rotate,a=e.border,r={},i=m(this.getBorders(a),2),s=i[0],u=i[1],h=t,c=o;return this.isVertical()?(r.width=c,r.height=h):(r.width=h,r.height=c),r.width+=2*s,r.height+=2*u,{canvas:r,rotate:n,width:t,height:o,border:a}}},{key:"getImage",value:function(){var e=this.getCroppingRect(),t=this.state.image;e.x*=t.resource.width,e.y*=t.resource.height,e.width*=t.resource.width,e.height*=t.resource.height;var o=document.createElement("canvas");this.isVertical()?(o.width=e.height,o.height=e.width):(o.width=e.width,o.height=e.height);var n=o.getContext("2d");return n.translate(o.width/2,o.height/2),n.rotate(this.props.rotate*Math.PI/180),n.translate(-o.width/2,-o.height/2),this.isVertical()&&n.translate((o.width-o.height)/2,(o.height-o.width)/2),t.backgroundColor&&(n.fillStyle=t.backgroundColor,n.fillRect(-e.x,-e.y,t.resource.width,t.resource.height)),n.drawImage(t.resource,-e.x,-e.y),o}},{key:"getImageScaledToCanvas",value:function(){var e=this.getDimensions(),t=e.width,o=e.height,n=document.createElement("canvas");return this.isVertical()?(n.width=o,n.height=t):(n.width=t,n.height=o),this.paintImage(n.getContext("2d"),this.state.image,0,1),n}},{key:"getXScale",value:function(){var e=this.props.width/this.props.height,t=this.state.image.width/this.state.image.height;return Math.min(1,e/t)}},{key:"getYScale",value:function(){var e=this.props.height/this.props.width,t=this.state.image.height/this.state.image.width;return Math.min(1,e/t)}},{key:"getCroppingRect",value:function(){var e=this.props.position||{x:this.state.image.x,y:this.state.image.y},t=1/this.props.scale*this.getXScale(),o=1/this.props.scale*this.getYScale(),n={x:e.x-t/2,y:e.y-o/2,width:t,height:o},a=0,r=1-n.width,i=0,s=1-n.height;return(this.props.disableBoundaryChecks||1<t||1<o)&&(a=-n.width,i=-n.height,s=r=1),y(y({},n),{},{x:Math.max(a,Math.min(n.x,r)),y:Math.max(i,Math.min(n.y,s))})}},{key:"loadImage",value:function(e){var t;M&&e instanceof File?this.loadingImage=(t=e,new Promise(function(o,n){var e=new FileReader;e.onload=function(e){try{var t=v(e.target.result);o(t)}catch(e){n(e)}},e.readAsDataURL(t)}).then(this.handleImageReady).catch(this.props.onLoadFailure)):"string"==typeof e&&(this.loadingImage=v(e,this.props.crossOrigin).then(this.handleImageReady).catch(this.props.onLoadFailure))}},{key:"getInitialSize",value:function(e,t){var o,n,a=this.getDimensions();return t/e<a.height/a.width?n=e*((o=this.getDimensions().height)/t):o=t*((n=this.getDimensions().width)/e),{height:o,width:n}}},{key:"paintImage",value:function(e,t,o,n){var a,r=3<arguments.length&&void 0!==n?n:P;t.resource&&(a=this.calculatePosition(t,o),e.save(),e.translate(e.canvas.width/2,e.canvas.height/2),e.rotate(this.props.rotate*Math.PI/180),e.translate(-e.canvas.width/2,-e.canvas.height/2),this.isVertical()&&e.translate((e.canvas.width-e.canvas.height)/2,(e.canvas.height-e.canvas.width)/2),e.scale(r,r),e.globalCompositeOperation="destination-over",e.drawImage(t.resource,a.x,a.y,a.width,a.height),t.backgroundColor&&(e.fillStyle=t.backgroundColor,e.fillRect(a.x,a.y,a.width,a.height)),e.restore())}},{key:"calculatePosition",value:function(e,t){e=e||this.state.image;var o=m(this.getBorders(t),2),n=o[0],a=o[1],r=this.getCroppingRect(),i=e.width*this.props.scale,s=e.height*this.props.scale,u=-r.x*i,h=-r.y*s;return this.isVertical()?(u+=a,h+=n):(u+=n,h+=a),{x:u,y:h,height:s,width:i}}},{key:"paint",value:function(e){e.save(),e.scale(P,P),e.translate(0,0),e.fillStyle="rgba("+this.props.color.slice(0,4).join(",")+")";var t,o,n,a,r,i,s,u,h=this.props.borderRadius,c=this.getDimensions(),l=m(this.getBorders(c.border),2),d=l[0],p=l[1],g=c.canvas.height,f=c.canvas.width,h=Math.max(h,0);h=Math.min(h,f/2-d,g/2-p),e.beginPath(),t=e,a=f-2*(o=d),r=g-2*(n=p),0===(i=h)?t.rect(o,n,a,r):(s=a-i,u=r-i,t.translate(o,n),t.arc(i,i,i,Math.PI,1.5*Math.PI),t.lineTo(s,0),t.arc(s,i,i,1.5*Math.PI,2*Math.PI),t.lineTo(a,u),t.arc(s,u,i,2*Math.PI,.5*Math.PI),t.lineTo(i,r),t.arc(i,u,i,.5*Math.PI,Math.PI),t.translate(-o,-n)),e.rect(f,0,-f,g),e.fill("evenodd"),e.restore()}},{key:"render",value:function(){var e=this.props,t=(e.scale,e.rotate,e.image,e.border,e.borderRadius,e.width,e.height,e.position,e.color,e.backgroundColor,e.style),o=(e.crossOrigin,e.onLoadFailure,e.onLoadSuccess,e.onImageReady,e.onImageChange,e.onMouseUp,e.onMouseMove,e.onPositionChange,e.disableBoundaryChecks,e.disableHiDPIScaling,e.disableCanvasRotation,l(e,["scale","rotate","image","border","borderRadius","width","height","position","color","backgroundColor","style","crossOrigin","onLoadFailure","onLoadSuccess","onImageReady","onImageChange","onMouseUp","onMouseMove","onPositionChange","disableBoundaryChecks","disableHiDPIScaling","disableCanvasRotation"])),n=this.getDimensions(),a={width:n.canvas.width,height:n.canvas.height,cursor:this.state.drag?"grabbing":"grab",touchAction:"none"},r={width:n.canvas.width*P,height:n.canvas.height*P,style:y(y({},a),t)};return r[I.react.down]=this.handleMouseDown,w&&(r[I.react.mouseDown]=this.handleMouseDown),i.default.createElement("canvas",u({ref:this.setCanvas},r,o))}}])&&r(e.prototype,t),o&&r(e,o),a}();return s(x,"propTypes",{scale:n.default.number,rotate:n.default.number,image:n.default.oneOfType([n.default.string].concat(function(e){if(Array.isArray(e))return f(e)}(b=M?[n.default.instanceOf(File)]:[])||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(b)||g(b)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}())),border:n.default.oneOfType([n.default.number,n.default.arrayOf(n.default.number)]),borderRadius:n.default.number,width:n.default.number,height:n.default.number,position:n.default.shape({x:n.default.number,y:n.default.number}),color:n.default.arrayOf(n.default.number),backgroundColor:n.default.string,crossOrigin:n.default.oneOf(["","anonymous","use-credentials"]),onLoadFailure:n.default.func,onLoadSuccess:n.default.func,onImageReady:n.default.func,onImageChange:n.default.func,onMouseUp:n.default.func,onMouseMove:n.default.func,onPositionChange:n.default.func,disableBoundaryChecks:n.default.bool,disableHiDPIScaling:n.default.bool,disableCanvasRotation:n.default.bool}),s(x,"defaultProps",{scale:1,rotate:0,border:25,borderRadius:0,width:200,height:200,color:[0,0,0,.5],onLoadFailure:function(){},onLoadSuccess:function(){},onImageReady:function(){},onImageChange:function(){},onMouseUp:function(){},onMouseMove:function(){},onPositionChange:function(){},disableBoundaryChecks:!1,disableHiDPIScaling:!1,disableCanvasRotation:!0}),x});


/***/ }),

/***/ 6995:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(8532)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _reactSwipe) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _reactSwipe2.default;
});

/***/ }),

/***/ 8532:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7294), __webpack_require__(5697)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var supportsCaptureOption = false;
  function setHasSupportToCaptureOption(hasSupport) {
    supportsCaptureOption = hasSupport;
  }

  try {
    addEventListener('test', null, Object.defineProperty({}, 'capture', { get: function get() {
        setHasSupportToCaptureOption(true);
      } }));
  } catch (e) {} // eslint-disable-line no-empty

  function getSafeEventHandlerOpts() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };

    return supportsCaptureOption ? options : options.capture;
  }

  /**
   * [getPosition returns a position element that works for mouse or touch events]
   * @param  {[Event]} event [the received event]
   * @return {[Object]}      [x and y coords]
   */
  function getPosition(event) {
    if ('touches' in event) {
      var _event$touches$ = event.touches[0],
          pageX = _event$touches$.pageX,
          pageY = _event$touches$.pageY;

      return { x: pageX, y: pageY };
    }

    var screenX = event.screenX,
        screenY = event.screenY;

    return { x: screenX, y: screenY };
  }

  var ReactSwipe = function (_Component) {
    _inherits(ReactSwipe, _Component);

    function ReactSwipe() {
      var _ref;

      _classCallCheck(this, ReactSwipe);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));

      _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
      _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
      _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);

      _this._onMouseDown = _this._onMouseDown.bind(_this);
      _this._onMouseMove = _this._onMouseMove.bind(_this);
      _this._onMouseUp = _this._onMouseUp.bind(_this);

      _this._setSwiperRef = _this._setSwiperRef.bind(_this);
      return _this;
    }

    _createClass(ReactSwipe, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.swiper) {
          this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
            capture: true,
            passive: false
          }));
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.swiper) {
          this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
            capture: true,
            passive: false
          }));
        }
      }
    }, {
      key: '_onMouseDown',
      value: function _onMouseDown(event) {
        if (!this.props.allowMouseEvents) {
          return;
        }

        this.mouseDown = true;

        document.addEventListener('mouseup', this._onMouseUp);
        document.addEventListener('mousemove', this._onMouseMove);

        this._handleSwipeStart(event);
      }
    }, {
      key: '_onMouseMove',
      value: function _onMouseMove(event) {
        if (!this.mouseDown) {
          return;
        }

        this._handleSwipeMove(event);
      }
    }, {
      key: '_onMouseUp',
      value: function _onMouseUp(event) {
        this.mouseDown = false;

        document.removeEventListener('mouseup', this._onMouseUp);
        document.removeEventListener('mousemove', this._onMouseMove);

        this._handleSwipeEnd(event);
      }
    }, {
      key: '_handleSwipeStart',
      value: function _handleSwipeStart(event) {
        var _getPosition = getPosition(event),
            x = _getPosition.x,
            y = _getPosition.y;

        this.moveStart = { x: x, y: y };
        this.props.onSwipeStart(event);
      }
    }, {
      key: '_handleSwipeMove',
      value: function _handleSwipeMove(event) {
        if (!this.moveStart) {
          return;
        }

        var _getPosition2 = getPosition(event),
            x = _getPosition2.x,
            y = _getPosition2.y;

        var deltaX = x - this.moveStart.x;
        var deltaY = y - this.moveStart.y;
        this.moving = true;

        // handling the responsability of cancelling the scroll to
        // the component handling the event
        var shouldPreventDefault = this.props.onSwipeMove({
          x: deltaX,
          y: deltaY
        }, event);

        if (shouldPreventDefault && event.cancelable) {
          event.preventDefault();
        }

        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
      }
    }, {
      key: '_handleSwipeEnd',
      value: function _handleSwipeEnd(event) {
        this.props.onSwipeEnd(event);

        var tolerance = this.props.tolerance;


        if (this.moving && this.movePosition) {
          if (this.movePosition.deltaX < -tolerance) {
            this.props.onSwipeLeft(1, event);
          } else if (this.movePosition.deltaX > tolerance) {
            this.props.onSwipeRight(1, event);
          }
          if (this.movePosition.deltaY < -tolerance) {
            this.props.onSwipeUp(1, event);
          } else if (this.movePosition.deltaY > tolerance) {
            this.props.onSwipeDown(1, event);
          }
        }

        this.moveStart = null;
        this.moving = false;
        this.movePosition = null;
      }
    }, {
      key: '_setSwiperRef',
      value: function _setSwiperRef(node) {
        this.swiper = node;
        this.props.innerRef(node);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            tagName = _props.tagName,
            className = _props.className,
            style = _props.style,
            children = _props.children,
            allowMouseEvents = _props.allowMouseEvents,
            onSwipeUp = _props.onSwipeUp,
            onSwipeDown = _props.onSwipeDown,
            onSwipeLeft = _props.onSwipeLeft,
            onSwipeRight = _props.onSwipeRight,
            onSwipeStart = _props.onSwipeStart,
            onSwipeMove = _props.onSwipeMove,
            onSwipeEnd = _props.onSwipeEnd,
            innerRef = _props.innerRef,
            tolerance = _props.tolerance,
            props = _objectWithoutProperties(_props, ['tagName', 'className', 'style', 'children', 'allowMouseEvents', 'onSwipeUp', 'onSwipeDown', 'onSwipeLeft', 'onSwipeRight', 'onSwipeStart', 'onSwipeMove', 'onSwipeEnd', 'innerRef', 'tolerance']);

        return _react2.default.createElement(
          this.props.tagName,
          _extends({
            ref: this._setSwiperRef,
            onMouseDown: this._onMouseDown,
            onTouchStart: this._handleSwipeStart,
            onTouchEnd: this._handleSwipeEnd,
            className: className,
            style: style
          }, props),
          children
        );
      }
    }]);

    return ReactSwipe;
  }(_react.Component);

  ReactSwipe.displayName = 'ReactSwipe';
  ReactSwipe.propTypes = {
    tagName: _propTypes2.default.string,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    children: _propTypes2.default.node,
    allowMouseEvents: _propTypes2.default.bool,
    onSwipeUp: _propTypes2.default.func,
    onSwipeDown: _propTypes2.default.func,
    onSwipeLeft: _propTypes2.default.func,
    onSwipeRight: _propTypes2.default.func,
    onSwipeStart: _propTypes2.default.func,
    onSwipeMove: _propTypes2.default.func,
    onSwipeEnd: _propTypes2.default.func,
    innerRef: _propTypes2.default.func,
    tolerance: _propTypes2.default.number.isRequired
  };
  ReactSwipe.defaultProps = {
    tagName: 'div',
    allowMouseEvents: false,
    onSwipeUp: function onSwipeUp() {},
    onSwipeDown: function onSwipeDown() {},
    onSwipeLeft: function onSwipeLeft() {},
    onSwipeRight: function onSwipeRight() {},
    onSwipeStart: function onSwipeStart() {},
    onSwipeMove: function onSwipeMove() {},
    onSwipeEnd: function onSwipeEnd() {},
    innerRef: function innerRef() {},

    tolerance: 0
  };
  exports.default = ReactSwipe;
});

/***/ }),

/***/ 3039:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var React = __importStar(__webpack_require__(7294));
var utils_1 = __webpack_require__(1826);
var types_1 = __webpack_require__(6234);
var INCREASE_KEYS = ['ArrowRight', 'ArrowUp', 'k', 'PageUp'];
var DECREASE_KEYS = ['ArrowLeft', 'ArrowDown', 'j', 'PageDown'];
var Range = /** @class */ (function (_super) {
    __extends(Range, _super);
    function Range(props) {
        var _this = _super.call(this, props) || this;
        _this.trackRef = React.createRef();
        _this.thumbRefs = [];
        _this.state = {
            draggedTrackPos: [-1, -1],
            draggedThumbIndex: -1,
            thumbZIndexes: new Array(_this.props.values.length).fill(0).map(function (t, i) { return i; }),
            isChanged: false,
            markOffsets: []
        };
        _this.getOffsets = function () {
            var _a = _this.props, direction = _a.direction, values = _a.values, min = _a.min, max = _a.max;
            var trackElement = _this.trackRef.current;
            var trackRect = trackElement.getBoundingClientRect();
            var trackPadding = (0, utils_1.getPaddingAndBorder)(trackElement);
            return _this.getThumbs().map(function (thumb, index) {
                var thumbOffsets = { x: 0, y: 0 };
                var thumbRect = thumb.getBoundingClientRect();
                var thumbMargins = (0, utils_1.getMargin)(thumb);
                switch (direction) {
                    case types_1.Direction.Right:
                        thumbOffsets.x = (thumbMargins.left + trackPadding.left) * -1;
                        thumbOffsets.y =
                            ((thumbRect.height - trackRect.height) / 2 + trackPadding.top) * -1;
                        thumbOffsets.x +=
                            trackRect.width * (0, utils_1.relativeValue)(values[index], min, max) -
                                thumbRect.width / 2;
                        return thumbOffsets;
                    case types_1.Direction.Left:
                        thumbOffsets.x = (thumbMargins.right + trackPadding.right) * -1;
                        thumbOffsets.y =
                            ((thumbRect.height - trackRect.height) / 2 + trackPadding.top) * -1;
                        thumbOffsets.x +=
                            trackRect.width -
                                trackRect.width * (0, utils_1.relativeValue)(values[index], min, max) -
                                thumbRect.width / 2;
                        return thumbOffsets;
                    case types_1.Direction.Up:
                        thumbOffsets.x =
                            ((thumbRect.width - trackRect.width) / 2 +
                                thumbMargins.left +
                                trackPadding.left) *
                                -1;
                        thumbOffsets.y = -trackPadding.left;
                        thumbOffsets.y +=
                            trackRect.height -
                                trackRect.height * (0, utils_1.relativeValue)(values[index], min, max) -
                                thumbRect.height / 2;
                        return thumbOffsets;
                    case types_1.Direction.Down:
                        thumbOffsets.x =
                            ((thumbRect.width - trackRect.width) / 2 +
                                thumbMargins.left +
                                trackPadding.left) *
                                -1;
                        thumbOffsets.y = -trackPadding.left;
                        thumbOffsets.y +=
                            trackRect.height * (0, utils_1.relativeValue)(values[index], min, max) -
                                thumbRect.height / 2;
                        return thumbOffsets;
                    default:
                        return (0, utils_1.assertUnreachable)(direction);
                }
            });
        };
        _this.getThumbs = function () {
            if (_this.trackRef && _this.trackRef.current) {
                return Array.from(_this.trackRef.current.children).filter(function (el) {
                    return el.hasAttribute('aria-valuenow');
                });
            }
            console.warn('No thumbs found in the track container. Did you forget to pass & spread the `props` param in renderTrack?');
            return [];
        };
        _this.getTargetIndex = function (e) {
            return _this.getThumbs().findIndex(function (child) { return child === e.target || child.contains(e.target); });
        };
        _this.addTouchEvents = function (e) {
            document.addEventListener('touchmove', _this.schdOnTouchMove, {
                passive: false
            });
            document.addEventListener('touchend', _this.schdOnEnd, {
                passive: false
            });
            document.addEventListener('touchcancel', _this.schdOnEnd, {
                passive: false
            });
        };
        _this.addMouseEvents = function (e) {
            document.addEventListener('mousemove', _this.schdOnMouseMove);
            document.addEventListener('mouseup', _this.schdOnEnd);
        };
        _this.onMouseDownTrack = function (e) {
            var _a;
            if (e.button !== 0)
                return;
            e.persist();
            e.preventDefault();
            _this.addMouseEvents(e.nativeEvent);
            if (_this.props.values.length > 1 && _this.props.draggableTrack) {
                if (_this.thumbRefs.some(function (thumbRef) { var _a; return (_a = thumbRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target); }))
                    return;
                // handle dragging the whole track
                _this.setState({
                    draggedTrackPos: [e.clientX, e.clientY]
                }, function () { return _this.onMove(e.clientX, e.clientY); });
            }
            else {
                // get the index of the thumb that is closest to the place where the track is clicked
                var draggedThumbIndex = (0, utils_1.getClosestThumbIndex)(_this.thumbRefs.map(function (t) { return t.current; }), e.clientX, e.clientY, _this.props.direction);
                // move the thumb which is closest to the place where the track is clicked
                (_a = _this.thumbRefs[draggedThumbIndex].current) === null || _a === void 0 ? void 0 : _a.focus();
                _this.setState({
                    draggedThumbIndex: draggedThumbIndex
                }, function () { return _this.onMove(e.clientX, e.clientY); });
            }
        };
        _this.onResize = function () {
            (0, utils_1.translateThumbs)(_this.getThumbs(), _this.getOffsets(), _this.props.rtl);
            _this.calculateMarkOffsets();
        };
        _this.onTouchStartTrack = function (e) {
            var _a;
            e.persist();
            _this.addTouchEvents(e.nativeEvent);
            if (_this.props.values.length > 1 && _this.props.draggableTrack) {
                if (_this.thumbRefs.some(function (thumbRef) { var _a; return (_a = thumbRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target); }))
                    return;
                // handle dragging the whole track
                _this.setState({
                    draggedTrackPos: [e.touches[0].clientX, e.touches[0].clientY]
                }, function () { return _this.onMove(e.touches[0].clientX, e.touches[0].clientY); });
            }
            else {
                // get the index of the thumb that is closest to the place where the track is clicked
                var draggedThumbIndex = (0, utils_1.getClosestThumbIndex)(_this.thumbRefs.map(function (t) { return t.current; }), e.touches[0].clientX, e.touches[0].clientY, _this.props.direction);
                // move the thumb which is closest to the place where the track is clicked
                (_a = _this.thumbRefs[draggedThumbIndex].current) === null || _a === void 0 ? void 0 : _a.focus();
                _this.setState({
                    draggedThumbIndex: draggedThumbIndex
                }, function () { return _this.onMove(e.touches[0].clientX, e.touches[0].clientY); });
            }
        };
        _this.onMouseOrTouchStart = function (e) {
            if (_this.props.disabled)
                return;
            var isTouch = (0, utils_1.isTouchEvent)(e);
            if (!isTouch && e.button !== 0)
                return;
            var index = _this.getTargetIndex(e);
            if (index === -1)
                return;
            if (isTouch) {
                _this.addTouchEvents(e);
            }
            else {
                _this.addMouseEvents(e);
            }
            _this.setState({
                draggedThumbIndex: index,
                thumbZIndexes: _this.state.thumbZIndexes.map(function (t, i) {
                    if (i === index) {
                        return Math.max.apply(Math, _this.state.thumbZIndexes);
                    }
                    return t <= _this.state.thumbZIndexes[index] ? t : t - 1;
                })
            });
        };
        _this.onMouseMove = function (e) {
            e.preventDefault();
            _this.onMove(e.clientX, e.clientY);
        };
        _this.onTouchMove = function (e) {
            e.preventDefault();
            _this.onMove(e.touches[0].clientX, e.touches[0].clientY);
        };
        _this.onKeyDown = function (e) {
            var _a = _this.props, values = _a.values, onChange = _a.onChange, step = _a.step, rtl = _a.rtl, direction = _a.direction;
            var isChanged = _this.state.isChanged;
            var index = _this.getTargetIndex(e.nativeEvent);
            var inverter = rtl || direction === types_1.Direction.Left || direction === types_1.Direction.Down
                ? -1
                : 1;
            if (index === -1)
                return;
            if (INCREASE_KEYS.includes(e.key)) {
                e.preventDefault();
                _this.setState({
                    draggedThumbIndex: index,
                    isChanged: true
                });
                onChange((0, utils_1.replaceAt)(values, index, _this.normalizeValue(values[index] + inverter * (e.key === 'PageUp' ? step * 10 : step), index)));
            }
            else if (DECREASE_KEYS.includes(e.key)) {
                e.preventDefault();
                _this.setState({
                    draggedThumbIndex: index,
                    isChanged: true
                });
                onChange((0, utils_1.replaceAt)(values, index, _this.normalizeValue(values[index] -
                    inverter * (e.key === 'PageDown' ? step * 10 : step), index)));
            }
            else if (e.key === 'Tab') {
                _this.setState({ draggedThumbIndex: -1 }, function () {
                    // If key pressed when thumb was moving, fire onFinalChange
                    if (isChanged) {
                        _this.fireOnFinalChange();
                    }
                });
            }
            else {
                if (isChanged) {
                    _this.fireOnFinalChange();
                }
            }
        };
        _this.onKeyUp = function (e) {
            var isChanged = _this.state.isChanged;
            _this.setState({
                draggedThumbIndex: -1
            }, function () {
                if (isChanged) {
                    _this.fireOnFinalChange();
                }
            });
        };
        _this.onMove = function (clientX, clientY) {
            var _a = _this.state, draggedThumbIndex = _a.draggedThumbIndex, draggedTrackPos = _a.draggedTrackPos;
            var _b = _this.props, direction = _b.direction, min = _b.min, max = _b.max, onChange = _b.onChange, values = _b.values, step = _b.step, rtl = _b.rtl;
            if (draggedThumbIndex === -1 &&
                draggedTrackPos[0] === -1 &&
                draggedTrackPos[1] === -1)
                return null;
            var trackElement = _this.trackRef.current;
            // If component was closed down prematurely, A last onMove could be triggered based on requestAnimationFrame()
            if (!trackElement)
                return null;
            var trackRect = trackElement.getBoundingClientRect();
            var trackLength = (0, utils_1.isVertical)(direction)
                ? trackRect.height
                : trackRect.width;
            if (draggedTrackPos[0] !== -1 && draggedTrackPos[1] !== -1) {
                // calculate how much it moved since the last update
                var dX = clientX - draggedTrackPos[0];
                var dY = clientY - draggedTrackPos[1];
                // calculate the delta of the value
                var deltaValue = 0;
                switch (direction) {
                    case types_1.Direction.Right:
                    case types_1.Direction.Left:
                        deltaValue = (dX / trackLength) * (max - min);
                        break;
                    case types_1.Direction.Down:
                    case types_1.Direction.Up:
                        deltaValue = (dY / trackLength) * (max - min);
                        break;
                    default:
                        (0, utils_1.assertUnreachable)(direction);
                }
                // invert for RTL
                if (rtl) {
                    deltaValue *= -1;
                }
                if (Math.abs(deltaValue) >= step / 2) {
                    // adjust delta so it fits into the range
                    for (var i = 0; i < _this.thumbRefs.length; i++) {
                        if ((values[i] === max && Math.sign(deltaValue) === 1) ||
                            (values[i] === min && Math.sign(deltaValue) === -1))
                            return;
                        var thumbValue = values[i] + deltaValue;
                        if (thumbValue > max)
                            deltaValue = max - values[i];
                        else if (thumbValue < min)
                            deltaValue = min - values[i];
                    }
                    // add the delta to each thumb
                    var newValues = values.slice(0);
                    for (var i = 0; i < _this.thumbRefs.length; i++) {
                        newValues = (0, utils_1.replaceAt)(newValues, i, _this.normalizeValue(values[i] + deltaValue, i));
                    }
                    _this.setState({
                        draggedTrackPos: [clientX, clientY]
                    });
                    onChange(newValues);
                }
            }
            else {
                var newValue = 0;
                switch (direction) {
                    case types_1.Direction.Right:
                        newValue =
                            ((clientX - trackRect.left) / trackLength) * (max - min) + min;
                        break;
                    case types_1.Direction.Left:
                        newValue =
                            ((trackLength - (clientX - trackRect.left)) / trackLength) *
                                (max - min) +
                                min;
                        break;
                    case types_1.Direction.Down:
                        newValue =
                            ((clientY - trackRect.top) / trackLength) * (max - min) + min;
                        break;
                    case types_1.Direction.Up:
                        newValue =
                            ((trackLength - (clientY - trackRect.top)) / trackLength) *
                                (max - min) +
                                min;
                        break;
                    default:
                        (0, utils_1.assertUnreachable)(direction);
                }
                // invert for RTL
                if (rtl) {
                    newValue = max + min - newValue;
                }
                if (Math.abs(values[draggedThumbIndex] - newValue) >= step / 2) {
                    onChange((0, utils_1.replaceAt)(values, draggedThumbIndex, _this.normalizeValue(newValue, draggedThumbIndex)));
                }
            }
        };
        _this.normalizeValue = function (value, index) {
            var _a = _this.props, min = _a.min, max = _a.max, step = _a.step, allowOverlap = _a.allowOverlap, values = _a.values;
            return (0, utils_1.normalizeValue)(value, index, min, max, step, allowOverlap, values);
        };
        _this.onEnd = function (e) {
            e.preventDefault();
            document.removeEventListener('mousemove', _this.schdOnMouseMove);
            document.removeEventListener('touchmove', _this.schdOnTouchMove);
            document.removeEventListener('mouseup', _this.schdOnEnd);
            document.removeEventListener('touchend', _this.schdOnEnd);
            document.removeEventListener('touchcancel', _this.schdOnEnd);
            if (_this.state.draggedThumbIndex === -1 &&
                _this.state.draggedTrackPos[0] === -1 &&
                _this.state.draggedTrackPos[1] === -1)
                return null;
            _this.setState({ draggedThumbIndex: -1, draggedTrackPos: [-1, -1] }, function () {
                _this.fireOnFinalChange();
            });
        };
        _this.fireOnFinalChange = function () {
            _this.setState({ isChanged: false });
            var _a = _this.props, onFinalChange = _a.onFinalChange, values = _a.values;
            if (onFinalChange) {
                onFinalChange(values);
            }
        };
        _this.updateMarkRefs = function (props) {
            if (!props.renderMark) { // don't create mark refs unless we are rendering marks
                _this.numOfMarks = undefined;
                _this.markRefs = undefined;
                return;
            }
            _this.numOfMarks = (props.max - props.min) / _this.props.step;
            _this.markRefs = [];
            for (var i = 0; i < _this.numOfMarks + 1; i++) {
                _this.markRefs[i] = React.createRef();
            }
        };
        _this.calculateMarkOffsets = function () {
            if (!_this.props.renderMark ||
                !_this.trackRef ||
                !_this.numOfMarks ||
                !_this.markRefs ||
                _this.trackRef.current === null)
                return;
            var elStyles = window.getComputedStyle(_this.trackRef.current);
            var trackWidth = parseInt(elStyles.width, 10);
            var trackHeight = parseInt(elStyles.height, 10);
            var paddingLeft = parseInt(elStyles.paddingLeft, 10);
            var paddingTop = parseInt(elStyles.paddingTop, 10);
            var res = [];
            for (var i = 0; i < _this.numOfMarks + 1; i++) {
                var markHeight = 9999;
                var markWidth = 9999;
                if (_this.markRefs[i].current) {
                    var markRect = _this.markRefs[i].current.getBoundingClientRect();
                    markHeight = markRect.height;
                    markWidth = markRect.width;
                }
                if (_this.props.direction === types_1.Direction.Left ||
                    _this.props.direction === types_1.Direction.Right) {
                    res.push([
                        Math.round((trackWidth / _this.numOfMarks) * i + paddingLeft - markWidth / 2),
                        -Math.round((markHeight - trackHeight) / 2)
                    ]);
                }
                else {
                    res.push([
                        Math.round((trackHeight / _this.numOfMarks) * i + paddingTop - markHeight / 2),
                        -Math.round((markWidth - trackWidth) / 2)
                    ]);
                }
            }
            _this.setState({ markOffsets: res });
        };
        if (props.step === 0) {
            throw new Error('"step" property should be a positive number');
        }
        _this.schdOnMouseMove = (0, utils_1.schd)(_this.onMouseMove);
        _this.schdOnTouchMove = (0, utils_1.schd)(_this.onTouchMove);
        _this.schdOnEnd = (0, utils_1.schd)(_this.onEnd);
        _this.thumbRefs = props.values.map(function () { return React.createRef(); });
        _this.updateMarkRefs(props);
        return _this;
    }
    Range.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, values = _a.values, min = _a.min, step = _a.step;
        this.resizeObserver = window.ResizeObserver
            ? new window.ResizeObserver(this.onResize)
            : {
                observe: function () { return window.addEventListener('resize', _this.onResize); },
                unobserve: function () { return window.removeEventListener('resize', _this.onResize); }
            };
        document.addEventListener('touchstart', this.onMouseOrTouchStart, {
            passive: false
        });
        document.addEventListener('mousedown', this.onMouseOrTouchStart, {
            passive: false
        });
        !this.props.allowOverlap && (0, utils_1.checkInitialOverlap)(this.props.values);
        this.props.values.forEach(function (value) {
            return (0, utils_1.checkBoundaries)(value, _this.props.min, _this.props.max);
        });
        this.resizeObserver.observe(this.trackRef.current);
        (0, utils_1.translateThumbs)(this.getThumbs(), this.getOffsets(), this.props.rtl);
        this.calculateMarkOffsets();
        values.forEach(function (value) {
            if (!(0, utils_1.isStepDivisible)(min, value, step)) {
                console.warn('The `values` property is in conflict with the current `step`, `min`, and `max` properties. Please provide values that are accessible using the min, max, and step values.');
            }
        });
    };
    Range.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, max = _a.max, min = _a.min, step = _a.step, values = _a.values, rtl = _a.rtl;
        if (prevProps.max !== max ||
            prevProps.min !== min ||
            prevProps.step !== step) {
            this.updateMarkRefs(this.props);
        }
        (0, utils_1.translateThumbs)(this.getThumbs(), this.getOffsets(), rtl);
        // ensure offsets are calculated when the refs for the marks have been created
        // and those refs have been mounted to the dom
        // on the state update in calculateOffsets with new markOffsets are calculated
        if (prevProps.max !== max ||
            prevProps.min !== min ||
            prevProps.step !== step ||
            prevState.markOffsets.length !== this.state.markOffsets.length) {
            this.calculateMarkOffsets();
            values.forEach(function (value) {
                if (!(0, utils_1.isStepDivisible)(min, value, step)) {
                    console.warn('The `values` property is in conflict with the current `step`, `min`, and `max` properties. Please provide values that are accessible using the min, max, and step values.');
                }
            });
        }
    };
    Range.prototype.componentWillUnmount = function () {
        var options = {
            passive: false
        };
        document.removeEventListener('mousedown', this.onMouseOrTouchStart, options);
        // These need to be removed!!
        document.removeEventListener('mousemove', this.schdOnMouseMove);
        document.removeEventListener('touchmove', this.schdOnTouchMove);
        document.removeEventListener('touchstart', this.onMouseOrTouchStart);
        document.removeEventListener('mouseup', this.schdOnEnd);
        document.removeEventListener('touchend', this.schdOnEnd);
        this.resizeObserver.unobserve(this.trackRef.current);
    };
    Range.prototype.render = function () {
        var _this = this;
        var _a = this.props, renderTrack = _a.renderTrack, renderThumb = _a.renderThumb, _b = _a.renderMark, renderMark = _b === void 0 ? function () { return null; } : _b, values = _a.values, min = _a.min, max = _a.max, allowOverlap = _a.allowOverlap, disabled = _a.disabled;
        var _c = this.state, draggedThumbIndex = _c.draggedThumbIndex, thumbZIndexes = _c.thumbZIndexes, markOffsets = _c.markOffsets;
        return renderTrack({
            props: {
                style: {
                    // creates stacking context that prevents z-index applied to thumbs
                    // interfere with other elements
                    transform: 'scale(1)',
                    cursor: draggedThumbIndex > -1
                        ? 'grabbing'
                        : this.props.draggableTrack
                            ? (0, utils_1.isVertical)(this.props.direction)
                                ? 'ns-resize'
                                : 'ew-resize'
                            : values.length === 1 && !disabled
                                ? 'pointer'
                                : 'inherit'
                },
                onMouseDown: disabled ? utils_1.voidFn : this.onMouseDownTrack,
                onTouchStart: disabled ? utils_1.voidFn : this.onTouchStartTrack,
                ref: this.trackRef
            },
            isDragged: this.state.draggedThumbIndex > -1,
            disabled: disabled,
            children: __spreadArray(__spreadArray([], markOffsets.map(function (offset, index, arr) {
                return renderMark({
                    props: {
                        style: _this.props.direction === types_1.Direction.Left ||
                            _this.props.direction === types_1.Direction.Right
                            ? {
                                position: 'absolute',
                                left: "".concat(offset[0], "px"),
                                marginTop: "".concat(offset[1], "px")
                            }
                            : {
                                position: 'absolute',
                                top: "".concat(offset[0], "px"),
                                marginLeft: "".concat(offset[1], "px")
                            },
                        key: "mark".concat(index),
                        ref: _this.markRefs[index]
                    },
                    index: index
                });
            }), true), values.map(function (value, index) {
                var isDragged = _this.state.draggedThumbIndex === index;
                return renderThumb({
                    index: index,
                    value: value,
                    isDragged: isDragged,
                    props: {
                        style: {
                            position: 'absolute',
                            zIndex: thumbZIndexes[index],
                            cursor: disabled ? 'inherit' : isDragged ? 'grabbing' : 'grab',
                            userSelect: 'none',
                            touchAction: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                            msUserSelect: 'none'
                        },
                        key: index,
                        tabIndex: disabled ? undefined : 0,
                        'aria-valuemax': allowOverlap ? max : values[index + 1] || max,
                        'aria-valuemin': allowOverlap ? min : values[index - 1] || min,
                        'aria-valuenow': value,
                        draggable: false,
                        ref: _this.thumbRefs[index],
                        role: 'slider',
                        onKeyDown: disabled ? utils_1.voidFn : _this.onKeyDown,
                        onKeyUp: disabled ? utils_1.voidFn : _this.onKeyUp
                    }
                });
            }), true)
        });
    };
    Range.defaultProps = {
        step: 1,
        direction: types_1.Direction.Right,
        rtl: false,
        disabled: false,
        allowOverlap: false,
        draggableTrack: false,
        min: 0,
        max: 100
    };
    return Range;
}(React.Component));
exports["default"] = Range;


/***/ }),

/***/ 4398:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.checkValuesAgainstBoundaries = exports.relativeValue = exports.useThumbOverlap = exports.Direction = exports.getTrackBackground = exports.Range = void 0;
var Range_1 = __importDefault(__webpack_require__(3039));
exports.Range = Range_1.default;
var utils_1 = __webpack_require__(1826);
Object.defineProperty(exports, "getTrackBackground", ({ enumerable: true, get: function () { return utils_1.getTrackBackground; } }));
Object.defineProperty(exports, "useThumbOverlap", ({ enumerable: true, get: function () { return utils_1.useThumbOverlap; } }));
Object.defineProperty(exports, "relativeValue", ({ enumerable: true, get: function () { return utils_1.relativeValue; } }));
Object.defineProperty(exports, "checkValuesAgainstBoundaries", ({ enumerable: true, get: function () { return utils_1.checkValuesAgainstBoundaries; } }));
var types_1 = __webpack_require__(6234);
Object.defineProperty(exports, "Direction", ({ enumerable: true, get: function () { return types_1.Direction; } }));


/***/ }),

/***/ 6234:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Direction = void 0;
var Direction;
(function (Direction) {
    Direction["Right"] = "to right";
    Direction["Left"] = "to left";
    Direction["Down"] = "to bottom";
    Direction["Up"] = "to top";
})(Direction = exports.Direction || (exports.Direction = {}));


/***/ }),

/***/ 1826:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useThumbOverlap = exports.assertUnreachable = exports.voidFn = exports.getTrackBackground = exports.replaceAt = exports.schd = exports.translate = exports.getClosestThumbIndex = exports.translateThumbs = exports.getPaddingAndBorder = exports.getMargin = exports.checkInitialOverlap = exports.checkValuesAgainstBoundaries = exports.checkBoundaries = exports.isVertical = exports.relativeValue = exports.normalizeValue = exports.isStepDivisible = exports.isTouchEvent = exports.getStepDecimals = void 0;
var react_1 = __webpack_require__(7294);
var types_1 = __webpack_require__(6234);
var getStepDecimals = function (step) {
    var decimals = step.toString().split('.')[1];
    return decimals ? decimals.length : 0;
};
exports.getStepDecimals = getStepDecimals;
function isTouchEvent(event) {
    return ((event.touches && event.touches.length) ||
        (event.changedTouches && event.changedTouches.length));
}
exports.isTouchEvent = isTouchEvent;
function isStepDivisible(min, max, step) {
    var res = (max - min) / step;
    var precision = 8;
    var roundedRes = Number(res.toFixed(precision));
    return parseInt(roundedRes.toString(), 10) === roundedRes;
}
exports.isStepDivisible = isStepDivisible;
function normalizeValue(value, index, min, max, step, allowOverlap, values) {
    var BIG_NUM = 10e10;
    value = Math.round(value * BIG_NUM) / BIG_NUM;
    if (!allowOverlap) {
        var prev = values[index - 1];
        var next = values[index + 1];
        if (prev && prev > value)
            return prev;
        if (next && next < value)
            return next;
    }
    if (value > max)
        return max;
    if (value < min)
        return min;
    // `remainder` is a difference between the given value and a full step value
    // that is closest lower to the given value and is in the range between the min value
    // and the given value
    var remainder = Math.floor(value * BIG_NUM - min * BIG_NUM) %
        Math.floor(step * BIG_NUM);
    var closestLowerNum = Math.floor(value * BIG_NUM - Math.abs(remainder));
    var rounded = remainder === 0 ? value : closestLowerNum / BIG_NUM;
    // Values with a remainder `< step/2` are rounded to the closest lower value
    // while values with a remainder `= > step/2` are rounded to the closest bigger value
    var res = Math.abs(remainder / BIG_NUM) < step / 2
        ? rounded
        : rounded + step;
    var decimalPlaces = (0, exports.getStepDecimals)(step);
    return parseFloat(res.toFixed(decimalPlaces));
}
exports.normalizeValue = normalizeValue;
function relativeValue(value, min, max) {
    return (value - min) / (max - min);
}
exports.relativeValue = relativeValue;
function isVertical(direction) {
    return direction === types_1.Direction.Up || direction === types_1.Direction.Down;
}
exports.isVertical = isVertical;
function checkBoundaries(value, min, max) {
    if (min >= max) {
        throw new RangeError("min (".concat(min, ") is equal/bigger than max (").concat(max, ")"));
    }
    if (value < min) {
        throw new RangeError("value (".concat(value, ") is smaller than min (").concat(min, ")"));
    }
    if (value > max) {
        throw new RangeError("value (".concat(value, ") is bigger than max (").concat(max, ")"));
    }
}
exports.checkBoundaries = checkBoundaries;
function checkValuesAgainstBoundaries(value, min, max) {
    if (value < min) {
        // set selectedValue to min
        return min;
    }
    if (value > max) {
        // set selectedValue to max
        return max;
    }
    else {
        return value;
    }
}
exports.checkValuesAgainstBoundaries = checkValuesAgainstBoundaries;
function checkInitialOverlap(values) {
    if (values.length < 2)
        return;
    if (!values.slice(1).every(function (item, i) { return values[i] <= item; })) {
        throw new RangeError("values={[".concat(values, "]} needs to be sorted when allowOverlap={false}"));
    }
}
exports.checkInitialOverlap = checkInitialOverlap;
function getMargin(element) {
    var style = window.getComputedStyle(element);
    return {
        top: parseInt(style['margin-top'], 10),
        bottom: parseInt(style['margin-bottom'], 10),
        left: parseInt(style['margin-left'], 10),
        right: parseInt(style['margin-right'], 10)
    };
}
exports.getMargin = getMargin;
function getPaddingAndBorder(element) {
    var style = window.getComputedStyle(element);
    return {
        top: parseInt(style['padding-top'], 10) + parseInt(style['border-top-width'], 10),
        bottom: parseInt(style['padding-bottom'], 10) + parseInt(style['border-bottom-width'], 10),
        left: parseInt(style['padding-left'], 10) + parseInt(style['border-left-width'], 10),
        right: parseInt(style['padding-right'], 10) + parseInt(style['border-right-width'], 10),
    };
}
exports.getPaddingAndBorder = getPaddingAndBorder;
function translateThumbs(elements, offsets, rtl) {
    var inverter = rtl ? -1 : 1;
    elements.forEach(function (element, index) {
        return translate(element, inverter * offsets[index].x, offsets[index].y);
    });
}
exports.translateThumbs = translateThumbs;
/**
 * Util function for calculating the index of the thumb that is closes to a given position
 * @param thumbs - array of Thumb element to calculate the distance from
 * @param clientX - target x position (mouse/touch)
 * @param clientY - target y position (mouse/touch)
 * @param direction - the direction of the track
 */
function getClosestThumbIndex(thumbs, clientX, clientY, direction) {
    var thumbIndex = 0;
    var minThumbDistance = getThumbDistance(thumbs[0], clientX, clientY, direction);
    for (var i = 1; i < thumbs.length; i++) {
        var thumbDistance = getThumbDistance(thumbs[i], clientX, clientY, direction);
        if (thumbDistance < minThumbDistance) {
            minThumbDistance = thumbDistance;
            thumbIndex = i;
        }
    }
    return thumbIndex;
}
exports.getClosestThumbIndex = getClosestThumbIndex;
function translate(element, x, y) {
    element.style.transform = "translate(".concat(x, "px, ").concat(y, "px)");
}
exports.translate = translate;
// adapted from https://github.com/alexreardon/raf-schd
var schd = function (fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        lastArgs = args;
        if (frameId) {
            return;
        }
        frameId = requestAnimationFrame(function () {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    return wrapperFn;
};
exports.schd = schd;
function replaceAt(values, index, value) {
    var ret = values.slice(0);
    ret[index] = value;
    return ret;
}
exports.replaceAt = replaceAt;
function getTrackBackground(_a) {
    var values = _a.values, colors = _a.colors, min = _a.min, max = _a.max, _b = _a.direction, direction = _b === void 0 ? types_1.Direction.Right : _b, _c = _a.rtl, rtl = _c === void 0 ? false : _c;
    if (rtl && direction === types_1.Direction.Right) {
        direction = types_1.Direction.Left;
    }
    else if (rtl && types_1.Direction.Left) {
        direction = types_1.Direction.Right;
    }
    // sort values ascending
    var progress = values.slice(0).sort(function (a, b) { return a - b; }).map(function (value) { return ((value - min) / (max - min)) * 100; });
    var middle = progress.reduce(function (acc, point, index) {
        return "".concat(acc, ", ").concat(colors[index], " ").concat(point, "%, ").concat(colors[index + 1], " ").concat(point, "%");
    }, '');
    return "linear-gradient(".concat(direction, ", ").concat(colors[0], " 0%").concat(middle, ", ").concat(colors[colors.length - 1], " 100%)");
}
exports.getTrackBackground = getTrackBackground;
function voidFn() { }
exports.voidFn = voidFn;
function assertUnreachable(x) {
    throw new Error("Didn't expect to get here");
}
exports.assertUnreachable = assertUnreachable;
/**
 * Util function for grabbing the true largest width of a thumb
 * including the label
 * @param thumbEl - Thumb element to grab the largest width from
 * @param value - Thumb value, not label value
 * @param separator - Label separator value
 */
var getThumbWidth = function (thumbEl, value, separator, decimalPlaces, valueToLabel) {
    if (valueToLabel === void 0) { valueToLabel = function (value) { return value; }; }
    var width = Math.ceil(__spreadArray([thumbEl], Array.from(thumbEl.children), true).reduce(function (width, el) {
        var elWidth = Math.ceil(el.getBoundingClientRect().width);
        /**
         * If a label contains a merged label value, it won't return the true
         * label width for that Thumb. Clone the label and change the value
         * to that individual Thumb value in order to grab the true width.
         */
        if (el.innerText &&
            el.innerText.includes(separator) &&
            el.childElementCount === 0) {
            var elClone = el.cloneNode(true);
            elClone.innerHTML = valueToLabel(value.toFixed(decimalPlaces));
            elClone.style.visibility = 'hidden';
            document.body.appendChild(elClone);
            elWidth = Math.ceil(elClone.getBoundingClientRect().width);
            document.body.removeChild(elClone);
        }
        return elWidth > width ? elWidth : width;
    }, thumbEl.getBoundingClientRect().width));
    return width;
};
/**
 * Bulk of logic for thumb overlaps
 * Consider a scenario with 5 thumbs;
 * Thumb 1 overlaps with thumb 0 and thumb 2
 * Thumb 2 overlaps with thumb 3
 * We need an array that contains [0, 1, 2, 3]
 * The function needs to return the directly overlapping thumbs
 * and all thumbs overlapping linked to those and so on
 * @param index - Thumb index calculating overlaps for
 * @param offsets - Current Array of Thumb offsets for Range
 * @param thumbs - Array of Thumb elements
 * @param values - Array of Thumb values
 * @param separator - String separator for merged label values
 * @returns overlaps - Array of all overlapping thumbs from the index
 */
var getOverlaps = function (index, offsets, thumbs, values, separator, decimalPlaces, valueToLabel) {
    if (valueToLabel === void 0) { valueToLabel = function (value) { return value; }; }
    var overlaps = [];
    /**
     * Recursive function for building the overlaps Array
     * If an overlap is found, find the overlaps for that overlap
     * @param thumbIndex current Thumb index to find overlaps from
     */
    var buildOverlaps = function (thumbIndex) {
        var thumbXWidth = getThumbWidth(thumbs[thumbIndex], values[thumbIndex], separator, decimalPlaces, valueToLabel);
        var thumbX = offsets[thumbIndex].x;
        /**
         * Iterate through the Thumb offsets, if there is a match
         * add the thumbIndex and siblingIndex to the overlaps Array
         *
         * Then build overlaps from the overlapping siblingIndex
         */
        offsets.forEach(function (_a, siblingIndex) {
            var siblingX = _a.x;
            var siblingWidth = getThumbWidth(thumbs[siblingIndex], values[siblingIndex], separator, decimalPlaces, valueToLabel);
            if (thumbIndex !== siblingIndex &&
                ((thumbX >= siblingX && thumbX <= siblingX + siblingWidth) ||
                    (thumbX + thumbXWidth >= siblingX &&
                        thumbX + thumbXWidth <= siblingX + siblingWidth))) {
                if (!overlaps.includes(siblingIndex)) {
                    overlaps.push(thumbIndex);
                    overlaps.push(siblingIndex);
                    overlaps = __spreadArray(__spreadArray([], overlaps, true), [thumbIndex, siblingIndex], false);
                    buildOverlaps(siblingIndex);
                }
            }
        });
    };
    buildOverlaps(index);
    // Sort and remove duplicates from the built overlaps
    return Array.from(new Set(overlaps.sort()));
};
/**
 * A custom React Hook for calculating whether a thumb overlaps
 * another and whether labels could/should merge.
 * @param rangeRef - React ref value of Range component
 * @param values - current Range values Array
 * @param index - thumb index
 * @param step - step value, used to calculate the number of decimal places
 * @param separator - string to separate thumb values
 * @returns label value + styling for thumb label
 */
var useThumbOverlap = function (rangeRef, values, index, step, separator, valueToLabel) {
    if (step === void 0) { step = 0.1; }
    if (separator === void 0) { separator = ' - '; }
    if (valueToLabel === void 0) { valueToLabel = function (value) { return value; }; }
    var decimalPlaces = (0, exports.getStepDecimals)(step);
    // Create initial label style and value. Label value defaults to thumb value
    var _a = (0, react_1.useState)({}), labelStyle = _a[0], setLabelStyle = _a[1];
    var _b = (0, react_1.useState)(valueToLabel(values[index].toFixed(decimalPlaces))), labelValue = _b[0], setLabelValue = _b[1];
    // When the rangeRef or values change, update the Thumb label values and styling
    (0, react_1.useEffect)(function () {
        if (rangeRef) {
            var thumbs = rangeRef.getThumbs();
            if (thumbs.length < 1)
                return;
            var newStyle = {};
            var offsets_1 = rangeRef.getOffsets();
            /**
             * Get any overlaps for the given Thumb index. This must return all linked
             * Thumbs. So if there are 4 Thumbs and Thumbs 2, 3 and 4 overlap. If we are
             * getting the overlaps for Thumb 1 and it overlaps only Thumb 2, we must get
             * 2, 3 and 4 also.
             */
            var overlaps = getOverlaps(index, offsets_1, thumbs, values, separator, decimalPlaces, valueToLabel);
            // Set a default label value of the Thumb value
            var labelValue_1 = valueToLabel(values[index].toFixed(decimalPlaces));
            /**
             * If there are overlaps for the Thumb, we need to calculate the correct
             * Label value along with the relevant styling. We only want to show a Label
             * for the left most Thumb in an overlapping set.
             * All other Thumbs will be set to display: none.
             */
            if (overlaps.length) {
                /**
                 * Get an Array of the offsets for the overlapping Thumbs
                 * This is so we can determine if the Thumb we are looking at
                 * is the left most thumb in an overlapping set
                 */
                var offsetsX = overlaps.reduce(function (a, c, i, s) {
                    return a.length ? __spreadArray(__spreadArray([], a, true), [offsets_1[s[i]].x], false) : [offsets_1[s[i]].x];
                }, []);
                /**
                 * If our Thumb is the left most Thumb, we can build a Label value
                 * and set the style for that Label
                 */
                if (Math.min.apply(Math, offsetsX) === offsets_1[index].x) {
                    /**
                     * First calculate the Label value. To do this,
                     * grab all the values for the Thumbs in our overlaps.
                     * Then convert that to a Set and sort it whilst removing duplicates.
                     */
                    var labelValues_1 = [];
                    overlaps.forEach(function (thumb) {
                        labelValues_1.push(values[thumb].toFixed(decimalPlaces));
                    });
                    /**
                     *  Update the labelValue with the resulting Array
                     *  joined by our defined separator
                     */
                    labelValue_1 = Array.from(new Set(labelValues_1.sort(function (a, b) { return parseFloat(a) - parseFloat(b); })))
                        .map(valueToLabel)
                        .join(separator);
                    /**
                     * Lastly, build the label styling. The label styling will
                     * position the label and apply a transform so that it's centered.
                     * We want the center point between the left edge of the left most Thumb
                     * and the right edge of the right most Thumb.
                     */
                    var first = Math.min.apply(Math, offsetsX);
                    var last = Math.max.apply(Math, offsetsX);
                    var lastWidth = thumbs[overlaps[offsetsX.indexOf(last)]].getBoundingClientRect().width;
                    newStyle.left = "".concat(Math.abs(first - (last + lastWidth)) / 2, "px");
                    newStyle.transform = 'translate(-50%, 0)';
                }
                else {
                    // If the Thumb isn't the left most Thumb, hide the Label!
                    newStyle.visibility = 'hidden';
                }
            }
            // Update the label value and style
            setLabelValue(labelValue_1);
            setLabelStyle(newStyle);
        }
    }, [rangeRef, values]);
    return [labelValue, labelStyle];
};
exports.useThumbOverlap = useThumbOverlap;
/**
 * Util function for calculating the distance of the center of a thumb
 * form a given mouse/touch target's position
 * @param thumbEl - Thumb element to calculate the distance from
 * @param clientX - target x position (mouse/touch)
 * @param clientY - target y position (mouse/touch)
 * @param direction - the direction of the track
 */
function getThumbDistance(thumbEl, clientX, clientY, direction) {
    var _a = thumbEl.getBoundingClientRect(), left = _a.left, top = _a.top, width = _a.width, height = _a.height;
    return isVertical(direction) ? Math.abs(clientY - (top + height / 2)) : Math.abs(clientX - (left + width / 2));
}


/***/ }),

/***/ 2751:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _default = function _default(position, metric, axis) {
  var positionPercent = position === 0 ? position : position + metric;
  var positionCss = axis === 'horizontal' ? [positionPercent, 0, 0] : [0, positionPercent, 0];
  var transitionProp = 'translate3d';
  var translatedPosition = '(' + positionCss.join(',') + ')';
  return transitionProp + translatedPosition;
};

exports["default"] = _default;

/***/ }),

/***/ 4954:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.fadeAnimationHandler = exports.slideStopSwipingHandler = exports.slideSwipeAnimationHandler = exports.slideAnimationHandler = void 0;

var _react = __webpack_require__(7294);

var _CSSTranslate = _interopRequireDefault(__webpack_require__(2751));

var _utils = __webpack_require__(8918);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Main animation handler for the default 'sliding' style animation
 * @param props
 * @param state
 */
var slideAnimationHandler = function slideAnimationHandler(props, state) {
  var returnStyles = {};
  var selectedItem = state.selectedItem;
  var previousItem = selectedItem;
  var lastPosition = _react.Children.count(props.children) - 1;
  var needClonedSlide = props.infiniteLoop && (selectedItem < 0 || selectedItem > lastPosition); // Handle list position if it needs a clone

  if (needClonedSlide) {
    if (previousItem < 0) {
      if (props.centerMode && props.centerSlidePercentage && props.axis === 'horizontal') {
        returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * props.centerSlidePercentage - (100 - props.centerSlidePercentage) / 2, props.axis);
      } else {
        returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * 100, props.axis);
      }
    } else if (previousItem > lastPosition) {
      returnStyles.itemListStyle = (0, _utils.setPosition)(0, props.axis);
    }

    return returnStyles;
  }

  var currentPosition = (0, _utils.getPosition)(selectedItem, props); // if 3d is available, let's take advantage of the performance of transform

  var transformProp = (0, _CSSTranslate.default)(currentPosition, '%', props.axis);
  var transitionTime = props.transitionTime + 'ms';
  returnStyles.itemListStyle = {
    WebkitTransform: transformProp,
    msTransform: transformProp,
    OTransform: transformProp,
    transform: transformProp
  };

  if (!state.swiping) {
    returnStyles.itemListStyle = _objectSpread(_objectSpread({}, returnStyles.itemListStyle), {}, {
      WebkitTransitionDuration: transitionTime,
      MozTransitionDuration: transitionTime,
      OTransitionDuration: transitionTime,
      transitionDuration: transitionTime,
      msTransitionDuration: transitionTime
    });
  }

  return returnStyles;
};
/**
 * Swiping animation handler for the default 'sliding' style animation
 * @param delta
 * @param props
 * @param state
 * @param setState
 */


exports.slideAnimationHandler = slideAnimationHandler;

var slideSwipeAnimationHandler = function slideSwipeAnimationHandler(delta, props, state, setState) {
  var returnStyles = {};
  var isHorizontal = props.axis === 'horizontal';

  var childrenLength = _react.Children.count(props.children);

  var initialBoundry = 0;
  var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
  var finalBoundry = props.infiniteLoop ? (0, _utils.getPosition)(childrenLength - 1, props) - 100 : (0, _utils.getPosition)(childrenLength - 1, props);
  var axisDelta = isHorizontal ? delta.x : delta.y;
  var handledDelta = axisDelta; // prevent user from swiping left out of boundaries

  if (currentPosition === initialBoundry && axisDelta > 0) {
    handledDelta = 0;
  } // prevent user from swiping right out of boundaries


  if (currentPosition === finalBoundry && axisDelta < 0) {
    handledDelta = 0;
  }

  var position = currentPosition + 100 / (state.itemSize / handledDelta);
  var hasMoved = Math.abs(axisDelta) > props.swipeScrollTolerance;

  if (props.infiniteLoop && hasMoved) {
    // When allowing infinite loop, if we slide left from position 0 we reveal the cloned last slide that appears before it
    // if we slide even further we need to jump to other side so it can continue - and vice versa for the last slide
    if (state.selectedItem === 0 && position > -100) {
      position -= childrenLength * 100;
    } else if (state.selectedItem === childrenLength - 1 && position < -childrenLength * 100) {
      position += childrenLength * 100;
    }
  }

  if (!props.preventMovementUntilSwipeScrollTolerance || hasMoved || state.swipeMovementStarted) {
    if (!state.swipeMovementStarted) {
      setState({
        swipeMovementStarted: true
      });
    }

    returnStyles.itemListStyle = (0, _utils.setPosition)(position, props.axis);
  } //allows scroll if the swipe was within the tolerance


  if (hasMoved && !state.cancelClick) {
    setState({
      cancelClick: true
    });
  }

  return returnStyles;
};
/**
 * Default 'sliding' style animination handler for when a swipe action stops.
 * @param props
 * @param state
 */


exports.slideSwipeAnimationHandler = slideSwipeAnimationHandler;

var slideStopSwipingHandler = function slideStopSwipingHandler(props, state) {
  var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
  var itemListStyle = (0, _utils.setPosition)(currentPosition, props.axis);
  return {
    itemListStyle: itemListStyle
  };
};
/**
 * Main animation handler for the default 'fade' style animation
 * @param props
 * @param state
 */


exports.slideStopSwipingHandler = slideStopSwipingHandler;

var fadeAnimationHandler = function fadeAnimationHandler(props, state) {
  var transitionTime = props.transitionTime + 'ms';
  var transitionTimingFunction = 'ease-in-out';
  var slideStyle = {
    position: 'absolute',
    display: 'block',
    zIndex: -2,
    minHeight: '100%',
    opacity: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transitionTimingFunction: transitionTimingFunction,
    msTransitionTimingFunction: transitionTimingFunction,
    MozTransitionTimingFunction: transitionTimingFunction,
    WebkitTransitionTimingFunction: transitionTimingFunction,
    OTransitionTimingFunction: transitionTimingFunction
  };

  if (!state.swiping) {
    slideStyle = _objectSpread(_objectSpread({}, slideStyle), {}, {
      WebkitTransitionDuration: transitionTime,
      MozTransitionDuration: transitionTime,
      OTransitionDuration: transitionTime,
      transitionDuration: transitionTime,
      msTransitionDuration: transitionTime
    });
  }

  return {
    slideStyle: slideStyle,
    selectedStyle: _objectSpread(_objectSpread({}, slideStyle), {}, {
      opacity: 1,
      position: 'relative'
    }),
    prevStyle: _objectSpread({}, slideStyle)
  };
};

exports.fadeAnimationHandler = fadeAnimationHandler;

/***/ }),

/***/ 5743:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _reactEasySwipe = _interopRequireDefault(__webpack_require__(6995));

var _cssClasses = _interopRequireDefault(__webpack_require__(5702));

var _Thumbs = _interopRequireDefault(__webpack_require__(5040));

var _document = _interopRequireDefault(__webpack_require__(6513));

var _window = _interopRequireDefault(__webpack_require__(885));

var _utils = __webpack_require__(8918);

var _animations = __webpack_require__(4954);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);

  var _super = _createSuper(Carousel);

  // @ts-ignore
  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "carouselWrapperRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "listRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "itemsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "timer", void 0);

    _defineProperty(_assertThisInitialized(_this), "animationHandler", void 0);

    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node) {
      _this.thumbsRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setCarouselWrapperRef", function (node) {
      _this.carouselWrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setListRef", function (node) {
      _this.listRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setItemsRef", function (node, index) {
      if (!_this.itemsRef) {
        _this.itemsRef = [];
      }

      _this.itemsRef[index] = node;
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function () {
      if (_react.Children.count(_this.props.children) <= 1) {
        return;
      }

      _this.clearAutoPlay();

      if (!_this.props.autoPlay) {
        return;
      }

      _this.timer = setTimeout(function () {
        _this.increment();
      }, _this.props.interval);
    });

    _defineProperty(_assertThisInitialized(_this), "clearAutoPlay", function () {
      if (_this.timer) clearTimeout(_this.timer);
    });

    _defineProperty(_assertThisInitialized(_this), "resetAutoPlay", function () {
      _this.clearAutoPlay();

      _this.autoPlay();
    });

    _defineProperty(_assertThisInitialized(_this), "stopOnHover", function () {
      _this.setState({
        isMouseEntered: true
      }, _this.clearAutoPlay);
    });

    _defineProperty(_assertThisInitialized(_this), "startOnLeave", function () {
      _this.setState({
        isMouseEntered: false
      }, _this.autoPlay);
    });

    _defineProperty(_assertThisInitialized(_this), "isFocusWithinTheCarousel", function () {
      if (!_this.carouselWrapperRef) {
        return false;
      }

      if ((0, _document.default)().activeElement === _this.carouselWrapperRef || _this.carouselWrapperRef.contains((0, _document.default)().activeElement)) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "navigateWithKeyboard", function (e) {
      if (!_this.isFocusWithinTheCarousel()) {
        return;
      }

      var axis = _this.props.axis;
      var isHorizontal = axis === 'horizontal';
      var keyNames = {
        ArrowUp: 38,
        ArrowRight: 39,
        ArrowDown: 40,
        ArrowLeft: 37
      };
      var nextKey = isHorizontal ? keyNames.ArrowRight : keyNames.ArrowDown;
      var prevKey = isHorizontal ? keyNames.ArrowLeft : keyNames.ArrowUp;

      if (nextKey === e.keyCode) {
        _this.increment();
      } else if (prevKey === e.keyCode) {
        _this.decrement();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
      if (!_this.state.initialized || !_this.itemsRef || _this.itemsRef.length === 0) {
        return;
      }

      var isHorizontal = _this.props.axis === 'horizontal';
      var firstItem = _this.itemsRef[0];

      if (!firstItem) {
        return;
      }

      var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;

      _this.setState({
        itemSize: itemSize
      });

      if (_this.thumbsRef) {
        _this.thumbsRef.updateSizes();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setMountState", function () {
      _this.setState({
        hasMount: true
      });

      _this.updateSizes();
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item) {
      if (_react.Children.count(_this.props.children) === 0) {
        return;
      }

      if (_this.state.cancelClick) {
        _this.setState({
          cancelClick: false
        });

        return;
      }

      _this.props.onClickItem(index, item);

      if (index !== _this.state.selectedItem) {
        _this.setState({
          selectedItem: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (index, item) {
      if (_react.Children.count(_this.props.children) <= 1) {
        return;
      }

      _this.props.onChange(index, item);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickThumb", function (index, item) {
      _this.props.onClickThumb(index, item);

      _this.moveTo(index);
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function (event) {
      _this.setState({
        swiping: true
      });

      _this.props.onSwipeStart(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function (event) {
      _this.setState({
        swiping: false,
        cancelClick: false,
        swipeMovementStarted: false
      });

      _this.props.onSwipeEnd(event);

      _this.clearAutoPlay();

      if (_this.state.autoPlay) {
        _this.autoPlay();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta, event) {
      _this.props.onSwipeMove(event);

      var animationHandlerResponse = _this.props.swipeAnimationHandler(delta, _this.props, _this.state, _this.setState.bind(_assertThisInitialized(_this)));

      _this.setState(_objectSpread({}, animationHandlerResponse)); // If we have not moved, we should have an empty object returned
      // Return false to allow scrolling when not swiping


      return !!Object.keys(animationHandlerResponse).length;
    });

    _defineProperty(_assertThisInitialized(_this), "decrement", function () {
      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      _this.moveTo(_this.state.selectedItem - (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "increment", function () {
      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      _this.moveTo(_this.state.selectedItem + (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
      if (typeof position !== 'number') {
        return;
      }

      var lastPosition = _react.Children.count(_this.props.children) - 1;

      if (position < 0) {
        position = _this.props.infiniteLoop ? lastPosition : 0;
      }

      if (position > lastPosition) {
        position = _this.props.infiniteLoop ? 0 : lastPosition;
      }

      _this.selectItem({
        // if it's not a slider, we don't need to set position here
        selectedItem: position
      }); // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
      // and will result in the interval function not being cleared correctly.


      if (_this.state.autoPlay && _this.state.isMouseEntered === false) {
        _this.resetAutoPlay();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickNext", function () {
      _this.increment(1);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickPrev", function () {
      _this.decrement(1);
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeForward", function () {
      _this.increment(1);

      if (_this.props.emulateTouch) {
        _this.setState({
          cancelClick: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeBackwards", function () {
      _this.decrement(1);

      if (_this.props.emulateTouch) {
        _this.setState({
          cancelClick: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeItem", function (newIndex) {
      return function (e) {
        if (!(0, _utils.isKeyboardEvent)(e) || e.key === 'Enter') {
          _this.moveTo(newIndex);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "selectItem", function (state) {
      // Merge in the new state while updating updating previous item
      _this.setState(_objectSpread({
        previousItem: _this.state.selectedItem
      }, state), function () {
        // Run animation handler and update styles based on it
        _this.setState(_this.animationHandler(_this.props, _this.state));
      });

      _this.handleOnChange(state.selectedItem, _react.Children.toArray(_this.props.children)[state.selectedItem]);
    });

    _defineProperty(_assertThisInitialized(_this), "getInitialImage", function () {
      var selectedItem = _this.props.selectedItem;
      var item = _this.itemsRef && _this.itemsRef[selectedItem];
      var images = item && item.getElementsByTagName('img') || [];
      return images[0];
    });

    _defineProperty(_assertThisInitialized(_this), "getVariableItemHeight", function (position) {
      var item = _this.itemsRef && _this.itemsRef[position];

      if (_this.state.hasMount && item && item.children.length) {
        var slideImages = item.children[0].getElementsByTagName('img') || [];

        if (slideImages.length > 0) {
          var image = slideImages[0];

          if (!image.complete) {
            // if the image is still loading, the size won't be available so we trigger a new render after it's done
            var onImageLoad = function onImageLoad() {
              _this.forceUpdate();

              image.removeEventListener('load', onImageLoad);
            };

            image.addEventListener('load', onImageLoad);
          }
        } // try to get img first, if img not there find first display tag


        var displayItem = slideImages[0] || item.children[0];
        var height = displayItem.clientHeight;
        return height > 0 ? height : null;
      }

      return null;
    });

    var initState = {
      initialized: false,
      previousItem: props.selectedItem,
      selectedItem: props.selectedItem,
      hasMount: false,
      isMouseEntered: false,
      autoPlay: props.autoPlay,
      swiping: false,
      swipeMovementStarted: false,
      cancelClick: false,
      itemSize: 1,
      itemListStyle: {},
      slideStyle: {},
      selectedStyle: {},
      prevStyle: {}
    };
    _this.animationHandler = typeof props.animationHandler === 'function' && props.animationHandler || props.animationHandler === 'fade' && _animations.fadeAnimationHandler || _animations.slideAnimationHandler;
    _this.state = _objectSpread(_objectSpread({}, initState), _this.animationHandler(props, initState));
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.children) {
        return;
      }

      this.setupCarousel();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevProps.children && this.props.children && !this.state.initialized) {
        this.setupCarousel();
      }

      if (!prevProps.autoFocus && this.props.autoFocus) {
        this.forceFocus();
      }

      if (prevState.swiping && !this.state.swiping) {
        // We stopped swiping, ensure we are heading to the new/current slide and not stuck
        this.setState(_objectSpread({}, this.props.stopSwipingHandler(this.props, this.state)));
      }

      if (prevProps.selectedItem !== this.props.selectedItem || prevProps.centerMode !== this.props.centerMode) {
        this.updateSizes();
        this.moveTo(this.props.selectedItem);
      }

      if (prevProps.autoPlay !== this.props.autoPlay) {
        if (this.props.autoPlay) {
          this.setupAutoPlay();
        } else {
          this.destroyAutoPlay();
        }

        this.setState({
          autoPlay: this.props.autoPlay
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyCarousel();
    }
  }, {
    key: "setupCarousel",
    value: function setupCarousel() {
      var _this2 = this;

      this.bindEvents();

      if (this.state.autoPlay && _react.Children.count(this.props.children) > 1) {
        this.setupAutoPlay();
      }

      if (this.props.autoFocus) {
        this.forceFocus();
      }

      this.setState({
        initialized: true
      }, function () {
        var initialImage = _this2.getInitialImage();

        if (initialImage && !initialImage.complete) {
          // if it's a carousel of images, we set the mount state after the first image is loaded
          initialImage.addEventListener('load', _this2.setMountState);
        } else {
          _this2.setMountState();
        }
      });
    }
  }, {
    key: "destroyCarousel",
    value: function destroyCarousel() {
      if (this.state.initialized) {
        this.unbindEvents();
        this.destroyAutoPlay();
      }
    }
  }, {
    key: "setupAutoPlay",
    value: function setupAutoPlay() {
      this.autoPlay();
      var carouselWrapper = this.carouselWrapperRef;

      if (this.props.stopOnHover && carouselWrapper) {
        carouselWrapper.addEventListener('mouseenter', this.stopOnHover);
        carouselWrapper.addEventListener('mouseleave', this.startOnLeave);
      }
    }
  }, {
    key: "destroyAutoPlay",
    value: function destroyAutoPlay() {
      this.clearAutoPlay();
      var carouselWrapper = this.carouselWrapperRef;

      if (this.props.stopOnHover && carouselWrapper) {
        carouselWrapper.removeEventListener('mouseenter', this.stopOnHover);
        carouselWrapper.removeEventListener('mouseleave', this.startOnLeave);
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      // as the widths are calculated, we need to resize
      // the carousel when the window is resized
      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes);

      if (this.props.useKeyboardArrows) {
        (0, _document.default)().addEventListener('keydown', this.navigateWithKeyboard);
      }
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      // removing listeners
      (0, _window.default)().removeEventListener('resize', this.updateSizes);
      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
      var initialImage = this.getInitialImage();

      if (initialImage) {
        initialImage.removeEventListener('load', this.setMountState);
      }

      if (this.props.useKeyboardArrows) {
        (0, _document.default)().removeEventListener('keydown', this.navigateWithKeyboard);
      }
    }
  }, {
    key: "forceFocus",
    value: function forceFocus() {
      var _this$carouselWrapper;

      (_this$carouselWrapper = this.carouselWrapperRef) === null || _this$carouselWrapper === void 0 ? void 0 : _this$carouselWrapper.focus();
    }
  }, {
    key: "renderItems",
    value: function renderItems(isClone) {
      var _this3 = this;

      if (!this.props.children) {
        return [];
      }

      return _react.Children.map(this.props.children, function (item, index) {
        var isSelected = index === _this3.state.selectedItem;
        var isPrevious = index === _this3.state.previousItem;
        var style = isSelected && _this3.state.selectedStyle || isPrevious && _this3.state.prevStyle || _this3.state.slideStyle || {};

        if (_this3.props.centerMode && _this3.props.axis === 'horizontal') {
          style = _objectSpread(_objectSpread({}, style), {}, {
            minWidth: _this3.props.centerSlidePercentage + '%'
          });
        }

        if (_this3.state.swiping && _this3.state.swipeMovementStarted) {
          style = _objectSpread(_objectSpread({}, style), {}, {
            pointerEvents: 'none'
          });
        }

        var slideProps = {
          ref: function ref(e) {
            return _this3.setItemsRef(e, index);
          },
          key: 'itemKey' + index + (isClone ? 'clone' : ''),
          className: _cssClasses.default.ITEM(true, index === _this3.state.selectedItem, index === _this3.state.previousItem),
          onClick: _this3.handleClickItem.bind(_this3, index, item),
          style: style
        };
        return /*#__PURE__*/_react.default.createElement("li", slideProps, _this3.props.renderItem(item, {
          isSelected: index === _this3.state.selectedItem,
          isPrevious: index === _this3.state.previousItem
        }));
      });
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      var _this4 = this;

      var _this$props = this.props,
          showIndicators = _this$props.showIndicators,
          labels = _this$props.labels,
          renderIndicator = _this$props.renderIndicator,
          children = _this$props.children;

      if (!showIndicators) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "control-dots"
      }, _react.Children.map(children, function (_, index) {
        return renderIndicator && renderIndicator(_this4.changeItem(index), index === _this4.state.selectedItem, index, labels.item);
      }));
    }
  }, {
    key: "renderStatus",
    value: function renderStatus() {
      if (!this.props.showStatus) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("p", {
        className: "carousel-status"
      }, this.props.statusFormatter(this.state.selectedItem + 1, _react.Children.count(this.props.children)));
    }
  }, {
    key: "renderThumbs",
    value: function renderThumbs() {
      if (!this.props.showThumbs || !this.props.children || _react.Children.count(this.props.children) === 0) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_Thumbs.default, {
        ref: this.setThumbsRef,
        onSelectItem: this.handleClickThumb,
        selectedItem: this.state.selectedItem,
        transitionTime: this.props.transitionTime,
        thumbWidth: this.props.thumbWidth,
        labels: this.props.labels,
        emulateTouch: this.props.emulateTouch
      }, this.props.renderThumbs(this.props.children));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (!this.props.children || _react.Children.count(this.props.children) === 0) {
        return null;
      }

      var isSwipeable = this.props.swipeable && _react.Children.count(this.props.children) > 1;
      var isHorizontal = this.props.axis === 'horizontal';
      var canShowArrows = this.props.showArrows && _react.Children.count(this.props.children) > 1; // show left arrow?

      var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop) || false; // show right arrow

      var hasNext = canShowArrows && (this.state.selectedItem < _react.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || false;
      var itemsClone = this.renderItems(true);
      var firstClone = itemsClone.shift();
      var lastClone = itemsClone.pop();
      var swiperProps = {
        className: _cssClasses.default.SLIDER(true, this.state.swiping),
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: this.state.itemListStyle,
        tolerance: this.props.swipeScrollTolerance
      };
      var containerStyles = {};

      if (isHorizontal) {
        swiperProps.onSwipeLeft = this.onSwipeForward;
        swiperProps.onSwipeRight = this.onSwipeBackwards;

        if (this.props.dynamicHeight) {
          var itemHeight = this.getVariableItemHeight(this.state.selectedItem); // swiperProps.style.height = itemHeight || 'auto';

          containerStyles.height = itemHeight || 'auto';
        }
      } else {
        swiperProps.onSwipeUp = this.props.verticalSwipe === 'natural' ? this.onSwipeBackwards : this.onSwipeForward;
        swiperProps.onSwipeDown = this.props.verticalSwipe === 'natural' ? this.onSwipeForward : this.onSwipeBackwards;
        swiperProps.style = _objectSpread(_objectSpread({}, swiperProps.style), {}, {
          height: this.state.itemSize
        });
        containerStyles.height = this.state.itemSize;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        "aria-label": this.props.ariaLabel,
        className: _cssClasses.default.ROOT(this.props.className),
        ref: this.setCarouselWrapperRef,
        tabIndex: this.props.useKeyboardArrows ? 0 : undefined
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.CAROUSEL(true),
        style: {
          width: this.props.width
        }
      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, hasPrev, this.props.labels.leftArrow), /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.WRAPPER(true, this.props.axis),
        style: containerStyles
      }, isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, _extends({
        tagName: "ul",
        innerRef: this.setListRef
      }, swiperProps, {
        allowMouseEvents: this.props.emulateTouch
      }), this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone) : /*#__PURE__*/_react.default.createElement("ul", {
        className: _cssClasses.default.SLIDER(true, this.state.swiping),
        ref: function ref(node) {
          return _this5.setListRef(node);
        },
        style: this.state.itemListStyle || {}
      }, this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone)), this.props.renderArrowNext(this.onClickNext, hasNext, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
    }
  }]);

  return Carousel;
}(_react.default.Component);

exports["default"] = Carousel;

_defineProperty(Carousel, "displayName", 'Carousel');

_defineProperty(Carousel, "defaultProps", {
  ariaLabel: undefined,
  axis: 'horizontal',
  centerSlidePercentage: 80,
  interval: 3000,
  labels: {
    leftArrow: 'previous slide / item',
    rightArrow: 'next slide / item',
    item: 'slide item'
  },
  onClickItem: _utils.noop,
  onClickThumb: _utils.noop,
  onChange: _utils.noop,
  onSwipeStart: function onSwipeStart() {},
  onSwipeEnd: function onSwipeEnd() {},
  onSwipeMove: function onSwipeMove() {
    return false;
  },
  preventMovementUntilSwipeScrollTolerance: false,
  renderArrowPrev: function renderArrowPrev(onClickHandler, hasPrev, label) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": label,
      className: _cssClasses.default.ARROW_PREV(!hasPrev),
      onClick: onClickHandler
    });
  },
  renderArrowNext: function renderArrowNext(onClickHandler, hasNext, label) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": label,
      className: _cssClasses.default.ARROW_NEXT(!hasNext),
      onClick: onClickHandler
    });
  },
  renderIndicator: function renderIndicator(onClickHandler, isSelected, index, label) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: _cssClasses.default.DOT(isSelected),
      onClick: onClickHandler,
      onKeyDown: onClickHandler,
      value: index,
      key: index,
      role: "button",
      tabIndex: 0,
      "aria-label": "".concat(label, " ").concat(index + 1)
    });
  },
  renderItem: function renderItem(item) {
    return item;
  },
  renderThumbs: function renderThumbs(children) {
    var images = _react.Children.map(children, function (item) {
      var img = item; // if the item is not an image, try to find the first image in the item's children.

      if (item.type !== 'img') {
        img = _react.Children.toArray(item.props.children).find(function (children) {
          return children.type === 'img';
        });
      }

      if (!img) {
        return undefined;
      }

      return img;
    });

    if (images.filter(function (image) {
      return image;
    }).length === 0) {
      console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md");
      return [];
    }

    return images;
  },
  statusFormatter: _utils.defaultStatusFormatter,
  selectedItem: 0,
  showArrows: true,
  showIndicators: true,
  showStatus: true,
  showThumbs: true,
  stopOnHover: true,
  swipeScrollTolerance: 5,
  swipeable: true,
  transitionTime: 350,
  verticalSwipe: 'standard',
  width: '100%',
  animationHandler: 'slide',
  swipeAnimationHandler: _animations.slideSwipeAnimationHandler,
  stopSwipingHandler: _animations.slideStopSwipingHandler
});

/***/ }),

/***/ 629:
/***/ (function() {

"use strict";


/***/ }),

/***/ 8918:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.setPosition = exports.getPosition = exports.isKeyboardEvent = exports.defaultStatusFormatter = exports.noop = void 0;

var _react = __webpack_require__(7294);

var _CSSTranslate = _interopRequireDefault(__webpack_require__(2751));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

exports.noop = noop;

var defaultStatusFormatter = function defaultStatusFormatter(current, total) {
  return "".concat(current, " of ").concat(total);
};

exports.defaultStatusFormatter = defaultStatusFormatter;

var isKeyboardEvent = function isKeyboardEvent(e) {
  return e ? e.hasOwnProperty('key') : false;
};
/**
 * Gets the list 'position' relative to a current index
 * @param index
 */


exports.isKeyboardEvent = isKeyboardEvent;

var getPosition = function getPosition(index, props) {
  if (props.infiniteLoop) {
    // index has to be added by 1 because of the first cloned slide
    ++index;
  }

  if (index === 0) {
    return 0;
  }

  var childrenLength = _react.Children.count(props.children);

  if (props.centerMode && props.axis === 'horizontal') {
    var currentPosition = -index * props.centerSlidePercentage;
    var lastPosition = childrenLength - 1;

    if (index && (index !== lastPosition || props.infiniteLoop)) {
      currentPosition += (100 - props.centerSlidePercentage) / 2;
    } else if (index === lastPosition) {
      currentPosition += 100 - props.centerSlidePercentage;
    }

    return currentPosition;
  }

  return -index * 100;
};
/**
 * Sets the 'position' transform for sliding animations
 * @param position
 * @param forceReflow
 */


exports.getPosition = getPosition;

var setPosition = function setPosition(position, axis) {
  var style = {};
  ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
    // @ts-ignore
    style[prop] = (0, _CSSTranslate.default)(position, '%', axis);
  });
  return style;
};

exports.setPosition = setPosition;

/***/ }),

/***/ 5040:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _cssClasses = _interopRequireDefault(__webpack_require__(5702));

var _dimensions = __webpack_require__(4528);

var _CSSTranslate = _interopRequireDefault(__webpack_require__(2751));

var _reactEasySwipe = _interopRequireDefault(__webpack_require__(6995));

var _window = _interopRequireDefault(__webpack_require__(885));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isKeyboardEvent = function isKeyboardEvent(e) {
  return e.hasOwnProperty('key');
};

var Thumbs = /*#__PURE__*/function (_Component) {
  _inherits(Thumbs, _Component);

  var _super = _createSuper(Thumbs);

  function Thumbs(_props) {
    var _this;

    _classCallCheck(this, Thumbs);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "itemsWrapperRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "itemsListRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "setItemsWrapperRef", function (node) {
      _this.itemsWrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setItemsListRef", function (node) {
      _this.itemsListRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node, index) {
      if (!_this.thumbsRef) {
        _this.thumbsRef = [];
      }

      _this.thumbsRef[index] = node;
    });

    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
      if (!_this.props.children || !_this.itemsWrapperRef || !_this.thumbsRef) {
        return;
      }

      var total = _react.Children.count(_this.props.children);

      var wrapperSize = _this.itemsWrapperRef.clientWidth;
      var itemSize = _this.props.thumbWidth ? _this.props.thumbWidth : (0, _dimensions.outerWidth)(_this.thumbsRef[0]);
      var visibleItems = Math.floor(wrapperSize / itemSize);
      var showArrows = visibleItems < total;
      var lastPosition = showArrows ? total - visibleItems : 0;

      _this.setState(function (_state, props) {
        return {
          itemSize: itemSize,
          visibleItems: visibleItems,
          firstItem: showArrows ? _this.getFirstItem(props.selectedItem) : 0,
          lastPosition: lastPosition,
          showArrows: showArrows
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item, e) {
      if (!isKeyboardEvent(e) || e.key === 'Enter') {
        var handler = _this.props.onSelectItem;

        if (typeof handler === 'function') {
          handler(index, item);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function () {
      _this.setState({
        swiping: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function () {
      _this.setState({
        swiping: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta) {
      var deltaX = delta.x;

      if (!_this.state.itemSize || !_this.itemsWrapperRef || !_this.state.visibleItems) {
        return false;
      }

      var leftBoundary = 0;

      var childrenLength = _react.Children.count(_this.props.children);

      var currentPosition = -(_this.state.firstItem * 100) / _this.state.visibleItems;
      var lastLeftItem = Math.max(childrenLength - _this.state.visibleItems, 0);
      var lastLeftBoundary = -lastLeftItem * 100 / _this.state.visibleItems; // prevent user from swiping left out of boundaries

      if (currentPosition === leftBoundary && deltaX > 0) {
        deltaX = 0;
      } // prevent user from swiping right out of boundaries


      if (currentPosition === lastLeftBoundary && deltaX < 0) {
        deltaX = 0;
      }

      var wrapperSize = _this.itemsWrapperRef.clientWidth;
      var position = currentPosition + 100 / (wrapperSize / deltaX); // if 3d isn't available we will use left to move

      if (_this.itemsListRef) {
        ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
          _this.itemsListRef.style[prop] = (0, _CSSTranslate.default)(position, '%', _this.props.axis);
        });
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "slideRight", function (positions) {
      _this.moveTo(_this.state.firstItem - (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "slideLeft", function (positions) {
      _this.moveTo(_this.state.firstItem + (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
      // position can't be lower than 0
      position = position < 0 ? 0 : position; // position can't be higher than last postion

      position = position >= _this.state.lastPosition ? _this.state.lastPosition : position;

      _this.setState({
        firstItem: position
      });
    });

    _this.state = {
      selectedItem: _props.selectedItem,
      swiping: false,
      showArrows: false,
      firstItem: 0,
      visibleItems: 0,
      lastPosition: 0
    };
    return _this;
  }

  _createClass(Thumbs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupThumbs();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.selectedItem !== this.state.selectedItem) {
        this.setState({
          selectedItem: this.props.selectedItem,
          firstItem: this.getFirstItem(this.props.selectedItem)
        });
      }

      if (this.props.children === prevProps.children) {
        return;
      } // This will capture any size changes for arrow adjustments etc.
      // usually in the same render cycle so we don't see any flickers


      this.updateSizes();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyThumbs();
    }
  }, {
    key: "setupThumbs",
    value: function setupThumbs() {
      // as the widths are calculated, we need to resize
      // the carousel when the window is resized
      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes); // when the component is rendered we need to calculate
      // the container size to adjust the responsive behaviour

      this.updateSizes();
    }
  }, {
    key: "destroyThumbs",
    value: function destroyThumbs() {
      // removing listeners
      (0, _window.default)().removeEventListener('resize', this.updateSizes);
      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
    }
  }, {
    key: "getFirstItem",
    value: function getFirstItem(selectedItem) {
      var firstItem = selectedItem;

      if (selectedItem >= this.state.lastPosition) {
        firstItem = this.state.lastPosition;
      }

      if (selectedItem < this.state.firstItem + this.state.visibleItems) {
        firstItem = this.state.firstItem;
      }

      if (selectedItem < this.state.firstItem) {
        firstItem = selectedItem;
      }

      return firstItem;
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      return this.props.children.map(function (img, index) {
        var itemClass = _cssClasses.default.ITEM(false, index === _this2.state.selectedItem);

        var thumbProps = {
          key: index,
          ref: function ref(e) {
            return _this2.setThumbsRef(e, index);
          },
          className: itemClass,
          onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
          onKeyDown: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
          'aria-label': "".concat(_this2.props.labels.item, " ").concat(index + 1),
          style: {
            width: _this2.props.thumbWidth
          }
        };
        return /*#__PURE__*/_react.default.createElement("li", _extends({}, thumbProps, {
          role: "button",
          tabIndex: 0
        }), img);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (!this.props.children) {
        return null;
      }

      var isSwipeable = _react.Children.count(this.props.children) > 1; // show left arrow?

      var hasPrev = this.state.showArrows && this.state.firstItem > 0; // show right arrow

      var hasNext = this.state.showArrows && this.state.firstItem < this.state.lastPosition; // obj to hold the transformations and styles

      var itemListStyles = {};
      var currentPosition = -this.state.firstItem * (this.state.itemSize || 0);
      var transformProp = (0, _CSSTranslate.default)(currentPosition, 'px', this.props.axis);
      var transitionTime = this.props.transitionTime + 'ms';
      itemListStyles = {
        WebkitTransform: transformProp,
        MozTransform: transformProp,
        MsTransform: transformProp,
        OTransform: transformProp,
        transform: transformProp,
        msTransform: transformProp,
        WebkitTransitionDuration: transitionTime,
        MozTransitionDuration: transitionTime,
        MsTransitionDuration: transitionTime,
        OTransitionDuration: transitionTime,
        transitionDuration: transitionTime,
        msTransitionDuration: transitionTime
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.CAROUSEL(false)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.WRAPPER(false),
        ref: this.setItemsWrapperRef
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: _cssClasses.default.ARROW_PREV(!hasPrev),
        onClick: function onClick() {
          return _this3.slideRight();
        },
        "aria-label": this.props.labels.leftArrow
      }), isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, {
        tagName: "ul",
        className: _cssClasses.default.SLIDER(false, this.state.swiping),
        onSwipeLeft: this.slideLeft,
        onSwipeRight: this.slideRight,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: itemListStyles,
        innerRef: this.setItemsListRef,
        allowMouseEvents: this.props.emulateTouch
      }, this.renderItems()) : /*#__PURE__*/_react.default.createElement("ul", {
        className: _cssClasses.default.SLIDER(false, this.state.swiping),
        ref: function ref(node) {
          return _this3.setItemsListRef(node);
        },
        style: itemListStyles
      }, this.renderItems()), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: _cssClasses.default.ARROW_NEXT(!hasNext),
        onClick: function onClick() {
          return _this3.slideLeft();
        },
        "aria-label": this.props.labels.rightArrow
      })));
    }
  }]);

  return Thumbs;
}(_react.Component);

exports["default"] = Thumbs;

_defineProperty(Thumbs, "displayName", 'Thumbs');

_defineProperty(Thumbs, "defaultProps", {
  axis: 'horizontal',
  labels: {
    leftArrow: 'previous slide / item',
    rightArrow: 'next slide / item',
    item: 'slide item'
  },
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 350
});

/***/ }),

/***/ 5702:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _classnames = _interopRequireDefault(__webpack_require__(4184));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  ROOT: function ROOT(customClassName) {
    return (0, _classnames.default)(_defineProperty({
      'carousel-root': true
    }, customClassName || '', !!customClassName));
  },
  CAROUSEL: function CAROUSEL(isSlider) {
    return (0, _classnames.default)({
      carousel: true,
      'carousel-slider': isSlider
    });
  },
  WRAPPER: function WRAPPER(isSlider, axis) {
    return (0, _classnames.default)({
      'thumbs-wrapper': !isSlider,
      'slider-wrapper': isSlider,
      'axis-horizontal': axis === 'horizontal',
      'axis-vertical': axis !== 'horizontal'
    });
  },
  SLIDER: function SLIDER(isSlider, isSwiping) {
    return (0, _classnames.default)({
      thumbs: !isSlider,
      slider: isSlider,
      animated: !isSwiping
    });
  },
  ITEM: function ITEM(isSlider, selected, previous) {
    return (0, _classnames.default)({
      thumb: !isSlider,
      slide: isSlider,
      selected: selected,
      previous: previous
    });
  },
  ARROW_PREV: function ARROW_PREV(disabled) {
    return (0, _classnames.default)({
      'control-arrow control-prev': true,
      'control-disabled': disabled
    });
  },
  ARROW_NEXT: function ARROW_NEXT(disabled) {
    return (0, _classnames.default)({
      'control-arrow control-next': true,
      'control-disabled': disabled
    });
  },
  DOT: function DOT(selected) {
    return (0, _classnames.default)({
      dot: true,
      selected: selected
    });
  }
};
exports["default"] = _default;

/***/ }),

/***/ 4528:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.outerWidth = void 0;

var outerWidth = function outerWidth(el) {
  var width = el.offsetWidth;
  var style = getComputedStyle(el);
  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return width;
};

exports.outerWidth = outerWidth;

/***/ }),

/***/ 615:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "lr", ({
  enumerable: true,
  get: function get() {
    return _Carousel.default;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _types.CarouselProps;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _Thumbs.default;
  }
});

var _Carousel = _interopRequireDefault(__webpack_require__(5743));

var _types = __webpack_require__(629);

var _Thumbs = _interopRequireDefault(__webpack_require__(5040));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 6513:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _default = function _default() {
  return document;
};

exports["default"] = _default;

/***/ }),

/***/ 885:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _default = function _default() {
  return window;
};

exports["default"] = _default;

/***/ }),

/***/ 2909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useButtonGroupContext; },
/* harmony export */   "u": function() { return /* binding */ ButtonGroupContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var defaultContext = {
  isButtonGroup: false,
  disabled: false
};
var ButtonGroupContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultContext);
var useButtonGroupContext = function useButtonGroupContext() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(ButtonGroupContext);
};

/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ button_button; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/button/button.drip.js


var defaultProps = {
  x: 0,
  y: 0
};

var ButtonDrip = function ButtonDrip(_ref) {
  var x = _ref.x,
      y = _ref.y,
      color = _ref.color,
      onCompleted = _ref.onCompleted;
  var dripRef = (0,react.useRef)(null);
  /* istanbul ignore next */

  var top = Number.isNaN(+y) ? 0 : y - 10;
  /* istanbul ignore next */

  var left = Number.isNaN(+x) ? 0 : x - 10;
  (0,react.useEffect)(function () {
    /* istanbul ignore next */
    if (!dripRef.current) return;
    dripRef.current.addEventListener('animationend', onCompleted);
    return function () {
      /* istanbul ignore next */
      if (!dripRef.current) return;
      dripRef.current.removeEventListener('animationend', onCompleted);
    };
  });
  return /*#__PURE__*/react.createElement("div", {
    ref: dripRef,
    className: "jsx-3424889537" + " " + "drip"
  }, /*#__PURE__*/react.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    style: {
      top: top,
      left: left
    },
    className: "jsx-3424889537"
  }, /*#__PURE__*/react.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    className: "jsx-3424889537"
  }, /*#__PURE__*/react.createElement("g", {
    fill: color,
    className: "jsx-3424889537"
  }, /*#__PURE__*/react.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: "10",
    className: "jsx-3424889537"
  })))), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3424889537"
  }, ".drip.jsx-3424889537{position:absolute;left:0;right:0;top:0;bottom:0;}svg.jsx-3424889537{position:absolute;-webkit-animation:350ms ease-in expand-jsx-3424889537;animation:350ms ease-in expand-jsx-3424889537;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;width:1rem;height:1rem;}@-webkit-keyframes expand-jsx-3424889537{0%{opacity:0;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);}30%{opacity:1;}80%{opacity:0.5;}100%{-webkit-transform:scale(28);-ms-transform:scale(28);transform:scale(28);opacity:0;}}@keyframes expand-jsx-3424889537{0%{opacity:0;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);}30%{opacity:1;}80%{opacity:0.5;}100%{-webkit-transform:scale(28);-ms-transform:scale(28);transform:scale(28);opacity:0;}}"));
};

ButtonDrip.defaultProps = defaultProps;
ButtonDrip.displayName = 'GeistButtonDrip';
/* harmony default export */ var button_drip = (ButtonDrip);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/loading/loading.js


var _excluded = ["children", "type", "color", "className", "spaceRatio"];





var loading_defaultProps = {
  type: 'default',
  className: '',
  spaceRatio: 1
};

var getIconBgColor = function getIconBgColor(type, palette, color) {
  var colors = {
    "default": palette.accents_6,
    secondary: palette.secondary,
    success: palette.success,
    warning: palette.warning,
    error: palette.error
  };
  return color ? color : colors[type];
};

var LoadingComponent = function LoadingComponent(_ref) {
  var children = _ref.children,
      type = _ref.type,
      color = _ref.color,
      className = _ref.className,
      spaceRatio = _ref.spaceRatio,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var classes = (0,use_classes/* default */.Z)('loading-container', className);
  var bgColor = (0,react.useMemo)(function () {
    return getIconBgColor(type, theme.palette, color);
  }, [type, theme.palette, color]);
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2201634259", [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, '100%'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.palette.accents_5, bgColor, spaceRatio]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), /*#__PURE__*/react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2201634259", [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, '100%'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.palette.accents_5, bgColor, spaceRatio]]]) + " " + "loading"
  }, children && /*#__PURE__*/react.createElement("label", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2201634259", [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, '100%'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.palette.accents_5, bgColor, spaceRatio]]])
  }, children), /*#__PURE__*/react.createElement("i", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2201634259", [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, '100%'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.palette.accents_5, bgColor, spaceRatio]]])
  }), /*#__PURE__*/react.createElement("i", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2201634259", [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, '100%'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.palette.accents_5, bgColor, spaceRatio]]])
  }), /*#__PURE__*/react.createElement("i", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2201634259", [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, '100%'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.palette.accents_5, bgColor, spaceRatio]]])
  })), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2201634259",
    dynamic: [SCALES.font(1), SCALES.width(1, '100%'), SCALES.height(1, '100%'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.palette.accents_5, bgColor, spaceRatio]
  }, ".loading-container.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;font-size:".concat(SCALES.font(1), ";width:").concat(SCALES.width(1, '100%'), ";height:").concat(SCALES.height(1, '100%'), ";min-height:1em;padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}label.__jsx-style-dynamic-selector{margin-right:0.5em;color:").concat(theme.palette.accents_5, ";line-height:1;}label.__jsx-style-dynamic-selector *{margin:0;}.loading.__jsx-style-dynamic-selector{position:absolute;top:50%;left:50%;width:100%;height:100%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:transparent;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}i.__jsx-style-dynamic-selector{width:0.25em;height:0.25em;border-radius:50%;background-color:").concat(bgColor, ";margin:0 calc(0.25em / 2 * ").concat(spaceRatio, ");display:inline-block;-webkit-animation:loading-blink-__jsx-style-dynamic-selector 1.4s infinite both;animation:loading-blink-__jsx-style-dynamic-selector 1.4s infinite both;}i.__jsx-style-dynamic-selector:nth-child(2){-webkit-animation-delay:0.2s;animation-delay:0.2s;}i.__jsx-style-dynamic-selector:nth-child(3){-webkit-animation-delay:0.4s;animation-delay:0.4s;}@-webkit-keyframes loading-blink-__jsx-style-dynamic-selector{0%{opacity:0.2;}20%{opacity:1;}100%{opacity:0.2;}}@keyframes loading-blink-__jsx-style-dynamic-selector{0%{opacity:0.2;}20%{opacity:1;}100%{opacity:0.2;}}")));
};

LoadingComponent.defaultProps = loading_defaultProps;
LoadingComponent.displayName = 'GeistLoading';
var Loading = (0,with_scale/* default */.Z)(LoadingComponent);
/* harmony default export */ var loading = (Loading);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/loading/index.js

/* harmony default export */ var esm_loading = (loading);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/button/button-loading.js




var ButtonLoading = function ButtonLoading(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/react.createElement("div", {
    className: "jsx-3416748964" + " " + "btn-loading"
  }, /*#__PURE__*/react.createElement(esm_loading, {
    color: color
  }), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3416748964"
  }, ".btn-loading.jsx-3416748964{position:absolute;top:0;left:0;right:0;bottom:0;z-index:2;background-color:var(--geist-ui-button-bg);}"));
};

ButtonLoading.displayName = 'GeistButtonLoading';
/* harmony default export */ var button_loading = (ButtonLoading);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/button/button-icon.js


var button_icon_excluded = ["isRight", "isSingle", "children", "className"];



var button_icon_defaultProps = {
  isRight: false,
  className: ''
};

var ButtonIcon = function ButtonIcon(_ref) {
  var isRight = _ref.isRight,
      isSingle = _ref.isSingle,
      children = _ref.children,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, button_icon_excluded);

  var classes = (0,use_classes/* default */.Z)('icon', {
    right: isRight,
    single: isSingle
  }, className);
  return /*#__PURE__*/react.createElement("span", (0,esm_extends/* default */.Z)({}, props, {
    className: "jsx-3744348184" + " " + (props && props.className != null && props.className || classes || "")
  }), children, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3744348184"
  }, ".icon.jsx-3744348184{position:absolute;left:var(--geist-ui-button-icon-padding);right:auto;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:inherit;z-index:1;}.right.jsx-3744348184{right:var(--geist-ui-button-icon-padding);left:auto;}.icon.jsx-3744348184 svg{background:transparent;height:calc(var(--geist-ui-button-height) / 1.12);width:calc(var(--geist-ui-button-height) / 1.12);}.single.jsx-3744348184{position:static;-webkit-transform:none;-ms-transform:none;transform:none;}"));
};

ButtonIcon.defaultProps = button_icon_defaultProps;
ButtonIcon.displayName = 'GeistButtonIcon';
/* harmony default export */ var button_icon = (ButtonIcon);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/button/utils.js





var getButtonChildrenWithIcon = function getButtonChildrenWithIcon(auto, children, icons) {
  var icon = icons.icon,
      iconRight = icons.iconRight;
  var hasIcon = icon || iconRight;
  var isRight = Boolean(iconRight);
  var paddingForAutoMode = auto ? "calc(var(--geist-ui-button-height) / 2 + var(--geist-ui-button-icon-padding) * .5)" : 0;
  var classes = (0,use_classes/* default */.Z)('text', isRight ? 'right' : 'left');
  if (!hasIcon) return /*#__PURE__*/react.createElement("div", {
    className: "text"
  }, children);

  if (react.Children.count(children) === 0) {
    return /*#__PURE__*/react.createElement(button_icon, {
      isRight: isRight,
      isSingle: true
    }, hasIcon);
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(button_icon, {
    isRight: isRight
  }, hasIcon), /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3568181479", [paddingForAutoMode, paddingForAutoMode]]]) + " " + (classes || "")
  }, children, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3568181479",
    dynamic: [paddingForAutoMode, paddingForAutoMode]
  }, ".left.__jsx-style-dynamic-selector{padding-left:".concat(paddingForAutoMode, ";}.right.__jsx-style-dynamic-selector{padding-right:").concat(paddingForAutoMode, ";}"))));
};
var filterPropsWithGroup = function filterPropsWithGroup(props, config) {
  if (!config.isButtonGroup) return props;
  return (0,esm_extends/* default */.Z)({}, props, {
    auto: true,
    shadow: false,
    ghost: config.ghost || props.ghost,
    type: config.type || props.type,
    disabled: config.disabled || props.disabled
  });
};
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/button-group/button-group-context.js
var button_group_context = __webpack_require__(2909);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/color.js
var color = __webpack_require__(1185);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/button/styles.js


var getButtonGhostColors = function getButtonGhostColors(palette, type) {
  var colors = {
    secondary: {
      bg: palette.background,
      border: palette.accents_7,
      color: palette.accents_7
    },
    success: {
      bg: palette.background,
      border: palette.success,
      color: palette.successDark
    },
    warning: {
      bg: palette.background,
      border: palette.warningDark,
      color: palette.warningDark
    },
    error: {
      bg: palette.background,
      border: palette.error,
      color: palette.errorDark
    }
  };
  return colors[type] || null;
};
var getButtonColors = function getButtonColors(palette, props) {
  var type = props.type,
      disabled = props.disabled,
      ghost = props.ghost;
  var colors = {
    "default": {
      bg: palette.background,
      border: palette.border,
      color: palette.accents_7
    },
    secondary: {
      bg: palette.foreground,
      border: palette.foreground,
      color: palette.background
    },
    success: {
      bg: palette.success,
      border: palette.success,
      color: '#fff'
    },
    warning: {
      bg: palette.warning,
      border: palette.warning,
      color: palette.accents_6
    },
    error: {
      bg: palette.error,
      border: palette.error,
      color: '#fff'
    },
    abort: {
      bg: 'transparent',
      border: 'transparent',
      color: palette.accents_5
    }
  };
  if (disabled) return {
    bg: palette.accents_1,
    border: palette.accents_2,
    color: '#ccc'
  };
  /**
   * The '-light' type is the same color as the common type,
   * only hover's color is different.
   * e.g.
   *   Color['success'] === Color['success-light']
   *   Color['warning'] === Color['warning-light']
   */

  var withoutLightType = type === null || type === void 0 ? void 0 : type.replace('-light', '');
  var defaultColor = colors["default"];
  if (ghost) return getButtonGhostColors(palette, withoutLightType) || defaultColor;
  return colors[withoutLightType] || defaultColor;
};
var getButtonGhostHoverColors = function getButtonGhostHoverColors(palette, type) {
  var colors = {
    secondary: {
      bg: palette.background,
      border: palette.foreground,
      color: palette.foreground,
      active: palette.accents_7,
      hover: palette.accents_5
    },
    success: {
      bg: palette.background,
      border: palette.success,
      active: palette.successLight,
      color: palette.successDark,
      hover: palette.successLighter
    },
    warning: {
      bg: palette.background,
      border: palette.warningDark,
      color: palette.warningDark,
      active: palette.warningLight,
      hover: palette.warningLighter
    },
    error: {
      bg: palette.background,
      border: palette.error,
      color: palette.errorDark,
      active: palette.errorLight,
      hover: palette.errorLighter
    }
  };
  var withoutLightType = type.replace('-light', '');
  return colors[withoutLightType] || null;
};
var getButtonHoverColors = function getButtonHoverColors(palette, props) {
  var type = props.type,
      disabled = props.disabled,
      loading = props.loading,
      shadow = props.shadow,
      ghost = props.ghost;
  var defaultColor = getButtonColors(palette, props);
  var alphaBackground = (0,color/* addColorAlpha */.j)(defaultColor.bg, 0.85);
  var colors = {
    "default": {
      bg: palette.background,
      border: palette.foreground
    },
    secondary: {
      bg: palette.background,
      border: palette.foreground
    },
    success: {
      bg: palette.background,
      border: palette.success
    },
    warning: {
      bg: palette.background,
      border: palette.warning
    },
    error: {
      bg: palette.background,
      border: palette.error
    },
    abort: {
      bg: 'transparent',
      border: 'transparent',
      color: palette.accents_5
    },
    'secondary-light': (0,esm_extends/* default */.Z)({}, defaultColor, {
      bg: alphaBackground
    }),
    'success-light': (0,esm_extends/* default */.Z)({}, defaultColor, {
      bg: alphaBackground
    }),
    'warning-light': (0,esm_extends/* default */.Z)({}, defaultColor, {
      bg: alphaBackground
    }),
    'error-light': (0,esm_extends/* default */.Z)({}, defaultColor, {
      bg: alphaBackground
    })
  };
  if (disabled) return {
    bg: palette.accents_1,
    border: palette.accents_2,
    color: '#ccc'
  };
  if (loading) return (0,esm_extends/* default */.Z)({}, defaultColor, {
    color: 'transparent'
  });
  if (shadow) return defaultColor;
  var hoverColor = (ghost ? getButtonGhostHoverColors(palette, type) : colors[type]) || colors["default"];
  return (0,esm_extends/* default */.Z)({}, hoverColor, {
    color: hoverColor.color || hoverColor.border
  });
};
var getButtonCursor = function getButtonCursor(disabled, loading) {
  if (disabled) return {
    cursor: 'not-allowed',
    events: 'auto'
  };
  if (loading) return {
    cursor: 'default',
    events: 'none'
  };
  return {
    cursor: 'pointer',
    events: 'auto'
  };
};
var getButtonDripColor = function getButtonDripColor(palette, props) {
  var type = props.type,
      ghost = props.ghost;
  var isLightHover = type.endsWith('light');
  var hoverColors = getButtonHoverColors(palette, props);
  return isLightHover ? (0,color/* addColorAlpha */.j)(hoverColors.bg, 0.65) : ghost && hoverColors.active ? (0,color/* addColorAlpha */.j)(hoverColors.active, 0.65) : (0,color/* addColorAlpha */.j)(palette.accents_2, 0.65);
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/button/button.js



var button_excluded = ["children", "disabled", "type", "loading", "shadow", "ghost", "effect", "onClick", "auto", "icon", "htmlType", "iconRight", "className"];










var button_defaultProps = {
  type: 'default',
  htmlType: 'button',
  ghost: false,
  loading: false,
  shadow: false,
  auto: false,
  effect: true,
  disabled: false,
  className: ''
};
var ButtonComponent = /*#__PURE__*/react.forwardRef(function (btnProps, ref) {
  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var buttonRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, function () {
    return buttonRef.current;
  });

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      dripShow = _useState2[0],
      setDripShow = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      dripX = _useState4[0],
      setDripX = _useState4[1];

  var _useState5 = (0,react.useState)(0),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      dripY = _useState6[0],
      setDripY = _useState6[1];

  var groupConfig = (0,button_group_context/* useButtonGroupContext */.M)();
  var filteredProps = filterPropsWithGroup(btnProps, groupConfig);
  /* eslint-disable @typescript-eslint/no-unused-vars */

  var children = filteredProps.children,
      disabled = filteredProps.disabled,
      type = filteredProps.type,
      loading = filteredProps.loading,
      shadow = filteredProps.shadow,
      ghost = filteredProps.ghost,
      effect = filteredProps.effect,
      onClick = filteredProps.onClick,
      auto = filteredProps.auto,
      icon = filteredProps.icon,
      htmlType = filteredProps.htmlType,
      iconRight = filteredProps.iconRight,
      className = filteredProps.className,
      props = (0,objectWithoutProperties/* default */.Z)(filteredProps, button_excluded);
  /* eslint-enable @typescript-eslint/no-unused-vars */


  var _useMemo = (0,react.useMemo)(function () {
    return getButtonColors(theme.palette, filteredProps);
  }, [theme.palette, filteredProps]),
      bg = _useMemo.bg,
      border = _useMemo.border,
      color = _useMemo.color;

  var hover = (0,react.useMemo)(function () {
    return getButtonHoverColors(theme.palette, filteredProps);
  }, [theme.palette, filteredProps]);

  var _useMemo2 = (0,react.useMemo)(function () {
    return getButtonCursor(disabled, loading);
  }, [disabled, loading]),
      cursor = _useMemo2.cursor,
      events = _useMemo2.events;

  var dripColor = (0,react.useMemo)(function () {
    return getButtonDripColor(theme.palette, filteredProps);
  }, [theme.palette, filteredProps]);
  /* istanbul ignore next */

  var dripCompletedHandle = function dripCompletedHandle() {
    setDripShow(false);
    setDripX(0);
    setDripY(0);
  };

  var clickHandler = function clickHandler(event) {
    if (disabled || loading) return;
    var showDrip = !shadow && !ghost && effect;
    /* istanbul ignore next */

    if (showDrip && buttonRef.current) {
      var rect = buttonRef.current.getBoundingClientRect();
      setDripShow(true);
      setDripX(event.clientX - rect.left);
      setDripY(event.clientY - rect.top);
    }

    onClick && onClick(event);
  };

  var childrenWithIcon = (0,react.useMemo)(function () {
    return getButtonChildrenWithIcon(auto, children, {
      icon: icon,
      iconRight: iconRight
    });
  }, [auto, children, icon, iconRight]);
  var paddingLeft = auto ? SCALES.pl(1.375) : SCALES.pl(1.75),
      paddingRight = auto ? SCALES.pr(1.375) : SCALES.pr(1.75);
  return /*#__PURE__*/react.createElement("button", (0,esm_extends/* default */.Z)({
    ref: buttonRef,
    type: htmlType,
    disabled: disabled,
    onClick: clickHandler
  }, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["985888584", [SCALES.height(2.5), theme.layout.radius, SCALES.font(0.875), color, bg, border, border, border, border, cursor, events, shadow ? theme.expressiveness.shadowSmall : 'none', SCALES.pl(0.727), SCALES.height(2.5), color, bg, auto ? 'min-content' : SCALES.width(10.5), auto ? 'auto' : 'initial', SCALES.height(2.5), SCALES.pt(0), paddingRight, SCALES.pb(0), paddingLeft, SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), hover.color, hover.color, hover.hover, hover.border, cursor, events, shadow ? theme.expressiveness.shadowMedium : 'none', shadow ? '-0.03rem' : disabled ? '0rem' : '-0.01rem', disabled ? '0rem' : '-0.01rem', hover.active, shadow ? '0.06rem' : disabled ? '0rem' : '0.03rem', disabled ? '0rem' : '0.03rem', disabled ? '0 0' : '0.03rem 0.03rem']]]) + " " + (props && props.className != null && props.className || (0,use_classes/* default */.Z)('btn', className) || "")
  }), loading && /*#__PURE__*/react.createElement(button_loading, {
    color: color
  }), childrenWithIcon, dripShow && /*#__PURE__*/react.createElement(button_drip, {
    x: dripX,
    y: dripY,
    color: dripColor,
    onCompleted: dripCompletedHandle
  }), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "985888584",
    dynamic: [SCALES.height(2.5), theme.layout.radius, SCALES.font(0.875), color, bg, border, border, border, border, cursor, events, shadow ? theme.expressiveness.shadowSmall : 'none', SCALES.pl(0.727), SCALES.height(2.5), color, bg, auto ? 'min-content' : SCALES.width(10.5), auto ? 'auto' : 'initial', SCALES.height(2.5), SCALES.pt(0), paddingRight, SCALES.pb(0), paddingLeft, SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), hover.color, hover.color, hover.hover, hover.border, cursor, events, shadow ? theme.expressiveness.shadowMedium : 'none', shadow ? '-0.03rem' : disabled ? '0rem' : '-0.01rem', disabled ? '0rem' : '-0.01rem', hover.active, shadow ? '0.06rem' : disabled ? '0rem' : '0.03rem', disabled ? '0rem' : '0.03rem', disabled ? '0 0' : '0.03rem 0.03rem']
  }, ".btn.__jsx-style-dynamic-selector{box-sizing:border-box;display:inline-block;line-height:".concat(SCALES.height(2.5), ";border-radius:").concat(theme.layout.radius, ";font-weight:400;font-size:").concat(SCALES.font(0.875), ";-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:none;text-transform:capitalize;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center;white-space:nowrap;-webkit-transition:background-color 200ms ease 0ms,box-shadow 200ms ease 0ms, border 200ms ease 0ms,color 200ms ease 0ms;transition:background-color 200ms ease 0ms,box-shadow 200ms ease 0ms, border 200ms ease 0ms,color 200ms ease 0ms;position:relative;overflow:hidden;color:").concat(color, ";background-color:").concat(bg, ";border-top:1px solid ").concat(border, ";border-right:2px solid ").concat(border, ";border-bottom:2px solid ").concat(border, ";border-left:1px solid ").concat(border, ";cursor:").concat(cursor, ";pointer-events:").concat(events, ";box-shadow:").concat(shadow ? theme.expressiveness.shadowSmall : 'none', ";--geist-ui-button-icon-padding:").concat(SCALES.pl(0.727), ";--geist-ui-button-height:").concat(SCALES.height(2.5), ";--geist-ui-button-color:").concat(color, ";--geist-ui-button-bg:").concat(bg, ";min-width:").concat(auto ? 'min-content' : SCALES.width(10.5), ";width:").concat(auto ? 'auto' : 'initial', ";height:").concat(SCALES.height(2.5), ";padding:").concat(SCALES.pt(0), " ").concat(paddingRight, " ").concat(SCALES.pb(0), " ").concat(paddingLeft, ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.btn.__jsx-style-dynamic-selector:hover{color:").concat(hover.color, ";--geist-ui-button-color:").concat(hover.color, ";background-color:").concat(hover.hover, ";border-color:").concat(hover.border, ";cursor:").concat(cursor, ";pointer-events:").concat(events, ";box-shadow:").concat(shadow ? theme.expressiveness.shadowMedium : 'none', ";-webkit-transform:translate3d(0rem,").concat(shadow ? '-0.03rem' : disabled ? '0rem' : '-0.01rem', ",").concat(disabled ? '0rem' : '-0.01rem', ");-ms-transform:translate3d(0rem,").concat(shadow ? '-0.03rem' : disabled ? '0rem' : '-0.01rem', ",").concat(disabled ? '0rem' : '-0.01rem', ");transform:translate3d(0rem,").concat(shadow ? '-0.03rem' : disabled ? '0rem' : '-0.01rem', ",").concat(disabled ? '0rem' : '-0.01rem', ");-webkit-transition:-webkit-transform 100ms ease 0ms;-webkit-transition:transform 100ms ease 0ms;transition:transform 100ms ease 0ms;box-shadow:100ms ease 0ms;}.btn.__jsx-style-dynamic-selector:active{background-color:").concat(hover.active, ";-webkit-transform:translate3d(0rem,").concat(shadow ? '0.06rem' : disabled ? '0rem' : '0.03rem', ",").concat(disabled ? '0rem' : '0.03rem', ");-ms-transform:translate3d(0rem,").concat(shadow ? '0.06rem' : disabled ? '0rem' : '0.03rem', ",").concat(disabled ? '0rem' : '0.03rem', ");transform:translate3d(0rem,").concat(shadow ? '0.06rem' : disabled ? '0rem' : '0.03rem', ",").concat(disabled ? '0rem' : '0.03rem', ");-webkit-transition:-webkit-transform 30ms ease 0ms;-webkit-transition:transform 30ms ease 0ms;transition:transform 30ms ease 0ms;box-shadow:inset 0 0 ").concat(disabled ? '0 0' : '0.03rem 0.03rem', "  #1100111a;}.btn.__jsx-style-dynamic-selector .text{position:relative;z-index:1;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;line-height:inherit;top:-1px;}.btn.__jsx-style-dynamic-selector .text p,.btn.__jsx-style-dynamic-selector .text pre,.btn.__jsx-style-dynamic-selector .text div{margin:0;}")));
});
ButtonComponent.defaultProps = button_defaultProps;
ButtonComponent.displayName = 'GeistButton';
var Button = (0,with_scale/* default */.Z)(ButtonComponent);
/* harmony default export */ var button_button = (Button);

/***/ }),

/***/ 5718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1635);

/* harmony default export */ __webpack_exports__["Z"] = (_button__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 7814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/card/styles.js

var getStyles = function getStyles(type, palette, isShadow) {
  var colors = {
    "default": {
      color: palette.foreground,
      bgColor: palette.background
    },
    dark: {
      color: palette.background,
      bgColor: palette.foreground
    },
    secondary: {
      color: palette.background,
      bgColor: palette.secondary
    },
    success: {
      color: palette.background,
      bgColor: palette.success
    },
    warning: {
      color: palette.background,
      bgColor: palette.warning
    },
    error: {
      color: palette.background,
      bgColor: palette.error
    },
    lite: {
      color: palette.foreground,
      bgColor: palette.background
    },
    alert: {
      color: 'white',
      bgColor: palette.alert
    },
    purple: {
      color: 'white',
      bgColor: palette.purple
    },
    violet: {
      color: 'white',
      bgColor: palette.violet
    },
    cyan: {
      color: 'black',
      bgColor: palette.cyan
    }
  };
  var showBorder = type === 'default' && !isShadow;
  return (0,esm_extends/* default */.Z)({}, colors[type], {
    borderColor: showBorder ? palette.border : 'transparent'
  });
};
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/card/card-footer.js


var _excluded = ["children", "className", "disableAutoMargin"];





var defaultProps = {
  disableAutoMargin: false,
  className: ''
};

var CardFooterComponent = function CardFooterComponent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disableAutoMargin = _ref.disableAutoMargin,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var classes = (0,use_classes/* default */.Z)({
    'auto-margin': !disableAutoMargin
  }, className);
  return /*#__PURE__*/react.createElement("footer", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1602358380", [SCALES.py(0.66), SCALES.px(1.31), SCALES.font(0.875), theme.palette.border, theme.layout.radius, theme.layout.radius, SCALES.height(3.3), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.layout.gapQuarter]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), children, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "1602358380",
    dynamic: [SCALES.py(0.66), SCALES.px(1.31), SCALES.font(0.875), theme.palette.border, theme.layout.radius, theme.layout.radius, SCALES.height(3.3), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.layout.gapQuarter]
  }, "footer.__jsx-style-dynamic-selector{padding:".concat(SCALES.py(0.66), " ").concat(SCALES.px(1.31), ";display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow:hidden;color:inherit;background-color:inherit;font-size:").concat(SCALES.font(0.875), ";border-top:1px solid ").concat(theme.palette.border, ";border-bottom-left-radius:").concat(theme.layout.radius, ";border-bottom-right-radius:").concat(theme.layout.radius, ";min-height:").concat(SCALES.height(3.3), ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.auto-margin.__jsx-style-dynamic-selector *{margin-top:0;margin-bottom:0;margin-right:").concat(theme.layout.gapQuarter, ";}")));
};

CardFooterComponent.defaultProps = defaultProps;
CardFooterComponent.displayName = 'GeistCardFooter';
var CardFooter = (0,with_scale/* default */.Z)(CardFooterComponent);
/* harmony default export */ var card_footer = (CardFooter);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/card/card-content.js


var card_content_excluded = ["className", "children"];




var card_content_defaultProps = {
  className: ''
};

var CardContentComponent = function CardContentComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, card_content_excluded);

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["490544004", [SCALES.width(1, '100%'), SCALES.height(1, 'auto'), SCALES.pt(1), SCALES.pr(1), SCALES.pb(1), SCALES.pl(1), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + (props && props.className != null && props.className || (0,use_classes/* default */.Z)('content', className) || "")
  }), children, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "490544004",
    dynamic: [SCALES.width(1, '100%'), SCALES.height(1, 'auto'), SCALES.pt(1), SCALES.pr(1), SCALES.pb(1), SCALES.pl(1), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]
  }, ".content.__jsx-style-dynamic-selector{width:".concat(SCALES.width(1, '100%'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(1), " ").concat(SCALES.pr(1), " ").concat(SCALES.pb(1), " ").concat(SCALES.pl(1), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.content.__jsx-style-dynamic-selector>p:first-child{margin-top:0;}.content.__jsx-style-dynamic-selector>p:last-child{margin-bottom:0;}")));
};

CardContentComponent.defaultProps = card_content_defaultProps;
CardContentComponent.displayName = 'GeistCardContent';
var CardContent = (0,with_scale/* default */.Z)(CardContentComponent);
/* harmony default export */ var card_content = (CardContent);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/image/index.js + 6 modules
var esm_image = __webpack_require__(9918);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/collections.js
var collections = __webpack_require__(9265);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/card/card.js



var card_excluded = ["children", "hoverable", "className", "shadow", "type"];










var card_defaultProps = {
  type: 'default',
  hoverable: false,
  shadow: false,
  className: ''
};

var CardComponent = function CardComponent(_ref) {
  var children = _ref.children,
      hoverable = _ref.hoverable,
      className = _ref.className,
      shadow = _ref.shadow,
      type = _ref.type,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, card_excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var hoverShadow = (0,react.useMemo)(function () {
    if (shadow) return theme.expressiveness.shadowMedium;
    return hoverable ? theme.expressiveness.shadowSmall : 'none';
  }, [hoverable, shadow, theme.expressiveness]);

  var _useMemo = (0,react.useMemo)(function () {
    return getStyles(type, theme.palette, shadow);
  }, [type, theme.palette, shadow]),
      color = _useMemo.color,
      bgColor = _useMemo.bgColor,
      borderColor = _useMemo.borderColor;

  var _pickChild = (0,collections/* pickChild */.xC)(children, card_footer),
      _pickChild2 = (0,slicedToArray/* default */.Z)(_pickChild, 2),
      withoutFooterChildren = _pickChild2[0],
      footerChildren = _pickChild2[1];

  var _pickChild3 = (0,collections/* pickChild */.xC)(withoutFooterChildren, esm_image/* default */.Z),
      _pickChild4 = (0,slicedToArray/* default */.Z)(_pickChild3, 2),
      withoutImageChildren = _pickChild4[0],
      imageChildren = _pickChild4[1];

  var hasContent = (0,collections/* hasChild */.bJ)(withoutImageChildren, card_content);
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["4234389955", [theme.palette.background, theme.layout.radius, shadow ? theme.expressiveness.shadowSmall : 'none', color, bgColor, borderColor, SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), hoverShadow]]]) + " " + (props && props.className != null && props.className || (0,use_classes/* default */.Z)('card', className) || "")
  }), imageChildren, hasContent ? withoutImageChildren : /*#__PURE__*/react.createElement(card_content, null, withoutImageChildren), footerChildren, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "4234389955",
    dynamic: [theme.palette.background, theme.layout.radius, shadow ? theme.expressiveness.shadowSmall : 'none', color, bgColor, borderColor, SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), hoverShadow]
  }, ".card.__jsx-style-dynamic-selector{background:".concat(theme.palette.background, ";-webkit-transition:all 0.2s ease;transition:all 0.2s ease;border-radius:").concat(theme.layout.radius, ";box-shadow:").concat(shadow ? theme.expressiveness.shadowSmall : 'none', ";box-sizing:border-box;color:").concat(color, ";background-color:").concat(bgColor, ";border:1px solid ").concat(borderColor, ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.card.__jsx-style-dynamic-selector:hover{box-shadow:").concat(hoverShadow, ";}.card.__jsx-style-dynamic-selector img{width:100%;}.card.__jsx-style-dynamic-selector .image{border-bottom-left-radius:0;border-bottom-right-radius:0;}")));
};

CardComponent.defaultProps = card_defaultProps;
CardComponent.displayName = 'GeistCard';
var Card = (0,with_scale/* default */.Z)(CardComponent);
/* harmony default export */ var card = (Card);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/card/index.js



card.Footer = card_footer;
card.Actions = card_footer;
card.Content = card_content;
card.Body = card_content;
/* harmony default export */ var esm_card = (card);

/***/ }),

/***/ 9236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_collapse; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/collapse/collapse-icon.js



var CollapseIcon = function CollapseIcon(_ref) {
  var active = _ref.active;
  return /*#__PURE__*/react.createElement("svg", {
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    shapeRendering: "geometricPrecision",
    style: {
      color: 'currentColor'
    },
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2249786880", [active ? '-180deg' : '0']]])
  }, /*#__PURE__*/react.createElement("path", {
    d: "M6 9l6 6 6-6",
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2249786880", [active ? '-180deg' : '0']]])
  }), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2249786880",
    dynamic: [active ? '-180deg' : '0']
  }, "svg.__jsx-style-dynamic-selector{-webkit-transition:-webkit-transform 200ms ease;-webkit-transition:transform 200ms ease;transition:transform 200ms ease;-webkit-transform:rotateZ(".concat(active ? '-180deg' : '0', ");-ms-transform:rotateZ(").concat(active ? '-180deg' : '0', ");transform:rotateZ(").concat(active ? '-180deg' : '0', ");width:1.5em;height:1.5em;}")));
};

var MemoCollapseIcon = /*#__PURE__*/react.memo(CollapseIcon);
/* harmony default export */ var collapse_icon = (MemoCollapseIcon);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-real-shape.js
var use_real_shape = __webpack_require__(4729);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/shared/expand.js





var defaultProps = {
  isExpanded: false,
  delay: 200
};

var Expand = function Expand(_ref) {
  var isExpanded = _ref.isExpanded,
      delay = _ref.delay,
      children = _ref.children;

  var _useState = (0,react.useState)(isExpanded ? 'auto' : '0'),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      height = _useState2[0],
      setHeight = _useState2[1];

  var _useState3 = (0,react.useState)(isExpanded),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      selfExpanded = _useState4[0],
      setSelfExpanded = _useState4[1];

  var _useState5 = (0,react.useState)(isExpanded),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      visible = _useState6[0],
      setVisible = _useState6[1];

  var contentRef = (0,react.useRef)(null);
  var entryTimer = (0,react.useRef)();
  var leaveTimer = (0,react.useRef)();
  var resetTimer = (0,react.useRef)();

  var _useRealShape = (0,use_real_shape/* default */.Z)(contentRef),
      _useRealShape2 = (0,slicedToArray/* default */.Z)(_useRealShape, 2),
      state = _useRealShape2[0],
      updateShape = _useRealShape2[1];

  var classes = (0,use_classes/* default */.Z)('container', {
    expanded: selfExpanded
  });
  (0,react.useEffect)(function () {
    return setHeight("".concat(state.height, "px"));
  }, [state.height]);
  (0,react.useEffect)(function () {
    // show element or reset height.
    // force an update once manually, even if the element does not change.
    // (the height of the element might be "auto")
    if (isExpanded) {
      setVisible(isExpanded);
    } else {
      updateShape();
      setHeight("".concat(state.height, "px"));
    } // show expand animation


    entryTimer.current = window.setTimeout(function () {
      setSelfExpanded(isExpanded);
      clearTimeout(entryTimer.current);
    }, 30); // Reset height after animation

    if (isExpanded) {
      resetTimer.current = window.setTimeout(function () {
        setHeight('auto');
        clearTimeout(resetTimer.current);
      }, delay);
    } else {
      leaveTimer.current = window.setTimeout(function () {
        setVisible(isExpanded);
        clearTimeout(leaveTimer.current);
      }, delay / 2);
    }

    return function () {
      clearTimeout(entryTimer.current);
      clearTimeout(leaveTimer.current);
      clearTimeout(resetTimer.current);
    };
  }, [isExpanded]);
  return /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3719208140", [visible ? 'visible' : 'hidden', visible ? 'visible' : 'hidden', delay, height]]]) + " " + (classes || "")
  }, /*#__PURE__*/react.createElement("div", {
    ref: contentRef,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3719208140", [visible ? 'visible' : 'hidden', visible ? 'visible' : 'hidden', delay, height]]]) + " " + "content"
  }, children), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3719208140",
    dynamic: [visible ? 'visible' : 'hidden', visible ? 'visible' : 'hidden', delay, height]
  }, ".container.__jsx-style-dynamic-selector{padding:0;margin:0;height:0;overflow:".concat(visible ? 'visible' : 'hidden', ";visibility:").concat(visible ? 'visible' : 'hidden', ";-webkit-transition:height ").concat(delay, "ms ease;transition:height ").concat(delay, "ms ease;}.expanded.__jsx-style-dynamic-selector{height:").concat(height, ";visibility:visible;}")));
};

Expand.defaultProps = defaultProps;
Expand.displayName = 'GeistExpand';
/* harmony default export */ var expand = (Expand);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/collapse/collapse-context.js

var defaultContext = {
  values: []
};
var CollapseContext = /*#__PURE__*/react.createContext(defaultContext);
var useCollapseContext = function useCollapseContext() {
  return react.useContext(CollapseContext);
};
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-current-state.js + 2 modules
var use_current_state = __webpack_require__(1052);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-warning.js
var use_warning = __webpack_require__(1421);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/collapse/collapse.js



var _excluded = ["children", "title", "subtitle", "initialVisible", "shadow", "className", "index"];










var collapse_defaultProps = {
  className: '',
  shadow: false,
  initialVisible: false
};

var CollapseComponent = function CollapseComponent(_ref) {
  var children = _ref.children,
      title = _ref.title,
      subtitle = _ref.subtitle,
      initialVisible = _ref.initialVisible,
      shadow = _ref.shadow,
      className = _ref.className,
      index = _ref.index,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var _useCollapseContext = useCollapseContext(),
      values = _useCollapseContext.values,
      updateValues = _useCollapseContext.updateValues;

  var _useCurrentState = (0,use_current_state/* default */.Z)(initialVisible),
      _useCurrentState2 = (0,slicedToArray/* default */.Z)(_useCurrentState, 3),
      visible = _useCurrentState2[0],
      setVisible = _useCurrentState2[1],
      visibleRef = _useCurrentState2[2];

  var classes = (0,use_classes/* default */.Z)('collapse', {
    shadow: shadow
  }, className);

  if (!title) {
    (0,use_warning/* default */.Z)('"title" is required.', 'Collapse');
  }

  (0,react.useEffect)(function () {
    if (!values.length) return;
    var isActive = !!values.find(function (item) {
      return item === index;
    });
    setVisible(isActive);
  }, [values.join(',')]);

  var clickHandler = function clickHandler() {
    var next = !visibleRef.current;
    setVisible(next);
    updateValues && updateValues(index, next);
  };

  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3106940587", [theme.palette.border, theme.palette.border, SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.expressiveness.shadowSmall, theme.layout.radius, theme.layout.gap, theme.palette.foreground, theme.palette.accents_5, SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0)]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), /*#__PURE__*/react.createElement("div", {
    role: "button",
    onClick: clickHandler,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3106940587", [theme.palette.border, theme.palette.border, SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.expressiveness.shadowSmall, theme.layout.radius, theme.layout.gap, theme.palette.foreground, theme.palette.accents_5, SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0)]]]) + " " + "view"
  }, /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3106940587", [theme.palette.border, theme.palette.border, SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.expressiveness.shadowSmall, theme.layout.radius, theme.layout.gap, theme.palette.foreground, theme.palette.accents_5, SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0)]]]) + " " + "title"
  }, /*#__PURE__*/react.createElement("h3", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3106940587", [theme.palette.border, theme.palette.border, SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.expressiveness.shadowSmall, theme.layout.radius, theme.layout.gap, theme.palette.foreground, theme.palette.accents_5, SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0)]]])
  }, title), " ", /*#__PURE__*/react.createElement(collapse_icon, {
    active: visible
  })), subtitle && /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3106940587", [theme.palette.border, theme.palette.border, SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.expressiveness.shadowSmall, theme.layout.radius, theme.layout.gap, theme.palette.foreground, theme.palette.accents_5, SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0)]]]) + " " + "subtitle"
  }, subtitle)), /*#__PURE__*/react.createElement(expand, {
    isExpanded: visible
  }, /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3106940587", [theme.palette.border, theme.palette.border, SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.expressiveness.shadowSmall, theme.layout.radius, theme.layout.gap, theme.palette.foreground, theme.palette.accents_5, SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0)]]]) + " " + "content"
  }, children)), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3106940587",
    dynamic: [theme.palette.border, theme.palette.border, SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.expressiveness.shadowSmall, theme.layout.radius, theme.layout.gap, theme.palette.foreground, theme.palette.accents_5, SCALES.pt(1.2), SCALES.pr(0), SCALES.pb(1.2), SCALES.pl(0)]
  }, ".collapse.__jsx-style-dynamic-selector{border-top:1px solid ".concat(theme.palette.border, ";border-bottom:1px solid ").concat(theme.palette.border, ";font-size:").concat(SCALES.font(1), ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(1.2), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(1.2), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.shadow.__jsx-style-dynamic-selector{box-shadow:").concat(theme.expressiveness.shadowSmall, ";border:none;border-radius:").concat(theme.layout.radius, ";padding:").concat(theme.layout.gap, ";}.view.__jsx-style-dynamic-selector{cursor:pointer;outline:none;}.title.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:").concat(theme.palette.foreground, ";}.title.__jsx-style-dynamic-selector h3.__jsx-style-dynamic-selector{margin:0;font-size:1.5em;}.subtitle.__jsx-style-dynamic-selector{color:").concat(theme.palette.accents_5, ";margin:0;}.subtitle.__jsx-style-dynamic-selector>*{margin:0;}.content.__jsx-style-dynamic-selector{font-size:inherit;line-height:1.6em;padding:").concat(SCALES.pt(1.2), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(1.2), " ").concat(SCALES.pl(0), ";}.content.__jsx-style-dynamic-selector>*:first-child{margin-top:0;}.content.__jsx-style-dynamic-selector>*:last-child{margin-bottom:0;}")));
};

CollapseComponent.defaultProps = collapse_defaultProps;
CollapseComponent.displayName = 'GeistCollapse';
var Collapse = (0,with_scale/* default */.Z)(CollapseComponent);
/* harmony default export */ var collapse = (Collapse);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(1451);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/collections.js
var collections = __webpack_require__(9265);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/collapse/collapse-group.js




var collapse_group_excluded = ["children", "accordion", "className"];








var collapse_group_defaultProps = {
  accordion: true,
  className: ''
};

var CollapseGroupComponent = function CollapseGroupComponent(_ref) {
  var children = _ref.children,
      accordion = _ref.accordion,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, collapse_group_excluded);

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var _useCurrentState = (0,use_current_state/* default */.Z)([]),
      _useCurrentState2 = (0,slicedToArray/* default */.Z)(_useCurrentState, 3),
      state = _useCurrentState2[0],
      setState = _useCurrentState2[1],
      stateRef = _useCurrentState2[2];

  var classes = (0,use_classes/* default */.Z)('collapse-group', className);

  var updateValues = function updateValues(currentIndex, nextState) {
    var hasChild = stateRef.current.find(function (val) {
      return val === currentIndex;
    });

    if (accordion) {
      if (nextState) return setState([currentIndex]);
      return setState([]);
    }

    if (nextState) {
      // In a few cases, the user will set Collapse Component state manually.
      // If the user incorrectly set the state, Group component should ignore it.

      /* istanbul ignore if */
      if (hasChild) return;
      return setState([].concat((0,toConsumableArray/* default */.Z)(stateRef.current), [currentIndex]));
    }

    setState(stateRef.current.filter(function (item) {
      return item !== currentIndex;
    }));
  };

  var initialValue = (0,react.useMemo)(function () {
    return {
      values: state,
      updateValues: updateValues
    };
  }, [state.join(',')]);
  var hasIndexChildren = (0,react.useMemo)(function () {
    return (0,collections/* setChildrenIndex */.CV)(children, [collapse]);
  }, [children]);
  return /*#__PURE__*/react.createElement(CollapseContext.Provider, {
    value: initialValue
  }, /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2415399140", [SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0.6), SCALES.pb(0), SCALES.pl(0.6), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), hasIndexChildren, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2415399140",
    dynamic: [SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0.6), SCALES.pb(0), SCALES.pl(0.6), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]
  }, ".collapse-group.__jsx-style-dynamic-selector{width:".concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0.6), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0.6), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.collapse-group.__jsx-style-dynamic-selector>div + div{border-top:none;}"))));
};

CollapseGroupComponent.defaultProps = collapse_group_defaultProps;
CollapseGroupComponent.displayName = 'GeistCollapseGroup';
var CollapseGroup = (0,with_scale/* default */.Z)(CollapseGroupComponent);
/* harmony default export */ var collapse_group = (CollapseGroup);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/collapse/index.js


collapse.Group = collapse_group;
/* harmony default export */ var esm_collapse = (collapse);

/***/ }),

/***/ 2050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_description; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/description/description.js


var _excluded = ["title", "content", "className"];





var defaultProps = {
  title: 'Title',
  content: '',
  className: ''
};

var DescriptionComponent = function DescriptionComponent(_ref) {
  var title = _ref.title,
      content = _ref.content,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var classes = (0,use_classes/* default */.Z)('description', className);
  return /*#__PURE__*/react.createElement("dl", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2323318745", [SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.palette.accents_5, theme.palette.foreground]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), /*#__PURE__*/react.createElement("dt", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2323318745", [SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.palette.accents_5, theme.palette.foreground]]])
  }, title), /*#__PURE__*/react.createElement("dd", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2323318745", [SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.palette.accents_5, theme.palette.foreground]]])
  }, content), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2323318745",
    dynamic: [SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), theme.palette.accents_5, theme.palette.foreground]
  }, ".description.__jsx-style-dynamic-selector{font-size:".concat(SCALES.font(1), ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}dt.__jsx-style-dynamic-selector{font-size:0.75em;line-height:1em;margin-bottom:0.5em;text-transform:uppercase;white-space:nowrap;color:").concat(theme.palette.accents_5, ";font-weight:500;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}dd.__jsx-style-dynamic-selector{font-size:0.875em;margin:0;line-height:1.1em;color:").concat(theme.palette.foreground, ";font-weight:500;}dd.__jsx-style-dynamic-selector p,dt.__jsx-style-dynamic-selector p{margin:0;}")));
};

DescriptionComponent.defaultProps = defaultProps;
DescriptionComponent.displayName = 'GeistDescription';
var Description = (0,with_scale/* default */.Z)(DescriptionComponent);
/* harmony default export */ var description = (Description);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/description/index.js

/* harmony default export */ var esm_description = (description);

/***/ }),

/***/ 6293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_grid; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/grid/basic-item.js


var _excluded = ["xs", "sm", "md", "lg", "xl", "justify", "direction", "alignItems", "alignContent", "children", "className"];





var defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false,
  className: ''
};

var getItemLayout = function getItemLayout(val) {
  var display = val === 0 ? 'display: none;' : 'display: inherit;';

  if (typeof val === 'number') {
    var width = 100 / 24 * val;
    var ratio = width > 100 ? '100%' : width < 0 ? '0' : "".concat(width, "%");
    return {
      grow: 0,
      display: display,
      width: ratio,
      basis: ratio
    };
  }

  return {
    grow: 1,
    display: display,
    width: '100%',
    basis: '0'
  };
};

var GridBasicItem = function GridBasicItem(_ref) {
  var xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      justify = _ref.justify,
      direction = _ref.direction,
      alignItems = _ref.alignItems,
      alignContent = _ref.alignContent,
      children = _ref.children,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var classes = (0,react.useMemo)(function () {
    var aligns = {
      justify: justify,
      direction: direction,
      alignItems: alignItems,
      alignContent: alignContent,
      xs: xs,
      sm: sm,
      md: md,
      lg: lg,
      xl: xl
    };
    var classString = Object.keys(aligns).reduce(function (pre, name) {
      if (aligns[name] !== undefined && aligns[name] !== false) return "".concat(pre, " ").concat(name);
      return pre;
    }, '');
    return classString.trim();
  }, [justify, direction, alignItems, alignContent, xs, sm, md, lg, xl]);
  var layout = (0,react.useMemo)(function () {
    return {
      xs: getItemLayout(xs),
      sm: getItemLayout(sm),
      md: getItemLayout(md),
      lg: getItemLayout(lg),
      xl: getItemLayout(xl)
    };
  }, [xs, sm, md, lg, xl]);
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["568430467", [SCALES.font(1, 'inherit'), SCALES.height(1, 'auto'), justify, direction, alignContent, alignItems, layout.xs.grow, layout.xs.width, layout.xs.basis, layout.xs.display, theme.breakpoints.sm.min, layout.sm.grow, layout.sm.width, layout.sm.basis, layout.sm.display, theme.breakpoints.md.min, layout.md.grow, layout.md.width, layout.md.basis, layout.md.display, theme.breakpoints.lg.min, layout.lg.grow, layout.lg.width, layout.lg.basis, layout.lg.display, theme.breakpoints.xl.min, layout.xl.grow, layout.xl.width, layout.xl.basis, layout.xl.display]]]) + " " + (props && props.className != null && props.className || (0,use_classes/* default */.Z)('item', classes, className) || "")
  }), children, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "568430467",
    dynamic: [SCALES.font(1, 'inherit'), SCALES.height(1, 'auto'), justify, direction, alignContent, alignItems, layout.xs.grow, layout.xs.width, layout.xs.basis, layout.xs.display, theme.breakpoints.sm.min, layout.sm.grow, layout.sm.width, layout.sm.basis, layout.sm.display, theme.breakpoints.md.min, layout.md.grow, layout.md.width, layout.md.basis, layout.md.display, theme.breakpoints.lg.min, layout.lg.grow, layout.lg.width, layout.lg.basis, layout.lg.display, theme.breakpoints.xl.min, layout.xl.grow, layout.xl.width, layout.xl.basis, layout.xl.display]
  }, ".item.__jsx-style-dynamic-selector{font-size:".concat(SCALES.font(1, 'inherit'), ";height:").concat(SCALES.height(1, 'auto'), ";}.justify.__jsx-style-dynamic-selector{-webkit-box-pack:").concat(justify, ";-webkit-justify-content:").concat(justify, ";-ms-flex-pack:").concat(justify, ";justify-content:").concat(justify, ";}.direction.__jsx-style-dynamic-selector{-webkit-flex-direction:").concat(direction, ";-ms-flex-direction:").concat(direction, ";flex-direction:").concat(direction, ";}.alignContent.__jsx-style-dynamic-selector{-webkit-align-content:").concat(alignContent, ";-ms-flex-line-pack:").concat(alignContent, ";align-content:").concat(alignContent, ";}.alignItems.__jsx-style-dynamic-selector{-webkit-align-items:").concat(alignItems, ";-webkit-box-align:").concat(alignItems, ";-ms-flex-align:").concat(alignItems, ";align-items:").concat(alignItems, ";}.xs.__jsx-style-dynamic-selector{-webkit-box-flex:").concat(layout.xs.grow, ";-webkit-flex-grow:").concat(layout.xs.grow, ";-ms-flex-positive:").concat(layout.xs.grow, ";flex-grow:").concat(layout.xs.grow, ";max-width:").concat(layout.xs.width, ";-webkit-flex-basis:").concat(layout.xs.basis, ";-ms-flex-preferred-size:").concat(layout.xs.basis, ";flex-basis:").concat(layout.xs.basis, ";").concat(layout.xs.display, ";}@media only screen and (min-width:").concat(theme.breakpoints.sm.min, "){.sm.__jsx-style-dynamic-selector{-webkit-box-flex:").concat(layout.sm.grow, ";-webkit-flex-grow:").concat(layout.sm.grow, ";-ms-flex-positive:").concat(layout.sm.grow, ";flex-grow:").concat(layout.sm.grow, ";max-width:").concat(layout.sm.width, ";-webkit-flex-basis:").concat(layout.sm.basis, ";-ms-flex-preferred-size:").concat(layout.sm.basis, ";flex-basis:").concat(layout.sm.basis, ";").concat(layout.sm.display, ";}}@media only screen and (min-width:").concat(theme.breakpoints.md.min, "){.md.__jsx-style-dynamic-selector{-webkit-box-flex:").concat(layout.md.grow, ";-webkit-flex-grow:").concat(layout.md.grow, ";-ms-flex-positive:").concat(layout.md.grow, ";flex-grow:").concat(layout.md.grow, ";max-width:").concat(layout.md.width, ";-webkit-flex-basis:").concat(layout.md.basis, ";-ms-flex-preferred-size:").concat(layout.md.basis, ";flex-basis:").concat(layout.md.basis, ";").concat(layout.md.display, ";}}@media only screen and (min-width:").concat(theme.breakpoints.lg.min, "){.lg.__jsx-style-dynamic-selector{-webkit-box-flex:").concat(layout.lg.grow, ";-webkit-flex-grow:").concat(layout.lg.grow, ";-ms-flex-positive:").concat(layout.lg.grow, ";flex-grow:").concat(layout.lg.grow, ";max-width:").concat(layout.lg.width, ";-webkit-flex-basis:").concat(layout.lg.basis, ";-ms-flex-preferred-size:").concat(layout.lg.basis, ";flex-basis:").concat(layout.lg.basis, ";").concat(layout.lg.display, ";}}@media only screen and (min-width:").concat(theme.breakpoints.xl.min, "){.xl.__jsx-style-dynamic-selector{-webkit-box-flex:").concat(layout.xl.grow, ";-webkit-flex-grow:").concat(layout.xl.grow, ";-ms-flex-positive:").concat(layout.xl.grow, ";flex-grow:").concat(layout.xl.grow, ";max-width:").concat(layout.xl.width, ";-webkit-flex-basis:").concat(layout.xl.basis, ";-ms-flex-preferred-size:").concat(layout.xl.basis, ";flex-basis:").concat(layout.xl.basis, ";").concat(layout.xl.display, ";}}")));
};

GridBasicItem.defaultProps = defaultProps;
GridBasicItem.displayName = 'GeistGridBasicItem';
/* harmony default export */ var basic_item = (GridBasicItem);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/grid/grid.js


var grid_excluded = ["children", "className"];





var grid_defaultProps = {
  className: ''
};

var GridComponent = function GridComponent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, grid_excluded);

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var _styles$className = {
    styles: /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
      id: "1271839607",
      dynamic: [SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.pt(0, 'var(--grid-gap-unit)'), SCALES.pr(0, 'var(--grid-gap-unit)'), SCALES.pb(0, 'var(--grid-gap-unit)'), SCALES.pl(0, 'var(--grid-gap-unit)')]
    }, "div.__jsx-style-dynamic-selector{margin:".concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";box-sizing:border-box;padding:").concat(SCALES.pt(0, 'var(--grid-gap-unit)'), " ").concat(SCALES.pr(0, 'var(--grid-gap-unit)'), " ").concat(SCALES.pb(0, 'var(--grid-gap-unit)'), " ").concat(SCALES.pl(0, 'var(--grid-gap-unit)'), ";}")),
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1271839607", [SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.pt(0, 'var(--grid-gap-unit)'), SCALES.pr(0, 'var(--grid-gap-unit)'), SCALES.pb(0, 'var(--grid-gap-unit)'), SCALES.pl(0, 'var(--grid-gap-unit)')]]])
  },
      resolveClassName = _styles$className.className,
      styles = _styles$className.styles;
  var classes = (0,use_classes/* default */.Z)(resolveClassName, className);
  return /*#__PURE__*/react.createElement(basic_item, (0,esm_extends/* default */.Z)({
    className: classes
  }, props), children, styles);
};

GridComponent.defaultProps = grid_defaultProps;
GridComponent.displayName = 'GeistGrid';
var Grid = (0,with_scale/* default */.Z)(GridComponent);
/* harmony default export */ var grid = (Grid);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/grid/grid-container.js


var grid_container_excluded = ["gap", "wrap", "children", "className"];





var grid_container_defaultProps = {
  gap: 0,
  wrap: 'wrap',
  className: ''
};

var GridContainerComponent = function GridContainerComponent(_ref) {
  var gap = _ref.gap,
      wrap = _ref.wrap,
      children = _ref.children,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, grid_container_excluded);

  var _useScale = (0,use_scale/* default */.ZP)(),
      unit = _useScale.unit,
      SCALES = _useScale.SCALES;

  var gapUnit = (0,react.useMemo)(function () {
    return "calc(".concat(gap, " * ").concat(unit, " * 1/3)");
  }, [gap, unit]);
  var _styles$className = {
    styles: /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
      id: "741709477",
      dynamic: [gapUnit, wrap, SCALES.width(1, 'var(--grid-container-width)'), SCALES.mt(0, 'var(--grid-container-margin)'), SCALES.mr(0, 'var(--grid-container-margin)'), SCALES.mb(0, 'var(--grid-container-margin)'), SCALES.ml(0, 'var(--grid-container-margin)')]
    }, "div.__jsx-style-dynamic-selector{--grid-gap-unit:".concat(gapUnit, ";--grid-container-width:calc(100% + var(--grid-gap-unit) * 2);display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:").concat(wrap, ";-ms-flex-wrap:").concat(wrap, ";flex-wrap:").concat(wrap, ";box-sizing:border-box;width:").concat(SCALES.width(1, 'var(--grid-container-width)'), ";margin:").concat(SCALES.mt(0, 'var(--grid-container-margin)'), " ").concat(SCALES.mr(0, 'var(--grid-container-margin)'), " ").concat(SCALES.mb(0, 'var(--grid-container-margin)'), " ").concat(SCALES.ml(0, 'var(--grid-container-margin)'), ";}")),
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["741709477", [gapUnit, wrap, SCALES.width(1, 'var(--grid-container-width)'), SCALES.mt(0, 'var(--grid-container-margin)'), SCALES.mr(0, 'var(--grid-container-margin)'), SCALES.mb(0, 'var(--grid-container-margin)'), SCALES.ml(0, 'var(--grid-container-margin)')]]])
  },
      resolveClassName = _styles$className.className,
      styles = _styles$className.styles;
  var classes = (0,use_classes/* default */.Z)(resolveClassName, className);
  return /*#__PURE__*/react.createElement(basic_item, (0,esm_extends/* default */.Z)({
    className: classes
  }, props), children, styles);
};

GridContainerComponent.defaultProps = grid_container_defaultProps;
GridContainerComponent.displayName = 'GeistGridContainer';
var GridContainer = (0,with_scale/* default */.Z)(GridContainerComponent);
/* harmony default export */ var grid_container = (GridContainer);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/grid/index.js


grid.Container = grid_container;
/* harmony default export */ var esm_grid = (grid);

/***/ }),

/***/ 9918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_image; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/image/image.skeleton.js


var _excluded = ["opacity"];



var defaultProps = {
  opacity: 0.5
};
var ImageSkeleton = /*#__PURE__*/react.memo(function (_ref) {
  var opacity = _ref.opacity,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,use_theme/* default */.Z)();
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2946022605", [theme.palette.accents_1, theme.palette.accents_2, theme.palette.accents_2, theme.palette.accents_1, opacity]]]) + " " + (props && props.className != null && props.className || "skeleton")
  }), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2946022605",
    dynamic: [theme.palette.accents_1, theme.palette.accents_2, theme.palette.accents_2, theme.palette.accents_1, opacity]
  }, ".skeleton.__jsx-style-dynamic-selector{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;background-image:linear-gradient( 270deg, ".concat(theme.palette.accents_1, ", ").concat(theme.palette.accents_2, ", ").concat(theme.palette.accents_2, ", ").concat(theme.palette.accents_1, " );background-size:400% 100%;-webkit-animation:loading-__jsx-style-dynamic-selector 3s ease-in-out infinite;animation:loading-__jsx-style-dynamic-selector 3s ease-in-out infinite;opacity:").concat(opacity, ";-webkit-transition:opacity 300ms ease-out;transition:opacity 300ms ease-out;}@-webkit-keyframes loading-__jsx-style-dynamic-selector{0%{background-position:200% 0;}to{background-position:-200% 0;}}@keyframes loading-__jsx-style-dynamic-selector{0%{background-position:200% 0;}to{background-position:-200% 0;}}")));
});
ImageSkeleton.defaultProps = defaultProps;
ImageSkeleton.displayName = 'GeistImageSkeleton';
/* harmony default export */ var image_skeleton = (ImageSkeleton);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/image/helpers.js
var transformDataSource = function transformDataSource(src) {
  var left = "".concat(src).slice(0, 4);

  if (encodeURIComponent(left) === '%3Csvg') {
    return "data:image/svg+xml;utf8,".concat(src);
  }

  return src;
};
var getHostFromUrl = function getHostFromUrl(url) {
  try {
    return new URL(url).host;
  } catch (e) {
    return url;
  }
};
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/image/image.js



var image_excluded = ["src", "disableSkeleton", "className", "maxDelay"];







var image_defaultProps = {
  disableSkeleton: false,
  className: '',
  maxDelay: 3000
};

var ImageComponent = function ImageComponent(_ref) {
  var src = _ref.src,
      disableSkeleton = _ref.disableSkeleton,
      className = _ref.className,
      maxDelay = _ref.maxDelay,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, image_excluded);

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES,
      getScaleProps = _useScale.getScaleProps;

  var width = getScaleProps(['width', 'w']);
  var height = getScaleProps(['height', 'h']);
  var showAnimation = !disableSkeleton && width && height;
  var theme = (0,use_theme/* default */.Z)();

  var _useState = (0,react.useState)(true),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      showSkeleton = _useState4[0],
      setShowSkeleton = _useState4[1];

  var imageRef = (0,react.useRef)(null);
  var url = (0,react.useMemo)(function () {
    return transformDataSource(src);
  }, [src]);

  var imageLoaded = function imageLoaded() {
    if (!showAnimation) return;
    setLoading(false);
  };

  (0,react.useEffect)(function () {
    if (!showAnimation) return;
    if (!imageRef.current) return;

    if (imageRef.current.complete) {
      setLoading(false);
      setShowSkeleton(false);
    }
  });
  (0,react.useEffect)(function () {
    var timer = setTimeout(function () {
      if (showAnimation) {
        setShowSkeleton(false);
      }

      clearTimeout(timer);
    }, maxDelay);
    return function () {
      return clearTimeout(timer);
    };
  }, [loading]);
  return /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["4175752462", [theme.layout.radius, SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0, 'auto'), SCALES.mb(0), SCALES.ml(0, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.width(1, 'auto'), SCALES.height(1, 'auto')]]]) + " " + ((0,use_classes/* default */.Z)('image', className) || "")
  }, showSkeleton && showAnimation && /*#__PURE__*/react.createElement(image_skeleton, {
    opacity: loading ? 0.5 : 0
  }), /*#__PURE__*/react.createElement("img", (0,esm_extends/* default */.Z)({
    ref: imageRef,
    onLoad: imageLoaded,
    src: url
  }, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["4175752462", [theme.layout.radius, SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0, 'auto'), SCALES.mb(0), SCALES.ml(0, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.width(1, 'auto'), SCALES.height(1, 'auto')]]]) + " " + (props && props.className != null && props.className || "")
  })), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "4175752462",
    dynamic: [theme.layout.radius, SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0, 'auto'), SCALES.mb(0), SCALES.ml(0, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.width(1, 'auto'), SCALES.height(1, 'auto')]
  }, ".image.__jsx-style-dynamic-selector{position:relative;border-radius:".concat(theme.layout.radius, ";overflow:hidden;max-width:100%;width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0, 'auto'), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";}img.__jsx-style-dynamic-selector{width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";object-fit:scale-down;display:inline-block;}")));
};

ImageComponent.defaultProps = image_defaultProps;
ImageComponent.displayName = 'GeistImage';
var Image = (0,with_scale/* default */.Z)(ImageComponent);
/* harmony default export */ var image_image = (Image);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/link/index.js + 2 modules
var esm_link = __webpack_require__(5901);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/image/image-browser-https-icon.js



var ImageBrowserHttpsIcon = function ImageBrowserHttpsIcon() {
  return /*#__PURE__*/react.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: "jsx-4165143638"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M5 10.2H19V21H5V10.2Z",
    className: "jsx-4165143638"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12C13.933 12 15.5 10.3882 15.5 8.4C15.5 6.41177 13.933 4.8 12 4.8C10.067 4.8 8.5 6.41177 8.5 8.4C8.5 10.3882 10.067 12 12 12ZM12 13.8C14.8995 13.8 17.25 11.3823 17.25 8.4C17.25 5.41766 14.8995 3 12 3C9.10051 3 6.75 5.41766 6.75 8.4C6.75 11.3823 9.10051 13.8 12 13.8Z",
    className: "jsx-4165143638"
  }), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "4165143638"
  }, "svg.jsx-4165143638{width:1em;height:1em;}"));
};

var MemoImageBrowserHttpsIcon = /*#__PURE__*/react.memo(ImageBrowserHttpsIcon);
/* harmony default export */ var image_browser_https_icon = (MemoImageBrowserHttpsIcon);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/image/styles.js
var getBrowserColors = function getBrowserColors(invert, palette) {
  return invert ? {
    color: palette.background,
    barBgColor: palette.foreground,
    inputBgColor: palette.accents_8,
    borderColor: palette.accents_7,
    titleColor: palette.accents_2
  } : {
    color: palette.foreground,
    barBgColor: palette.background,
    inputBgColor: palette.accents_1,
    borderColor: palette.border,
    titleColor: palette.accents_5
  };
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/image/image-browser.js


var image_browser_excluded = ["url", "title", "children", "showFullLink", "invert", "anchorProps", "className"];









var image_browser_defaultProps = {
  className: '',
  showFullLink: false,
  anchorProps: {},
  invert: false
};

var getTitle = function getTitle(title, colors) {
  return /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["524099755", [colors.titleColor]]]) + " " + "title"
  }, title, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "524099755",
    dynamic: [colors.titleColor]
  }, ".title.__jsx-style-dynamic-selector{color:".concat(colors.titleColor, ";font-size:0.75em;}")));
};

var getAddressInput = function getAddressInput(url, showFullLink, colors, anchorProps) {
  return /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3718009574", [colors.inputBgColor]]]) + " " + "address-input"
  }, /*#__PURE__*/react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3718009574", [colors.inputBgColor]]]) + " " + "https"
  }, /*#__PURE__*/react.createElement(image_browser_https_icon, null)), /*#__PURE__*/react.createElement(esm_link/* default */.Z, (0,esm_extends/* default */.Z)({
    href: url,
    title: url,
    target: "_blank"
  }, anchorProps), showFullLink ? url : getHostFromUrl(url)), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3718009574",
    dynamic: [colors.inputBgColor]
  }, ".address-input.__jsx-style-dynamic-selector{height:1.75em;max-width:60%;min-width:40%;background-color:".concat(colors.inputBgColor, ";color:inherit;border-radius:3px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding:0 10px;overflow:hidden;position:relative;}.address-input.__jsx-style-dynamic-selector *{font-size:0.75em;color:inherit;}.address-input.__jsx-style-dynamic-selector a{max-width:90%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:inline-block;color:inherit;}.https.__jsx-style-dynamic-selector{width:0.75em;height:0.75em;font-size:1em;margin-right:0.31em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin-top:-1px;color:inherit;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}")));
};

var ImageBrowserComponent = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var url = _ref.url,
      title = _ref.title,
      children = _ref.children,
      showFullLink = _ref.showFullLink,
      invert = _ref.invert,
      anchorProps = _ref.anchorProps,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, image_browser_excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var colors = (0,react.useMemo)(function () {
    return getBrowserColors(invert, theme.palette);
  }, [invert, theme.palette]);
  var input = (0,react.useMemo)(function () {
    if (url) return getAddressInput(url, showFullLink, colors, anchorProps);
    if (title) return getTitle(title, colors);
    return null;
  }, [url, showFullLink, title, colors, anchorProps]);
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: ref
  }, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1856409351", [theme.expressiveness.shadowLarge, theme.layout.radius, SCALES.font(1), SCALES.width(1, 'max-content'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0, 'auto'), SCALES.mb(0), SCALES.ml(0, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), colors.color, colors.barBgColor, colors.borderColor, theme.layout.gapHalf]]]) + " " + (props && props.className != null && props.className || (0,use_classes/* default */.Z)('browser', className) || "")
  }), /*#__PURE__*/react.createElement("header", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1856409351", [theme.expressiveness.shadowLarge, theme.layout.radius, SCALES.font(1), SCALES.width(1, 'max-content'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0, 'auto'), SCALES.mb(0), SCALES.ml(0, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), colors.color, colors.barBgColor, colors.borderColor, theme.layout.gapHalf]]])
  }, /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1856409351", [theme.expressiveness.shadowLarge, theme.layout.radius, SCALES.font(1), SCALES.width(1, 'max-content'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0, 'auto'), SCALES.mb(0), SCALES.ml(0, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), colors.color, colors.barBgColor, colors.borderColor, theme.layout.gapHalf]]]) + " " + "traffic"
  }, /*#__PURE__*/react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1856409351", [theme.expressiveness.shadowLarge, theme.layout.radius, SCALES.font(1), SCALES.width(1, 'max-content'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0, 'auto'), SCALES.mb(0), SCALES.ml(0, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), colors.color, colors.barBgColor, colors.borderColor, theme.layout.gapHalf]]]) + " " + "close"
  }), /*#__PURE__*/react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1856409351", [theme.expressiveness.shadowLarge, theme.layout.radius, SCALES.font(1), SCALES.width(1, 'max-content'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0, 'auto'), SCALES.mb(0), SCALES.ml(0, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), colors.color, colors.barBgColor, colors.borderColor, theme.layout.gapHalf]]]) + " " + "mini"
  }), /*#__PURE__*/react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1856409351", [theme.expressiveness.shadowLarge, theme.layout.radius, SCALES.font(1), SCALES.width(1, 'max-content'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0, 'auto'), SCALES.mb(0), SCALES.ml(0, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), colors.color, colors.barBgColor, colors.borderColor, theme.layout.gapHalf]]]) + " " + "full"
  })), input), children, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "1856409351",
    dynamic: [theme.expressiveness.shadowLarge, theme.layout.radius, SCALES.font(1), SCALES.width(1, 'max-content'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0, 'auto'), SCALES.mb(0), SCALES.ml(0, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), colors.color, colors.barBgColor, colors.borderColor, theme.layout.gapHalf]
  }, ".browser.__jsx-style-dynamic-selector{background-color:transparent;box-shadow:".concat(theme.expressiveness.shadowLarge, ";max-width:100%;border-radius:").concat(theme.layout.radius, ";overflow:hidden;font-size:").concat(SCALES.font(1), ";width:").concat(SCALES.width(1, 'max-content'), ";height:").concat(SCALES.height(1, 'auto'), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0, 'auto'), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";}.browser.__jsx-style-dynamic-selector .image{border-top-left-radius:0;border-top-right-radius:0;}header.__jsx-style-dynamic-selector{height:2.5em;width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;position:relative;color:").concat(colors.color, ";background-color:").concat(colors.barBgColor, ";border-bottom:1px solid ").concat(colors.borderColor, ";}.traffic.__jsx-style-dynamic-selector{width:auto;position:absolute;left:").concat(theme.layout.gapHalf, ";top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);bottom:0;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:inherit;}.traffic.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector{border-radius:50%;width:0.75em;height:0.75em;max-width:20px;max-height:20px;display:inline-block;margin-right:0.5em;}.close.__jsx-style-dynamic-selector{background-color:#ff5f56;}.mini.__jsx-style-dynamic-selector{background-color:#ffbd2e;}.full.__jsx-style-dynamic-selector{background-color:#27c93f;}")));
});
ImageBrowserComponent.defaultProps = image_browser_defaultProps;
ImageBrowserComponent.displayName = 'GeistImageBrowser';
var ImageBrowser = (0,with_scale/* default */.Z)(ImageBrowserComponent);
/* harmony default export */ var image_browser = (ImageBrowser);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/image/index.js


image_image.Browser = image_browser;
/* harmony default export */ var esm_image = (image_image);

/***/ }),

/***/ 6358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_input; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/input/input-label.js




var InputLabel = function InputLabel(_ref) {
  var children = _ref.children,
      isRight = _ref.isRight;
  var theme = (0,use_theme/* default */.Z)();
  return /*#__PURE__*/react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3089782703", [theme.layout.gapHalf, theme.palette.accents_4, theme.palette.accents_1, theme.layout.radius, theme.layout.radius, theme.palette.border, theme.palette.border, theme.palette.border, theme.layout.radius, theme.layout.radius, theme.palette.border]]]) + " " + ((isRight ? 'right' : '') || "")
  }, children, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3089782703",
    dynamic: [theme.layout.gapHalf, theme.palette.accents_4, theme.palette.accents_1, theme.layout.radius, theme.layout.radius, theme.palette.border, theme.palette.border, theme.palette.border, theme.layout.radius, theme.layout.radius, theme.palette.border]
  }, "span.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;width:initial;height:100%;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;pointer-events:none;margin:0;padding:0 ".concat(theme.layout.gapHalf, ";color:").concat(theme.palette.accents_4, ";background-color:").concat(theme.palette.accents_1, ";border-top-left-radius:").concat(theme.layout.radius, ";border-bottom-left-radius:").concat(theme.layout.radius, ";border-top:1px solid ").concat(theme.palette.border, ";border-left:1px solid ").concat(theme.palette.border, ";border-bottom:1px solid ").concat(theme.palette.border, ";font-size:inherit;line-height:1;}span.right.__jsx-style-dynamic-selector{border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:").concat(theme.layout.radius, ";border-bottom-right-radius:").concat(theme.layout.radius, ";border-left:0;border-right:1px solid ").concat(theme.palette.border, ";}")));
};

var MemoInputLabel = /*#__PURE__*/react.memo(InputLabel);
/* harmony default export */ var input_label = (MemoInputLabel);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/input/input-block-label.js




var InputBlockLabelComponent = function InputBlockLabelComponent(_ref) {
  var children = _ref.children;
  var theme = (0,use_theme/* default */.Z)();
  return /*#__PURE__*/react.createElement("label", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1278828862", [theme.palette.accents_6]]])
  }, children, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "1278828862",
    dynamic: [theme.palette.accents_6]
  }, "label.__jsx-style-dynamic-selector{display:block;font-weight:normal;color:".concat(theme.palette.accents_6, ";padding:0 0 0 1px;margin-bottom:0.5em;font-size:1em;line-height:1.5;}label.__jsx-style-dynamic-selector>*:first-child{margin-top:0;}label.__jsx-style-dynamic-selector>*:last-child{margin-bottom:0;}")));
};

InputBlockLabelComponent.displayName = 'GeistInputBlockLabel';
var InputBlockLabel = /*#__PURE__*/react.memo(InputBlockLabelComponent);
/* harmony default export */ var input_block_label = (InputBlockLabel);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/input/input-icon.js



var InputIconComponent = function InputIconComponent(_ref) {
  var icon = _ref.icon,
      clickable = _ref.clickable,
      onClick = _ref.onClick;
  return /*#__PURE__*/react.createElement("span", {
    onClick: onClick,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["4247656379", [clickable ? 'pointer' : 'default', clickable ? 'auto' : 'none']]]) + " " + "input-icon"
  }, icon, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "4247656379",
    dynamic: [clickable ? 'pointer' : 'default', clickable ? 'auto' : 'none']
  }, ".input-icon.__jsx-style-dynamic-selector{box-sizing:border-box;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;width:calc(var(--input-height) - 2px);-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;height:100%;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin:0;padding:0;line-height:1;position:relative;cursor:".concat(clickable ? 'pointer' : 'default', ";pointer-events:").concat(clickable ? 'auto' : 'none', ";}.input-icon.__jsx-style-dynamic-selector svg{width:calc(var(--input-height) - 2px);height:calc(var(--input-height) - 2px);-webkit-transform:scale(0.44);-ms-transform:scale(0.44);transform:scale(0.44);}")));
};

InputIconComponent.displayName = 'GeistInputIcon';
var InputIcon = /*#__PURE__*/react.memo(InputIconComponent);
/* harmony default export */ var input_icon = (InputIcon);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/input/input-icon-clear.js





var InputIconClear = function InputIconClear(_ref) {
  var onClick = _ref.onClick,
      disabled = _ref.disabled,
      visible = _ref.visible;
  var theme = (0,use_theme/* default */.Z)();
  var classes = (0,use_classes/* default */.Z)('clear-icon', {
    visible: visible
  });

  var clickHandler = function clickHandler(event) {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    onClick && onClick(event);
  };

  return /*#__PURE__*/react.createElement("div", {
    onClick: clickHandler,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1567030211", [disabled ? 'not-allowed' : 'pointer', theme.palette.accents_3, disabled ? theme.palette.accents_3 : theme.palette.foreground]]]) + " " + (classes || "")
  }, /*#__PURE__*/react.createElement("svg", {
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    shapeRendering: "geometricPrecision",
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1567030211", [disabled ? 'not-allowed' : 'pointer', theme.palette.accents_3, disabled ? theme.palette.accents_3 : theme.palette.foreground]]])
  }, /*#__PURE__*/react.createElement("path", {
    d: "M18 6L6 18",
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1567030211", [disabled ? 'not-allowed' : 'pointer', theme.palette.accents_3, disabled ? theme.palette.accents_3 : theme.palette.foreground]]])
  }), /*#__PURE__*/react.createElement("path", {
    d: "M6 6l12 12",
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1567030211", [disabled ? 'not-allowed' : 'pointer', theme.palette.accents_3, disabled ? theme.palette.accents_3 : theme.palette.foreground]]])
  })), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "1567030211",
    dynamic: [disabled ? 'not-allowed' : 'pointer', theme.palette.accents_3, disabled ? theme.palette.accents_3 : theme.palette.foreground]
  }, ".clear-icon.__jsx-style-dynamic-selector{box-sizing:border-box;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;width:calc(var(--input-height) - 2px);-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;height:100%;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;cursor:".concat(disabled ? 'not-allowed' : 'pointer', ";-webkit-transition:color 150ms ease 0s;transition:color 150ms ease 0s;margin:0;padding:0;color:").concat(theme.palette.accents_3, ";visibility:hidden;opacity:0;}.visible.__jsx-style-dynamic-selector{visibility:visible;opacity:1;}.clear-icon.__jsx-style-dynamic-selector:hover{color:").concat(disabled ? theme.palette.accents_3 : theme.palette.foreground, ";}svg.__jsx-style-dynamic-selector{color:currentColor;width:calc(var(--input-height) - 2px);height:calc(var(--input-height) - 2px);-webkit-transform:scale(0.44);-ms-transform:scale(0.44);transform:scale(0.44);}")));
};

var MemoInputIconClear = /*#__PURE__*/react.memo(InputIconClear);
/* harmony default export */ var input_icon_clear = (MemoInputIconClear);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/input/styles.js
var styles = __webpack_require__(3468);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/input/input-props.js
var defaultProps = {
  disabled: false,
  readOnly: false,
  clearable: false,
  iconClickable: false,
  type: 'default',
  htmlType: 'text',
  autoComplete: 'off',
  className: '',
  placeholder: '',
  initialValue: ''
};
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/input/input.js



var _excluded = ["label", "labelRight", "type", "htmlType", "icon", "iconRight", "iconClickable", "onIconClick", "initialValue", "onChange", "readOnly", "value", "onClearClick", "clearable", "className", "onBlur", "onFocus", "autoComplete", "placeholder", "children", "disabled"];












var simulateChangeEvent = function simulateChangeEvent(el, event) {
  return (0,esm_extends/* default */.Z)({}, event, {
    target: el,
    currentTarget: el
  });
};

var InputComponent = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      labelRight = _ref.labelRight,
      type = _ref.type,
      htmlType = _ref.htmlType,
      icon = _ref.icon,
      iconRight = _ref.iconRight,
      iconClickable = _ref.iconClickable,
      onIconClick = _ref.onIconClick,
      initialValue = _ref.initialValue,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly,
      value = _ref.value,
      onClearClick = _ref.onClearClick,
      clearable = _ref.clearable,
      className = _ref.className,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      autoComplete = _ref.autoComplete,
      placeholder = _ref.placeholder,
      children = _ref.children,
      disabled = _ref.disabled,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var inputRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, function () {
    return inputRef.current;
  });

  var _useState = (0,react.useState)(initialValue),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selfValue = _useState2[0],
      setSelfValue = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1];

  var isControlledComponent = (0,react.useMemo)(function () {
    return value !== undefined;
  }, [value]);
  var labelClasses = (0,react.useMemo)(function () {
    return labelRight ? 'right-label' : label ? 'left-label' : '';
  }, [label, labelRight]);
  var iconClasses = (0,react.useMemo)(function () {
    return iconRight ? 'right-icon' : icon ? 'left-icon' : '';
  }, [icon, iconRight]);

  var _useMemo = (0,react.useMemo)(function () {
    return (0,styles/* getColors */.E)(theme.palette, type);
  }, [theme.palette, type]),
      color = _useMemo.color,
      borderColor = _useMemo.borderColor,
      hoverBorder = _useMemo.hoverBorder;

  var changeHandler = function changeHandler(event) {
    if (disabled || readOnly) return;
    setSelfValue(event.target.value);
    onChange && onChange(event);
  };

  var clearHandler = function clearHandler(event) {
    setSelfValue('');
    onClearClick && onClearClick(event);
    /* istanbul ignore next */

    if (!inputRef.current) return;
    var changeEvent = simulateChangeEvent(inputRef.current, event);
    changeEvent.target.value = '';
    onChange && onChange(changeEvent);
    inputRef.current.focus();
  };

  var focusHandler = function focusHandler(e) {
    setHover(true);
    onFocus && onFocus(e);
  };

  var blurHandler = function blurHandler(e) {
    setHover(false);
    onBlur && onBlur(e);
  };

  var iconClickHandler = function iconClickHandler(e) {
    if (disabled) return;
    onIconClick && onIconClick(e);
  };

  var iconProps = (0,react.useMemo)(function () {
    return {
      clickable: iconClickable,
      onClick: iconClickHandler
    };
  }, [iconClickable, iconClickHandler]);
  (0,react.useEffect)(function () {
    if (isControlledComponent) {
      setSelfValue(value);
    }
  });
  var controlledValue = isControlledComponent ? {
    value: selfValue
  } : {
    defaultValue: initialValue
  };

  var inputProps = (0,esm_extends/* default */.Z)({}, props, controlledValue);

  return /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["9324941", [SCALES.height(2.25), SCALES.font(0.875), SCALES.width(1, 'initial'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.width(1, 'initial'), theme.layout.radius, borderColor, theme.palette.accents_1, theme.palette.accents_2, hoverBorder, SCALES.font(0.875), color, theme.palette.accents_3, theme.palette.background, color]]]) + " " + "with-label"
  }, children && /*#__PURE__*/react.createElement(input_block_label, null, children), /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["9324941", [SCALES.height(2.25), SCALES.font(0.875), SCALES.width(1, 'initial'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.width(1, 'initial'), theme.layout.radius, borderColor, theme.palette.accents_1, theme.palette.accents_2, hoverBorder, SCALES.font(0.875), color, theme.palette.accents_3, theme.palette.background, color]]]) + " " + ((0,use_classes/* default */.Z)('input-container', className) || "")
  }, label && /*#__PURE__*/react.createElement(input_label, null, label), /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["9324941", [SCALES.height(2.25), SCALES.font(0.875), SCALES.width(1, 'initial'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.width(1, 'initial'), theme.layout.radius, borderColor, theme.palette.accents_1, theme.palette.accents_2, hoverBorder, SCALES.font(0.875), color, theme.palette.accents_3, theme.palette.background, color]]]) + " " + ((0,use_classes/* default */.Z)('input-wrapper', {
      hover: hover,
      disabled: disabled
    }, labelClasses) || "")
  }, icon && /*#__PURE__*/react.createElement(input_icon, (0,esm_extends/* default */.Z)({
    icon: icon
  }, iconProps)), /*#__PURE__*/react.createElement("input", (0,esm_extends/* default */.Z)({
    type: htmlType,
    ref: inputRef,
    placeholder: placeholder,
    disabled: disabled,
    readOnly: readOnly,
    onFocus: focusHandler,
    onBlur: blurHandler,
    onChange: changeHandler,
    autoComplete: autoComplete
  }, inputProps, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["9324941", [SCALES.height(2.25), SCALES.font(0.875), SCALES.width(1, 'initial'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.width(1, 'initial'), theme.layout.radius, borderColor, theme.palette.accents_1, theme.palette.accents_2, hoverBorder, SCALES.font(0.875), color, theme.palette.accents_3, theme.palette.background, color]]]) + " " + (inputProps && inputProps.className != null && inputProps.className || (0,use_classes/* default */.Z)({
      disabled: disabled
    }, iconClasses) || "")
  })), clearable && /*#__PURE__*/react.createElement(input_icon_clear, {
    visible: Boolean(inputRef.current && inputRef.current.value !== ''),
    disabled: disabled || readOnly,
    onClick: clearHandler
  }), iconRight && /*#__PURE__*/react.createElement(input_icon, (0,esm_extends/* default */.Z)({
    icon: iconRight
  }, iconProps))), labelRight && /*#__PURE__*/react.createElement(input_label, {
    isRight: true
  }, labelRight)), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "9324941",
    dynamic: [SCALES.height(2.25), SCALES.font(0.875), SCALES.width(1, 'initial'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.width(1, 'initial'), theme.layout.radius, borderColor, theme.palette.accents_1, theme.palette.accents_2, hoverBorder, SCALES.font(0.875), color, theme.palette.accents_3, theme.palette.background, color]
  }, ".with-label.__jsx-style-dynamic-selector{display:inline-block;box-sizing:border-box;-webkit-box-align:center;--input-height:".concat(SCALES.height(2.25), ";font-size:").concat(SCALES.font(0.875), ";width:").concat(SCALES.width(1, 'initial'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.input-container.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:").concat(SCALES.width(1, 'initial'), ";height:var(--input-height);}.input-wrapper.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%;-webkit-flex:1;-ms-flex:1;flex:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-radius:").concat(theme.layout.radius, ";border:2px solid ").concat(borderColor, ";-webkit-transition:border 0.2s ease 0s,color 0.2s ease 0s;transition:border 0.2s ease 0s,color 0.2s ease 0s;}.input-wrapper.left-label.__jsx-style-dynamic-selector{border-top-left-radius:0;border-bottom-left-radius:0;}.input-wrapper.right-label.__jsx-style-dynamic-selector{border-top-right-radius:0;border-bottom-right-radius:0;}.input-wrapper.disabled.__jsx-style-dynamic-selector{background-color:").concat(theme.palette.accents_1, ";border-color:").concat(theme.palette.accents_2, ";cursor:not-allowed;}input.disabled.__jsx-style-dynamic-selector{cursor:not-allowed;}.input-wrapper.hover.__jsx-style-dynamic-selector{border-color:").concat(hoverBorder, ";}input.__jsx-style-dynamic-selector{margin:0.25em 0.625em;padding:0;box-shadow:none;font-size:").concat(SCALES.font(0.875), ";background-color:transparent;border:none;color:").concat(color, ";outline:none;border-radius:0;width:100%;min-width:0;-webkit-appearance:none;}input.left-icon.__jsx-style-dynamic-selector{margin-left:0;}input.right-icon.__jsx-style-dynamic-selector{margin-right:0;}.__jsx-style-dynamic-selector::-webkit-input-placeholder,.__jsx-style-dynamic-selector::-moz-placeholder,.__jsx-style-dynamic-selector:-ms-input-placeholder,.__jsx-style-dynamic-selector::-webkit-input-placeholder{color:").concat(theme.palette.accents_3, ";}.__jsx-style-dynamic-selector::-moz-placeholder,.__jsx-style-dynamic-selector::-moz-placeholder,.__jsx-style-dynamic-selector:-ms-input-placeholder,.__jsx-style-dynamic-selector::-webkit-input-placeholder{color:").concat(theme.palette.accents_3, ";}.__jsx-style-dynamic-selector:-ms-input-placeholder,.__jsx-style-dynamic-selector::-moz-placeholder,.__jsx-style-dynamic-selector:-ms-input-placeholder,.__jsx-style-dynamic-selector::-webkit-input-placeholder{color:").concat(theme.palette.accents_3, ";}.__jsx-style-dynamic-selector::placeholder,.__jsx-style-dynamic-selector::-moz-placeholder,.__jsx-style-dynamic-selector:-ms-input-placeholder,.__jsx-style-dynamic-selector::-webkit-input-placeholder{color:").concat(theme.palette.accents_3, ";}.__jsx-style-dynamic-selector::-ms-reveal{display:none !important;}input.__jsx-style-dynamic-selector:-webkit-autofill,input.__jsx-style-dynamic-selector:-webkit-autofill.__jsx-style-dynamic-selector:hover,input.__jsx-style-dynamic-selector:-webkit-autofill.__jsx-style-dynamic-selector:active,input.__jsx-style-dynamic-selector:-webkit-autofill.__jsx-style-dynamic-selector:focus{-webkit-box-shadow:0 0 0 30px ").concat(theme.palette.background, " inset !important;-webkit-text-fill-color:").concat(color, " !important;}")));
});
InputComponent.defaultProps = defaultProps;
InputComponent.displayName = 'GeistInput';
var Input = (0,with_scale/* default */.Z)(InputComponent);
/* harmony default export */ var input = (Input);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/textarea/index.js + 1 modules
var esm_textarea = __webpack_require__(8676);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/input/password-icon.js


var PasswordIcon = function PasswordIcon(_ref) {
  var visible = _ref.visible;
  return /*#__PURE__*/react.createElement("svg", {
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    shapeRendering: "geometricPrecision",
    style: {
      color: 'currentColor'
    }
  }, !visible ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("path", {
    d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  })) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("path", {
    d: "M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M1 1l22 22"
  })));
};

var MemoPasswordIcon = /*#__PURE__*/react.memo(PasswordIcon);
/* harmony default export */ var password_icon = (MemoPasswordIcon);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/scale-context.js
var scale_context = __webpack_require__(5934);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/input/password.js



var password_excluded = ["hideToggle", "children"];






var passwordDefaultProps = (0,esm_extends/* default */.Z)({}, defaultProps, {
  hideToggle: false
});

var InputPasswordComponent = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var hideToggle = _ref.hideToggle,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, password_excluded);

  var _useScale = (0,scale_context/* useScale */.TT)(),
      getAllScaleProps = _useScale.getAllScaleProps;

  var inputRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  (0,react.useImperativeHandle)(ref, function () {
    return inputRef.current;
  });

  var iconClickHandler = function iconClickHandler() {
    setVisible(function (v) {
      return !v;
    });
    /* istanbul ignore next */

    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  var inputProps = (0,react.useMemo)(function () {
    return (0,esm_extends/* default */.Z)({}, props, {
      ref: inputRef,
      iconClickable: true,
      onIconClick: iconClickHandler,
      htmlType: visible ? 'text' : 'password'
    });
  }, [props, iconClickHandler, visible, inputRef]);
  var icon = (0,react.useMemo)(function () {
    if (hideToggle) return null;
    return /*#__PURE__*/react.createElement(password_icon, {
      visible: visible
    });
  }, [hideToggle, visible]);
  return /*#__PURE__*/react.createElement(input, (0,esm_extends/* default */.Z)({
    iconRight: icon
  }, getAllScaleProps(), inputProps), children);
});
InputPasswordComponent.defaultProps = passwordDefaultProps;
InputPasswordComponent.displayName = 'GeistInputPassword';
var InputPassword = (0,with_scale/* default */.Z)(InputPasswordComponent);
/* harmony default export */ var input_password = (InputPassword);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/input/index.js



input.Textarea = esm_textarea/* default */.Z;
input.Password = input_password;
/* harmony default export */ var esm_input = (input);

/***/ }),

/***/ 3468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getColors; }
/* harmony export */ });
var getColors = function getColors(palette, status) {
  var colors = {
    "default": {
      color: palette.foreground,
      borderColor: palette.border,
      hoverBorder: palette.accents_5
    },
    secondary: {
      color: palette.foreground,
      borderColor: palette.secondary,
      hoverBorder: palette.secondary
    },
    success: {
      color: palette.foreground,
      borderColor: palette.successLight,
      hoverBorder: palette.success
    },
    warning: {
      color: palette.foreground,
      borderColor: palette.warningLight,
      hoverBorder: palette.warning
    },
    error: {
      color: palette.error,
      borderColor: palette.error,
      hoverBorder: palette.errorDark
    }
  };
  if (!status) return colors["default"];
  return colors[status];
};

/***/ }),

/***/ 5901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_link; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/link/icon.js


var LinkIconComponent = function LinkIconComponent() {
  return /*#__PURE__*/react.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "0.9375em",
    height: "0.9375em",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    shapeRendering: "geometricPrecision",
    className: "jsx-3409194595" + " " + "icon"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6",
    className: "jsx-3409194595"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M15 3h6v6",
    className: "jsx-3409194595"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10 14L21 3",
    className: "jsx-3409194595"
  }), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3409194595"
  }, ".icon.jsx-3409194595{margin:0 0 -1px 0.1875em;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;color:currentColor;}"));
};
LinkIconComponent.displayName = 'GeistLinkIcon';
var LinkIcon = /*#__PURE__*/react.memo(LinkIconComponent);
/* harmony default export */ var link_icon = (LinkIcon);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/color.js
var utils_color = __webpack_require__(1185);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/link/link.js


var _excluded = ["href", "color", "underline", "children", "className", "block", "icon"];







var defaultProps = {
  href: '',
  color: false,
  icon: false,
  underline: false,
  block: false,
  className: ''
};
var LinkComponent = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var href = _ref.href,
      color = _ref.color,
      underline = _ref.underline,
      children = _ref.children,
      className = _ref.className,
      block = _ref.block,
      icon = _ref.icon,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var linkColor = color || block ? theme.palette.link : 'inherit';
  var hoverColor = color || block ? theme.palette.successLight : 'inherit';
  var decoration = underline ? 'underline' : 'none';
  var classes = (0,use_classes/* default */.Z)('link', {
    block: block
  }, className);
  return /*#__PURE__*/react.createElement("a", (0,esm_extends/* default */.Z)({
    href: href
  }, props, {
    ref: ref,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["442871747", [linkColor, block ? theme.layout.radius : 0, SCALES.font(1, 'inherit'), SCALES.width(1, 'fit-content'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.pt(0.125), SCALES.pr(0.25), SCALES.pb(0.125), SCALES.pl(0.25), SCALES.mt(0), SCALES.mr(-0.125), SCALES.mb(0), SCALES.ml(-0.125), decoration, block ? (0,utils_color/* addColorAlpha */.j)(theme.palette.link, 0.1) : 'unset', hoverColor]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), children, icon && /*#__PURE__*/react.createElement(link_icon, null), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "442871747",
    dynamic: [linkColor, block ? theme.layout.radius : 0, SCALES.font(1, 'inherit'), SCALES.width(1, 'fit-content'), SCALES.height(1, 'auto'), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.pt(0.125), SCALES.pr(0.25), SCALES.pb(0.125), SCALES.pl(0.25), SCALES.mt(0), SCALES.mr(-0.125), SCALES.mb(0), SCALES.ml(-0.125), decoration, block ? (0,utils_color/* addColorAlpha */.j)(theme.palette.link, 0.1) : 'unset', hoverColor]
  }, ".link.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-align-items:baseline;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;line-height:inherit;color:".concat(linkColor, ";-webkit-text-decoration:none;text-decoration:none;border-radius:").concat(block ? theme.layout.radius : 0, ";-webkit-transition:color 200ms ease 0ms;transition:color 200ms ease 0ms;font-size:").concat(SCALES.font(1, 'inherit'), ";width:").concat(SCALES.width(1, 'fit-content'), ";height:").concat(SCALES.height(1, 'auto'), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";}.block.__jsx-style-dynamic-selector{padding:").concat(SCALES.pt(0.125), " ").concat(SCALES.pr(0.25), " ").concat(SCALES.pb(0.125), " ").concat(SCALES.pl(0.25), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(-0.125), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(-0.125), ";}.link.__jsx-style-dynamic-selector:hover,.link.__jsx-style-dynamic-selector:active,.link.__jsx-style-dynamic-selector:focus{-webkit-text-decoration:").concat(decoration, ";text-decoration:").concat(decoration, ";}.link.__jsx-style-dynamic-selector:hover{background-color:").concat(block ? (0,utils_color/* addColorAlpha */.j)(theme.palette.link, 0.1) : 'unset', ";color:").concat(hoverColor, ";}")));
});
LinkComponent.defaultProps = defaultProps;
LinkComponent.displayName = 'GeistLink';
var Link = (0,with_scale/* default */.Z)(LinkComponent);
/* harmony default export */ var link_link = (Link);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/link/index.js

/* harmony default export */ var esm_link = (link_link);

/***/ }),

/***/ 9037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_modal; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-portal.js + 1 modules
var use_portal = __webpack_require__(4123);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/shared/css-transition.js
var css_transition = __webpack_require__(1777);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/collections.js
var collections = __webpack_require__(9265);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/modal/modal-wrapper.js


var _excluded = ["className", "children", "visible"];







var defaultProps = {
  className: '',
  visible: false
};

var ModalWrapper = function ModalWrapper(_ref) {
  var className = _ref.className,
      children = _ref.children,
      visible = _ref.visible,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var modalContent = (0,react.useRef)(null);
  var tabStart = (0,react.useRef)(null);
  var tabEnd = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (!visible) return;
    var activeElement = document.activeElement;
    var isChild = (0,collections/* isChildElement */.Tv)(modalContent.current, activeElement);
    if (isChild) return;
    tabStart.current && tabStart.current.focus();
  }, [visible]);

  var onKeyDown = function onKeyDown(event) {
    var isTabDown = event.keyCode === 9;
    if (!visible || !isTabDown) return;
    var activeElement = document.activeElement;

    if (event.shiftKey) {
      if (activeElement === tabStart.current) {
        tabEnd.current && tabEnd.current.focus();
      }
    } else {
      if (activeElement === tabEnd.current) {
        tabStart.current && tabStart.current.focus();
      }
    }
  };

  return /*#__PURE__*/react.createElement(css_transition/* default */.Z, {
    name: "wrapper",
    visible: visible,
    clearTime: 300
  }, /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    role: "dialog",
    tabIndex: -1,
    onKeyDown: onKeyDown,
    ref: modalContent
  }, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["4268738715", [theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.expressiveness.shadowLarge, SCALES.font(1), SCALES.height(1, 'auto'), SCALES.pl(1.3125), SCALES.pr(1.3125), SCALES.pt(1.3125), SCALES.pb(1.3125), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + (props && props.className != null && props.className || (0,use_classes/* default */.Z)('wrapper', className) || "")
  }), /*#__PURE__*/react.createElement("div", {
    tabIndex: 0,
    "aria-hidden": "true",
    ref: tabStart,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["4268738715", [theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.expressiveness.shadowLarge, SCALES.font(1), SCALES.height(1, 'auto'), SCALES.pl(1.3125), SCALES.pr(1.3125), SCALES.pt(1.3125), SCALES.pb(1.3125), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + "hide-tab"
  }), children, /*#__PURE__*/react.createElement("div", {
    tabIndex: 0,
    "aria-hidden": "true",
    ref: tabEnd,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["4268738715", [theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.expressiveness.shadowLarge, SCALES.font(1), SCALES.height(1, 'auto'), SCALES.pl(1.3125), SCALES.pr(1.3125), SCALES.pt(1.3125), SCALES.pb(1.3125), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + "hide-tab"
  }), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "4268738715",
    dynamic: [theme.palette.background, theme.palette.foreground, theme.layout.radius, theme.expressiveness.shadowLarge, SCALES.font(1), SCALES.height(1, 'auto'), SCALES.pl(1.3125), SCALES.pr(1.3125), SCALES.pt(1.3125), SCALES.pb(1.3125), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]
  }, ".wrapper.__jsx-style-dynamic-selector{max-width:100%;vertical-align:middle;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;position:relative;box-sizing:border-box;background-color:".concat(theme.palette.background, ";color:").concat(theme.palette.foreground, ";border-radius:").concat(theme.layout.radius, ";box-shadow:").concat(theme.expressiveness.shadowLarge, ";opacity:0;outline:none;-webkit-transform:translate3d(0px,-30px,0px);-ms-transform:translate3d(0px,-30px,0px);transform:translate3d(0px,-30px,0px);-webkit-transition:opacity 0.35s cubic-bezier(0.4,0,0.2,1) 0s, -webkit-transform 0.35s cubic-bezier(0.4,0,0.2,1) 0s;-webkit-transition:opacity 0.35s cubic-bezier(0.4,0,0.2,1) 0s, transform 0.35s cubic-bezier(0.4,0,0.2,1) 0s;transition:opacity 0.35s cubic-bezier(0.4,0,0.2,1) 0s, transform 0.35s cubic-bezier(0.4,0,0.2,1) 0s;width:100%;font-size:").concat(SCALES.font(1), ";height:").concat(SCALES.height(1, 'auto'), ";--modal-wrapper-padding-left:").concat(SCALES.pl(1.3125), ";--modal-wrapper-padding-right:").concat(SCALES.pr(1.3125), ";padding:").concat(SCALES.pt(1.3125), " var(--modal-wrapper-padding-right) ").concat(SCALES.pb(1.3125), " var(--modal-wrapper-padding-left);margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.wrapper-enter.__jsx-style-dynamic-selector{opacity:0;-webkit-transform:translate3d(0px,-30px,0px);-ms-transform:translate3d(0px,-30px,0px);transform:translate3d(0px,-30px,0px);}.wrapper-enter-active.__jsx-style-dynamic-selector{opacity:1;-webkit-transform:translate3d(0px,0px,0px);-ms-transform:translate3d(0px,0px,0px);transform:translate3d(0px,0px,0px);}.wrapper-leave.__jsx-style-dynamic-selector{opacity:1;-webkit-transform:translate3d(0px,0px,0px);-ms-transform:translate3d(0px,0px,0px);transform:translate3d(0px,0px,0px);}.wrapper-leave-active.__jsx-style-dynamic-selector{opacity:0;-webkit-transform:translate3d(0px,-30px,0px);-ms-transform:translate3d(0px,-30px,0px);transform:translate3d(0px,-30px,0px);}.hide-tab.__jsx-style-dynamic-selector{outline:none;overflow:hidden;width:0;height:0;opacity:0;}"))));
};

ModalWrapper.defaultProps = defaultProps;
ModalWrapper.displayName = 'GeistModalWrapper';
/* harmony default export */ var modal_wrapper = (ModalWrapper);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/modal/modal-context.js

var defaultContext = {};
var ModalContext = /*#__PURE__*/react.createContext(defaultContext);
var useModalContext = function useModalContext() {
  return react.useContext(ModalContext);
};
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/button/button.js + 7 modules
var button_button = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/modal/modal-action.js


var modal_action_excluded = ["className", "children", "onClick", "passive", "disabled"];







var modal_action_defaultProps = {
  className: '',
  passive: false,
  disabled: false
};
var ModalActionComponent = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      passive = _ref.passive,
      disabled = _ref.disabled,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, modal_action_excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var btnRef = (0,react.useRef)(null);

  var _useModalContext = useModalContext(),
      _close = _useModalContext.close;

  (0,react.useImperativeHandle)(ref, function () {
    return btnRef.current;
  });

  var clickHandler = function clickHandler(event) {
    if (disabled) return;
    var actionEvent = Object.assign({}, event, {
      close: function close() {
        return _close && _close();
      }
    });
    onClick && onClick(actionEvent);
  };

  var color = (0,react.useMemo)(function () {
    return passive ? theme.palette.accents_5 : theme.palette.foreground;
  }, [theme.palette, passive, disabled]);
  var bgColor = (0,react.useMemo)(function () {
    return disabled ? theme.palette.accents_1 : theme.palette.background;
  }, [theme.palette, disabled]);
  var _styles$className = {
    styles: /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
      id: "930885138",
      dynamic: [SCALES.font(0.75), color, theme.palette.background, SCALES.height(3.5625), disabled ? color : theme.palette.foreground, disabled ? bgColor : theme.palette.accents_1]
    }, "button.btn.__jsx-style-dynamic-selector{font-size:".concat(SCALES.font(0.75), ";border:none;color:").concat(color, ";background-color:").concat(theme.palette.background, ";display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-flex:1;-ms-flex:1;flex:1;height:").concat(SCALES.height(3.5625), ";border-radius:0;min-width:0;}button.btn.__jsx-style-dynamic-selector:hover,button.btn.__jsx-style-dynamic-selector:focus{color:").concat(disabled ? color : theme.palette.foreground, ";background-color:").concat(disabled ? bgColor : theme.palette.accents_1, ";}")),
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["930885138", [SCALES.font(0.75), color, theme.palette.background, SCALES.height(3.5625), disabled ? color : theme.palette.foreground, disabled ? bgColor : theme.palette.accents_1]]])
  },
      resolveClassName = _styles$className.className,
      styles = _styles$className.styles;
  var classes = (0,use_classes/* default */.Z)(resolveClassName, className);

  var overrideProps = (0,esm_extends/* default */.Z)({}, props, {
    effect: false,
    ref: btnRef
  });

  return /*#__PURE__*/react.createElement(button_button/* default */.Z, (0,esm_extends/* default */.Z)({
    className: classes,
    onClick: clickHandler,
    disabled: disabled
  }, overrideProps), children, styles);
});
ModalActionComponent.defaultProps = modal_action_defaultProps;
ModalActionComponent.displayName = 'GeistModalAction';
var ModalAction = (0,with_scale/* default */.Z)(ModalActionComponent);
/* harmony default export */ var modal_action = (ModalAction);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/modal/modal-actions.js



var modal_actions_excluded = ["children"];




var ModalActionsComponent = function ModalActionsComponent(_ref) {
  var children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, modal_actions_excluded);

  var theme = (0,use_theme/* default */.Z)();
  var ref = (0,react.useRef)(null);

  var _useState = (0,react.useState)('auto'),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      height = _useState2[0],
      setHeight = _useState2[1];

  (0,react.useEffect)(function () {
    if (!ref.current) return;
    setHeight("".concat(ref.current.clientHeight, "px"));
  }, [ref]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2914444644", [theme.palette.border, theme.layout.radius, theme.layout.radius, theme.palette.border, height]]])
  }), /*#__PURE__*/react.createElement("footer", (0,esm_extends/* default */.Z)({
    ref: ref
  }, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2914444644", [theme.palette.border, theme.layout.radius, theme.layout.radius, theme.palette.border, height]]]) + " " + (props && props.className != null && props.className || "")
  }), children), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2914444644",
    dynamic: [theme.palette.border, theme.layout.radius, theme.layout.radius, theme.palette.border, height]
  }, "footer.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;overflow:hidden;width:100%;height:auto;position:absolute;bottom:0;left:0;right:0;border-top:1px solid ".concat(theme.palette.border, ";border-bottom-left-radius:").concat(theme.layout.radius, ";border-bottom-right-radius:").concat(theme.layout.radius, ";}footer.__jsx-style-dynamic-selector>button.btn + button.btn{border-left:1px solid ").concat(theme.palette.border, ";}div.__jsx-style-dynamic-selector{height:").concat(height, ";-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;}")));
};

ModalActionsComponent.displayName = 'GeistModalActions';
var ModalActions = /*#__PURE__*/react.memo(ModalActionsComponent);
/* harmony default export */ var modal_actions = (ModalActions);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/shared/backdrop.js
var backdrop = __webpack_require__(4552);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-body-scroll.js + 2 modules
var use_body_scroll = __webpack_require__(6121);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-keyboard/index.js + 2 modules
var use_keyboard = __webpack_require__(2631);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-keyboard/codes.js
var codes = __webpack_require__(7513);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/modal/modal-exit.js





var X = function X() {
  var theme = (0,use_theme/* default */.Z)();
  return /*#__PURE__*/react.createElement("svg", {
    viewBox: "0 0 24 24",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    shapeRendering: "geometricPrecision",
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3674282193", [theme.palette.background]]])
  }, /*#__PURE__*/react.createElement("path", {
    d: "M18 6L6 18M6 6l12 12",
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3674282193", [theme.palette.background]]])
  }), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3674282193",
    dynamic: [theme.palette.background]
  }, "svg.__jsx-style-dynamic-selector{color:inherit;stroke:".concat(theme.palette.background, ";-webkit-transition:all 200ms ease;transition:all 200ms ease;width:1.214em;height:1.214em;padding-x:0.5em;cursor:pointer;}")));
};

var ModalExit = function ModalExit(_ref) {
  var onClick = _ref.onClick,
      visible = _ref.visible;
  return /*#__PURE__*/react.createElement(css_transition/* default */.Z, {
    visible: visible,
    clearTime: 300
  }, /*#__PURE__*/react.createElement("div", {
    onClick: onClick,
    style: {
      padding: '.38rem'
    },
    className: "jsx-3700450091" + " " + "exit"
  }, /*#__PURE__*/react.createElement(X, null), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3700450091"
  }, ".exit.jsx-3700450091{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;width:100%;}.exit-enter.jsx-3700450091{opacity:0;-webkit-transform:translate3d(0px,-30px,0px);-ms-transform:translate3d(0px,-30px,0px);transform:translate3d(0px,-30px,0px);}.exit-enter-active.jsx-3700450091{opacity:1;-webkit-transform:translate3d(0px,0px,0px);-ms-transform:translate3d(0px,0px,0px);transform:translate3d(0px,0px,0px);}.exit-leave.jsx-3700450091{opacity:1;-webkit-transform:translate3d(0px,0px,0px);-ms-transform:translate3d(0px,0px,0px);transform:translate3d(0px,0px,0px);}.exit-leave-active.jsx-3700450091{opacity:0;-webkit-transform:translate3d(0px,-30px,0px);-ms-transform:translate3d(0px,-30px,0px);transform:translate3d(0px,-30px,0px);}")));
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/modal/modal.js















var modal_defaultProps = {
  wrapClassName: '',
  keyboard: true,
  disableBackdropClick: false,
  positionClassName: '',
  backdropClassName: '',
  layerClassName: ''
};

var ModalComponent = function ModalComponent(_ref) {
  var customVisible = _ref.visible,
      onClose = _ref.onClose,
      children = _ref.children,
      keyboard = _ref.keyboard,
      wrapClassName = _ref.wrapClassName,
      onContentClick = _ref.onContentClick,
      disableBackdropClick = _ref.disableBackdropClick,
      positionClassName = _ref.positionClassName,
      backdropClassName = _ref.backdropClassName,
      layerClassName = _ref.layerClassName;
  var portal = (0,use_portal/* default */.Z)('modal');

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var _useBodyScroll = (0,use_body_scroll/* default */.Z)(null, {
    delayReset: 300
  }),
      _useBodyScroll2 = (0,slicedToArray/* default */.Z)(_useBodyScroll, 2),
      setBodyHidden = _useBodyScroll2[1];

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _pickChild = (0,collections/* pickChild */.xC)(children, modal_action),
      _pickChild2 = (0,slicedToArray/* default */.Z)(_pickChild, 2),
      withoutActionsChildren = _pickChild2[0],
      ActionsChildren = _pickChild2[1];

  var hasActions = ActionsChildren && react.Children.count(ActionsChildren) > 0;

  var closeModal = function closeModal() {
    onClose && onClose();
    setVisible(false);
    setBodyHidden(false);
  };

  (0,react.useEffect)(function () {
    if (typeof customVisible === 'undefined') return;
    setVisible(customVisible);
    setBodyHidden(customVisible);
  }, [customVisible]);

  var _useKeyboard = (0,use_keyboard/* default */.ZP)(function () {
    keyboard && closeModal();
  }, codes/* KeyCode.Escape */.V.Escape, {
    disableGlobalEvent: true
  }),
      bindings = _useKeyboard.bindings;

  var closeFromBackdrop = function closeFromBackdrop() {
    if (disableBackdropClick) return;
    closeModal();
  };

  var modalConfig = (0,react.useMemo)(function () {
    return {
      close: closeModal
    };
  }, []);
  if (!portal) return null;
  return /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/react.createElement(ModalContext.Provider, {
    value: modalConfig
  }, /*#__PURE__*/react.createElement(backdrop/* default */.Z, (0,esm_extends/* default */.Z)({
    onClick: closeFromBackdrop,
    onContentClick: onContentClick,
    visible: visible,
    width: SCALES.width(26),
    positionClassName: positionClassName,
    backdropClassName: backdropClassName,
    layerClassName: layerClassName
  }, bindings), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ModalExit, {
    visible: visible,
    onClick: closeFromBackdrop
  }), /*#__PURE__*/react.createElement(modal_wrapper, {
    visible: visible,
    className: wrapClassName
  }, withoutActionsChildren, hasActions && /*#__PURE__*/react.createElement(modal_actions, null, ActionsChildren))))), portal);
};

ModalComponent.defaultProps = modal_defaultProps;
ModalComponent.displayName = 'GeistModal';
var Modal = (0,with_scale/* default */.Z)(ModalComponent);
/* harmony default export */ var modal = (Modal);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/modal/modal-title.js
var modal_title = __webpack_require__(9129);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/modal/modal-subtitle.js
var modal_subtitle = __webpack_require__(7528);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/modal/modal-content.js
var modal_content = __webpack_require__(7489);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/modal/index.js





modal.Title = modal_title/* default */.Z;
modal.Subtitle = modal_subtitle/* default */.Z;
modal.Content = modal_content/* default */.Z;
modal.Action = modal_action;
/* harmony default export */ var esm_modal = (modal);

/***/ }),

/***/ 7489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91);
/* harmony import */ var _styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9978);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _use_scale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7243);
/* harmony import */ var _use_scale__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3793);
/* harmony import */ var _use_classes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8931);


var _excluded = ["className", "children"];




var defaultProps = {
  className: ''
};

var ModalContentComponent = function ModalContentComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  var _useScale = (0,_use_scale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(),
      SCALES = _useScale.SCALES;

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props, {
    className: _styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dynamic */ .ZP.dynamic([["498745028", [SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(1.3125), SCALES.pr(1.3125), SCALES.pb(0.6625), SCALES.pl(1.3125), SCALES.mt(0), SCALES.mr(0, 'calc(var(--modal-wrapper-padding-right) * -1)'), SCALES.mb(0), SCALES.ml(0, 'calc(var(--modal-wrapper-padding-left) * -1)')]]]) + " " + (props && props.className != null && props.className || (0,_use_classes__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)('content', className) || "")
  }), children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
    id: "498745028",
    dynamic: [SCALES.font(1), SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(1.3125), SCALES.pr(1.3125), SCALES.pb(0.6625), SCALES.pl(1.3125), SCALES.mt(0), SCALES.mr(0, 'calc(var(--modal-wrapper-padding-right) * -1)'), SCALES.mb(0), SCALES.ml(0, 'calc(var(--modal-wrapper-padding-left) * -1)')]
  }, ".content.__jsx-style-dynamic-selector{position:relative;text-align:left;font-size:".concat(SCALES.font(1), ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(1.3125), " ").concat(SCALES.pr(1.3125), " ").concat(SCALES.pb(0.6625), " ").concat(SCALES.pl(1.3125), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0, 'calc(var(--modal-wrapper-padding-right) * -1)'), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0, 'calc(var(--modal-wrapper-padding-left) * -1)'), ";}.content.__jsx-style-dynamic-selector>*:first-child{margin-top:0;}.content.__jsx-style-dynamic-selector>*:last-child{margin-bottom:0;}")));
};

ModalContentComponent.defaultProps = defaultProps;
ModalContentComponent.displayName = 'GeistModalContent';
var ModalContent = (0,_use_scale__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ModalContentComponent);
/* harmony default export */ __webpack_exports__["Z"] = (ModalContent);

/***/ }),

/***/ 7528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91);
/* harmony import */ var _styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9978);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _use_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5711);
/* harmony import */ var _use_scale__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7243);
/* harmony import */ var _use_scale__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3793);


var _excluded = ["className", "children"];




var defaultProps = {
  className: ''
};

var ModalSubtitleComponent = function ModalSubtitleComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  var theme = (0,_use_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();

  var _useScale = (0,_use_scale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(),
      SCALES = _useScale.SCALES;

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props, {
    className: _styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dynamic */ .ZP.dynamic([["2550488204", [theme.palette.accents_5, SCALES.font(0.875), SCALES.width(1, 'auto'), SCALES.height(1, '1.5em'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + (props && props.className != null && props.className || className || "")
  }), children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
    id: "2550488204",
    dynamic: [theme.palette.accents_5, SCALES.font(0.875), SCALES.width(1, 'auto'), SCALES.height(1, '1.5em'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]
  }, "p.__jsx-style-dynamic-selector{font-weight:normal;display:inline-block;text-align:center;word-break:break-word;text-transform:uppercase;color:".concat(theme.palette.accents_5, ";font-size:").concat(SCALES.font(0.875), ";line-height:1.5em;width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, '1.5em'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}")));
};

ModalSubtitleComponent.defaultProps = defaultProps;
ModalSubtitleComponent.displayName = 'GeistModalSubtitle';
var ModalSubtitle = (0,_use_scale__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ModalSubtitleComponent);
/* harmony default export */ __webpack_exports__["Z"] = (ModalSubtitle);

/***/ }),

/***/ 9129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91);
/* harmony import */ var _styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9978);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _use_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5711);
/* harmony import */ var _use_scale__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7243);
/* harmony import */ var _use_scale__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3793);


var _excluded = ["className", "children"];




var defaultProps = {
  className: ''
};

var ModalTitleComponent = function ModalTitleComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  var theme = (0,_use_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();

  var _useScale = (0,_use_scale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(),
      SCALES = _useScale.SCALES;

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h2", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props, {
    className: _styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dynamic */ .ZP.dynamic([["2865939188", [SCALES.font(1.5), theme.palette.foreground, SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]]]) + " " + (props && props.className != null && props.className || className || "")
  }), children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
    id: "2865939188",
    dynamic: [SCALES.font(1.5), theme.palette.foreground, SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0)]
  }, "h2.__jsx-style-dynamic-selector{line-height:1.6;font-weight:normal;text-align:center;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;word-break:break-word;text-transform:capitalize;font-size:".concat(SCALES.font(1.5), ";color:").concat(theme.palette.foreground, ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}")));
};

ModalTitleComponent.defaultProps = defaultProps;
ModalTitleComponent.displayName = 'GeistModalTitle';
var ModalTitle = (0,_use_scale__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ModalTitleComponent);
/* harmony default export */ __webpack_exports__["Z"] = (ModalTitle);

/***/ }),

/***/ 1278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_select; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(1451);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-current-state.js + 2 modules
var use_current_state = __webpack_require__(1052);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/collections.js
var collections = __webpack_require__(9265);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/select/select-icon.js



var SelectIconComponent = function SelectIconComponent() {
  return /*#__PURE__*/react.createElement("svg", {
    viewBox: "0 0 24 24",
    strokeWidth: "1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    shapeRendering: "geometricPrecision",
    className: "jsx-3693441034"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M6 9l6 6 6-6",
    className: "jsx-3693441034"
  }), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3693441034"
  }, "svg.jsx-3693441034{color:inherit;stroke:currentColor;-webkit-transition:all 200ms ease;transition:all 200ms ease;width:1.214em;height:1.214em;padding-x:0.5em;}"));
};

SelectIconComponent.displayName = 'GeistSelectIcon';
var SelectIcon = /*#__PURE__*/react.memo(SelectIconComponent);
/* harmony default export */ var select_icon = (SelectIcon);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/select/select-context.js

var defaultContext = {
  visible: false,
  disableAll: false
};
var SelectContext = /*#__PURE__*/react.createContext(defaultContext);
var useSelectContext = function useSelectContext() {
  return react.useContext(SelectContext);
};
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-portal.js + 1 modules
var use_portal = __webpack_require__(4123);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-resize.js
var use_resize = __webpack_require__(6134);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/shared/css-transition.js
var css_transition = __webpack_require__(1777);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-click-anywhere.js
var use_click_anywhere = __webpack_require__(895);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/utils/use-dom-observer.js


var useDOMObserver = function useDOMObserver(ref) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var config = {
    attributes: false,
    childList: true,
    subtree: true
  };
  (0,react.useEffect)(function () {
    if (!ref || !ref.current) return;
    var unmount = false;

    var done = function done() {
      if (unmount) return;
      callback.apply(void 0, arguments);
    };

    var observer = new MutationObserver(done);
    observer.observe(ref.current, config);
    return function () {
      unmount = true;
      observer.disconnect();
    };
  }, [ref]);
};

/* harmony default export */ var use_dom_observer = (useDOMObserver);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/layouts.js
var layouts = __webpack_require__(726);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/shared/dropdown.js












var defaultRect = {
  top: -1000,
  left: -1000,
  right: -1000,
  width: 0
};
var Dropdown = /*#__PURE__*/react.memo(function (_ref) {
  var children = _ref.children,
      parent = _ref.parent,
      visible = _ref.visible,
      disableMatchWidth = _ref.disableMatchWidth,
      getPopupContainer = _ref.getPopupContainer;
  var el = (0,use_portal/* default */.Z)('dropdown', getPopupContainer);

  var _useState = (0,react.useState)(defaultRect),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      rect = _useState2[0],
      setRect = _useState2[1];

  var classes = (0,use_classes/* default */.Z)('dropdown', disableMatchWidth ? 'disable-match' : 'width-match', 'partial-border');
  if (!parent) return null;
  /* istanbul ignore next */

  if (false) { var style, _el; }

  var updateRect = function updateRect() {
    var _getRefRect = (0,layouts/* getRefRect */.eH)(parent, getPopupContainer),
        top = _getRefRect.top,
        left = _getRefRect.left,
        right = _getRefRect.right,
        nativeWidth = _getRefRect.width;

    setRect({
      top: top,
      left: left,
      right: right,
      width: nativeWidth
    });
  };

  (0,use_resize/* default */.Z)(updateRect);
  (0,use_click_anywhere/* default */.Z)(function () {
    var _getRefRect2 = (0,layouts/* getRefRect */.eH)(parent, getPopupContainer),
        top = _getRefRect2.top,
        left = _getRefRect2.left;

    var shouldUpdatePosition = top !== rect.top || left !== rect.left;
    if (!shouldUpdatePosition) return;
    updateRect();
  });
  use_dom_observer(parent, function () {
    updateRect();
  });
  (0,react.useEffect)(function () {
    if (!parent || !parent.current) return;
    parent.current.addEventListener('mouseenter', updateRect);
    /* istanbul ignore next */

    return function () {
      if (!parent || !parent.current) return;
      parent.current.removeEventListener('mouseenter', updateRect);
    };
  }, [parent]);

  var clickHandler = function clickHandler(event) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    event.preventDefault();
  };

  var mouseDownHandler = function mouseDownHandler(event) {
    event.preventDefault();
  };

  if (!el) return null;
  return /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/react.createElement(css_transition/* default */.Z, {
    visible: visible,
    enterTime: 5,
    leaveTime: 2
  }, /*#__PURE__*/react.createElement("div", {
    onClick: clickHandler,
    onMouseDown: mouseDownHandler,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3264365935", [rect.top, rect.left, rect.width, rect.width]]]) + " " + (classes || "")
  }, children, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3264365935",
    dynamic: [rect.top, rect.left, rect.width, rect.width]
  }, ".dropdown.__jsx-style-dynamic-selector{position:absolute;top:".concat(rect.top, "px;left:").concat(rect.left, "px;z-index:1100;}.width-match.__jsx-style-dynamic-selector{width:").concat(rect.width, "px;}.disable-match.__jsx-style-dynamic-selector{min-width:").concat(rect.width, "px;}")))), el);
});
/* harmony default export */ var dropdown = (Dropdown);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/select/select-dropdown.js






var defaultProps = {
  className: '',
  dropdownStyle: {}
};
var SelectDropdown = /*#__PURE__*/react.forwardRef(function (_ref, dropdownRef) {
  var visible = _ref.visible,
      children = _ref.children,
      className = _ref.className,
      dropdownStyle = _ref.dropdownStyle,
      disableMatchWidth = _ref.disableMatchWidth,
      getPopupContainer = _ref.getPopupContainer,
      typeColor = _ref.typeColor;
  var theme = (0,use_theme/* default */.Z)();
  var internalDropdownRef = (0,react.useRef)(null);

  var _useSelectContext = useSelectContext(),
      ref = _useSelectContext.ref;

  var classes = (0,use_classes/* default */.Z)('select-dropdown', className);
  (0,react.useImperativeHandle)(dropdownRef, function () {
    return internalDropdownRef.current;
  });
  var roundedCorner = "calc(4 * ".concat(theme.layout.radius, ") ");
  return /*#__PURE__*/react.createElement(dropdown, {
    parent: ref,
    visible: visible,
    disableMatchWidth: disableMatchWidth,
    getPopupContainer: getPopupContainer
  }, /*#__PURE__*/react.createElement("div", {
    ref: internalDropdownRef,
    style: dropdownStyle,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["2852375681", [roundedCorner, roundedCorner, typeColor, theme.expressiveness.shadowLarge, theme.palette.background]]]) + " " + (classes || "")
  }, children, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2852375681",
    dynamic: [roundedCorner, roundedCorner, typeColor, theme.expressiveness.shadowLarge, theme.palette.background]
  }, ".select-dropdown.__jsx-style-dynamic-selector{border-radius:0px 0px ".concat(roundedCorner, " ").concat(roundedCorner, ";border:1px solid ").concat(typeColor, ";border-top:none;box-shadow:").concat(theme.expressiveness.shadowLarge, ";background-color:").concat(theme.palette.background, ";overflow-y:auto;overflow-anchor:none;padding:0.38em 0;-webkit-scroll-behavior:smooth;-moz-scroll-behavior:smooth;-ms-scroll-behavior:smooth;scroll-behavior:smooth;}"))));
});
SelectDropdown.defaultProps = defaultProps;
SelectDropdown.displayName = 'GeistSelectDropdown';
/* harmony default export */ var select_dropdown = (SelectDropdown);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/grid/index.js + 3 modules
var grid = __webpack_require__(6293);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/select/select-icon-clear.js




var SelectIconClear = function SelectIconClear(_ref) {
  var onClick = _ref.onClick;
  var theme = (0,use_theme/* default */.Z)();

  var clickHandler = function clickHandler(event) {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    onClick && onClick(event);
  };

  return /*#__PURE__*/react.createElement("div", {
    onClick: clickHandler,
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3218630561", [theme.palette.accents_5, theme.palette.foreground]]]) + " " + "clear-icon"
  }, /*#__PURE__*/react.createElement("svg", {
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    shapeRendering: "geometricPrecision",
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3218630561", [theme.palette.accents_5, theme.palette.foreground]]])
  }, /*#__PURE__*/react.createElement("path", {
    d: "M18 6L6 18",
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3218630561", [theme.palette.accents_5, theme.palette.foreground]]])
  }), /*#__PURE__*/react.createElement("path", {
    d: "M6 6l12 12",
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3218630561", [theme.palette.accents_5, theme.palette.foreground]]])
  })), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3218630561",
    dynamic: [theme.palette.accents_5, theme.palette.foreground]
  }, ".clear-icon.__jsx-style-dynamic-selector{padding:0 0 0 0.5em;margin:0;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%;cursor:pointer;box-sizing:border-box;-webkit-transition:color 150ms ease 0s;transition:color 150ms ease 0s;color:".concat(theme.palette.accents_5, ";visibility:visible;opacity:1;}.clear-icon.__jsx-style-dynamic-selector:hover{color:").concat(theme.palette.foreground, ";}svg.__jsx-style-dynamic-selector{color:currentColor;width:1em;height:1em;}")));
};

var MemoSelectIconClear = /*#__PURE__*/react.memo(SelectIconClear);
/* harmony default export */ var select_icon_clear = (MemoSelectIconClear);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/select/select-multiple-value.js






var SelectMultipleValue = function SelectMultipleValue(_ref) {
  var disabled = _ref.disabled,
      onClear = _ref.onClear,
      children = _ref.children;
  var theme = (0,use_theme/* default */.Z)();
  return /*#__PURE__*/react.createElement(grid/* default */.Z, null, /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["760864904", [theme.layout.radius, theme.palette.accents_4, disabled ? theme.palette.accents_6 : theme.palette.accents_8, theme.palette.foreground]]]) + " " + "item"
  }, children, !!onClear && /*#__PURE__*/react.createElement(select_icon_clear, {
    onClick: onClear
  })), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "760864904",
    dynamic: [theme.layout.radius, theme.palette.accents_4, disabled ? theme.palette.accents_6 : theme.palette.accents_8, theme.palette.foreground]
  }, ".item.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;justify-items:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:1;padding:0 0.5em;font-size:var(--select-font-size);height:calc(var(--select-font-size) * 2);border-radius:".concat(theme.layout.radius, ";background-color:").concat(theme.palette.accents_4, ";color:").concat(disabled ? theme.palette.accents_6 : theme.palette.accents_8, ";}.item.__jsx-style-dynamic-selector>div:not(.clear-icon),.item.__jsx-style-dynamic-selector>div:not(.clear-icon):hover{border-radius:0;background-color:transparent;padding:0;margin:0;color:").concat(theme.palette.foreground, ";}")));
};

SelectMultipleValue.displayName = 'GeistSelectMultipleValue';
/* harmony default export */ var select_multiple_value = (SelectMultipleValue);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/select/styles.js
var getColors = function getColors(palette, status) {
  var colors = {
    "default": {
      background: palette.background,
      border: palette.background,
      hover: palette.accents_1,
      iconBorder: palette.accents_6,
      placeholderColor: palette.accents_7
    },
    secondary: {
      background: palette.accents_4,
      border: palette.accents_4,
      hover: palette.accents_5,
      iconBorder: palette.accents_6,
      placeholderColor: palette.accents_3
    },
    success: {
      background: palette.successLighter,
      border: palette.successLighter,
      hover: palette.successLight,
      iconBorder: palette.successDark,
      placeholderColor: palette.success
    },
    warning: {
      background: palette.warningLight,
      border: palette.warningLight,
      hover: palette.warning,
      iconBorder: palette.warningDark,
      placeholderColor: palette.warning
    },
    error: {
      background: palette.errorLighter,
      border: palette.errorLighter,
      hover: palette.errorLight,
      iconBorder: palette.errorDark,
      placeholderColor: palette.error
    }
  };
  if (!status) return colors["default"];
  return colors[status];
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/shared/ellipsis.js



var Ellipsis = function Ellipsis(_ref) {
  var children = _ref.children,
      height = _ref.height;
  return /*#__PURE__*/react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["822089635", [height]]])
  }, children, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "822089635",
    dynamic: [height]
  }, "span.__jsx-style-dynamic-selector{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:".concat(height, ";min-width:0;}")));
};

/* harmony default export */ var shared_ellipsis = (/*#__PURE__*/react.memo(Ellipsis));
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/select/select-input.js


var SelectInput = /*#__PURE__*/react.forwardRef(function (_ref, inputRef) {
  var visible = _ref.visible,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus;
  var ref = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(inputRef, function () {
    return ref.current;
  });
  (0,react.useEffect)(function () {
    if (visible) {
      var _ref$current;

      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
    }
  }, [visible]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("input", {
    ref: ref,
    type: "search",
    role: "combobox",
    "aria-haspopup": "listbox",
    readOnly: true,
    unselectable: "on",
    "aria-expanded": visible,
    onBlur: onBlur,
    onFocus: onFocus,
    className: "jsx-2813108835"
  }), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "2813108835"
  }, "input.jsx-2813108835{position:fixed;top:-10000px;left:-10000px;opacity:0;z-index:-1;width:0;height:0;padding:0;font-size:0;border:none;}"));
});
SelectInput.displayName = 'GeistSelectInput';
/* harmony default export */ var select_input = (SelectInput);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/select/select.js




var _excluded = ["children", "type", "disabled", "initialValue", "value", "icon", "onChange", "pure", "multiple", "clearable", "placeholder", "className", "dropdownClassName", "dropdownStyle", "disableMatchWidth", "getPopupContainer", "onDropdownVisibleChange"];















var select_defaultProps = {
  disabled: false,
  type: 'default',
  icon: select_icon,
  pure: false,
  multiple: false,
  clearable: true,
  className: '',
  disableMatchWidth: false,
  onDropdownVisibleChange: function onDropdownVisibleChange() {}
};
var SelectComponent = /*#__PURE__*/react.forwardRef(function (_ref, selectRef) {
  var children = _ref.children,
      type = _ref.type,
      disabled = _ref.disabled,
      init = _ref.initialValue,
      customValue = _ref.value,
      Icon = _ref.icon,
      onChange = _ref.onChange,
      pure = _ref.pure,
      multiple = _ref.multiple,
      clearable = _ref.clearable,
      placeholder = _ref.placeholder,
      className = _ref.className,
      dropdownClassName = _ref.dropdownClassName,
      dropdownStyle = _ref.dropdownStyle,
      disableMatchWidth = _ref.disableMatchWidth,
      getPopupContainer = _ref.getPopupContainer,
      onDropdownVisibleChange = _ref.onDropdownVisibleChange,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var ref = (0,react.useRef)(null);
  var inputRef = (0,react.useRef)(null);
  var dropdownRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      selectFocus = _useState4[0],
      setSelectFocus = _useState4[1];

  var _useCurrentState = (0,use_current_state/* default */.Z)(function () {
    if (!multiple) return init;
    if (Array.isArray(init)) return init;
    return typeof init === 'undefined' ? [] : [init];
  }),
      _useCurrentState2 = (0,slicedToArray/* default */.Z)(_useCurrentState, 3),
      value = _useCurrentState2[0],
      setValue = _useCurrentState2[1],
      valueRef = _useCurrentState2[2];

  var isEmpty = (0,react.useMemo)(function () {
    if (!Array.isArray(value)) return !value;
    return value.length === 0;
  }, [value]);

  var _useMemo = (0,react.useMemo)(function () {
    return getColors(theme.palette, type);
  }, [theme.palette, type]),
      background = _useMemo.background,
      border = _useMemo.border,
      hover = _useMemo.hover,
      iconBorder = _useMemo.iconBorder,
      placeholderColor = _useMemo.placeholderColor;

  var updateVisible = function updateVisible(next) {
    onDropdownVisibleChange(next);
    setVisible(next);
  };

  var updateValue = function updateValue(next) {
    setValue(function (last) {
      if (!Array.isArray(last)) return next;
      if (!last.includes(next)) return [].concat((0,toConsumableArray/* default */.Z)(last), [next]);
      return last.filter(function (item) {
        return item !== next;
      });
    });
    onChange && onChange(valueRef.current);

    if (!multiple) {
      updateVisible(false);
    }
  };

  var initialValue = (0,react.useMemo)(function () {
    return {
      value: value,
      visible: visible,
      updateValue: updateValue,
      updateVisible: updateVisible,
      ref: ref,
      disableAll: disabled
    };
  }, [visible, disabled, ref, value, multiple]);

  var clickHandler = function clickHandler(event) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    event.preventDefault();
    if (disabled) return;
    updateVisible(!visible);
    event.preventDefault();
  };

  var mouseDownHandler = function mouseDownHandler(event) {
    /* istanbul ignore next */
    if (visible) {
      event.preventDefault();
    }
  };

  (0,react.useEffect)(function () {
    if (customValue === undefined) return;
    setValue(customValue);
  }, [customValue]);
  (0,react.useImperativeHandle)(selectRef, function () {
    return {
      focus: function focus() {
        var _inputRef$current;

        return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      },
      blur: function blur() {
        var _inputRef$current2;

        return (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.blur();
      },
      scrollTo: function scrollTo(options) {
        var _dropdownRef$current;

        return (_dropdownRef$current = dropdownRef.current) === null || _dropdownRef$current === void 0 ? void 0 : _dropdownRef$current.scrollTo(options);
      }
    };
  }, [inputRef, dropdownRef]);
  var selectedChild = (0,react.useMemo)(function () {
    var _pickChildByProps = (0,collections/* pickChildByProps */.jG)(children, 'value', value),
        _pickChildByProps2 = (0,slicedToArray/* default */.Z)(_pickChildByProps, 2),
        optionChildren = _pickChildByProps2[1];

    return react.Children.map(optionChildren, function (child) {
      if (! /*#__PURE__*/react.isValidElement(child)) return null;

      var _el = /*#__PURE__*/react.cloneElement(child, {
        preventAllEvents: true
      }); // @ts-ignore


      var el = _el.props.displayName ? _el.props.displayName : _el; // console.log(el)

      if (!multiple) return el;
      return /*#__PURE__*/react.createElement(select_multiple_value, {
        disabled: disabled,
        onClear: clearable ? function () {
          return updateValue(child.props.value);
        } : null
      }, el);
    });
  }, [value, children, multiple]);

  var onInputBlur = function onInputBlur() {
    updateVisible(false);
    setSelectFocus(false);
  };

  var classes = (0,use_classes/* default */.Z)('select', {
    active: selectFocus || visible,
    multiple: multiple
  }, className);
  var roundedCorner = "calc(4 * ".concat(theme.layout.radius, ") ");
  var activeCorners = "".concat(roundedCorner, " ").concat(roundedCorner, " 0 0");
  return /*#__PURE__*/react.createElement(SelectContext.Provider, {
    value: initialValue
  }, /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    ref: ref,
    onClick: clickHandler,
    onMouseDown: mouseDownHandler
  }, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1415297858", [disabled ? 'not-allowed' : 'pointer', border, roundedCorner, disabled ? theme.palette.accents_1 : visible ? theme.palette.background : background, SCALES.font(0.875), SCALES.height(2.25), SCALES.width(1, 'initial'), SCALES.pt(0), SCALES.pr(1.667), SCALES.pb(0), SCALES.pl(0.667), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.pt(0.334), SCALES.pr(0.334), SCALES.pb(0.334), SCALES.pl(0.667), hover, disabled ? theme.palette.border : hover, disabled ? 'none' : "0 0 0 1px ".concat(hover), visible ? activeCorners : roundedCorner, disabled ? theme.palette.accents_5 : iconBorder, disabled ? theme.palette.accents_4 : theme.palette.foreground, placeholderColor, theme.layout.gapQuarter, visible ? '180' : '0', iconBorder]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), /*#__PURE__*/react.createElement(select_input, {
    ref: inputRef,
    visible: visible,
    onBlur: onInputBlur,
    onFocus: function onFocus() {
      return setSelectFocus(true);
    }
  }), isEmpty && /*#__PURE__*/react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1415297858", [disabled ? 'not-allowed' : 'pointer', border, roundedCorner, disabled ? theme.palette.accents_1 : visible ? theme.palette.background : background, SCALES.font(0.875), SCALES.height(2.25), SCALES.width(1, 'initial'), SCALES.pt(0), SCALES.pr(1.667), SCALES.pb(0), SCALES.pl(0.667), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.pt(0.334), SCALES.pr(0.334), SCALES.pb(0.334), SCALES.pl(0.667), hover, disabled ? theme.palette.border : hover, disabled ? 'none' : "0 0 0 1px ".concat(hover), visible ? activeCorners : roundedCorner, disabled ? theme.palette.accents_5 : iconBorder, disabled ? theme.palette.accents_4 : theme.palette.foreground, placeholderColor, theme.layout.gapQuarter, visible ? '180' : '0', iconBorder]]]) + " " + "value placeholder"
  }, /*#__PURE__*/react.createElement(shared_ellipsis, {
    height: "var(--select-height)"
  }, placeholder)), value && !multiple && /*#__PURE__*/react.createElement("span", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1415297858", [disabled ? 'not-allowed' : 'pointer', border, roundedCorner, disabled ? theme.palette.accents_1 : visible ? theme.palette.background : background, SCALES.font(0.875), SCALES.height(2.25), SCALES.width(1, 'initial'), SCALES.pt(0), SCALES.pr(1.667), SCALES.pb(0), SCALES.pl(0.667), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.pt(0.334), SCALES.pr(0.334), SCALES.pb(0.334), SCALES.pl(0.667), hover, disabled ? theme.palette.border : hover, disabled ? 'none' : "0 0 0 1px ".concat(hover), visible ? activeCorners : roundedCorner, disabled ? theme.palette.accents_5 : iconBorder, disabled ? theme.palette.accents_4 : theme.palette.foreground, placeholderColor, theme.layout.gapQuarter, visible ? '180' : '0', iconBorder]]]) + " " + "value"
  }, selectedChild), value && multiple && /*#__PURE__*/react.createElement(grid/* default.Container */.Z.Container, {
    gap: 0.5
  }, selectedChild), /*#__PURE__*/react.createElement(select_dropdown, {
    ref: dropdownRef,
    visible: visible,
    className: dropdownClassName,
    dropdownStyle: dropdownStyle,
    disableMatchWidth: disableMatchWidth,
    typeColor: background,
    getPopupContainer: getPopupContainer
  }, children), !pure && /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["1415297858", [disabled ? 'not-allowed' : 'pointer', border, roundedCorner, disabled ? theme.palette.accents_1 : visible ? theme.palette.background : background, SCALES.font(0.875), SCALES.height(2.25), SCALES.width(1, 'initial'), SCALES.pt(0), SCALES.pr(1.667), SCALES.pb(0), SCALES.pl(0.667), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.pt(0.334), SCALES.pr(0.334), SCALES.pb(0.334), SCALES.pl(0.667), hover, disabled ? theme.palette.border : hover, disabled ? 'none' : "0 0 0 1px ".concat(hover), visible ? activeCorners : roundedCorner, disabled ? theme.palette.accents_5 : iconBorder, disabled ? theme.palette.accents_4 : theme.palette.foreground, placeholderColor, theme.layout.gapQuarter, visible ? '180' : '0', iconBorder]]]) + " " + "icon"
  }, /*#__PURE__*/react.createElement(select_icon, null)), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "1415297858",
    dynamic: [disabled ? 'not-allowed' : 'pointer', border, roundedCorner, disabled ? theme.palette.accents_1 : visible ? theme.palette.background : background, SCALES.font(0.875), SCALES.height(2.25), SCALES.width(1, 'initial'), SCALES.pt(0), SCALES.pr(1.667), SCALES.pb(0), SCALES.pl(0.667), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), SCALES.pt(0.334), SCALES.pr(0.334), SCALES.pb(0.334), SCALES.pl(0.667), hover, disabled ? theme.palette.border : hover, disabled ? 'none' : "0 0 0 1px ".concat(hover), visible ? activeCorners : roundedCorner, disabled ? theme.palette.accents_5 : iconBorder, disabled ? theme.palette.accents_4 : theme.palette.foreground, placeholderColor, theme.layout.gapQuarter, visible ? '180' : '0', iconBorder]
  }, ".select.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap;position:relative;cursor:".concat(disabled ? 'not-allowed' : 'pointer', ";max-width:90vw;overflow:hidden;-webkit-transition:border 15ms ease-in 0s,color 20ms ease-out 0s, box-shadow 20ms ease 0s;transition:border 15ms ease-in 0s,color 20ms ease-out 0s, box-shadow 20ms ease 0s;border:1px solid ").concat(border, ";border-radius:").concat(roundedCorner, ";background-color:").concat(disabled ? theme.palette.accents_1 : visible ? theme.palette.background : background, ";--select-font-size:").concat(SCALES.font(0.875), ";--select-height:").concat(SCALES.height(2.25), ";min-width:11.5rem;width:").concat(SCALES.width(1, 'initial'), ";height:var(--select-height);padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(1.667), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0.667), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.multiple.__jsx-style-dynamic-selector{height:auto;min-height:var(--select-height);padding:").concat(SCALES.pt(0.334), " ").concat(SCALES.pr(0.334), " ").concat(SCALES.pb(0.334), " ").concat(SCALES.pl(0.667), ";}.select.active.__jsx-style-dynamic-selector,.select.__jsx-style-dynamic-selector:hover{background-color:").concat(hover, ";border:1px solid ").concat(disabled ? theme.palette.border : hover, ";box-shadow:").concat(disabled ? 'none' : "0 0 0 1px ".concat(hover), ";}.select.active.__jsx-style-dynamic-selector{border-radius:").concat(visible ? activeCorners : roundedCorner, ";}.select.active.icon.__jsx-style-dynamic-selector,.select.__jsx-style-dynamic-selector:hover .icon.__jsx-style-dynamic-selector{color:").concat(disabled ? theme.palette.accents_5 : iconBorder, ";}.value.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-flex:1;-ms-flex:1;flex:1;height:100%;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:1;padding:0;font-size:var(--select-font-size);color:").concat(disabled ? theme.palette.accents_4 : theme.palette.foreground, ";width:calc(100% - 1.25em);}.value.__jsx-style-dynamic-selector>div,.value.__jsx-style-dynamic-selector>div:hover{border-radius:0;background-color:transparent;padding:0;margin:0;color:inherit;}.placeholder.__jsx-style-dynamic-selector{color:").concat(placeholderColor, ";}.icon.__jsx-style-dynamic-selector{position:absolute;right:").concat(theme.layout.gapQuarter, ";font-size:var(--select-font-size);top:50%;bottom:0;-webkit-transform:translateY(-50%) rotate(").concat(visible ? '180' : '0', "deg);-ms-transform:translateY(-50%) rotate(").concat(visible ? '180' : '0', "deg);transform:translateY(-50%) rotate(").concat(visible ? '180' : '0', "deg);pointer-events:none;-webkit-transition:-webkit-transform 200ms ease;-webkit-transition:transform 200ms ease;transition:transform 200ms ease;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:").concat(iconBorder, ";}"))));
});
SelectComponent.defaultProps = select_defaultProps;
SelectComponent.displayName = 'GeistSelect';
var Select = (0,with_scale/* default */.Z)(SelectComponent);
/* harmony default export */ var select_select = (Select);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-warning.js
var use_warning = __webpack_require__(1421);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/select/select-option.js


var select_option_excluded = ["value", "displayName", "className", "children", "disabled", "divider", "label", "preventAllEvents", "ellipsis"];








var select_option_defaultProps = {
  disabled: false,
  divider: false,
  label: false,
  className: '',
  preventAllEvents: false,
  ellipsis: true
};

var SelectOptionComponent = function SelectOptionComponent(_ref) {
  var identValue = _ref.value,
      displayName = _ref.displayName,
      className = _ref.className,
      children = _ref.children,
      disabled = _ref.disabled,
      divider = _ref.divider,
      label = _ref.label,
      preventAllEvents = _ref.preventAllEvents,
      ellipsis = _ref.ellipsis,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, select_option_excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var _useSelectContext = useSelectContext(),
      updateValue = _useSelectContext.updateValue,
      value = _useSelectContext.value,
      disableAll = _useSelectContext.disableAll;

  var isDisabled = (0,react.useMemo)(function () {
    return disabled || disableAll;
  }, [disabled, disableAll]);
  var isLabel = (0,react.useMemo)(function () {
    return label || divider;
  }, [label, divider]);
  var classes = (0,use_classes/* default */.Z)('option', {
    divider: divider,
    label: label
  }, className);

  if (!isLabel && identValue === undefined) {
    (0,use_warning/* default */.Z)('The props "value" is required.', 'Select Option');
  }

  var selected = (0,react.useMemo)(function () {
    if (!value) return false;

    if (typeof value === 'string') {
      return identValue === value;
    }

    return value.includes("".concat(identValue));
  }, [identValue, value]);
  var bgColor = (0,react.useMemo)(function () {
    if (isDisabled) return theme.palette.accents_1;
    return selected ? theme.palette.accents_2 : theme.palette.background;
  }, [selected, isDisabled, theme.palette]);
  var hoverBgColor = (0,react.useMemo)(function () {
    if (isDisabled || isLabel || selected) return bgColor;
    return theme.palette.accents_1;
  }, [selected, isDisabled, theme.palette, isLabel, bgColor]);
  var color = (0,react.useMemo)(function () {
    if (isDisabled) return theme.palette.accents_4;
    return selected ? theme.palette.foreground : theme.palette.accents_5;
  }, [selected, isDisabled, theme.palette]);

  var clickHandler = function clickHandler(event) {
    if (preventAllEvents) return;
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    event.preventDefault();
    if (isDisabled || isLabel) return;
    updateValue && updateValue(identValue);
  };

  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    onClick: clickHandler
  }, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["199367556", [bgColor, color, isDisabled ? 'not-allowed' : 'pointer', SCALES.font(0.75), SCALES.width(1, '100%'), SCALES.height(2.25), SCALES.pt(0), SCALES.pr(0.667), SCALES.pb(0), SCALES.pl(0.667), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), hoverBgColor, theme.palette.accents_7, theme.palette.border, SCALES.width(1, '100%'), SCALES.height(1, 0), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0.5), SCALES.mr(0), SCALES.mb(0.5), SCALES.ml(0), theme.palette.accents_7, theme.palette.border, SCALES.font(0.875), SCALES.width(1, '100%')]]]) + " " + (props && props.className != null && props.className || classes || "")
  }), ellipsis ? /*#__PURE__*/react.createElement(shared_ellipsis, {
    height: SCALES.height(2.25)
  }, children) : /*#__PURE__*/react.createElement(react.Fragment, null, children), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "199367556",
    dynamic: [bgColor, color, isDisabled ? 'not-allowed' : 'pointer', SCALES.font(0.75), SCALES.width(1, '100%'), SCALES.height(2.25), SCALES.pt(0), SCALES.pr(0.667), SCALES.pb(0), SCALES.pl(0.667), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), hoverBgColor, theme.palette.accents_7, theme.palette.border, SCALES.width(1, '100%'), SCALES.height(1, 0), SCALES.pt(0), SCALES.pr(0), SCALES.pb(0), SCALES.pl(0), SCALES.mt(0.5), SCALES.mr(0), SCALES.mb(0.5), SCALES.ml(0), theme.palette.accents_7, theme.palette.border, SCALES.font(0.875), SCALES.width(1, '100%')]
  }, ".option.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;max-width:100%;box-sizing:border-box;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-weight:normal;background-color:".concat(bgColor, ";color:").concat(color, ";-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:0;cursor:").concat(isDisabled ? 'not-allowed' : 'pointer', ";-webkit-transition:background 0.2s ease 0s,border-color 0.2s ease 0s;transition:background 0.2s ease 0s,border-color 0.2s ease 0s;--select-font-size:").concat(SCALES.font(0.75), ";font-size:var(--select-font-size);width:").concat(SCALES.width(1, '100%'), ";height:").concat(SCALES.height(2.25), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0.667), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0.667), ";margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.option.__jsx-style-dynamic-selector:hover{background-color:").concat(hoverBgColor, ";color:").concat(theme.palette.accents_7, ";}.divider.__jsx-style-dynamic-selector{line-height:0;overflow:hidden;border-top:1px solid ").concat(theme.palette.border, ";width:").concat(SCALES.width(1, '100%'), ";height:").concat(SCALES.height(1, 0), ";padding:").concat(SCALES.pt(0), " ").concat(SCALES.pr(0), " ").concat(SCALES.pb(0), " ").concat(SCALES.pl(0), ";margin:").concat(SCALES.mt(0.5), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0.5), " ").concat(SCALES.ml(0), ";}.label.__jsx-style-dynamic-selector{color:").concat(theme.palette.accents_7, ";border-bottom:1px solid ").concat(theme.palette.border, ";text-transform:capitalize;cursor:default;font-size:").concat(SCALES.font(0.875), ";width:").concat(SCALES.width(1, '100%'), ";font-weight:500;}")));
};

SelectOptionComponent.defaultProps = select_option_defaultProps;
SelectOptionComponent.displayName = 'GeistSelectOption';
var SelectOption = (0,with_scale/* default */.Z)(SelectOptionComponent);
/* harmony default export */ var select_option = (SelectOption);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/select/index.js


select_select.Option = select_option;
/* harmony default export */ var esm_select = (select_select);

/***/ }),

/***/ 4552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7462);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6854);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91);
/* harmony import */ var _styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9978);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _use_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5711);
/* harmony import */ var _css_transition__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1777);
/* harmony import */ var _utils_use_current_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1052);
/* harmony import */ var _use_classes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8931);



var _excluded = ["children", "onClick", "visible", "width", "onContentClick", "backdropClassName", "positionClassName", "layerClassName"];






var defaultProps = {
  onClick: function onClick() {},
  visible: false,
  onContentClick: function onContentClick() {},
  backdropClassName: '',
  positionClassName: '',
  layerClassName: ''
};
var Backdrop = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(function (_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      visible = _ref.visible,
      width = _ref.width,
      onContentClick = _ref.onContentClick,
      backdropClassName = _ref.backdropClassName,
      positionClassName = _ref.positionClassName,
      layerClassName = _ref.layerClassName,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  var theme = (0,_use_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();

  var _useCurrentState = (0,_utils_use_current_state__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(false),
      _useCurrentState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useCurrentState, 3),
      setIsContentMouseDown = _useCurrentState2[1],
      IsContentMouseDownRef = _useCurrentState2[2];

  var clickHandler = function clickHandler(event) {
    if (IsContentMouseDownRef.current) return;
    onClick && onClick(event);
  };

  var mouseUpHandler = function mouseUpHandler() {
    if (!IsContentMouseDownRef.current) return;
    var timer = setTimeout(function () {
      setIsContentMouseDown(false);
      clearTimeout(timer);
    }, 0);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_css_transition__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    name: "backdrop-wrapper",
    visible: visible,
    clearTime: 300
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    onClick: clickHandler,
    onMouseUp: mouseUpHandler
  }, props, {
    className: _styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"].dynamic */ .ZP.dynamic([["2161354224", [width, theme.expressiveness.portalOpacity, theme.expressiveness.portalOpacity, theme.expressiveness.portalOpacity]]]) + " " + (props && props.className != null && props.className || (0,_use_classes__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)('backdrop', backdropClassName) || "")
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: _styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"].dynamic */ .ZP.dynamic([["2161354224", [width, theme.expressiveness.portalOpacity, theme.expressiveness.portalOpacity, theme.expressiveness.portalOpacity]]]) + " " + ((0,_use_classes__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)('layer', layerClassName) || "")
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    onClick: onContentClick,
    onMouseDown: function onMouseDown() {
      return setIsContentMouseDown(true);
    },
    className: _styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"].dynamic */ .ZP.dynamic([["2161354224", [width, theme.expressiveness.portalOpacity, theme.expressiveness.portalOpacity, theme.expressiveness.portalOpacity]]]) + " " + ((0,_use_classes__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)('position', positionClassName) || "")
  }, children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styled_jsx_es_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
    id: "2161354224",
    dynamic: [width, theme.expressiveness.portalOpacity, theme.expressiveness.portalOpacity, theme.expressiveness.portalOpacity]
  }, ".backdrop.__jsx-style-dynamic-selector{position:fixed;top:0;left:0;right:0;bottom:0;overflow:auto;z-index:1000;-webkit-overflow-scrolling:touch;box-sizing:border-box;text-align:center;}.position.__jsx-style-dynamic-selector{position:relative;z-index:1001;outline:none;max-width:100%;width:".concat(width, ";margin:20px auto;vertical-align:middle;display:inline-block;}.backdrop.__jsx-style-dynamic-selector:before{display:inline-block;width:0;height:100%;vertical-align:middle;content:'';}.layer.__jsx-style-dynamic-selector{position:fixed;top:0;left:0;right:0;bottom:0;width:100%;height:100%;opacity:").concat(theme.expressiveness.portalOpacity, ";background-color:black;-webkit-transition:opacity 0.35s cubic-bezier(0.4,0,0.2,1);transition:opacity 0.35s cubic-bezier(0.4,0,0.2,1);pointer-events:none;z-index:1000;}.backdrop-wrapper-enter.__jsx-style-dynamic-selector .layer.__jsx-style-dynamic-selector{opacity:0;}.backdrop-wrapper-enter-active.__jsx-style-dynamic-selector .layer.__jsx-style-dynamic-selector{opacity:").concat(theme.expressiveness.portalOpacity, ";}.backdrop-wrapper-leave.__jsx-style-dynamic-selector .layer.__jsx-style-dynamic-selector{opacity:").concat(theme.expressiveness.portalOpacity, ";}.backdrop-wrapper-leave-active.__jsx-style-dynamic-selector .layer.__jsx-style-dynamic-selector{opacity:0;}"))));
});
Backdrop.defaultProps = defaultProps;
Backdrop.displayName = 'GeistBackdrop';
/* harmony default export */ __webpack_exports__["Z"] = (Backdrop);

/***/ }),

/***/ 1777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7462);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6854);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);



var _excluded = ["children", "className", "visible", "enterTime", "leaveTime", "clearTime", "name"];

var defaultProps = {
  visible: false,
  enterTime: 60,
  leaveTime: 60,
  clearTime: 60,
  className: '',
  name: 'transition'
};

var CssTransition = function CssTransition(_ref) {
  var children = _ref.children,
      className = _ref.className,
      visible = _ref.visible,
      enterTime = _ref.enterTime,
      leaveTime = _ref.leaveTime,
      clearTime = _ref.clearTime,
      name = _ref.name,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_useState, 2),
      classes = _useState2[0],
      setClasses = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(visible),
      _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_useState3, 2),
      renderable = _useState4[0],
      setRenderable = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var statusClassName = visible ? 'enter' : 'leave';
    var time = visible ? enterTime : leaveTime;

    if (visible && !renderable) {
      setRenderable(true);
    }

    setClasses("".concat(name, "-").concat(statusClassName)); // set class to active

    var timer = setTimeout(function () {
      setClasses("".concat(name, "-").concat(statusClassName, " ").concat(name, "-").concat(statusClassName, "-active"));
      clearTimeout(timer);
    }, time); // remove classess when animation over

    var clearClassesTimer = setTimeout(function () {
      if (!visible) {
        setClasses('');
        setRenderable(false);
      }

      clearTimeout(clearClassesTimer);
    }, time + clearTime);
    return function () {
      clearTimeout(timer);
      clearTimeout(clearClassesTimer);
    };
  }, [visible, renderable]);
  if (! /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children) || !renderable) return null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props, {
    className: "".concat(children.props.className, " ").concat(className, " ").concat(classes)
  }));
};

CssTransition.defaultProps = defaultProps;
CssTransition.displayName = 'GeistCssTransition';
/* harmony default export */ __webpack_exports__["Z"] = (CssTransition);

/***/ }),

/***/ 9978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fw": function() { return /* binding */ _server; }
/* harmony export */ });
/* unused harmony export style */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* provided dependency */ var process = __webpack_require__(3454);


var style$1 = {}

var stylesheetRegistry = {}

function hash(str) {
  var hash = 5381,
    i = str.length

  while (i) {
    hash = (hash * 33) ^ str.charCodeAt(--i)
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0
}

var stringHash = hash

var stylesheet = {}

;(function (exports) {
  exports.__esModule = true
  exports['default'] = void 0

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i]
      descriptor.enumerable = descriptor.enumerable || false
      descriptor.configurable = true
      if ('value' in descriptor) descriptor.writable = true
      Object.defineProperty(target, descriptor.key, descriptor)
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps)
    if (staticProps) _defineProperties(Constructor, staticProps)
    return Constructor
  }

  /*
  Based on Glamor's sheet
  https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
  */
  var isProd =
    typeof process !== 'undefined' && process.env && "production" === 'production'

  var isString = function isString(o) {
    return Object.prototype.toString.call(o) === '[object String]'
  }

  var StyleSheet = /*#__PURE__*/ (function () {
    function StyleSheet(_temp) {
      var _ref = _temp === void 0 ? {} : _temp,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? 'stylesheet' : _ref$name,
        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
        optimizeForSpeed =
          _ref$optimizeForSpeed === void 0 ? isProd : _ref$optimizeForSpeed,
        _ref$isBrowser = _ref.isBrowser,
        isBrowser =
          _ref$isBrowser === void 0 ? typeof window !== 'undefined' : _ref$isBrowser

      invariant(isString(name), '`name` must be a string')
      this._name = name
      this._deletedRulePlaceholder = '#' + name + '-deleted-rule____{}'
      invariant(
        typeof optimizeForSpeed === 'boolean',
        '`optimizeForSpeed` must be a boolean',
      )
      this._optimizeForSpeed = optimizeForSpeed
      this._isBrowser = isBrowser
      this._serverSheet = undefined
      this._tags = []
      this._injected = false
      this._rulesCount = 0
      var node = this._isBrowser && document.querySelector('meta[property="csp-nonce"]')
      this._nonce = node ? node.getAttribute('content') : null
    }

    var _proto = StyleSheet.prototype

    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
      invariant(typeof bool === 'boolean', '`setOptimizeForSpeed` accepts a boolean')
      invariant(
        this._rulesCount === 0,
        'optimizeForSpeed cannot be when rules have already been inserted',
      )
      this.flush()
      this._optimizeForSpeed = bool
      this.inject()
    }

    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
      return this._optimizeForSpeed
    }

    _proto.inject = function inject() {
      var _this = this

      invariant(!this._injected, 'sheet already injected')
      this._injected = true

      if (this._isBrowser && this._optimizeForSpeed) {
        this._tags[0] = this.makeStyleTag(this._name)
        this._optimizeForSpeed = 'insertRule' in this.getSheet()

        if (!this._optimizeForSpeed) {
          if (!isProd) {
            console.warn(
              'StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.',
            )
          }

          this.flush()
          this._injected = true
        }

        return
      }

      this._serverSheet = {
        cssRules: [],
        insertRule: function insertRule(rule, index) {
          if (typeof index === 'number') {
            _this._serverSheet.cssRules[index] = {
              cssText: rule,
            }
          } else {
            _this._serverSheet.cssRules.push({
              cssText: rule,
            })
          }

          return index
        },
        deleteRule: function deleteRule(index) {
          _this._serverSheet.cssRules[index] = null
        },
      }
    }

    _proto.getSheetForTag = function getSheetForTag(tag) {
      if (tag.sheet) {
        return tag.sheet
      } // this weirdness brought to you by firefox

      for (var i = 0; i < document.styleSheets.length; i++) {
        if (document.styleSheets[i].ownerNode === tag) {
          return document.styleSheets[i]
        }
      }
    }

    _proto.getSheet = function getSheet() {
      return this.getSheetForTag(this._tags[this._tags.length - 1])
    }

    _proto.insertRule = function insertRule(rule, index) {
      invariant(isString(rule), '`insertRule` accepts only strings')

      if (!this._isBrowser) {
        if (typeof index !== 'number') {
          index = this._serverSheet.cssRules.length
        }

        this._serverSheet.insertRule(rule, index)

        return this._rulesCount++
      }

      if (this._optimizeForSpeed) {
        var sheet = this.getSheet()

        if (typeof index !== 'number') {
          index = sheet.cssRules.length
        } // this weirdness for perf, and chrome's weird bug
        // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule

        try {
          sheet.insertRule(rule, index)
        } catch (error) {
          if (!isProd) {
            console.warn(
              'StyleSheet: illegal rule: \n\n' +
                rule +
                '\n\nSee https://stackoverflow.com/q/20007992 for more info',
            )
          }

          return -1
        }
      } else {
        var insertionPoint = this._tags[index]

        this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint))
      }

      return this._rulesCount++
    }

    _proto.replaceRule = function replaceRule(index, rule) {
      if (this._optimizeForSpeed || !this._isBrowser) {
        var sheet = this._isBrowser ? this.getSheet() : this._serverSheet

        if (!rule.trim()) {
          rule = this._deletedRulePlaceholder
        }

        if (!sheet.cssRules[index]) {
          // @TBD Should we throw an error?
          return index
        }

        sheet.deleteRule(index)

        try {
          sheet.insertRule(rule, index)
        } catch (error) {
          if (!isProd) {
            console.warn(
              'StyleSheet: illegal rule: \n\n' +
                rule +
                '\n\nSee https://stackoverflow.com/q/20007992 for more info',
            )
          } // In order to preserve the indices we insert a deleteRulePlaceholder

          sheet.insertRule(this._deletedRulePlaceholder, index)
        }
      } else {
        var tag = this._tags[index]
        invariant(tag, 'old rule at index `' + index + '` not found')
        tag.textContent = rule
      }

      return index
    }

    _proto.deleteRule = function deleteRule(index) {
      if (!this._isBrowser) {
        this._serverSheet.deleteRule(index)

        return
      }

      if (this._optimizeForSpeed) {
        this.replaceRule(index, '')
      } else {
        var tag = this._tags[index]
        invariant(tag, 'rule at index `' + index + '` not found')
        tag.parentNode.removeChild(tag)
        this._tags[index] = null
      }
    }

    _proto.flush = function flush() {
      this._injected = false
      this._rulesCount = 0

      if (this._isBrowser) {
        this._tags.forEach(function (tag) {
          return tag && tag.parentNode.removeChild(tag)
        })

        this._tags = []
      } else {
        // simpler on server
        this._serverSheet.cssRules = []
      }
    }

    _proto.cssRules = function cssRules() {
      var _this2 = this

      if (!this._isBrowser) {
        return this._serverSheet.cssRules
      }

      return this._tags.reduce(function (rules, tag) {
        if (tag) {
          rules = rules.concat(
            Array.prototype.map.call(
              _this2.getSheetForTag(tag).cssRules,
              function (rule) {
                return rule.cssText === _this2._deletedRulePlaceholder ? null : rule
              },
            ),
          )
        } else {
          rules.push(null)
        }

        return rules
      }, [])
    }

    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
      if (cssString) {
        invariant(
          isString(cssString),
          'makeStyleTag acceps only strings as second parameter',
        )
      }

      var tag = document.createElement('style')
      if (this._nonce) tag.setAttribute('nonce', this._nonce)
      tag.type = 'text/css'
      tag.setAttribute('data-' + name, '')

      if (cssString) {
        tag.appendChild(document.createTextNode(cssString))
      }

      var head = document.head || document.getElementsByTagName('head')[0]

      if (relativeToTag) {
        head.insertBefore(tag, relativeToTag)
      } else {
        head.appendChild(tag)
      }

      return tag
    }

    _createClass(StyleSheet, [
      {
        key: 'length',
        get: function get() {
          return this._rulesCount
        },
      },
    ])

    return StyleSheet
  })()

  exports['default'] = StyleSheet

  function invariant(condition, message) {
    if (!condition) {
      throw new Error('StyleSheet: ' + message + '.')
    }
  }
})(stylesheet)
;(function (exports) {
  exports.__esModule = true
  exports['default'] = void 0

  var _stringHash = _interopRequireDefault(stringHash)

  var _stylesheet = _interopRequireDefault(stylesheet)

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj }
  }

  var sanitize = function sanitize(rule) {
    return rule.replace(/\/style/gi, '\\/style')
  }

  var StyleSheetRegistry = /*#__PURE__*/ (function () {
    function StyleSheetRegistry(_temp) {
      var _ref = _temp === void 0 ? {} : _temp,
        _ref$styleSheet = _ref.styleSheet,
        styleSheet = _ref$styleSheet === void 0 ? null : _ref$styleSheet,
        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
        optimizeForSpeed =
          _ref$optimizeForSpeed === void 0 ? false : _ref$optimizeForSpeed,
        _ref$isBrowser = _ref.isBrowser,
        isBrowser =
          _ref$isBrowser === void 0 ? typeof window !== 'undefined' : _ref$isBrowser

      this._sheet =
        styleSheet ||
        new _stylesheet['default']({
          name: 'styled-jsx',
          optimizeForSpeed: optimizeForSpeed,
        })

      this._sheet.inject()

      if (styleSheet && typeof optimizeForSpeed === 'boolean') {
        this._sheet.setOptimizeForSpeed(optimizeForSpeed)

        this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()
      }

      this._isBrowser = isBrowser
      this._fromServer = undefined
      this._indices = {}
      this._instancesCounts = {}
      this.computeId = this.createComputeId()
      this.computeSelector = this.createComputeSelector()
    }

    var _proto = StyleSheetRegistry.prototype

    _proto.add = function add(props) {
      var _this = this

      if (undefined === this._optimizeForSpeed) {
        this._optimizeForSpeed = Array.isArray(props.children)

        this._sheet.setOptimizeForSpeed(this._optimizeForSpeed)

        this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()
      }

      if (this._isBrowser && !this._fromServer) {
        this._fromServer = this.selectFromServer()
        this._instancesCounts = Object.keys(this._fromServer).reduce(function (
          acc,
          tagName,
        ) {
          acc[tagName] = 0
          return acc
        },
        {})
      }

      var _this$getIdAndRules = this.getIdAndRules(props),
        styleId = _this$getIdAndRules.styleId,
        rules = _this$getIdAndRules.rules // Deduping: just increase the instances count.

      if (styleId in this._instancesCounts) {
        this._instancesCounts[styleId] += 1
        return
      }

      var indices = rules
        .map(function (rule) {
          return _this._sheet.insertRule(rule)
        }) // Filter out invalid rules
        .filter(function (index) {
          return index !== -1
        })
      this._indices[styleId] = indices
      this._instancesCounts[styleId] = 1
    }

    _proto.remove = function remove(props) {
      var _this2 = this

      var _this$getIdAndRules2 = this.getIdAndRules(props),
        styleId = _this$getIdAndRules2.styleId

      invariant(styleId in this._instancesCounts, 'styleId: `' + styleId + '` not found')
      this._instancesCounts[styleId] -= 1

      if (this._instancesCounts[styleId] < 1) {
        var tagFromServer = this._fromServer && this._fromServer[styleId]

        if (tagFromServer) {
          tagFromServer.parentNode.removeChild(tagFromServer)
          delete this._fromServer[styleId]
        } else {
          this._indices[styleId].forEach(function (index) {
            return _this2._sheet.deleteRule(index)
          })

          delete this._indices[styleId]
        }

        delete this._instancesCounts[styleId]
      }
    }

    _proto.update = function update(props, nextProps) {
      this.add(nextProps)
      this.remove(props)
    }

    _proto.flush = function flush() {
      this._sheet.flush()

      this._sheet.inject()

      this._fromServer = undefined
      this._indices = {}
      this._instancesCounts = {}
      this.computeId = this.createComputeId()
      this.computeSelector = this.createComputeSelector()
    }

    _proto.cssRules = function cssRules() {
      var _this3 = this

      var fromServer = this._fromServer
        ? Object.keys(this._fromServer).map(function (styleId) {
            return [styleId, _this3._fromServer[styleId]]
          })
        : []

      var cssRules = this._sheet.cssRules()

      return fromServer.concat(
        Object.keys(this._indices)
          .map(function (styleId) {
            return [
              styleId,
              _this3._indices[styleId]
                .map(function (index) {
                  return cssRules[index].cssText
                })
                .join(_this3._optimizeForSpeed ? '' : '\n'),
            ]
          }) // filter out empty rules
          .filter(function (rule) {
            return Boolean(rule[1])
          }),
      )
    }
    /**
     * createComputeId
     *
     * Creates a function to compute and memoize a jsx id from a basedId and optionally props.
     */

    _proto.createComputeId = function createComputeId() {
      var cache = {}
      return function (baseId, props) {
        if (!props) {
          return 'jsx-' + baseId
        }

        var propsToString = String(props)
        var key = baseId + propsToString // return `jsx-${hashString(`${baseId}-${propsToString}`)}`

        if (!cache[key]) {
          cache[key] = 'jsx-' + (0, _stringHash['default'])(baseId + '-' + propsToString)
        }

        return cache[key]
      }
    }
    /**
     * createComputeSelector
     *
     * Creates a function to compute and memoize dynamic selectors.
     */

    _proto.createComputeSelector = function createComputeSelector(
      selectoPlaceholderRegexp,
    ) {
      if (selectoPlaceholderRegexp === void 0) {
        selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g
      }

      var cache = {}
      return function (id, css) {
        // Sanitize SSR-ed CSS.
        // Client side code doesn't need to be sanitized since we use
        // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
        if (!this._isBrowser) {
          css = sanitize(css)
        }

        var idcss = id + css

        if (!cache[idcss]) {
          cache[idcss] = css.replace(selectoPlaceholderRegexp, id)
        }

        return cache[idcss]
      }
    }

    _proto.getIdAndRules = function getIdAndRules(props) {
      var _this4 = this

      var css = props.children,
        dynamic = props.dynamic,
        id = props.id

      if (dynamic) {
        var styleId = this.computeId(id, dynamic)
        return {
          styleId: styleId,
          rules: Array.isArray(css)
            ? css.map(function (rule) {
                return _this4.computeSelector(styleId, rule)
              })
            : [this.computeSelector(styleId, css)],
        }
      }

      return {
        styleId: this.computeId(id),
        rules: Array.isArray(css) ? css : [css],
      }
    }
    /**
     * selectFromServer
     *
     * Collects style tags from the document with id __jsx-XXX
     */

    _proto.selectFromServer = function selectFromServer() {
      var elements = Array.prototype.slice.call(
        document.querySelectorAll('[id^="__jsx-"]'),
      )
      return elements.reduce(function (acc, element) {
        var id = element.id.slice(2)
        acc[id] = element
        return acc
      }, {})
    }

    return StyleSheetRegistry
  })()

  exports['default'] = StyleSheetRegistry

  function invariant(condition, message) {
    if (!condition) {
      throw new Error('StyleSheetRegistry: ' + message + '.')
    }
  }
})(stylesheetRegistry)
;(function (exports) {
  exports.__esModule = true
  exports['default'] = JSXStyle
  exports.flush = flush

  var _react = react__WEBPACK_IMPORTED_MODULE_0__

  var _stylesheetRegistry = _interopRequireDefault(stylesheetRegistry)

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj }
  }

  var styleSheetRegistry = new _stylesheetRegistry['default']()

  function JSXStyle(props) {
    if (typeof window === 'undefined') {
      styleSheetRegistry.add(props)
      return null
    }

    ;(0, _react.useLayoutEffect)(
      function () {
        styleSheetRegistry.add(props)
        return function () {
          styleSheetRegistry.remove(props)
        } // props.children can be string[], will be striped since id is identical
      },
      [props.id, String(props.dynamic)],
    )
    return null
  }

  JSXStyle.dynamic = function (info) {
    return info
      .map(function (tagInfo) {
        var baseId = tagInfo[0]
        var props = tagInfo[1]
        return styleSheetRegistry.computeId(baseId, props)
      })
      .join(' ')
  }

  function flush() {
    var cssRules = styleSheetRegistry.cssRules()
    styleSheetRegistry.flush()
    return cssRules
  }
})(style$1)

var style = style$1.default || style$1
style.flush = style$1.flush

var server = {}

;(function (exports) {
  exports.__esModule = true
  exports['default'] = flushToReact
  exports.flushToHTML = flushToHTML

  var _react = _interopRequireDefault(react__WEBPACK_IMPORTED_MODULE_0__)

  var _style = style$1.default || style$1
  _style.flush = style$1.flush

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj }
  }

  function flushToReact(options) {
    if (options === void 0) {
      options = {}
    }

    return (0, _style.flush)().map(function (args) {
      var id = args[0]
      var css = args[1]
      return _react['default'].createElement('style', {
        id: '__' + id,
        // Avoid warnings upon render with a key
        key: '__' + id,
        nonce: options.nonce ? options.nonce : undefined,
        dangerouslySetInnerHTML: {
          __html: css,
        },
      })
    })
  }

  function flushToHTML(options) {
    if (options === void 0) {
      options = {}
    }

    return (0, _style.flush)().reduce(function (html, args) {
      var id = args[0]
      var css = args[1]
      html +=
        '<style id="__' +
        id +
        '"' +
        (options.nonce ? ' nonce="' + options.nonce + '"' : '') +
        '>' +
        css +
        '</style>'
      return html
    }, '')
  }
})(server)
var _server = server.default || server
_server.flushToHTML = server.flushToHTML


/* harmony default export */ __webpack_exports__["ZP"] = (style);


/***/ }),

/***/ 1151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_text; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/text/child.js


var _excluded = ["children", "tag", "className", "type"];




var defaultProps = {
  type: 'default',
  className: ''
};

var getTypeColor = function getTypeColor(type, palette) {
  var colors = {
    "default": 'inherit',
    secondary: palette.secondary,
    success: palette.success,
    warning: palette.warning,
    error: palette.error
  };
  return colors[type] || colors["default"];
};

var TextChild = function TextChild(_ref) {
  var children = _ref.children,
      tag = _ref.tag,
      className = _ref.className,
      type = _ref.type,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var Component = tag;
  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES,
      getScaleProps = _useScale.getScaleProps;

  var font = getScaleProps('font');
  var mx = getScaleProps(['margin', 'marginLeft', 'marginRight', 'mx', 'ml', 'mr']);
  var my = getScaleProps(['margin', 'marginTop', 'marginBottom', 'my', 'mt', 'mb']);
  var px = getScaleProps(['padding', 'paddingLeft', 'paddingRight', 'pl', 'pr', 'px']);
  var py = getScaleProps(['padding', 'paddingTop', 'paddingBottom', 'pt', 'pb', 'py']);
  var color = (0,react.useMemo)(function () {
    return getTypeColor(type, theme.palette);
  }, [type, theme.palette]);
  var classNames = (0,react.useMemo)(function () {
    var keys = [{
      value: mx,
      className: 'mx'
    }, {
      value: my,
      className: 'my'
    }, {
      value: px,
      className: 'px'
    }, {
      value: py,
      className: 'py'
    }, {
      value: font,
      className: 'font'
    }];
    var scaleClassNames = keys.reduce(function (pre, next) {
      if (typeof next.value === 'undefined') return pre;
      return "".concat(pre, " ").concat(next.className);
    }, '');
    return "".concat(scaleClassNames, " ").concat(className).trim();
  }, [mx, my, px, py, font, className]);
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["3155699851", [tag, color, SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.font(1, 'inherit'), SCALES.ml(0, 'revert'), SCALES.mr(0, 'revert'), SCALES.mt(0, 'revert'), SCALES.mb(0, 'revert'), SCALES.pl(0, 'revert'), SCALES.pr(0, 'revert'), SCALES.pt(0, 'revert'), SCALES.pb(0, 'revert')]]]) + " " + (props && props.className != null && props.className || classNames || "")
  }), children, /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "3155699851",
    dynamic: [tag, color, SCALES.width(1, 'auto'), SCALES.height(1, 'auto'), SCALES.font(1, 'inherit'), SCALES.ml(0, 'revert'), SCALES.mr(0, 'revert'), SCALES.mt(0, 'revert'), SCALES.mb(0, 'revert'), SCALES.pl(0, 'revert'), SCALES.pr(0, 'revert'), SCALES.pt(0, 'revert'), SCALES.pb(0, 'revert')]
  }, "".concat(tag, ".__jsx-style-dynamic-selector{color:").concat(color, ";width:").concat(SCALES.width(1, 'auto'), ";height:").concat(SCALES.height(1, 'auto'), ";}.font.__jsx-style-dynamic-selector{font-size:").concat(SCALES.font(1, 'inherit'), ";}.mx.__jsx-style-dynamic-selector{margin-left:").concat(SCALES.ml(0, 'revert'), ";margin-right:").concat(SCALES.mr(0, 'revert'), ";}.my.__jsx-style-dynamic-selector{margin-top:").concat(SCALES.mt(0, 'revert'), ";margin-bottom:").concat(SCALES.mb(0, 'revert'), ";}.px.__jsx-style-dynamic-selector{padding-left:").concat(SCALES.pl(0, 'revert'), ";padding-right:").concat(SCALES.pr(0, 'revert'), ";}.py.__jsx-style-dynamic-selector{padding-top:").concat(SCALES.pt(0, 'revert'), ";padding-bottom:").concat(SCALES.pb(0, 'revert'), ";}")));
};

TextChild.defaultProps = defaultProps;
TextChild.displayName = 'GeistTextChild';
/* harmony default export */ var child = (TextChild);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/text/text.js


var text_excluded = ["h1", "h2", "h3", "h4", "h5", "h6", "p", "b", "small", "i", "span", "del", "em", "blockquote", "children", "className"];



var text_defaultProps = {
  h1: false,
  h2: false,
  h3: false,
  h4: false,
  h5: false,
  h6: false,
  p: false,
  b: false,
  small: false,
  i: false,
  span: false,
  del: false,
  em: false,
  blockquote: false,
  className: '',
  type: 'default'
};

var getModifierChild = function getModifierChild(tags, children) {
  if (!tags.length) return children;
  var nextTag = tags.slice(1, tags.length);
  return /*#__PURE__*/react.createElement(child, {
    tag: tags[0]
  }, getModifierChild(nextTag, children));
};

var TextComponent = function TextComponent(_ref) {
  var h1 = _ref.h1,
      h2 = _ref.h2,
      h3 = _ref.h3,
      h4 = _ref.h4,
      h5 = _ref.h5,
      h6 = _ref.h6,
      p = _ref.p,
      b = _ref.b,
      small = _ref.small,
      i = _ref.i,
      span = _ref.span,
      del = _ref.del,
      em = _ref.em,
      blockquote = _ref.blockquote,
      children = _ref.children,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, text_excluded);

  var elements = {
    h1: h1,
    h2: h2,
    h3: h3,
    h4: h4,
    h5: h5,
    h6: h6,
    p: p,
    blockquote: blockquote
  };
  var inlineElements = {
    span: span,
    small: small,
    b: b,
    em: em,
    i: i,
    del: del
  };
  var names = Object.keys(elements).filter(function (name) {
    return elements[name];
  });
  var inlineNames = Object.keys(inlineElements).filter(function (name) {
    return inlineElements[name];
  });
  /**
   *  Render element "p" only if no element is found.
   *  If there is only one modifier, just rendered one modifier element
   *  e.g.
   *    <Text /> => <p />
   *    <Text em /> => <em />
   *    <Text p em /> => <p><em>children</em></p>
   *
   */

  var tag = (0,react.useMemo)(function () {
    if (names[0]) return names[0];
    if (inlineNames[0]) return inlineNames[0];
    return 'p';
  }, [names, inlineNames]);
  var renderableChildElements = inlineNames.filter(function (name) {
    return name !== tag;
  });
  var modifers = (0,react.useMemo)(function () {
    if (!renderableChildElements.length) return children;
    return getModifierChild(renderableChildElements, children);
  }, [renderableChildElements, children]);
  return /*#__PURE__*/react.createElement(child, (0,esm_extends/* default */.Z)({
    className: className,
    tag: tag
  }, props), modifers);
};

TextComponent.defaultProps = text_defaultProps;
TextComponent.displayName = 'GeistText';
var Text = (0,with_scale/* default */.Z)(TextComponent);
/* harmony default export */ var text_text = (Text);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/text/index.js

/* harmony default export */ var esm_text = (text_text);

/***/ }),

/***/ 8676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_textarea; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/styled-jsx.es.js
var styled_jsx_es = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/prop-types.js
var prop_types = __webpack_require__(1139);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/input/styles.js
var styles = __webpack_require__(3468);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/index.js
var use_scale = __webpack_require__(7243);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js + 1 modules
var with_scale = __webpack_require__(3793);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js + 1 modules
var use_classes = __webpack_require__(8931);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/textarea/textarea.js



var _excluded = ["type", "disabled", "readOnly", "onFocus", "onBlur", "className", "initialValue", "onChange", "value", "placeholder", "resize"];







var resizeTypes = (0,prop_types/* tuple */.b)('none', 'both', 'horizontal', 'vertical', 'initial', 'inherit');
var defaultProps = {
  initialValue: '',
  type: 'default',
  disabled: false,
  readOnly: false,
  className: '',
  resize: 'none'
};
var TextareaComponent = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var type = _ref.type,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      className = _ref.className,
      initialValue = _ref.initialValue,
      onChange = _ref.onChange,
      value = _ref.value,
      placeholder = _ref.placeholder,
      resize = _ref.resize,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,use_theme/* default */.Z)();

  var _useScale = (0,use_scale/* default */.ZP)(),
      SCALES = _useScale.SCALES;

  var textareaRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, function () {
    return textareaRef.current;
  });
  var isControlledComponent = (0,react.useMemo)(function () {
    return value !== undefined;
  }, [value]);

  var _useState = (0,react.useState)(initialValue),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selfValue = _useState2[0],
      setSelfValue = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1];

  var _useMemo = (0,react.useMemo)(function () {
    return (0,styles/* getColors */.E)(theme.palette, type);
  }, [theme.palette, type]),
      color = _useMemo.color,
      borderColor = _useMemo.borderColor,
      hoverBorder = _useMemo.hoverBorder;

  var classes = (0,use_classes/* default */.Z)('wrapper', {
    hover: hover,
    disabled: disabled
  }, className);

  var changeHandler = function changeHandler(event) {
    if (disabled || readOnly) return;
    setSelfValue(event.target.value);
    onChange && onChange(event);
  };

  var focusHandler = function focusHandler(e) {
    setHover(true);
    onFocus && onFocus(e);
  };

  var blurHandler = function blurHandler(e) {
    setHover(false);
    onBlur && onBlur(e);
  };

  (0,react.useEffect)(function () {
    if (isControlledComponent) {
      setSelfValue(value);
    }
  });
  var controlledValue = isControlledComponent ? {
    value: selfValue
  } : {
    defaultValue: initialValue
  };

  var textareaProps = (0,esm_extends/* default */.Z)({}, props, controlledValue);

  return /*#__PURE__*/react.createElement("div", {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["12276481", [theme.layout.radius, borderColor, color, SCALES.font(0.875), SCALES.height(1, 'auto'), SCALES.width(1, 'initial'), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), hoverBorder, theme.palette.accents_1, theme.palette.accents_2, theme.font.sans, SCALES.pt(0.5), SCALES.pr(0.5), SCALES.pb(0.5), SCALES.pl(0.5), resize, theme.palette.background]]]) + " " + (classes || "")
  }, /*#__PURE__*/react.createElement("textarea", (0,esm_extends/* default */.Z)({
    ref: textareaRef,
    disabled: disabled,
    placeholder: placeholder,
    readOnly: readOnly,
    onFocus: focusHandler,
    onBlur: blurHandler,
    onChange: changeHandler
  }, textareaProps, {
    className: styled_jsx_es/* default.dynamic */.ZP.dynamic([["12276481", [theme.layout.radius, borderColor, color, SCALES.font(0.875), SCALES.height(1, 'auto'), SCALES.width(1, 'initial'), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), hoverBorder, theme.palette.accents_1, theme.palette.accents_2, theme.font.sans, SCALES.pt(0.5), SCALES.pr(0.5), SCALES.pb(0.5), SCALES.pl(0.5), resize, theme.palette.background]]]) + " " + (textareaProps && textareaProps.className != null && textareaProps.className || "")
  })), /*#__PURE__*/react.createElement(styled_jsx_es/* default */.ZP, {
    id: "12276481",
    dynamic: [theme.layout.radius, borderColor, color, SCALES.font(0.875), SCALES.height(1, 'auto'), SCALES.width(1, 'initial'), SCALES.mt(0), SCALES.mr(0), SCALES.mb(0), SCALES.ml(0), hoverBorder, theme.palette.accents_1, theme.palette.accents_2, theme.font.sans, SCALES.pt(0.5), SCALES.pr(0.5), SCALES.pb(0.5), SCALES.pl(0.5), resize, theme.palette.background]
  }, ".wrapper.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-radius:".concat(theme.layout.radius, ";border:1px solid ").concat(borderColor, ";color:").concat(color, ";-webkit-transition:border 0.2s ease 0s,color 0.2s ease 0s;transition:border 0.2s ease 0s,color 0.2s ease 0s;min-width:12.5rem;max-width:95vw;--textarea-font-size:").concat(SCALES.font(0.875), ";--textarea-height:").concat(SCALES.height(1, 'auto'), ";width:").concat(SCALES.width(1, 'initial'), ";height:var(--textarea-height);margin:").concat(SCALES.mt(0), " ").concat(SCALES.mr(0), " ").concat(SCALES.mb(0), " ").concat(SCALES.ml(0), ";}.wrapper.hover.__jsx-style-dynamic-selector{border-color:").concat(hoverBorder, ";}.wrapper.disabled.__jsx-style-dynamic-selector{background-color:").concat(theme.palette.accents_1, ";border-color:").concat(theme.palette.accents_2, ";cursor:not-allowed;}textarea.__jsx-style-dynamic-selector{background-color:transparent;box-shadow:none;display:block;font-family:").concat(theme.font.sans, ";font-size:var(--textarea-font-size);width:100%;height:var(--textarea-height);border:none;outline:none;padding:").concat(SCALES.pt(0.5), " ").concat(SCALES.pr(0.5), " ").concat(SCALES.pb(0.5), " ").concat(SCALES.pl(0.5), ";resize:").concat(resize, ";}.disabled.__jsx-style-dynamic-selector>textarea.__jsx-style-dynamic-selector{cursor:not-allowed;}textarea.__jsx-style-dynamic-selector:-webkit-autofill,textarea.__jsx-style-dynamic-selector:-webkit-autofill.__jsx-style-dynamic-selector:hover,textarea.__jsx-style-dynamic-selector:-webkit-autofill.__jsx-style-dynamic-selector:active,textarea.__jsx-style-dynamic-selector:-webkit-autofill.__jsx-style-dynamic-selector:focus{-webkit-box-shadow:0 0 0 30px ").concat(theme.palette.background, " inset !important;}")));
});
TextareaComponent.defaultProps = defaultProps;
TextareaComponent.displayName = 'GeistTextarea';
var Textarea = (0,with_scale/* default */.Z)(TextareaComponent);
/* harmony default export */ var textarea_textarea = (Textarea);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/textarea/index.js

/* harmony default export */ var esm_textarea = (textarea_textarea);

/***/ }),

/***/ 6454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _themes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5736);

/* harmony default export */ __webpack_exports__["Z"] = (_themes__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP);

/***/ }),

/***/ 5736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ themes_themes; }
});

// UNUSED EXPORTS: deepDuplicable, isObject

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(1002);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/themes/presets/shared.js
var defaultFont = {
  sans: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  mono: 'Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace',
  prism: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,"Liberation Mono", "Courier New", monospace'
};
var defaultBreakpoints = {
  xs: {
    min: '0',
    max: '650px'
  },
  sm: {
    min: '650px',
    max: '900px'
  },
  md: {
    min: '900px',
    max: '1280px'
  },
  lg: {
    min: '1280px',
    max: '1920px'
  },
  xl: {
    min: '1920px',
    max: '10000px'
  }
};
var defaultLayout = {
  gap: '16pt',
  gapNegative: '-16pt',
  gapHalf: '8pt',
  gapHalfNegative: '-8pt',
  gapQuarter: '4pt',
  gapQuarterNegative: '-4pt',
  pageMargin: '16pt',
  pageWidth: '750pt',
  pageWidthWithMargin: '782pt',
  breakpointMobile: defaultBreakpoints.xs.max,
  breakpointTablet: defaultBreakpoints.sm.max,
  radius: '6px',
  unit: '16px'
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/themes/presets/default.js

var palette = {
  accents_1: '#fafafa',
  accents_2: '#eaeaea',
  accents_3: '#999',
  accents_4: '#888',
  accents_5: '#666',
  accents_6: '#444',
  accents_7: '#333',
  accents_8: '#111',
  background: '#fff',
  foreground: '#000',
  selection: '#79ffe1',
  secondary: '#666',
  code: '#f81ce5',
  border: '#eaeaea',
  error: '#e00',
  errorLight: '#ff1a1a',
  errorLighter: '#f7d4d6',
  errorDark: '#c50000',
  success: '#0070f3',
  successLight: '#3291ff',
  successLighter: '#d3e5ff',
  successDark: '#0761d1',
  warning: '#f5a623',
  warningLight: '#f7b955',
  warningLighter: '#ffefcf',
  warningDark: '#ab570a',
  cyan: '#50e3c2',
  cyanLighter: '#aaffec',
  cyanLight: '#79ffe1',
  cyanDark: '#29bc9b',
  violet: '#7928ca',
  violetLighter: '#e3d7fc',
  violetLight: '#8a63d2',
  violetDark: '#4c2889',
  purple: '#f81ce5',
  alert: '#ff0080',
  magenta: '#eb367f',
  link: '#0070f3'
};
var expressiveness = {
  linkStyle: 'none',
  linkHoverStyle: 'none',
  dropdownBoxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.02)',
  scrollerStart: 'rgba(255, 255, 255, 1)',
  scrollerEnd: 'rgba(255, 255, 255, 0)',
  shadowSmall: '0 5px 10px rgba(0, 0, 0, 0.12)',
  shadowMedium: '0 8px 30px rgba(0, 0, 0, 0.12)',
  shadowLarge: '0 30px 60px rgba(0, 0, 0, 0.12)',
  portalOpacity: 0.25
};
var font = defaultFont;
var breakpoints = defaultBreakpoints;
var layout = defaultLayout;
var themes = {
  type: 'light',
  font: font,
  layout: layout,
  palette: palette,
  breakpoints: breakpoints,
  expressiveness: expressiveness
};
/* harmony default export */ var presets_default = (themes);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/themes/presets/dark.js

var dark_palette = {
  accents_1: '#111',
  accents_2: '#333',
  accents_3: '#444',
  accents_4: '#666',
  accents_5: '#888',
  accents_6: '#999',
  accents_7: '#eaeaea',
  accents_8: '#fafafa',
  background: '#000',
  foreground: '#fff',
  selection: '#f81ce5',
  secondary: '#888',
  code: '#79ffe1',
  border: '#333',
  error: '#e00',
  errorLighter: '#f7d4d6',
  errorLight: '#ff1a1a',
  errorDark: '#c50000',
  success: '#0070f3',
  successLighter: '#d3e5ff',
  successLight: '#3291ff',
  successDark: '#0761d1',
  warning: '#f5a623',
  warningLighter: '#ffefcf',
  warningLight: '#f7b955',
  warningDark: '#ab570a',
  cyan: '#50e3c2',
  cyanLighter: '#aaffec',
  cyanLight: '#79ffe1',
  cyanDark: '#29bc9b',
  violet: '#7928ca',
  violetLighter: '#e3d7fc',
  violetLight: '#8a63d2',
  violetDark: '#4c2889',
  purple: '#f81ce5',
  alert: '#ff0080',
  magenta: '#eb367f',
  link: '#3291ff'
};
var dark_expressiveness = {
  linkStyle: 'none',
  linkHoverStyle: 'none',
  dropdownBoxShadow: '0 0 0 1px #333',
  scrollerStart: 'rgba(255, 255, 255, 1)',
  scrollerEnd: 'rgba(255, 255, 255, 0)',
  shadowSmall: '0 0 0 1px #333',
  shadowMedium: '0 0 0 1px #333',
  shadowLarge: '0 0 0 1px #333',
  portalOpacity: 0.75
};
var dark_font = defaultFont;
var dark_breakpoints = defaultBreakpoints;
var dark_layout = defaultLayout;
var dark_themes = {
  type: 'dark',
  font: dark_font,
  layout: dark_layout,
  palette: dark_palette,
  breakpoints: dark_breakpoints,
  expressiveness: dark_expressiveness
};
/* harmony default export */ var dark = (dark_themes);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/themes/themes.js




var isObject = function isObject(target) {
  return target && (0,esm_typeof/* default */.Z)(target) === 'object';
};
var deepDuplicable = function deepDuplicable(source, target) {
  if (!isObject(target) || !isObject(source)) return source;
  var sourceKeys = Object.keys(source);
  var result = {};

  for (var _i = 0, _sourceKeys = sourceKeys; _i < _sourceKeys.length; _i++) {
    var key = _sourceKeys[_i];
    var sourceValue = source[key];
    var targetValue = target[key];

    if (Array.isArray(sourceValue) && Array.isArray(targetValue)) {
      result[key] = targetValue.concat(sourceValue);
    } else if (isObject(sourceValue) && isObject(targetValue)) {
      result[key] = deepDuplicable(sourceValue, (0,esm_extends/* default */.Z)({}, targetValue));
    } else if (targetValue) {
      result[key] = targetValue;
    } else {
      result[key] = sourceValue;
    }
  }

  return result;
};

var getPresets = function getPresets() {
  return [presets_default, dark];
};

var getPresetStaticTheme = function getPresetStaticTheme() {
  return presets_default;
};

var isAvailableThemeType = function isAvailableThemeType(type) {
  if (!type) return false;
  var presetThemes = getPresets();
  var hasType = presetThemes.find(function (theme) {
    return theme.type === type;
  });
  return !hasType;
};

var isPresetTheme = function isPresetTheme(themeOrType) {
  if (!themeOrType) return false;
  var isType = typeof themeOrType === 'string';
  var type = isType ? themeOrType : themeOrType.type;
  return !isAvailableThemeType(type);
};

var hasUserCustomTheme = function hasUserCustomTheme() {
  var themes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return !!themes.find(function (item) {
    return isAvailableThemeType(item.type);
  });
};

var create = function create(base, custom) {
  if (!isAvailableThemeType(custom.type)) {
    throw new Error('Duplicate or unavailable theme type');
  }

  return deepDuplicable(base, custom);
};

var createFromDark = function createFromDark(custom) {
  return create(dark, custom);
};

var createFromLight = function createFromLight(custom) {
  return create(presets_default, custom);
};

var Themes = {
  isPresetTheme: isPresetTheme,
  isAvailableThemeType: isAvailableThemeType,
  hasUserCustomTheme: hasUserCustomTheme,
  getPresets: getPresets,
  getPresetStaticTheme: getPresetStaticTheme,
  create: create,
  createFromDark: createFromDark,
  createFromLight: createFromLight
};
/* harmony default export */ var themes_themes = (Themes);

/***/ }),

/***/ 8931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_use_classes; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(1002);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-classes/use-classes.js


var classObjectToString = function classObjectToString(className) {
  var keys = Object.keys(className);
  var len = keys.length;
  var str = '';

  for (var index = 0; index < len; index++) {
    var key = keys[index];
    var val = className[keys[index]];
    if (!val) continue;
    str = str ? "".concat(str, " ").concat(String(key)) : String(key);
  }

  return str;
};

var isObjectClassName = function isObjectClassName(value) {
  return (0,esm_typeof/* default */.Z)(value) === 'object' && !Array.isArray(value);
};

var useClasses = function useClasses() {
  var len = arguments.length;
  var classes = '';
  if (len === 0) return classes;

  for (var index = 0; index < len; index++) {
    var val = index < 0 || arguments.length <= index ? undefined : arguments[index];
    if (!val) continue;

    if (isObjectClassName(val)) {
      classes += " ".concat(classObjectToString(val));
    } else {
      classes += " ".concat(String(val).trim());
    }
  }

  return classes.trim();
};

/* harmony default export */ var use_classes = (useClasses);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-classes/index.js

/* harmony default export */ var esm_use_classes = (use_classes);

/***/ }),

/***/ 7295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_use_clipboard; }
});

// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-portal.js + 1 modules
var use_portal = __webpack_require__(4123);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-warning.js
var use_warning = __webpack_require__(1421);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-clipboard/use-clipboard.js



var defaultOptions = {
  onError: function onError() {
    return (0,use_warning/* default */.Z)('Failed to copy.', 'use-clipboard');
  }
};

var useClipboard = function useClipboard() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var el = (0,use_portal/* default */.Z)('clipboard');

  var copyText = function copyText(el, text) {
    if (!el || !text) return;
    var selection = window.getSelection();
    if (!selection) return;
    el.style.whiteSpace = 'pre';
    el.textContent = text;
    var range = window.document.createRange();
    selection.removeAllRanges();
    range.selectNode(el);
    selection.addRange(range);

    try {
      window.document.execCommand('copy');
    } catch (e) {
      options.onError && options.onError();
    }

    selection.removeAllRanges();

    if (el) {
      el.textContent = '';
    }
  };

  var copy = (0,react.useCallback)(function (text) {
    copyText(el, text);
  }, [el]);
  return {
    copy: copy
  };
};

/* harmony default export */ var use_clipboard = (useClipboard);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-clipboard/index.js

/* harmony default export */ var esm_use_clipboard = (use_clipboard);

/***/ }),

/***/ 7513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ KeyMod; },
/* harmony export */   "V": function() { return /* binding */ KeyCode; }
/* harmony export */ });
/**
 * KeyBinding Codes
 * The content of this file is based on the design of the open source project "microsoft/vscode",
 *   Copyright (c) Microsoft Corporation. All rights reserved.
 *
 * We inherit the KeyMod values from "microsoft/vscode",
 * but use the Browser's KeyboardEvent event implementation, and all values are used only as identification.
 */
var KeyCode;

(function (KeyCode) {
  KeyCode[KeyCode["Unknown"] = 0] = "Unknown";
  KeyCode[KeyCode["Backspace"] = 8] = "Backspace";
  KeyCode[KeyCode["Tab"] = 9] = "Tab";
  KeyCode[KeyCode["Enter"] = 13] = "Enter";
  KeyCode[KeyCode["Shift"] = 16] = "Shift";
  KeyCode[KeyCode["Ctrl"] = 17] = "Ctrl";
  KeyCode[KeyCode["Alt"] = 18] = "Alt";
  KeyCode[KeyCode["PauseBreak"] = 19] = "PauseBreak";
  KeyCode[KeyCode["CapsLock"] = 20] = "CapsLock";
  KeyCode[KeyCode["Escape"] = 27] = "Escape";
  KeyCode[KeyCode["Space"] = 32] = "Space";
  KeyCode[KeyCode["PageUp"] = 33] = "PageUp";
  KeyCode[KeyCode["PageDown"] = 34] = "PageDown";
  KeyCode[KeyCode["End"] = 35] = "End";
  KeyCode[KeyCode["Home"] = 36] = "Home";
  KeyCode[KeyCode["LeftArrow"] = 37] = "LeftArrow";
  KeyCode[KeyCode["UpArrow"] = 38] = "UpArrow";
  KeyCode[KeyCode["RightArrow"] = 39] = "RightArrow";
  KeyCode[KeyCode["DownArrow"] = 40] = "DownArrow";
  KeyCode[KeyCode["Insert"] = 45] = "Insert";
  KeyCode[KeyCode["Delete"] = 46] = "Delete";
  KeyCode[KeyCode["KEY_0"] = 48] = "KEY_0";
  KeyCode[KeyCode["KEY_1"] = 49] = "KEY_1";
  KeyCode[KeyCode["KEY_2"] = 50] = "KEY_2";
  KeyCode[KeyCode["KEY_3"] = 51] = "KEY_3";
  KeyCode[KeyCode["KEY_4"] = 52] = "KEY_4";
  KeyCode[KeyCode["KEY_5"] = 53] = "KEY_5";
  KeyCode[KeyCode["KEY_6"] = 54] = "KEY_6";
  KeyCode[KeyCode["KEY_7"] = 55] = "KEY_7";
  KeyCode[KeyCode["KEY_8"] = 56] = "KEY_8";
  KeyCode[KeyCode["KEY_9"] = 57] = "KEY_9";
  KeyCode[KeyCode["KEY_A"] = 65] = "KEY_A";
  KeyCode[KeyCode["KEY_B"] = 66] = "KEY_B";
  KeyCode[KeyCode["KEY_C"] = 67] = "KEY_C";
  KeyCode[KeyCode["KEY_D"] = 68] = "KEY_D";
  KeyCode[KeyCode["KEY_E"] = 69] = "KEY_E";
  KeyCode[KeyCode["KEY_F"] = 70] = "KEY_F";
  KeyCode[KeyCode["KEY_G"] = 71] = "KEY_G";
  KeyCode[KeyCode["KEY_H"] = 72] = "KEY_H";
  KeyCode[KeyCode["KEY_I"] = 73] = "KEY_I";
  KeyCode[KeyCode["KEY_J"] = 74] = "KEY_J";
  KeyCode[KeyCode["KEY_K"] = 75] = "KEY_K";
  KeyCode[KeyCode["KEY_L"] = 76] = "KEY_L";
  KeyCode[KeyCode["KEY_M"] = 77] = "KEY_M";
  KeyCode[KeyCode["KEY_N"] = 78] = "KEY_N";
  KeyCode[KeyCode["KEY_O"] = 79] = "KEY_O";
  KeyCode[KeyCode["KEY_P"] = 80] = "KEY_P";
  KeyCode[KeyCode["KEY_Q"] = 81] = "KEY_Q";
  KeyCode[KeyCode["KEY_R"] = 82] = "KEY_R";
  KeyCode[KeyCode["KEY_S"] = 83] = "KEY_S";
  KeyCode[KeyCode["KEY_T"] = 84] = "KEY_T";
  KeyCode[KeyCode["KEY_U"] = 85] = "KEY_U";
  KeyCode[KeyCode["KEY_V"] = 86] = "KEY_V";
  KeyCode[KeyCode["KEY_W"] = 87] = "KEY_W";
  KeyCode[KeyCode["KEY_X"] = 88] = "KEY_X";
  KeyCode[KeyCode["KEY_Y"] = 89] = "KEY_Y";
  KeyCode[KeyCode["KEY_Z"] = 90] = "KEY_Z";
  KeyCode[KeyCode["Meta"] = 91] = "Meta";
  KeyCode[KeyCode["F1"] = 112] = "F1";
  KeyCode[KeyCode["F2"] = 113] = "F2";
  KeyCode[KeyCode["F3"] = 114] = "F3";
  KeyCode[KeyCode["F4"] = 115] = "F4";
  KeyCode[KeyCode["F5"] = 116] = "F5";
  KeyCode[KeyCode["F6"] = 117] = "F6";
  KeyCode[KeyCode["F7"] = 118] = "F7";
  KeyCode[KeyCode["F8"] = 119] = "F8";
  KeyCode[KeyCode["F9"] = 120] = "F9";
  KeyCode[KeyCode["F10"] = 121] = "F10";
  KeyCode[KeyCode["F11"] = 122] = "F11";
  KeyCode[KeyCode["F12"] = 123] = "F12";
  KeyCode[KeyCode["NumLock"] = 144] = "NumLock";
  KeyCode[KeyCode["ScrollLock"] = 145] = "ScrollLock";
  KeyCode[KeyCode["Equal"] = 187] = "Equal";
  KeyCode[KeyCode["Minus"] = 189] = "Minus";
  KeyCode[KeyCode["Backquote"] = 192] = "Backquote";
  KeyCode[KeyCode["Backslash"] = 220] = "Backslash";
})(KeyCode || (KeyCode = {}));

var KeyMod;

(function (KeyMod) {
  KeyMod[KeyMod["CtrlCmd"] = 2048] = "CtrlCmd";
  KeyMod[KeyMod["Shift"] = 1024] = "Shift";
  KeyMod[KeyMod["Alt"] = 512] = "Alt";
  KeyMod[KeyMod["WinCtrl"] = 256] = "WinCtrl";
})(KeyMod || (KeyMod = {}));

/***/ }),

/***/ 2631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_use_keyboard; }
});

// UNUSED EXPORTS: KeyCode, KeyMod

// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-keyboard/codes.js
var codes = __webpack_require__(7513);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/collections.js
var collections = __webpack_require__(9265);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-keyboard/helper.js


/* istanbul ignore next */

var getCtrlKeysByPlatform = function getCtrlKeysByPlatform() {
  return {
    CtrlCmd: (0,collections/* isMac */.V5)() ? 'metaKey' : 'ctrlKey',
    WinCtrl: (0,collections/* isMac */.V5)() ? 'ctrlKey' : 'metaKey'
  };
};
var getActiveModMap = function getActiveModMap(bindings) {
  var modBindings = bindings.filter(function (item) {
    return !!codes/* KeyMod */.D[item];
  });
  var activeModMap = {
    CtrlCmd: false,
    Shift: false,
    Alt: false,
    WinCtrl: false
  };
  modBindings.forEach(function (code) {
    var modKey = codes/* KeyMod */.D[code];
    activeModMap[modKey] = true;
  });
  return activeModMap;
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-keyboard/use-keyboard.js




var useKeyboard = function useKeyboard(handler, keyBindings) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var bindings = Array.isArray(keyBindings) ? keyBindings : [keyBindings];
  var _options$disableGloba = options.disableGlobalEvent,
      disableGlobalEvent = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$capture = options.capture,
      capture = _options$capture === void 0 ? false : _options$capture,
      _options$stopPropagat = options.stopPropagation,
      stopPropagation = _options$stopPropagat === void 0 ? false : _options$stopPropagat,
      _options$preventDefau = options.preventDefault,
      preventDefault = _options$preventDefau === void 0 ? true : _options$preventDefau,
      _options$event = options.event,
      event = _options$event === void 0 ? 'keydown' : _options$event;
  var activeModMap = getActiveModMap(bindings);
  var keyCode = bindings.filter(function (item) {
    return !codes/* KeyMod */.D[item];
  });

  var _getCtrlKeysByPlatfor = getCtrlKeysByPlatform(),
      CtrlCmd = _getCtrlKeysByPlatfor.CtrlCmd,
      WinCtrl = _getCtrlKeysByPlatfor.WinCtrl;

  var eventHandler = function eventHandler(event) {
    if (activeModMap.Shift && !event.shiftKey) return;
    if (activeModMap.Alt && !event.altKey) return;
    if (activeModMap.CtrlCmd && !event[CtrlCmd]) return;
    if (activeModMap.WinCtrl && !event[WinCtrl]) return;
    var hitOne = keyCode.find(function (k) {
      return k === event.keyCode;
    });
    if (keyCode && !hitOne) return;

    if (stopPropagation) {
      event.stopPropagation();
    }

    if (preventDefault) {
      event.preventDefault();
    }

    handler && handler(event);
  };

  (0,react.useEffect)(function () {
    if (!disableGlobalEvent) {
      document.addEventListener(event, eventHandler);
    }

    return function () {
      document.removeEventListener(event, eventHandler);
    };
  }, [disableGlobalEvent]);

  var elementBindingHandler = function elementBindingHandler(elementEventType) {
    var isCapture = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (elementEventType !== event) return function () {};
    if (isCapture !== capture) return function () {};
    return function (e) {
      return eventHandler(e);
    };
  };

  return {
    bindings: {
      onKeyDown: elementBindingHandler('keydown'),
      onKeyDownCapture: elementBindingHandler('keydown', true),
      onKeyPress: elementBindingHandler('keypress'),
      onKeyPressCapture: elementBindingHandler('keypress', true),
      onKeyUp: elementBindingHandler('keyup'),
      onKeyUpCapture: elementBindingHandler('keyup', true)
    }
  };
};

/* harmony default export */ var use_keyboard = (useKeyboard);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-keyboard/index.js



/* harmony default export */ var esm_use_keyboard = (use_keyboard);

/***/ }),

/***/ 8114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_use_media_query; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/prop-types.js
var prop_types = __webpack_require__(1139);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-media-query/use-media-query.js




var breakpoints = (0,prop_types/* tuple */.b)('xs', 'sm', 'md', 'lg', 'xl', 'mobile');
var matchType = (0,prop_types/* tuple */.b)('up', 'down', 'default');
var defaultResponsiveOptions = {
  match: 'default'
};

var makeQueries = function makeQueries(bp, up, down) {
  var queryString = function queryString(item) {
    var upQuery = "(min-width: ".concat(item.min, ")");
    var downQuery = "(max-width: ".concat(item.max, ")");
    return up ? upQuery : down ? downQuery : "".concat(upQuery, " and ").concat(downQuery);
  };

  var xs = queryString(bp.xs);
  return {
    xs: xs,
    mobile: xs,
    sm: queryString(bp.sm),
    md: queryString(bp.md),
    lg: queryString(bp.lg),
    xl: queryString(bp.xl)
  };
};

var useMediaQuery = function useMediaQuery(breakpoint) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultResponsiveOptions;
  var _options$match = options.match,
      matchType = _options$match === void 0 ? 'default' : _options$match,
      _options$ssrMatchMedi = options.ssrMatchMedia,
      ssrMatchMedia = _options$ssrMatchMedi === void 0 ? null : _options$ssrMatchMedi;
  var supportMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  var theme = (0,use_theme/* default */.Z)();
  var mediaQueries = (0,react.useMemo)(function () {
    var up = matchType === 'up';
    var down = matchType === 'down';
    return makeQueries(theme.breakpoints, up, down);
  }, [theme.breakpoints, options]);
  var query = (0,react.useMemo)(function () {
    return mediaQueries[breakpoint];
  }, [mediaQueries, breakpoint]);

  var matchQuery = function matchQuery(q) {
    return window.matchMedia(q);
  };
  /**
   * Do nothing in the server-side rendering.
   * If server match query fucntion is simulated, return user-defined value first.
   */


  var _useState = (0,react.useState)(function () {
    if (supportMedia) return matchQuery(query).matches;

    if (ssrMatchMedia && typeof ssrMatchMedia === 'function') {
      return ssrMatchMedia(query).matches;
    }

    return false;
  }),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  (0,react.useEffect)(function () {
    if (!supportMedia) return;
    var queryList = matchQuery(query);

    var update = function update() {
      return setState(matchQuery(query).matches);
    };

    update();
    /**
     * addListener is deprecated. EventTarget.addEventListener is recommended.
     * But in some old browsers, MediaQueryList does not inherit from EventTarget.
     */

    queryList.addListener(update);
    return function () {
      queryList.removeListener(update);
    };
  }, [supportMedia]);
  return state;
};

/* harmony default export */ var use_media_query = (useMediaQuery);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-media-query/index.js

/* harmony default export */ var esm_use_media_query = (use_media_query);

/***/ }),

/***/ 9768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_use_modal; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-current-state.js + 2 modules
var use_current_state = __webpack_require__(1052);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-modal/use-modal.js



var useModal = function useModal() {
  var initialVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useCurrentState = (0,use_current_state/* default */.Z)(initialVisible),
      _useCurrentState2 = (0,slicedToArray/* default */.Z)(_useCurrentState, 3),
      visible = _useCurrentState2[0],
      setVisible = _useCurrentState2[1],
      currentRef = _useCurrentState2[2];

  return {
    visible: visible,
    setVisible: setVisible,
    currentRef: currentRef,
    bindings: {
      visible: visible,
      onClose: function onClose() {
        return setVisible(false);
      }
    }
  };
};

/* harmony default export */ var use_modal = (useModal);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-modal/index.js

/* harmony default export */ var esm_use_modal = (use_modal);

/***/ }),

/***/ 7243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _scale_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5934);




/* harmony default export */ __webpack_exports__["ZP"] = (_scale_context__WEBPACK_IMPORTED_MODULE_0__/* .useScale */ .TT);


/***/ }),

/***/ 5934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SY": function() { return /* binding */ ScaleContext; },
/* harmony export */   "TT": function() { return /* binding */ useScale; },
/* harmony export */   "pP": function() { return /* binding */ ScalePropKeys; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var ScalePropKeys = ['width', 'height', 'padding', 'margin', 'w', 'h', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'pl', 'pr', 'pt', 'pb', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'ml', 'mr', 'mt', 'mb', 'px', 'py', 'mx', 'my', 'font', 'unit', 'scale'];

var defaultDynamicLayoutPipe = function defaultDynamicLayoutPipe(scale1x) {
  return "".concat(scale1x);
};

var defaultContext = {
  getScaleProps: function getScaleProps() {
    return undefined;
  },
  getAllScaleProps: function getAllScaleProps() {
    return {};
  },
  SCALES: {
    pl: defaultDynamicLayoutPipe,
    pr: defaultDynamicLayoutPipe,
    pb: defaultDynamicLayoutPipe,
    pt: defaultDynamicLayoutPipe,
    px: defaultDynamicLayoutPipe,
    py: defaultDynamicLayoutPipe,
    mb: defaultDynamicLayoutPipe,
    ml: defaultDynamicLayoutPipe,
    mr: defaultDynamicLayoutPipe,
    mt: defaultDynamicLayoutPipe,
    mx: defaultDynamicLayoutPipe,
    my: defaultDynamicLayoutPipe,
    width: defaultDynamicLayoutPipe,
    height: defaultDynamicLayoutPipe,
    font: defaultDynamicLayoutPipe
  },
  unit: '16px'
};
var ScaleContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultContext);
var useScale = function useScale() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(ScaleContext);
};

/***/ }),

/***/ 3793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ with_scale; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-scale/scale-context.js
var scale_context = __webpack_require__(5934);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/use-theme/index.js
var use_theme = __webpack_require__(5711);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/collections.js
var collections = __webpack_require__(9265);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-scale/utils.js
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


var generateGetScaleProps = function generateGetScaleProps(props) {
  var getScaleProps = function getScaleProps(keyOrKeys) {
    if (!Array.isArray(keyOrKeys)) return props[keyOrKeys];
    var value = undefined;

    var _iterator = _createForOfIteratorHelper(keyOrKeys),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        var currentValue = props[key];

        if (typeof currentValue !== 'undefined') {
          value = currentValue;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return value;
  };

  return getScaleProps;
};
var generateGetAllScaleProps = function generateGetAllScaleProps(props) {
  var getAllScaleProps = function getAllScaleProps() {
    var scaleProps = {};

    var _iterator2 = _createForOfIteratorHelper(scale_context/* ScalePropKeys */.pP),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var key = _step2.value;
        var value = props[key];

        if (typeof value !== 'undefined') {
          scaleProps[key] = value;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return scaleProps;
  };

  return getAllScaleProps;
};
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-scale/with-scale.js


var _excluded = ["children"],
    _excluded2 = ["paddingLeft", "pl", "paddingRight", "pr", "paddingTop", "pt", "paddingBottom", "pb", "marginTop", "mt", "marginRight", "mr", "marginBottom", "mb", "marginLeft", "ml", "px", "py", "mx", "my", "width", "height", "font", "w", "h", "margin", "padding", "unit", "scale"];






var reduceScaleCoefficient = function reduceScaleCoefficient(scale) {
  if (scale === 1) return scale;
  var diff = Math.abs((scale - 1) / 2);
  return scale > 1 ? 1 + diff : 1 - diff;
};

var withScale = function withScale(Render) {
  var ScaleFC = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
    var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33;

    var children = _ref.children,
        props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

    var _useTheme = (0,use_theme/* default */.Z)(),
        layout = _useTheme.layout;

    var paddingLeft = props.paddingLeft,
        pl = props.pl,
        paddingRight = props.paddingRight,
        pr = props.pr,
        paddingTop = props.paddingTop,
        pt = props.pt,
        paddingBottom = props.paddingBottom,
        pb = props.pb,
        marginTop = props.marginTop,
        mt = props.mt,
        marginRight = props.marginRight,
        mr = props.mr,
        marginBottom = props.marginBottom,
        mb = props.mb,
        marginLeft = props.marginLeft,
        ml = props.ml,
        px = props.px,
        py = props.py,
        mx = props.mx,
        my = props.my,
        width = props.width,
        height = props.height,
        font = props.font,
        w = props.w,
        h = props.h,
        margin = props.margin,
        padding = props.padding,
        _props$unit = props.unit,
        unit = _props$unit === void 0 ? layout.unit : _props$unit,
        _props$scale = props.scale,
        scale = _props$scale === void 0 ? 1 : _props$scale,
        innerProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded2);

    var makeScaleHandler = function makeScaleHandler(attrValue) {
      return function (scale1x, defaultValue) {
        // 0 means disable scale and the default value is 0
        if (scale1x === 0) {
          scale1x = 1;
          defaultValue = defaultValue || 0;
        }

        var factor = reduceScaleCoefficient(scale) * scale1x;

        if (typeof attrValue === 'undefined') {
          if (typeof defaultValue !== 'undefined') return "".concat(defaultValue);
          return "calc(".concat(factor, " * ").concat(unit, ")");
        }

        if (!(0,collections/* isCSSNumberValue */.Yr)(attrValue)) return "".concat(attrValue);
        var customFactor = factor * Number(attrValue);
        return "calc(".concat(customFactor, " * ").concat(unit, ")");
      };
    };

    var value = {
      unit: unit,
      SCALES: {
        pt: makeScaleHandler((_ref2 = (_ref3 = paddingTop !== null && paddingTop !== void 0 ? paddingTop : pt) !== null && _ref3 !== void 0 ? _ref3 : py) !== null && _ref2 !== void 0 ? _ref2 : padding),
        pr: makeScaleHandler((_ref4 = (_ref5 = paddingRight !== null && paddingRight !== void 0 ? paddingRight : pr) !== null && _ref5 !== void 0 ? _ref5 : px) !== null && _ref4 !== void 0 ? _ref4 : padding),
        pb: makeScaleHandler((_ref6 = (_ref7 = paddingBottom !== null && paddingBottom !== void 0 ? paddingBottom : pb) !== null && _ref7 !== void 0 ? _ref7 : py) !== null && _ref6 !== void 0 ? _ref6 : padding),
        pl: makeScaleHandler((_ref8 = (_ref9 = paddingLeft !== null && paddingLeft !== void 0 ? paddingLeft : pl) !== null && _ref9 !== void 0 ? _ref9 : px) !== null && _ref8 !== void 0 ? _ref8 : padding),
        px: makeScaleHandler((_ref10 = (_ref11 = (_ref12 = (_ref13 = px !== null && px !== void 0 ? px : paddingLeft) !== null && _ref13 !== void 0 ? _ref13 : paddingRight) !== null && _ref12 !== void 0 ? _ref12 : pl) !== null && _ref11 !== void 0 ? _ref11 : pr) !== null && _ref10 !== void 0 ? _ref10 : padding),
        py: makeScaleHandler((_ref14 = (_ref15 = (_ref16 = (_ref17 = py !== null && py !== void 0 ? py : paddingTop) !== null && _ref17 !== void 0 ? _ref17 : paddingBottom) !== null && _ref16 !== void 0 ? _ref16 : pt) !== null && _ref15 !== void 0 ? _ref15 : pb) !== null && _ref14 !== void 0 ? _ref14 : padding),
        mt: makeScaleHandler((_ref18 = (_ref19 = marginTop !== null && marginTop !== void 0 ? marginTop : mt) !== null && _ref19 !== void 0 ? _ref19 : my) !== null && _ref18 !== void 0 ? _ref18 : margin),
        mr: makeScaleHandler((_ref20 = (_ref21 = marginRight !== null && marginRight !== void 0 ? marginRight : mr) !== null && _ref21 !== void 0 ? _ref21 : mx) !== null && _ref20 !== void 0 ? _ref20 : margin),
        mb: makeScaleHandler((_ref22 = (_ref23 = marginBottom !== null && marginBottom !== void 0 ? marginBottom : mb) !== null && _ref23 !== void 0 ? _ref23 : my) !== null && _ref22 !== void 0 ? _ref22 : margin),
        ml: makeScaleHandler((_ref24 = (_ref25 = marginLeft !== null && marginLeft !== void 0 ? marginLeft : ml) !== null && _ref25 !== void 0 ? _ref25 : mx) !== null && _ref24 !== void 0 ? _ref24 : margin),
        mx: makeScaleHandler((_ref26 = (_ref27 = (_ref28 = (_ref29 = mx !== null && mx !== void 0 ? mx : marginLeft) !== null && _ref29 !== void 0 ? _ref29 : marginRight) !== null && _ref28 !== void 0 ? _ref28 : ml) !== null && _ref27 !== void 0 ? _ref27 : mr) !== null && _ref26 !== void 0 ? _ref26 : margin),
        my: makeScaleHandler((_ref30 = (_ref31 = (_ref32 = (_ref33 = my !== null && my !== void 0 ? my : marginTop) !== null && _ref33 !== void 0 ? _ref33 : marginBottom) !== null && _ref32 !== void 0 ? _ref32 : mt) !== null && _ref31 !== void 0 ? _ref31 : mb) !== null && _ref30 !== void 0 ? _ref30 : margin),
        width: makeScaleHandler(width !== null && width !== void 0 ? width : w),
        height: makeScaleHandler(height !== null && height !== void 0 ? height : h),
        font: makeScaleHandler(font)
      },
      getScaleProps: generateGetScaleProps(props),
      getAllScaleProps: generateGetAllScaleProps(props)
    };
    return /*#__PURE__*/react.createElement(scale_context/* ScaleContext.Provider */.SY.Provider, {
      value: value
    }, /*#__PURE__*/react.createElement(Render, (0,esm_extends/* default */.Z)({}, innerProps, {
      ref: ref
    }), children));
  });
  ScaleFC.displayName = "Scale".concat(Render.displayName || 'Wrapper');
  return ScaleFC;
};

/* harmony default export */ var with_scale = (withScale);

/***/ }),

/***/ 5711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _theme_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3932);

/* harmony default export */ __webpack_exports__["Z"] = (_theme_context__WEBPACK_IMPORTED_MODULE_0__/* .useTheme */ .F);

/***/ }),

/***/ 3932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useTheme; },
/* harmony export */   "N": function() { return /* binding */ ThemeContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _themes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6454);


var defaultTheme = _themes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getPresetStaticTheme */ .Z.getPresetStaticTheme();
var ThemeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultTheme);
var useTheme = function useTheme() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(ThemeContext);
};

/***/ }),

/***/ 5668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_toasts; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(1451);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/use-geist-ui-context.js
var use_geist_ui_context = __webpack_require__(1108);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/collections.js
var collections = __webpack_require__(9265);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-toasts/use-toast.js





var defaultToast = {
  delay: 2000,
  type: 'default'
};

var useToasts = function useToasts(layout) {
  var _useGeistUIContext = (0,use_geist_ui_context/* useGeistUIContext */.kW)(),
      updateToasts = _useGeistUIContext.updateToasts,
      toasts = _useGeistUIContext.toasts,
      updateToastLayout = _useGeistUIContext.updateToastLayout,
      updateLastToastId = _useGeistUIContext.updateLastToastId;

  (0,react.useEffect)(function () {
    if (!layout) return;
    updateToastLayout(function () {
      return layout ? (0,esm_extends/* default */.Z)({}, use_geist_ui_context/* defaultToastLayout */.TP, layout) : use_geist_ui_context/* defaultToastLayout */.TP;
    });
  }, []);

  var cancel = function cancel(internalId) {
    updateToasts(function (currentToasts) {
      return currentToasts.map(function (item) {
        if (item._internalIdent !== internalId) return item;
        return (0,esm_extends/* default */.Z)({}, item, {
          visible: false
        });
      });
    });
    updateLastToastId(function () {
      return internalId;
    });
  };

  var removeAll = function removeAll() {
    updateToasts(function (last) {
      return last.map(function (toast) {
        return (0,esm_extends/* default */.Z)({}, toast, {
          visible: false
        });
      });
    });
  };

  var findToastOneByID = function findToastOneByID(id) {
    return toasts.find(function (t) {
      return t.id === id;
    });
  };

  var removeToastOneByID = function removeToastOneByID(id) {
    updateToasts(function (last) {
      return last.map(function (toast) {
        if (toast.id !== id) return toast;
        return (0,esm_extends/* default */.Z)({}, toast, {
          visible: false
        });
      });
    });
  };

  var setToast = function setToast(toast) {
    var internalIdent = "toast-".concat((0,collections/* getId */.zv)());
    var delay = toast.delay || defaultToast.delay;

    if (toast.id) {
      var hasIdent = toasts.find(function (t) {
        return t.id === toast.id;
      });

      if (hasIdent) {
        throw new Error('Toast: Already have the same key: "ident"');
      }
    }

    updateToasts(function (last) {
      var newToast = {
        delay: delay,
        text: toast.text,
        visible: true,
        type: toast.type || defaultToast.type,
        id: toast.id || internalIdent,
        actions: toast.actions || [],
        _internalIdent: internalIdent,
        _timeout: window.setTimeout(function () {
          cancel(internalIdent);

          if (newToast._timeout) {
            window.clearTimeout(newToast._timeout);
            newToast._timeout = null;
          }
        }, delay),
        cancel: function (_cancel) {
          function cancel() {
            return _cancel.apply(this, arguments);
          }

          cancel.toString = function () {
            return _cancel.toString();
          };

          return cancel;
        }(function () {
          return cancel(internalIdent);
        })
      };
      return [].concat((0,toConsumableArray/* default */.Z)(last), [newToast]);
    });
  };

  return {
    toasts: toasts,
    setToast: setToast,
    removeAll: removeAll,
    findToastOneByID: findToastOneByID,
    removeToastOneByID: removeToastOneByID
  };
};

/* harmony default export */ var use_toast = (useToasts);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-toasts/index.js

/* harmony default export */ var use_toasts = (use_toast);

/***/ }),

/***/ 9265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bv": function() { return /* binding */ isGeistElement; },
/* harmony export */   "CV": function() { return /* binding */ setChildrenIndex; },
/* harmony export */   "P4": function() { return /* binding */ getReactNode; },
/* harmony export */   "Tv": function() { return /* binding */ isChildElement; },
/* harmony export */   "V5": function() { return /* binding */ isMac; },
/* harmony export */   "Yr": function() { return /* binding */ isCSSNumberValue; },
/* harmony export */   "bJ": function() { return /* binding */ hasChild; },
/* harmony export */   "jG": function() { return /* binding */ pickChildByProps; },
/* harmony export */   "jU": function() { return /* binding */ isBrowser; },
/* harmony export */   "xC": function() { return /* binding */ pickChild; },
/* harmony export */   "zv": function() { return /* binding */ getId; }
/* harmony export */ });
/* unused harmony exports capitalize, pickChildrenFirst, setChildrenProps */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var getId = function getId() {
  return Math.random().toString(32).slice(2, 10);
};
var capitalize = function capitalize(str) {
  var safeStr = String(str).trim();
  return safeStr.charAt(0).toUpperCase() + safeStr.slice(1);
};
var hasChild = function hasChild(children, child) {
  var types = react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (item) {
    if (! /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(item)) return null;
    return item.type;
  });
  return (types || []).includes(child);
};
var pickChild = function pickChild(children, targetChild) {
  var target = [];
  var withoutTargetChildren = react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (item) {
    if (! /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(item)) return item;

    if (item.type === targetChild) {
      target.push(item);
      return null;
    }

    return item;
  });
  var targetChildren = target.length >= 0 ? target : undefined;
  return [withoutTargetChildren, targetChildren];
};
var pickChildByProps = function pickChildByProps(children, key, value) {
  var target = [];
  var isArray = Array.isArray(value);
  var withoutPropChildren = react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (item) {
    if (! /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(item)) return null;
    if (!item.props) return item;

    if (isArray) {
      if (value.includes(item.props[key])) {
        target.push(item);
        return null;
      }

      return item;
    }

    if (item.props[key] === value) {
      target.push(item);
      return null;
    }

    return item;
  });
  var targetChildren = target.length >= 0 ? target : undefined;
  return [withoutPropChildren, targetChildren];
};
var pickChildrenFirst = function pickChildrenFirst(children) {
  return React.Children.toArray(children)[0];
};
var setChildrenProps = function setChildrenProps(children, props) {
  var targetComponents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (React.Children.count(children) === 0) return [];
  var allowAll = targetComponents.length === 0;

  var clone = function clone(child) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return /*#__PURE__*/React.cloneElement(child, props);
  };

  return React.Children.map(children, function (item) {
    if (! /*#__PURE__*/React.isValidElement(item)) return item;
    if (allowAll) return clone(item, props);
    var isAllowed = targetComponents.find(function (child) {
      return child === item.type;
    });
    if (isAllowed) return clone(item, props);
    return item;
  });
};
var setChildrenIndex = function setChildrenIndex(children) {
  var targetComponents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (react__WEBPACK_IMPORTED_MODULE_0__.Children.count(children) === 0) return [];
  var allowAll = targetComponents.length === 0;

  var clone = function clone(child) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, props);
  };

  var index = 0;
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (item) {
    if (! /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(item)) return item;
    index = index + 1;
    if (allowAll) return clone(item, {
      index: index
    });
    var isAllowed = targetComponents.find(function (child) {
      return child === item.type;
    });
    if (isAllowed) return clone(item, {
      index: index
    });
    index = index - 1;
    return item;
  });
};
var getReactNode = function getReactNode(node) {
  if (!node) return null;
  if (typeof node !== 'function') return node;
  return node();
};
var isChildElement = function isChildElement(parent, child) {
  if (!parent || !child) return false;
  var node = child;

  while (node) {
    if (node === parent) return true;
    node = node.parentNode;
  }

  return false;
};
var isGeistElement = function isGeistElement(el) {
  if (!el) return false;
  if (el !== null && el !== void 0 && el.dataset && el !== null && el !== void 0 && el.dataset['geist']) return true;
  el.attributes.getNamedItem('data-geist');
  return !!el.attributes.getNamedItem('data-geist');
};
var isBrowser = function isBrowser() {
  return Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
};
var isMac = function isMac() {
  if (!isBrowser()) return false;
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
};
var isCSSNumberValue = function isCSSNumberValue(value) {
  return value !== undefined && !Number.isNaN(+value);
};

/***/ }),

/***/ 1185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ addColorAlpha; }
/* harmony export */ });
/* unused harmony export colorToRgbValues */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6854);


var hexToRgb = function hexToRgb(color) {
  var fullReg = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  var full = color.replace(fullReg, function (_, r, g, b) {
    return "".concat(r).concat(r).concat(g).concat(g).concat(b).concat(b);
  });
  var values = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(full);

  if (!values) {
    throw new Error("Geist UI: Unsupported ".concat(color, " color."));
  }

  return [Number.parseInt(values[1], 16), Number.parseInt(values[2], 16), Number.parseInt(values[3], 16)];
};

var colorToRgbValues = function colorToRgbValues(color) {
  if (color.charAt(0) === '#') return hexToRgb(color);
  var safeColor = color.replace(/ /g, '');
  var colorType = color.substr(0, 4);
  var regArray = safeColor.match(/\((.+)\)/);

  if (!colorType.startsWith('rgb') || !regArray) {
    console.log(color);
    throw new Error("Geist UI: Only support [\"RGB\", \"RGBA\", \"HEX\"] color.");
  }

  return regArray[1].split(',').map(function (str) {
    return Number.parseFloat(str);
  });
}; // @ts-ignore

var HSLToRGB = function HSLToRGB(h, s, l) {
  s /= 100;
  l /= 100; // @ts-ignore

  var k = function k(n) {
    return (n + h / 30) % 12;
  };

  var a = s * Math.min(l, 1 - l); // @ts-ignore

  var f = function f(n) {
    return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  };

  return [255 * f(0), 255 * f(8), 255 * f(4)];
};

var HSLStringToArray = function HSLStringToArray(hslString) {
  var hslArray = hslString.replace(/hsl\(|\)/g, '').split(',').map(function (str) {
    return Number.parseFloat(str);
  });
  return hslArray;
};

var addColorAlpha = function addColorAlpha(color, alpha) {
  if (!/^#|rgb|RGB/.test(color)) {
    var _HSLStringToArray = HSLStringToArray(color),
        _HSLStringToArray2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_HSLStringToArray, 3),
        h = _HSLStringToArray2[0],
        s = _HSLStringToArray2[1],
        l = _HSLStringToArray2[2];

    color = "rgba(".concat(HSLToRGB(h, s, l).join(','), ",").concat(alpha, ")");
  }

  var _colorToRgbValues = colorToRgbValues(color),
      _colorToRgbValues2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_colorToRgbValues, 3),
      r = _colorToRgbValues2[0],
      g = _colorToRgbValues2[1],
      b = _colorToRgbValues2[2];

  var safeAlpha = alpha > 1 ? 1 : alpha < 0 ? 0 : alpha;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(safeAlpha, ")");
};

/***/ }),

/***/ 726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EL": function() { return /* binding */ useRect; },
/* harmony export */   "eH": function() { return /* binding */ getRefRect; },
/* harmony export */   "ft": function() { return /* binding */ isUnplacedRect; }
/* harmony export */ });
/* unused harmony exports getElementOffset, getEventRect */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6854);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);



var getElementOffset = function getElementOffset(el) {
  if (!el) return {
    top: 0,
    left: 0
  };

  var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      left = _el$getBoundingClient.left;

  return {
    top: top,
    left: left
  };
};
var defaultRect = {
  top: -1000,
  left: -1000,
  right: -1000,
  width: 0,
  height: 0,
  elementTop: -1000
};

var getRectFromDOMWithContainer = function getRectFromDOMWithContainer(domRect, getContainer) {
  if (!domRect) return defaultRect;
  var container = getContainer ? getContainer() : null;
  var scrollElement = container || document.documentElement;

  var _getElementOffset = getElementOffset(container),
      offsetTop = _getElementOffset.top,
      offsetLeft = _getElementOffset.left;

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, domRect, {
    width: domRect.width || domRect.right - domRect.left,
    height: domRect.height || domRect.top - domRect.bottom,
    top: domRect.bottom + scrollElement.scrollTop - offsetTop,
    left: domRect.left + scrollElement.scrollLeft - offsetLeft,
    elementTop: domRect.top + scrollElement.scrollTop - offsetTop
  });
};

var isUnplacedRect = function isUnplacedRect(rect) {
  if (!rect) return true;
  return rect.top === defaultRect.top && rect.left === defaultRect.left;
};
var getRefRect = function getRefRect(ref, getContainer) {
  if (!ref || !ref.current) return defaultRect;
  var rect = ref.current.getBoundingClientRect();
  return getRectFromDOMWithContainer(rect, getContainer);
};
var getEventRect = function getEventRect(event, getContainer) {
  var _event$target;

  var rect = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.getBoundingClientRect();
  if (!rect) return defaultRect;
  return getRectFromDOMWithContainer(rect, getContainer);
};

var isRefTarget = function isRefTarget(eventOrRef) {
  return typeof (eventOrRef === null || eventOrRef === void 0 ? void 0 : eventOrRef.target) === 'undefined';
};

var useRect = function useRect(initialState) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState || defaultRect),
      _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_useState, 2),
      rect = _useState2[0],
      setRect = _useState2[1];

  var updateRect = function updateRect(eventOrRef, getContainer) {
    if (isRefTarget(eventOrRef)) return setRect(getRefRect(eventOrRef, getContainer));
    setRect(getEventRect(eventOrRef, getContainer));
  };

  return {
    rect: rect,
    setRect: updateRect
  };
};

/***/ }),

/***/ 1139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ tuple; }
/* harmony export */ });
/* unused harmony export tupleNumber */
var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};
var tupleNumber = function tupleNumber() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args;
};
var buttonTypes = tuple('default', 'secondary', 'success', 'warning', 'error', 'abort', 'secondary-light', 'success-light', 'warning-light', 'error-light');
var normalTypes = tuple('default', 'secondary', 'success', 'warning', 'error');
var snippetTypes = tuple('default', 'secondary', 'success', 'warning', 'error', 'dark', 'lite');
var cardTypes = tuple('default', 'secondary', 'success', 'warning', 'error', 'dark', 'lite', 'alert', 'purple', 'violet', 'cyan');
var copyTypes = tuple('default', 'silent', 'prevent');
var triggerTypes = tuple('hover', 'click');
var placement = tuple('top', 'topStart', 'topEnd', 'left', 'leftStart', 'leftEnd', 'bottom', 'bottomStart', 'bottomEnd', 'right', 'rightStart', 'rightEnd');
var dividerAlign = tuple('start', 'center', 'end', 'left', 'right');

/***/ }),

/***/ 6121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_use_body_scroll; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-body-scroll/use-body-scroll.js



var defaultOptions = {
  scrollLayer: false,
  delayReset: 0
};
var elementStack = new Map();

var getOwnerPaddingRight = function getOwnerPaddingRight(element) {
  var owner = (element === null || element === void 0 ? void 0 : element.ownerDocument) || document;
  var view = owner.defaultView || window;
  return Number.parseInt(view.getComputedStyle(element).paddingRight, 10) || 0;
};

var getOwnerScrollbarWidth = function getOwnerScrollbarWidth(element) {
  var doc = (element === null || element === void 0 ? void 0 : element.ownerDocument) || document;
  return Math.abs(window.innerWidth - doc.documentElement.clientWidth);
};

var useBodyScroll = function useBodyScroll(elementRef, options) {
  /* istanbul ignore next */
  if (typeof document === 'undefined') return [false, function (t) {
    return t;
  }];
  var elRef = elementRef || (0,react.useRef)(document.body);

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      hidden = _useState2[0],
      setHidden = _useState2[1];

  var safeOptions = (0,esm_extends/* default */.Z)({}, defaultOptions, options || {});

  (0,react.useEffect)(function () {
    if (!elRef || !elRef.current) return;
    var lastOverflow = elRef.current.style.overflow;

    if (hidden) {
      if (elementStack.has(elRef.current)) return;
      var paddingRight = getOwnerPaddingRight(elRef.current);
      var scrollbarWidth = getOwnerScrollbarWidth(elRef.current);
      elementStack.set(elRef.current, {
        overflow: lastOverflow,
        paddingRight: elRef.current.style.paddingRight
      });
      elRef.current.style.overflow = 'hidden';
      elRef.current.style.paddingRight = "".concat(paddingRight + scrollbarWidth, "px");
      return;
    } // reset element overflow


    if (!elementStack.has(elRef.current)) return;

    var reset = function reset(el) {
      var store = elementStack.get(el);
      if (!store) return;
      el.style.overflow = store.overflow;
      el.style.paddingRight = store.paddingRight;
      elementStack["delete"](el);
    };

    var timer = window.setTimeout(function () {
      reset(elRef.current);
      window.clearTimeout(timer);
    }, safeOptions.delayReset);
  }, [hidden, elRef]);
  return [hidden, setHidden];
};

/* harmony default export */ var use_body_scroll = (useBodyScroll);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-body-scroll/index.js

/* harmony default export */ var esm_use_body_scroll = (use_body_scroll);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/utils/use-body-scroll.js

/* harmony default export */ var utils_use_body_scroll = (esm_use_body_scroll);

/***/ }),

/***/ 895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


var useClickAnyWhere = function useClickAnyWhere(handler) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var callback = function callback(event) {
      return handler(event);
    };

    document.addEventListener('click', callback);
    return function () {
      return document.removeEventListener('click', callback);
    };
  }, [handler]);
};

/* harmony default export */ __webpack_exports__["Z"] = (useClickAnyWhere);

/***/ }),

/***/ 1052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_use_current_state; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-current-state/use-current-state.js



var useCurrentState = function useCurrentState(initialState) {
  var _useState = (0,react.useState)(function () {
    return typeof initialState === 'function' ? initialState() : initialState;
  }),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var ref = (0,react.useRef)(initialState);
  (0,react.useEffect)(function () {
    ref.current = state;
  }, [state]);

  var setValue = function setValue(val) {
    var result = typeof val === 'function' ? val(ref.current) : val;
    ref.current = result;
    setState(result);
  };

  return [state, setValue, ref];
};

/* harmony default export */ var use_current_state = (useCurrentState);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/use-current-state/index.js

/* harmony default export */ var esm_use_current_state = (use_current_state);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/utils/use-current-state.js

/* harmony default export */ var utils_use_current_state = (esm_use_current_state);

/***/ }),

/***/ 1108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TP": function() { return /* binding */ defaultToastLayout; },
/* harmony export */   "b2": function() { return /* binding */ GeistUIContent; },
/* harmony export */   "kW": function() { return /* binding */ useGeistUIContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var defaultToastLayout = {
  padding: '12px 16px',
  margin: '8px 0',
  width: '420px',
  maxWidth: '90vw',
  maxHeight: '75px',
  placement: 'bottomRight'
};
var defaultParams = {
  toasts: [],
  toastLayout: defaultToastLayout,
  updateToastLayout: function updateToastLayout(t) {
    return t;
  },
  updateToasts: function updateToasts(t) {
    return t;
  },
  lastUpdateToastId: null,
  updateLastToastId: function updateLastToastId() {
    return null;
  }
};
var GeistUIContent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultParams);
var useGeistUIContext = function useGeistUIContext() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(GeistUIContent);
};

/***/ }),

/***/ 4123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_portal; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6854);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/sparkl-ui/esm/utils/collections.js
var collections = __webpack_require__(9265);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/utils/use-ssr.js




var useSSR = function useSSR() {
  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      browser = _useState2[0],
      setBrowser = _useState2[1];

  (0,react.useEffect)(function () {
    setBrowser((0,collections/* isBrowser */.jU)());
  }, []);
  return {
    isBrowser: browser,
    isServer: !browser
  };
};

/* harmony default export */ var use_ssr = (useSSR);
;// CONCATENATED MODULE: ./node_modules/sparkl-ui/esm/utils/use-portal.js





var createElement = function createElement(id) {
  var el = document.createElement('div');
  el.setAttribute('id', id);
  return el;
};

var usePortal = function usePortal() {
  var selectId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0,collections/* getId */.zv)();
  var getContainer = arguments.length > 1 ? arguments[1] : undefined;
  var id = "geist-ui-".concat(selectId);

  var _useSSR = use_ssr(),
      isBrowser = _useSSR.isBrowser;

  var _useState = (0,react.useState)(isBrowser ? createElement(id) : null),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      elSnapshot = _useState2[0],
      setElSnapshot = _useState2[1];

  (0,react.useEffect)(function () {
    var customContainer = getContainer ? getContainer() : null;
    var parentElement = customContainer || document.body;
    var hasElement = parentElement.querySelector("#".concat(id));
    var el = hasElement || createElement(id);

    if (!hasElement) {
      parentElement.appendChild(el);
    }

    setElSnapshot(el);
  }, []);
  return elSnapshot;
};

/* harmony default export */ var use_portal = (usePortal);

/***/ }),

/***/ 4729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRealShape */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6854);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


var getRealShape = function getRealShape(el) {
  var defaultShape = {
    width: 0,
    height: 0
  };
  if (!el || typeof window === 'undefined') return defaultShape;
  var rect = el.getBoundingClientRect();

  var _window$getComputedSt = window.getComputedStyle(el),
      width = _window$getComputedSt.width,
      height = _window$getComputedSt.height;

  var getCSSStyleVal = function getCSSStyleVal(str, parentNum) {
    if (!str) return 0;
    var strVal = str.includes('px') ? +str.split('px')[0] : str.includes('%') ? +str.split('%')[0] * parentNum * 0.01 : str;
    return Number.isNaN(+strVal) ? 0 : +strVal;
  };

  return {
    width: getCSSStyleVal("".concat(width), rect.width),
    height: getCSSStyleVal("".concat(height), rect.height)
  };
};

var useRealShape = function useRealShape(ref) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    width: 0,
    height: 0
  }),
      _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var update = function update() {
    var _getRealShape = getRealShape(ref.current),
        width = _getRealShape.width,
        height = _getRealShape.height;

    setState({
      width: width,
      height: height
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return update();
  }, [ref.current]);
  return [state, update];
};

/* harmony default export */ __webpack_exports__["Z"] = (useRealShape);

/***/ }),

/***/ 6134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


var useResize = function useResize(callback) {
  var immediatelyInvoke = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var fn = function fn() {
      return callback();
    };

    if (immediatelyInvoke) {
      fn();
    }

    window.addEventListener('resize', fn);
    return function () {
      return window.removeEventListener('resize', fn);
    };
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useResize);

/***/ }),

/***/ 1421:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var warningStack = {};

var useWarning = function useWarning(message, component) {
  var tag = component ? " [".concat(component, "]") : ' ';
  var log = "[Geist UI]".concat(tag, ": ").concat(message);
  if (typeof console === 'undefined') return;
  if (warningStack[log]) return;
  warningStack[log] = true;

  if (false) {}

  console.warn(log);
};

/* harmony default export */ __webpack_exports__["Z"] = (useWarning);

/***/ }),

/***/ 4207:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(3454);
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 583:
/***/ (function(module) {



function hash(str) {
  var hash = 5381,
      i    = str.length;

  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}

module.exports = hash;


/***/ }),

/***/ 590:
/***/ (function(__unused_webpack_module, exports, __nccwpck_require__) {



exports.__esModule = true;
exports.computeId = computeId;
exports.computeSelector = computeSelector;

var _stringHash = _interopRequireDefault(__nccwpck_require__(583));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var sanitize = function sanitize(rule) {
  return rule.replace(/\/style/gi, '\\/style');
};

var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */

function computeId(baseId, props) {
  if (!props) {
    return "jsx-" + baseId;
  }

  var propsToString = String(props);
  var key = baseId + propsToString;

  if (!cache[key]) {
    cache[key] = "jsx-" + (0, _stringHash["default"])(baseId + "-" + propsToString);
  }

  return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */


function computeSelector(id, css) {
  var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g; // Sanitize SSR-ed CSS.
  // Client side code doesn't need to be sanitized since we use
  // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).

  if (typeof window === 'undefined') {
    css = sanitize(css);
  }

  var idcss = id + css;

  if (!cache[idcss]) {
    cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
  }

  return cache[idcss];
}

/***/ }),

/***/ 503:
/***/ (function(__unused_webpack_module, exports) {



exports.__esModule = true;
exports["default"] = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/
var isProd = typeof process !== 'undefined' && process.env && "production" === 'production';

var isString = function isString(o) {
  return Object.prototype.toString.call(o) === '[object String]';
};

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? 'stylesheet' : _ref$name,
        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
        optimizeForSpeed = _ref$optimizeForSpeed === void 0 ? isProd : _ref$optimizeForSpeed,
        _ref$isBrowser = _ref.isBrowser,
        isBrowser = _ref$isBrowser === void 0 ? typeof window !== 'undefined' : _ref$isBrowser;

    invariant(isString(name), '`name` must be a string');
    this._name = name;
    this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
    invariant(typeof optimizeForSpeed === 'boolean', '`optimizeForSpeed` must be a boolean');
    this._optimizeForSpeed = optimizeForSpeed;
    this._isBrowser = isBrowser;
    this._serverSheet = undefined;
    this._tags = [];
    this._injected = false;
    this._rulesCount = 0;
    var node = this._isBrowser && document.querySelector('meta[property="csp-nonce"]');
    this._nonce = node ? node.getAttribute('content') : null;
  }

  var _proto = StyleSheet.prototype;

  _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
    invariant(typeof bool === 'boolean', '`setOptimizeForSpeed` accepts a boolean');
    invariant(this._rulesCount === 0, 'optimizeForSpeed cannot be when rules have already been inserted');
    this.flush();
    this._optimizeForSpeed = bool;
    this.inject();
  };

  _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
    return this._optimizeForSpeed;
  };

  _proto.inject = function inject() {
    var _this = this;

    invariant(!this._injected, 'sheet already injected');
    this._injected = true;

    if (this._isBrowser && this._optimizeForSpeed) {
      this._tags[0] = this.makeStyleTag(this._name);
      this._optimizeForSpeed = 'insertRule' in this.getSheet();

      if (!this._optimizeForSpeed) {
        if (!isProd) {
          console.warn('StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.');
        }

        this.flush();
        this._injected = true;
      }

      return;
    }

    this._serverSheet = {
      cssRules: [],
      insertRule: function insertRule(rule, index) {
        if (typeof index === 'number') {
          _this._serverSheet.cssRules[index] = {
            cssText: rule
          };
        } else {
          _this._serverSheet.cssRules.push({
            cssText: rule
          });
        }

        return index;
      },
      deleteRule: function deleteRule(index) {
        _this._serverSheet.cssRules[index] = null;
      }
    };
  };

  _proto.getSheetForTag = function getSheetForTag(tag) {
    if (tag.sheet) {
      return tag.sheet;
    } // this weirdness brought to you by firefox


    for (var i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].ownerNode === tag) {
        return document.styleSheets[i];
      }
    }
  };

  _proto.getSheet = function getSheet() {
    return this.getSheetForTag(this._tags[this._tags.length - 1]);
  };

  _proto.insertRule = function insertRule(rule, index) {
    invariant(isString(rule), '`insertRule` accepts only strings');

    if (!this._isBrowser) {
      if (typeof index !== 'number') {
        index = this._serverSheet.cssRules.length;
      }

      this._serverSheet.insertRule(rule, index);

      return this._rulesCount++;
    }

    if (this._optimizeForSpeed) {
      var sheet = this.getSheet();

      if (typeof index !== 'number') {
        index = sheet.cssRules.length;
      } // this weirdness for perf, and chrome's weird bug
      // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule


      try {
        sheet.insertRule(rule, index);
      } catch (error) {
        if (!isProd) {
          console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
        }

        return -1;
      }
    } else {
      var insertionPoint = this._tags[index];

      this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
    }

    return this._rulesCount++;
  };

  _proto.replaceRule = function replaceRule(index, rule) {
    if (this._optimizeForSpeed || !this._isBrowser) {
      var sheet = this._isBrowser ? this.getSheet() : this._serverSheet;

      if (!rule.trim()) {
        rule = this._deletedRulePlaceholder;
      }

      if (!sheet.cssRules[index]) {
        // @TBD Should we throw an error?
        return index;
      }

      sheet.deleteRule(index);

      try {
        sheet.insertRule(rule, index);
      } catch (error) {
        if (!isProd) {
          console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
        } // In order to preserve the indices we insert a deleteRulePlaceholder


        sheet.insertRule(this._deletedRulePlaceholder, index);
      }
    } else {
      var tag = this._tags[index];
      invariant(tag, "old rule at index `" + index + "` not found");
      tag.textContent = rule;
    }

    return index;
  };

  _proto.deleteRule = function deleteRule(index) {
    if (!this._isBrowser) {
      this._serverSheet.deleteRule(index);

      return;
    }

    if (this._optimizeForSpeed) {
      this.replaceRule(index, '');
    } else {
      var tag = this._tags[index];
      invariant(tag, "rule at index `" + index + "` not found");
      tag.parentNode.removeChild(tag);
      this._tags[index] = null;
    }
  };

  _proto.flush = function flush() {
    this._injected = false;
    this._rulesCount = 0;

    if (this._isBrowser) {
      this._tags.forEach(function (tag) {
        return tag && tag.parentNode.removeChild(tag);
      });

      this._tags = [];
    } else {
      // simpler on server
      this._serverSheet.cssRules = [];
    }
  };

  _proto.cssRules = function cssRules() {
    var _this2 = this;

    if (!this._isBrowser) {
      return this._serverSheet.cssRules;
    }

    return this._tags.reduce(function (rules, tag) {
      if (tag) {
        rules = rules.concat(Array.prototype.map.call(_this2.getSheetForTag(tag).cssRules, function (rule) {
          return rule.cssText === _this2._deletedRulePlaceholder ? null : rule;
        }));
      } else {
        rules.push(null);
      }

      return rules;
    }, []);
  };

  _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
    if (cssString) {
      invariant(isString(cssString), 'makeStyleTag accepts only strings as second parameter');
    }

    var tag = document.createElement('style');
    if (this._nonce) tag.setAttribute('nonce', this._nonce);
    tag.type = 'text/css';
    tag.setAttribute("data-" + name, '');

    if (cssString) {
      tag.appendChild(document.createTextNode(cssString));
    }

    var head = document.head || document.getElementsByTagName('head')[0];

    if (relativeToTag) {
      head.insertBefore(tag, relativeToTag);
    } else {
      head.appendChild(tag);
    }

    return tag;
  };

  _createClass(StyleSheet, [{
    key: "length",
    get: function get() {
      return this._rulesCount;
    }
  }]);

  return StyleSheet;
}();

exports["default"] = StyleSheet;

function invariant(condition, message) {
  if (!condition) {
    throw new Error("StyleSheet: " + message + ".");
  }
}

/***/ }),

/***/ 449:
/***/ (function(__unused_webpack_module, exports, __nccwpck_require__) {



exports.__esModule = true;
exports["default"] = JSXStyle;

var _react = _interopRequireDefault(__nccwpck_require__(522));

var _stylesheetRegistry = __nccwpck_require__(147);

var _hash = __nccwpck_require__(590);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = _react["default"].useInsertionEffect || _react["default"].useLayoutEffect;
var defaultRegistry = typeof window !== 'undefined' ? (0, _stylesheetRegistry.createStyleRegistry)() : undefined;

function JSXStyle(props) {
  var registry = defaultRegistry ? defaultRegistry : (0, _stylesheetRegistry.useStyleRegistry)(); // If `registry` does not exist, we do nothing here.

  if (!registry) {
    return null;
  }

  if (typeof window === 'undefined') {
    registry.add(props);
    return null;
  }

  useInsertionEffect(function () {
    registry.add(props);
    return function () {
      registry.remove(props);
    }; // props.children can be string[], will be striped since id is identical
  }, [props.id, String(props.dynamic)]);
  return null;
}

JSXStyle.dynamic = function (info) {
  return info.map(function (tagInfo) {
    var baseId = tagInfo[0];
    var props = tagInfo[1];
    return (0, _hash.computeId)(baseId, props);
  }).join(' ');
};

/***/ }),

/***/ 147:
/***/ (function(__unused_webpack_module, exports, __nccwpck_require__) {



exports.__esModule = true;
exports.createStyleRegistry = createStyleRegistry;
exports.StyleRegistry = StyleRegistry;
exports.useStyleRegistry = useStyleRegistry;
exports.StyleSheetContext = exports.StyleSheetRegistry = void 0;

var _react = _interopRequireWildcard(__nccwpck_require__(522));

var _stylesheet = _interopRequireDefault(__nccwpck_require__(503));

var _hash = __nccwpck_require__(590);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function mapRulesToStyle(cssRules, options) {
  if (options === void 0) {
    options = {};
  }

  return cssRules.map(function (args) {
    var id = args[0];
    var css = args[1];
    return _react["default"].createElement('style', {
      id: "__" + id,
      // Avoid warnings upon render with a key
      key: "__" + id,
      nonce: options.nonce ? options.nonce : undefined,
      dangerouslySetInnerHTML: {
        __html: css
      }
    });
  });
}

var StyleSheetRegistry = /*#__PURE__*/function () {
  function StyleSheetRegistry(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$styleSheet = _ref.styleSheet,
        styleSheet = _ref$styleSheet === void 0 ? null : _ref$styleSheet,
        _ref$optimizeForSpeed = _ref.optimizeForSpeed,
        optimizeForSpeed = _ref$optimizeForSpeed === void 0 ? false : _ref$optimizeForSpeed,
        _ref$isBrowser = _ref.isBrowser,
        isBrowser = _ref$isBrowser === void 0 ? typeof window !== 'undefined' : _ref$isBrowser;

    this._sheet = styleSheet || new _stylesheet["default"]({
      name: 'styled-jsx',
      optimizeForSpeed: optimizeForSpeed
    });

    this._sheet.inject();

    if (styleSheet && typeof optimizeForSpeed === 'boolean') {
      this._sheet.setOptimizeForSpeed(optimizeForSpeed);

      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
    }

    this._isBrowser = isBrowser;
    this._fromServer = undefined;
    this._indices = {};
    this._instancesCounts = {};
  }

  var _proto = StyleSheetRegistry.prototype;

  _proto.add = function add(props) {
    var _this = this;

    if (undefined === this._optimizeForSpeed) {
      this._optimizeForSpeed = Array.isArray(props.children);

      this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);

      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
    }

    if (this._isBrowser && !this._fromServer) {
      this._fromServer = this.selectFromServer();
      this._instancesCounts = Object.keys(this._fromServer).reduce(function (acc, tagName) {
        acc[tagName] = 0;
        return acc;
      }, {});
    }

    var _this$getIdAndRules = this.getIdAndRules(props),
        styleId = _this$getIdAndRules.styleId,
        rules = _this$getIdAndRules.rules; // Deduping: just increase the instances count.


    if (styleId in this._instancesCounts) {
      this._instancesCounts[styleId] += 1;
      return;
    }

    var indices = rules.map(function (rule) {
      return _this._sheet.insertRule(rule);
    }) // Filter out invalid rules
    .filter(function (index) {
      return index !== -1;
    });
    this._indices[styleId] = indices;
    this._instancesCounts[styleId] = 1;
  };

  _proto.remove = function remove(props) {
    var _this2 = this;

    var _this$getIdAndRules2 = this.getIdAndRules(props),
        styleId = _this$getIdAndRules2.styleId;

    invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
    this._instancesCounts[styleId] -= 1;

    if (this._instancesCounts[styleId] < 1) {
      var tagFromServer = this._fromServer && this._fromServer[styleId];

      if (tagFromServer) {
        tagFromServer.parentNode.removeChild(tagFromServer);
        delete this._fromServer[styleId];
      } else {
        this._indices[styleId].forEach(function (index) {
          return _this2._sheet.deleteRule(index);
        });

        delete this._indices[styleId];
      }

      delete this._instancesCounts[styleId];
    }
  };

  _proto.update = function update(props, nextProps) {
    this.add(nextProps);
    this.remove(props);
  };

  _proto.flush = function flush() {
    this._sheet.flush();

    this._sheet.inject();

    this._fromServer = undefined;
    this._indices = {};
    this._instancesCounts = {};
  };

  _proto.cssRules = function cssRules() {
    var _this3 = this;

    var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function (styleId) {
      return [styleId, _this3._fromServer[styleId]];
    }) : [];

    var cssRules = this._sheet.cssRules();

    return fromServer.concat(Object.keys(this._indices).map(function (styleId) {
      return [styleId, _this3._indices[styleId].map(function (index) {
        return cssRules[index].cssText;
      }).join(_this3._optimizeForSpeed ? '' : '\n')];
    }) // filter out empty rules
    .filter(function (rule) {
      return Boolean(rule[1]);
    }));
  };

  _proto.styles = function styles(options) {
    return mapRulesToStyle(this.cssRules(), options);
  };

  _proto.getIdAndRules = function getIdAndRules(props) {
    var css = props.children,
        dynamic = props.dynamic,
        id = props.id;

    if (dynamic) {
      var styleId = (0, _hash.computeId)(id, dynamic);
      return {
        styleId: styleId,
        rules: Array.isArray(css) ? css.map(function (rule) {
          return (0, _hash.computeSelector)(styleId, rule);
        }) : [(0, _hash.computeSelector)(styleId, css)]
      };
    }

    return {
      styleId: (0, _hash.computeId)(id),
      rules: Array.isArray(css) ? css : [css]
    };
  }
  /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */
  ;

  _proto.selectFromServer = function selectFromServer() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
    return elements.reduce(function (acc, element) {
      var id = element.id.slice(2);
      acc[id] = element;
      return acc;
    }, {});
  };

  return StyleSheetRegistry;
}();

exports.StyleSheetRegistry = StyleSheetRegistry;

function invariant(condition, message) {
  if (!condition) {
    throw new Error("StyleSheetRegistry: " + message + ".");
  }
}

var StyleSheetContext = (0, _react.createContext)(null);
exports.StyleSheetContext = StyleSheetContext;

function createStyleRegistry() {
  return new StyleSheetRegistry();
}

function StyleRegistry(_ref2) {
  var configuredRegistry = _ref2.registry,
      children = _ref2.children;
  var rootRegistry = (0, _react.useContext)(StyleSheetContext);

  var _useState = (0, _react.useState)(function () {
    return rootRegistry || configuredRegistry || createStyleRegistry();
  }),
      registry = _useState[0];

  return _react["default"].createElement(StyleSheetContext.Provider, {
    value: registry
  }, children);
}

function useStyleRegistry() {
  return (0, _react.useContext)(StyleSheetContext);
}

/***/ }),

/***/ 522:
/***/ (function(module) {

module.exports = __webpack_require__(7294);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __nccwpck_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		var threw = true;
/******/ 		try {
/******/ 			__webpack_modules__[moduleId](module, module.exports, __nccwpck_require__);
/******/ 			threw = false;
/******/ 		} finally {
/******/ 			if(threw) delete __webpack_module_cache__[moduleId];
/******/ 		}
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat */
/******/ 	
/******/ 	if (typeof __nccwpck_require__ !== 'undefined') __nccwpck_require__.ab = __dirname + "/";
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
var exports = __webpack_exports__;


exports.__esModule = true;
exports.style = exports.useStyleRegistry = exports.createStyleRegistry = exports.StyleRegistry = void 0;

var _stylesheetRegistry = __nccwpck_require__(147);

exports.StyleRegistry = _stylesheetRegistry.StyleRegistry;
exports.createStyleRegistry = _stylesheetRegistry.createStyleRegistry;
exports.useStyleRegistry = _stylesheetRegistry.useStyleRegistry;

var _style = _interopRequireDefault(__nccwpck_require__(449));

exports.style = _style["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
}();
module.exports = __webpack_exports__;
/******/ })()
;

/***/ }),

/***/ 5988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(4207).style


/***/ }),

/***/ 8087:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
exports.q = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 3250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(7294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 1688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3250);
} else {}


/***/ }),

/***/ 3897:
/***/ (function(module) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 5372:
/***/ (function(module) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 6115:
/***/ (function(module) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 7156:
/***/ (function(module) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 6690:
/***/ (function(module) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(6015);

var isNativeReflectConstruct = __webpack_require__(9617);

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    module.exports = _construct = Reflect.construct.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
  } else {
    module.exports = _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) setPrototypeOf(instance, Class.prototype);
      return instance;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  }

  return _construct.apply(null, arguments);
}

module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 9728:
/***/ (function(module) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 8416:
/***/ (function(module) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 434:
/***/ (function(module) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3808:
/***/ (function(module) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(6015);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 4836:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 6035:
/***/ (function(module) {

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 9617:
/***/ (function(module) {

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 8872:
/***/ (function(module) {

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 2218:
/***/ (function(module) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(7071);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 7071:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 4993:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(8698)["default"]);

var assertThisInitialized = __webpack_require__(6115);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 7061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(8698)["default"]);

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 6015:
/***/ (function(module) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 7424:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(5372);

var iterableToArrayLimit = __webpack_require__(8872);

var unsupportedIterableToArray = __webpack_require__(6116);

var nonIterableRest = __webpack_require__(2218);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 8698:
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 6116:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(3897);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3496:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(3808);

var setPrototypeOf = __webpack_require__(6015);

var isNativeFunction = __webpack_require__(6035);

var construct = __webpack_require__(3515);

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return construct(Class, arguments, getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return setPrototypeOf(Wrapper, Class);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _wrapNativeSuper(Class);
}

module.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 4687:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(7061)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 7462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 91:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 6854:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 1451:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 1002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(907);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 7568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 4924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 6042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 9396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 9534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 1753:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ OBJECT; },
/* harmony export */   "BN": function() { return /* binding */ internalMutate; },
/* harmony export */   "DY": function() { return /* binding */ SWRGlobalState; },
/* harmony export */   "J$": function() { return /* binding */ SWRConfig; },
/* harmony export */   "JG": function() { return /* binding */ mutate; },
/* harmony export */   "JN": function() { return /* binding */ createCacheHelper; },
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "PM": function() { return /* binding */ mergeObjects; },
/* harmony export */   "W6": function() { return /* binding */ IS_SERVER; },
/* harmony export */   "i_": function() { return /* binding */ UNDEFINED; },
/* harmony export */   "ko": function() { return /* binding */ subscribeCallback; },
/* harmony export */   "kw": function() { return /* binding */ rAF; },
/* harmony export */   "mf": function() { return /* binding */ isFunction; },
/* harmony export */   "o8": function() { return /* binding */ isUndefined; },
/* harmony export */   "qC": function() { return /* binding */ serialize; },
/* harmony export */   "s6": function() { return /* binding */ withArgs; },
/* harmony export */   "sj": function() { return /* binding */ constants; },
/* harmony export */   "u3": function() { return /* binding */ getTimestamp; },
/* harmony export */   "u_": function() { return /* binding */ defaultConfig; },
/* harmony export */   "w6": function() { return /* binding */ IS_REACT_LEGACY; },
/* harmony export */   "xD": function() { return /* binding */ withMiddleware; }
/* harmony export */ });
/* unused harmony exports cache, compare, defaultConfigOptions, hasRequestAnimationFrame, initCache, isDocumentDefined, isWindowDefined, mergeConfigs, noop, normalize, preload, preset, slowConnection, stableHash, useSWRConfig, useStateWithDeps */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

// Global state used to deduplicate requests and store listeners
var SWRGlobalState = new WeakMap();

var EMPTY_CACHE = {};
var noop = function () { };
// Using noop() as the undefined value as undefined can possibly be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var UNDEFINED = ( /*#__NOINLINE__*/noop());
var OBJECT = Object;
var isUndefined = function (v) { return v === UNDEFINED; };
var isFunction = function (v) { return typeof v == 'function'; };
var mergeObjects = function (a, b) { return OBJECT.assign({}, a, b); };
var STR_UNDEFINED = 'undefined';
// NOTE: Use function to guarantee it's re-evaluated between jsdom and node runtime for tests.
var isWindowDefined = typeof window != STR_UNDEFINED;
var isDocumentDefined = typeof document != STR_UNDEFINED;
var hasRequestAnimationFrame = function () {
    return isWindowDefined && typeof window['requestAnimationFrame'] != STR_UNDEFINED;
};
var createCacheHelper = function (cache, key) {
    var state = SWRGlobalState.get(cache);
    return [
        // Getter
        function () { return (cache.get(key) || EMPTY_CACHE); },
        // Setter
        function (info) {
            var prev = cache.get(key);
            state[5](key, mergeObjects(prev, info), prev || EMPTY_CACHE);
        },
        // Subscriber
        state[6]
    ];
};

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var table = new WeakMap();
// counter of the key
var counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
var stableHash = function (arg) {
    var type = typeof arg;
    var constructor = arg && arg.constructor;
    var isDate = constructor == Date;
    var result;
    var index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result)
            return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for (index = 0; index < arg.length; index++) {
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            var keys = OBJECT.keys(arg).sort();
            while (!isUndefined((index = keys.pop()))) {
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    }
    else {
        result = isDate
            ? arg.toJSON()
            : type == 'symbol'
                ? arg.toString()
                : type == 'string'
                    ? JSON.stringify(arg)
                    : '' + arg;
    }
    return result;
};

/**
 * Due to bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a work around, we always assume it's online on first load, and change
 * the status upon `online` or `offline` events.
 */
var online = true;
var isOnline = function () { return online; };
// For node and React Native, `add/removeEventListener` doesn't exist on window.
var _a$1 = __read(isWindowDefined && window.addEventListener
    ? [
        window.addEventListener.bind(window),
        window.removeEventListener.bind(window)
    ]
    : [noop, noop], 2), onWindowEvent = _a$1[0], offWindowEvent = _a$1[1];
var isVisible = function () {
    var visibilityState = isDocumentDefined && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
var initFocus = function (callback) {
    // focus revalidate
    if (isDocumentDefined) {
        document.addEventListener('visibilitychange', callback);
    }
    onWindowEvent('focus', callback);
    return function () {
        if (isDocumentDefined) {
            document.removeEventListener('visibilitychange', callback);
        }
        offWindowEvent('focus', callback);
    };
};
var initReconnect = function (callback) {
    // revalidate on reconnected
    var onOnline = function () {
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    var onOffline = function () {
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return function () {
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
var preset = {
    isOnline: isOnline,
    isVisible: isVisible
};
var defaultConfigOptions = {
    initFocus: initFocus,
    initReconnect: initReconnect
};

var IS_REACT_LEGACY = !react__WEBPACK_IMPORTED_MODULE_0__.useId;
var IS_SERVER = !isWindowDefined || 'Deno' in window;
// Polyfill requestAnimationFrame
var rAF = function (f) {
    return hasRequestAnimationFrame()
        ? window['requestAnimationFrame'](f)
        : setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var useIsomorphicLayoutEffect = IS_SERVER ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
var navigatorConnection = typeof navigator !== 'undefined' &&
    navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
var slowConnection = !IS_SERVER &&
    navigatorConnection &&
    (['slow-2g', '2g'].includes(navigatorConnection.effectiveType) ||
        navigatorConnection.saveData);

var serialize = function (key) {
    if (isFunction(key)) {
        try {
            key = key();
        }
        catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    var args = key;
    // If key is not falsy, or not an empty array, hash it.
    key =
        typeof key == 'string'
            ? key
            : (Array.isArray(key) ? key.length : key)
                ? stableHash(key)
                : '';
    return [key, args];
};

// Global timestamp.
var __timestamp = 0;
var getTimestamp = function () { return ++__timestamp; };

var FOCUS_EVENT = 0;
var RECONNECT_EVENT = 1;
var MUTATE_EVENT = 2;

var constants = {
    __proto__: null,
    FOCUS_EVENT: FOCUS_EVENT,
    RECONNECT_EVENT: RECONNECT_EVENT,
    MUTATE_EVENT: MUTATE_EVENT
};

function internalMutate() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(this, void 0, void 0, function () {
        function mutateByKey(_k) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, key, _b, get, set, _d, EVENT_REVALIDATORS, MUTATION, FETCH, revalidators, startRevalidate, data, error, beforeMutationTs, hasOptimisticData, state, displayedData, committedData, res;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _a = __read(serialize(_k), 1), key = _a[0];
                            if (!key)
                                return [2 /*return*/];
                            _b = __read(createCacheHelper(cache, key), 2), get = _b[0], set = _b[1];
                            _d = __read(SWRGlobalState.get(cache), 3), EVENT_REVALIDATORS = _d[0], MUTATION = _d[1], FETCH = _d[2];
                            revalidators = EVENT_REVALIDATORS[key];
                            startRevalidate = function () {
                                if (revalidate) {
                                    // Invalidate the key by deleting the concurrent request markers so new
                                    // requests will not be deduped.
                                    delete FETCH[key];
                                    if (revalidators && revalidators[0]) {
                                        return revalidators[0](MUTATE_EVENT).then(function () { return get().data; });
                                    }
                                }
                                return get().data;
                            };
                            // If there is no new data provided, revalidate the key with current state.
                            if (args.length < 3) {
                                // Revalidate and broadcast state.
                                return [2 /*return*/, startRevalidate()];
                            }
                            data = _data;
                            beforeMutationTs = getTimestamp();
                            MUTATION[key] = [beforeMutationTs, 0];
                            hasOptimisticData = !isUndefined(optimisticData);
                            state = get();
                            displayedData = state.data;
                            committedData = isUndefined(state._c) ? displayedData : state._c;
                            // Do optimistic data update.
                            if (hasOptimisticData) {
                                optimisticData = isFunction(optimisticData)
                                    ? optimisticData(committedData)
                                    : optimisticData;
                                // When we set optimistic data, backup the current committedData data in `_c`.
                                set({ data: optimisticData, _c: committedData });
                            }
                            if (isFunction(data)) {
                                // `data` is a function, call it passing current cache value.
                                try {
                                    data = data(committedData);
                                }
                                catch (err) {
                                    // If it throws an error synchronously, we shouldn't update the cache.
                                    error = err;
                                }
                            }
                            if (!(data && isFunction(data.then))) return [3 /*break*/, 2];
                            return [4 /*yield*/, data.catch(function (err) {
                                    error = err;
                                })
                                // Check if other mutations have occurred since we've started this mutation.
                                // If there's a race we don't update cache or broadcast the change,
                                // just return the data.
                            ];
                        case 1:
                            // This means that the mutation is async, we need to check timestamps to
                            // avoid race conditions.
                            data = _e.sent();
                            // Check if other mutations have occurred since we've started this mutation.
                            // If there's a race we don't update cache or broadcast the change,
                            // just return the data.
                            if (beforeMutationTs !== MUTATION[key][0]) {
                                if (error)
                                    throw error;
                                return [2 /*return*/, data];
                            }
                            else if (error && hasOptimisticData && rollbackOnError) {
                                // Rollback. Always populate the cache in this case but without
                                // transforming the data.
                                populateCache = true;
                                data = committedData;
                                // Reset data to be the latest committed data, and clear the `_c` value.
                                set({ data: data, _c: UNDEFINED });
                            }
                            _e.label = 2;
                        case 2:
                            // If we should write back the cache after request.
                            if (populateCache) {
                                if (!error) {
                                    // Transform the result into data.
                                    if (isFunction(populateCache)) {
                                        data = populateCache(data, committedData);
                                    }
                                    // Only update cached data if there's no error. Data can be `undefined` here.
                                    set({ data: data, _c: UNDEFINED });
                                }
                                // Always update error and original data here.
                                set({ error: error });
                            }
                            // Reset the timestamp to mark the mutation has ended.
                            MUTATION[key][1] = getTimestamp();
                            return [4 /*yield*/, startRevalidate()
                                // The mutation and revalidation are ended, we can clear it since the data is
                                // not an optimistic value anymore.
                            ];
                        case 3:
                            res = _e.sent();
                            // The mutation and revalidation are ended, we can clear it since the data is
                            // not an optimistic value anymore.
                            set({ _c: UNDEFINED });
                            // Throw error or return data
                            if (error)
                                throw error;
                            return [2 /*return*/, populateCache ? res : data];
                    }
                });
            });
        }
        var _a, cache, _key, _data, _opts, options, populateCache, optimisticData, revalidate, rollbackOnError, keyFilter, matchedKeys, _b, _d, key;
        var e_1, _e;
        return __generator(this, function (_f) {
            _a = __read(args, 4), cache = _a[0], _key = _a[1], _data = _a[2], _opts = _a[3];
            options = typeof _opts === 'boolean' ? { revalidate: _opts } : _opts || {};
            populateCache = isUndefined(options.populateCache)
                ? true
                : options.populateCache;
            optimisticData = options.optimisticData;
            revalidate = options.revalidate !== false;
            rollbackOnError = options.rollbackOnError !== false;
            // If the second argument is a key filter, return the mutation results for all
            // filtered keys.
            if (isFunction(_key)) {
                keyFilter = _key;
                matchedKeys = [];
                try {
                    for (_b = __values(cache.keys()), _d = _b.next(); !_d.done; _d = _b.next()) {
                        key = _d.value;
                        if (
                        // Skip the special useSWRInfinite keys.
                        !key.startsWith('$inf$') &&
                            keyFilter(cache.get(key)._k)) {
                            matchedKeys.push(key);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_e = _b.return)) _e.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return [2 /*return*/, Promise.all(matchedKeys.map(mutateByKey))];
            }
            return [2 /*return*/, mutateByKey(_key)];
        });
    });
}

var revalidateAllKeys = function (revalidators, type) {
    for (var key in revalidators) {
        if (revalidators[key][0])
            revalidators[key][0](type);
    }
};
var initCache = function (provider, options) {
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that bound to
    // the cache.
    // Provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        var opts_1 = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        var EVENT_REVALIDATORS_1 = {};
        var mutate_1 = internalMutate.bind(UNDEFINED, provider);
        var unmount_1 = noop;
        var subscriptions_1 = {};
        var subscribe_1 = function (key, callback) {
            var subs = subscriptions_1[key] || [];
            subscriptions_1[key] = subs;
            subs.push(callback);
            return function () { return subs.splice(subs.indexOf(callback), 1); };
        };
        var setter_1 = function (key, value, prev) {
            provider.set(key, value);
            var subs = subscriptions_1[key];
            if (subs) {
                for (var i = subs.length; i--;) {
                    subs[i](prev, value);
                }
            }
        };
        var initProvider = function () {
            if (!SWRGlobalState.has(provider)) {
                // Update the state if it's new, or the provider has been extended.
                SWRGlobalState.set(provider, [
                    EVENT_REVALIDATORS_1,
                    {},
                    {},
                    {},
                    mutate_1,
                    setter_1,
                    subscribe_1
                ]);
                if (!IS_SERVER) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can possibly be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    var releaseFocus_1 = opts_1.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS_1, FOCUS_EVENT)));
                    var releaseReconnect_1 = opts_1.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS_1, RECONNECT_EVENT)));
                    unmount_1 = function () {
                        releaseFocus_1 && releaseFocus_1();
                        releaseReconnect_1 && releaseReconnect_1();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise when re-mounting we
                        // will not re-register those event listeners.
                        SWRGlobalState.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [provider, mutate_1, initProvider, unmount_1];
    }
    return [provider, SWRGlobalState.get(provider)[4]];
};

// error retry
var onErrorRetry = function (_, __, config, revalidate, opts) {
    var maxRetryCount = config.errorRetryCount;
    var currentRetryCount = opts.retryCount;
    // Exponential backoff
    var timeout = ~~((Math.random() + 0.5) *
        (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
var compare = function (currentData, newData) {
    return stableHash(currentData) == stableHash(newData);
};
// Default cache provider
var _a = __read(initCache(new Map()), 2), cache = _a[0], mutate = _a[1];
// Default config
var defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry: onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare: compare,
    isPaused: function () { return false; },
    cache: cache,
    mutate: mutate,
    fallback: {}
}, 
// use web preset by default
preset);

var mergeConfigs = function (a, b) {
    // Need to create a new object to avoid mutating the original here.
    var v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        var u1 = a.use, f1 = a.fallback;
        var u2 = b.use, f2 = b.fallback;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

var SWRConfigContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var SWRConfig = function (props) {
    var value = props.value;
    var parentConfig = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext);
    var isFunctionalConfig = isFunction(value);
    var config = isFunctionalConfig ? value(parentConfig) : value;
    // Extend parent context values and middleware.
    var extendedConfig = isFunctionalConfig
        ? config
        : mergeConfigs(parentConfig, config);
    // Should not use the inherited provider.
    var provider = config && config.provider;
    // Use a lazy initialized state to create the cache on first access.
    var _a = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
        return provider
            ? initCache(provider(extendedConfig.cache || cache), config)
            : UNDEFINED;
    }), 1), cacheContext = _a[0];
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(function () {
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

// @ts-expect-error
var enableDevtools = isWindowDefined && window.__SWR_DEVTOOLS_USE__;
var use = enableDevtools
    ? // @ts-expect-error
        window.__SWR_DEVTOOLS_USE__
    : [];
var setupDevTools = function () {
    if (enableDevtools) {
        // @ts-expect-error
        window.__SWR_DEVTOOLS_REACT__ = react__WEBPACK_IMPORTED_MODULE_0__;
    }
};

var normalize = function (args) {
    return isFunction(args[1])
        ? [args[0], args[1], args[2] || {}]
        : [args[0], null, (args[1] === null ? args[2] : args[1]) || {}];
};

var useSWRConfig = function () {
    return mergeObjects(defaultConfig, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext));
};

var preload = function (key_, fetcher) {
    var key = serialize(key_)[0];
    var _a = __read(SWRGlobalState.get(cache), 4), PRELOAD = _a[3];
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key])
        return PRELOAD[key];
    var req = fetcher(key_);
    PRELOAD[key] = req;
    return req;
};
var middleware = function (useSWRNext) { return function (key_, fetcher_, config) {
    // fetcher might be a sync function, so this should not be an async function
    var fetcher = fetcher_ &&
        (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var key = serialize(key_)[0];
            var _a = __read(SWRGlobalState.get(cache), 4), PRELOAD = _a[3];
            var req = PRELOAD[key];
            if (req) {
                delete PRELOAD[key];
                return req;
            }
            return fetcher_.apply(void 0, __spreadArray([], __read(args), false));
        });
    return useSWRNext(key_, fetcher, config);
}; };

var BUILT_IN_MIDDLEWARE = use.concat(middleware);

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
var withArgs = function (hook) {
    return function useSWRArgs() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Get the default and inherited configuration.
        var fallbackConfig = useSWRConfig();
        // Normalize arguments.
        var _a = __read(normalize(args), 3), key = _a[0], fn = _a[1], _config = _a[2];
        // Merge configurations.
        var config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        var next = hook;
        var use = config.use;
        var middleware = (use || []).concat(BUILT_IN_MIDDLEWARE);
        for (var i = middleware.length; i--;) {
            next = middleware[i](next);
        }
        return next(key, fn || config.fetcher, config);
    };
};

/**
 * An implementation of state with dependency-tracking.
 */
var useStateWithDeps = function (state) {
    var rerender = useState({})[1];
    var unmountedRef = useRef(false);
    var stateRef = useRef(state);
    // If a state property (data, error or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    var stateDependenciesRef = useRef({
        data: false,
        error: false,
        isValidating: false
    });
    /**
     * @param payload To change stateRef, pass the values explicitly to setState:
     * @example
     * ```js
     * setState({
     *   isValidating: false
     *   data: newData // set data to newData
     *   error: undefined // set error to undefined
     * })
     *
     * setState({
     *   isValidating: false
     *   data: undefined // set data to undefined
     *   error: err // set error to err
     * })
     * ```
     */
    var setState = useCallback(function (payload) {
        var shouldRerender = false;
        var currentState = stateRef.current;
        for (var _ in payload) {
            var k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            if (IS_REACT_LEGACY) {
                rerender({});
            }
            else {
                React.startTransition(function () { return rerender({}); });
            }
        }
    }, 
    // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    useIsomorphicLayoutEffect(function () {
        unmountedRef.current = false;
        return function () {
            unmountedRef.current = true;
        };
    });
    return [stateRef, stateDependenciesRef.current, setState];
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
var subscribeCallback = function (key, callbacks, callback) {
    var keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return function () {
        var index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

// Create a custom hook with a middleware
var withMiddleware = function (useSWR, middleware) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a = __read(normalize(args), 3), key = _a[0], fn = _a[1], config = _a[2];
        var uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, __assign(__assign({}, config), { use: uses }));
    };
};

setupDevTools();




/***/ }),

/***/ 5591:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JG": function() { return /* reexport safe */ swr_internal__WEBPACK_IMPORTED_MODULE_2__.JG; },
/* harmony export */   "ZP": function() { return /* binding */ useSWR; }
/* harmony export */ });
/* unused harmony exports SWRConfig, unstable_serialize */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1688);
/* harmony import */ var swr_internal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1753);





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var WITH_DEDUPE = { dedupe: true };
var useSWRHandler = function (_key, fetcher, config) {
    var cache = config.cache, compare = config.compare, suspense = config.suspense, fallbackData = config.fallbackData, revalidateOnMount = config.revalidateOnMount, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline, keepPreviousData = config.keepPreviousData;
    var _a = __read(swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .SWRGlobalState.get */ .DY.get(cache), 3), EVENT_REVALIDATORS = _a[0], MUTATION = _a[1], FETCH = _a[2];
    // `key` is the identifier of the SWR `data` state, `keyInfo` holds extra
    // states such as `error` and `isValidating` inside,
    // all of them are derived from `_key`.
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    var _b = __read((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .serialize */ .qC)(_key), 2), key = _b[0], fnArg = _b[1];
    // If it's the initial render of this hook.
    var initialMountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    var unmountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // Refs to keep the key and config.
    var keyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(key);
    var fetcherRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fetcher);
    var configRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(config);
    var getConfig = function () { return configRef.current; };
    var isActive = function () { return getConfig().isVisible() && getConfig().isOnline(); };
    var _c = __read((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .createCacheHelper */ .JN)(cache, key), 3), getCache = _c[0], setCache = _c[1], subscribeCache = _c[2];
    var stateDependencies = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({}).current;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var fallback = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(fallbackData)
        ? config.fallback[key]
        : fallbackData;
    var isEqual = function (prev, current) {
        var equal = true;
        for (var _ in stateDependencies) {
            var t = _;
            if (!compare(current[t], prev[t])) {
                if (t === 'data' && (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(prev[t])) {
                    if (!compare(current[t], fallback)) {
                        equal = false;
                    }
                }
                else {
                    equal = false;
                }
            }
        }
        return equal;
    };
    var getSnapshot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        var shouldStartRequest = (function () {
            if (!key)
                return false;
            if (!fetcher)
                return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(revalidateOnMount))
                return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused())
                return false;
            if (suspense)
                return false;
            return true;
        })();
        var getSelectedCache = function () {
            var state = getCache();
            // We only select the needed fields from the state.
            var snapshot = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .mergeObjects */ .PM)(state);
            delete snapshot._k;
            if (!shouldStartRequest) {
                return snapshot;
            }
            return Object.assign({
                isValidating: true,
                isLoading: true
            }, snapshot);
        };
        var memorizedSnapshot = getSelectedCache();
        return function () {
            var snapshot = getSelectedCache();
            return isEqual(snapshot, memorizedSnapshot)
                ? memorizedSnapshot
                : (memorizedSnapshot = snapshot);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cache, key]);
    // Get the current state that SWR should return.
    var cached = (0,use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_1__.useSyncExternalStore)((0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (callback) {
        return subscribeCache(key, function (prev, current) {
            if (!isEqual(prev, current))
                callback();
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cache, key]), getSnapshot, getSnapshot);
    var isInitialMount = !initialMountedRef.current;
    var cachedData = cached.data;
    var data = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cachedData) ? fallback : cachedData;
    var error = cached.error;
    // Use a ref to store previous returned data. Use the initial data as its initial value.
    var laggyDataRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(data);
    var returnedData = keepPreviousData
        ? (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cachedData)
            ? laggyDataRef.current
            : cachedData
        : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    var shouldDoInitialRevalidation = (function () {
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(revalidateOnMount))
            return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused())
            return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately on mount again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense)
            return (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data) ? false : config.revalidateIfStale;
        // If there is no stale data, we need to revalidate on mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data) || config.revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate on mount, this will be true.
    var defaultValidatingState = !!(key &&
        fetcher &&
        isInitialMount &&
        shouldDoInitialRevalidation);
    var isValidating = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cached.isValidating)
        ? defaultValidatingState
        : cached.isValidating;
    var isLoading = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cached.isLoading)
        ? defaultValidatingState
        : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    var revalidate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (revalidateOpts) { return __awaiter(void 0, void 0, void 0, function () {
        var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, callbackSafeguard, finalState, finishRequestAndUpdateState, cleanupState, initialState, mutationInfo, cacheData, err_1, currentConfig, shouldRetryOnError;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentFetcher = fetcherRef.current;
                    if (!key ||
                        !currentFetcher ||
                        unmountedRef.current ||
                        getConfig().isPaused()) {
                        return [2 /*return*/, false];
                    }
                    loading = true;
                    opts = revalidateOpts || {};
                    shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
                    callbackSafeguard = function () {
                        if (swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .IS_REACT_LEGACY */ .w6) {
                            return (!unmountedRef.current &&
                                key === keyRef.current &&
                                initialMountedRef.current);
                        }
                        return key === keyRef.current;
                    };
                    finalState = {
                        isValidating: false,
                        isLoading: false
                    };
                    finishRequestAndUpdateState = function () {
                        setCache(finalState);
                    };
                    cleanupState = function () {
                        // Check if it's still the same request before deleting.
                        var requestInfo = FETCH[key];
                        if (requestInfo && requestInfo[1] === startAt) {
                            delete FETCH[key];
                        }
                    };
                    initialState = { isValidating: true };
                    // It is in the `isLoading` state, if and only if there is no cached data.
                    // This bypasses fallback data and laggy data.
                    if ((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(getCache().data)) {
                        initialState.isLoading = true;
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    if (shouldStartNewRequest) {
                        setCache(initialState);
                        // If no cache being rendered currently (it shows a blank page),
                        // we trigger the loading slow event.
                        if (config.loadingTimeout && (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(getCache().data)) {
                            setTimeout(function () {
                                if (loading && callbackSafeguard()) {
                                    getConfig().onLoadingSlow(key, config);
                                }
                            }, config.loadingTimeout);
                        }
                        // Start the request and save the timestamp.
                        // Key must be truthy if entering here.
                        FETCH[key] = [
                            currentFetcher(fnArg),
                            (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .getTimestamp */ .u3)()
                        ];
                    }
                    _a = __read(FETCH[key], 2), newData = _a[0], startAt = _a[1];
                    return [4 /*yield*/, newData];
                case 2:
                    newData = _b.sent();
                    if (shouldStartNewRequest) {
                        // If the request isn't interrupted, clean it up after the
                        // deduplication interval.
                        setTimeout(cleanupState, config.dedupingInterval);
                    }
                    // If there're other ongoing request(s), started after the current one,
                    // we need to ignore the current one to avoid possible race conditions:
                    //   req1------------------>res1        (current one)
                    //        req2---------------->res2
                    // the request that fired later will always be kept.
                    // The timestamp maybe be `undefined` or a number
                    if (!FETCH[key] || FETCH[key][1] !== startAt) {
                        if (shouldStartNewRequest) {
                            if (callbackSafeguard()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Clear error.
                    finalState.error = swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .UNDEFINED */ .i_;
                    mutationInfo = MUTATION[key];
                    if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(mutationInfo) &&
                        // case 1
                        (startAt <= mutationInfo[0] ||
                            // case 2
                            startAt <= mutationInfo[1] ||
                            // case 3
                            mutationInfo[1] === 0)) {
                        finishRequestAndUpdateState();
                        if (shouldStartNewRequest) {
                            if (callbackSafeguard()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    cacheData = getCache().data;
                    // Since the compare fn could be custom fn
                    // cacheData might be different from newData even when compare fn returns True
                    finalState.data = compare(cacheData, newData) ? cacheData : newData;
                    // Trigger the successful callback if it's the original request.
                    if (shouldStartNewRequest) {
                        if (callbackSafeguard()) {
                            getConfig().onSuccess(newData, key, config);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    cleanupState();
                    currentConfig = getConfig();
                    shouldRetryOnError = currentConfig.shouldRetryOnError;
                    // Not paused, we continue handling the error. Otherwise discard it.
                    if (!currentConfig.isPaused()) {
                        // Get a new error, don't use deep comparison for errors.
                        finalState.error = err_1;
                        // Error event and retry logic. Only for the actual request, not
                        // deduped ones.
                        if (shouldStartNewRequest && callbackSafeguard()) {
                            currentConfig.onError(err_1, key, currentConfig);
                            if (shouldRetryOnError === true ||
                                ((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .mf)(shouldRetryOnError) &&
                                    shouldRetryOnError(err_1))) {
                                if (isActive()) {
                                    // If it's inactive, stop. It will auto revalidate when
                                    // refocusing or reconnecting.
                                    // When retrying, deduplication is always enabled.
                                    currentConfig.onErrorRetry(err_1, key, currentConfig, revalidate, {
                                        retryCount: (opts.retryCount || 0) + 1,
                                        dedupe: true
                                    });
                                }
                            }
                        }
                    }
                    return [3 /*break*/, 4];
                case 4:
                    // Mark loading as stopped.
                    loading = false;
                    // Update the current hook's state.
                    finishRequestAndUpdateState();
                    return [2 /*return*/, true];
            }
        });
    }); }, 
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [key, cache]);
    // Similar to the global mutate, but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var boundMutate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    // Use callback to make sure `keyRef.current` returns latest result every time
    function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .internalMutate.apply */ .BN.apply(void 0, __spreadArray([cache, keyRef.current], __read(args), false));
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Logic for updating refs.
    (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .LI)(function () {
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cachedData)) {
            laggyDataRef.current = cachedData;
        }
    });
    // After mounted or key changed.
    (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .LI)(function () {
        if (!key)
            return;
        var softRevalidate = revalidate.bind(swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .UNDEFINED */ .i_, WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        var nextFocusRevalidatedAt = 0;
        var onRevalidate = function (type) {
            if (type == swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .revalidateEvents.FOCUS_EVENT */ .sj.FOCUS_EVENT) {
                var now = Date.now();
                if (getConfig().revalidateOnFocus &&
                    now > nextFocusRevalidatedAt &&
                    isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            }
            else if (type == swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .revalidateEvents.RECONNECT_EVENT */ .sj.RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            }
            else if (type == swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .revalidateEvents.MUTATE_EVENT */ .sj.MUTATE_EVENT) {
                return revalidate();
            }
            return;
        };
        var unsubEvents = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .subscribeCallback */ .ko)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({ _k: fnArg });
        // Trigger a revalidation.
        if (shouldDoInitialRevalidation) {
            if ((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data) || swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .IS_SERVER */ .W6) {
                // Revalidate immediately.
                softRevalidate();
            }
            else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .rAF */ .kw)(softRevalidate);
            }
        }
        return function () {
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [key]);
    // Polling
    (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .LI)(function () {
        var timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            var interval = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .mf)(refreshInterval)
                ? refreshInterval(data)
                : refreshInterval;
            // We only start next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online and not errored.
            if (!getCache().error &&
                (refreshWhenHidden || getConfig().isVisible()) &&
                (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            }
            else {
                // Schedule next interval to check again.
                next();
            }
        }
        next();
        return function () {
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [refreshInterval, refreshWhenHidden, refreshWhenOffline, key]);
    // Display debug info in React DevTools.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .IS_REACT_LEGACY */ .w6 && swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .IS_SERVER */ .W6) {
            throw new Error('Fallback data is required when using suspense in SSR.');
        }
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        throw (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(error) ? revalidate(WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data() {
            stateDependencies.data = true;
            return returnedData;
        },
        get error() {
            stateDependencies.error = true;
            return error;
        },
        get isValidating() {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading() {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
var SWRConfig = swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .OBJECT.defineProperty */ .$l.defineProperty(swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .SWRConfig */ .J$, 'defaultValue', {
    value: swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .defaultConfig */ .u_
});
var unstable_serialize = function (key) { return serialize(key)[0]; };
var useSWR = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .withArgs */ .s6)(useSWRHandler);

// useSWR




/***/ }),

/***/ 4593:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ index; },
/* harmony export */   "wE": function() { return /* binding */ unstable_serialize; }
/* harmony export */ });
/* unused harmony export infinite */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5591);
/* harmony import */ var swr_internal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1753);
/* harmony import */ var use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1688);





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

// We have to several type castings here because `useSWRInfinite` is a special
var INFINITE_PREFIX = '$inf$';
var EMPTY_PROMISE = Promise.resolve();
var getFirstPageKey = function (getKey) {
    return (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .serialize */ .qC)(getKey ? getKey(0, null) : null)[0];
};
var unstable_serialize = function (getKey) {
    return INFINITE_PREFIX + getFirstPageKey(getKey);
};
var infinite = (function (useSWRNext) {
    return function (getKey, fn, config) {
        var didMountRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
        var dataRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
        var cache = config.cache, _a = config.initialSize, initialSize = _a === void 0 ? 1 : _a, _b = config.revalidateAll, revalidateAll = _b === void 0 ? false : _b, _c = config.persistSize, persistSize = _c === void 0 ? false : _c, _d = config.revalidateFirstPage, revalidateFirstPage = _d === void 0 ? true : _d, _e = config.revalidateOnMount, revalidateOnMount = _e === void 0 ? false : _e;
        // The serialized key of the first page. This key will be used to store
        // metadata of this SWR infinite hook.
        var infiniteKey;
        try {
            infiniteKey = getFirstPageKey(getKey);
            if (infiniteKey)
                infiniteKey = INFINITE_PREFIX + infiniteKey;
        }
        catch (err) {
            // Not ready yet.
        }
        var _f = __read((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .createCacheHelper */ .JN)(cache, infiniteKey), 3), get = _f[0], set = _f[1], subscribeCache = _f[2];
        var getSnapshot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
            var size = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(get()._l) ? initialSize : get()._l;
            return size;
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [cache, infiniteKey, initialSize]);
        (0,use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_3__.useSyncExternalStore)((0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (callback) {
            if (infiniteKey)
                return subscribeCache(infiniteKey, function () {
                    callback();
                });
            return function () { };
        }, 
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [cache, infiniteKey]), getSnapshot, getSnapshot);
        var resolvePageSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
            var cachedPageSize = get()._l;
            return (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cachedPageSize) ? initialSize : cachedPageSize;
            // `cache` isn't allowed to change during the lifecycle
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [infiniteKey, initialSize]);
        // keep the last page size to restore it with the persistSize option
        var lastPageSizeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(resolvePageSize());
        // When the page key changes, we reset the page size if it's not persisted
        (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .LI)(function () {
            if (!didMountRef.current) {
                didMountRef.current = true;
                return;
            }
            if (infiniteKey) {
                // If the key has been changed, we keep the current page size if persistSize is enabled
                set({ _l: persistSize ? lastPageSizeRef.current : initialSize });
            }
            // `initialSize` isn't allowed to change during the lifecycle
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [infiniteKey, cache]);
        // Needs to check didMountRef during mounting, not in the fetcher
        var shouldRevalidateOnMount = revalidateOnMount && !didMountRef.current;
        // Actual SWR hook to load all pages in one fetcher.
        var swr = useSWRNext(infiniteKey, function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, forceRevalidateAll, originalData, data, pageSize, previousPageData, i, _b, pageKey, pageArg, _c, getSWRCache, setSWRCache, pageData, shouldFetchPage;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = __read(get()._i || [], 2), forceRevalidateAll = _a[0], originalData = _a[1];
                        data = [];
                        pageSize = resolvePageSize();
                        previousPageData = null;
                        i = 0;
                        _d.label = 1;
                    case 1:
                        if (!(i < pageSize)) return [3 /*break*/, 5];
                        _b = __read((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .serialize */ .qC)(getKey(i, previousPageData)), 2), pageKey = _b[0], pageArg = _b[1];
                        if (!pageKey) {
                            // `pageKey` is falsy, stop fetching new pages.
                            return [3 /*break*/, 5];
                        }
                        _c = __read((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .createCacheHelper */ .JN)(cache, pageKey), 2), getSWRCache = _c[0], setSWRCache = _c[1];
                        pageData = getSWRCache().data;
                        shouldFetchPage = revalidateAll ||
                            forceRevalidateAll ||
                            (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(pageData) ||
                            (revalidateFirstPage && !i && !(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(dataRef.current)) ||
                            shouldRevalidateOnMount ||
                            (originalData &&
                                !(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(originalData[i]) &&
                                !config.compare(originalData[i], pageData));
                        if (!(fn && shouldFetchPage)) return [3 /*break*/, 3];
                        return [4 /*yield*/, fn(pageArg)];
                    case 2:
                        pageData = _d.sent();
                        setSWRCache({ data: pageData, _k: pageArg });
                        _d.label = 3;
                    case 3:
                        data.push(pageData);
                        previousPageData = pageData;
                        _d.label = 4;
                    case 4:
                        ++i;
                        return [3 /*break*/, 1];
                    case 5:
                        // once we executed the data fetching based on the context, clear the context
                        set({ _i: swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .UNDEFINED */ .i_ });
                        // return the data
                        return [2 /*return*/, data];
                }
            });
        }); }, config);
        // update dataRef
        (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .LI)(function () {
            dataRef.current = swr.data;
        }, [swr.data]);
        var mutate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
        // eslint-disable-next-line func-names
        function (data, opts) {
            // When passing as a boolean, it's explicitly used to disable/enable
            // revalidation.
            var options = typeof opts === 'boolean' ? { revalidate: opts } : opts || {};
            // Default to true.
            var shouldRevalidate = options.revalidate !== false;
            // It is possible that the key is still falsy.
            if (!infiniteKey)
                return EMPTY_PROMISE;
            if (shouldRevalidate) {
                if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data)) {
                    // We only revalidate the pages that are changed
                    var originalData = dataRef.current;
                    set({ _i: [false, originalData] });
                }
                else {
                    // Calling `mutate()`, we revalidate all pages
                    set({ _i: [true] });
                }
            }
            return arguments.length
                ? swr.mutate(data, shouldRevalidate)
                : swr.mutate();
        }, 
        // swr.mutate is always the same reference
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [infiniteKey, cache]);
        // Function to load pages data from the cache based on the page size.
        var resolvePagesFromCache = function (pageSize) {
            var _a;
            // return an array of page data
            var data = [];
            var previousPageData = null;
            for (var i = 0; i < pageSize; ++i) {
                var _b = __read((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .serialize */ .qC)(getKey(i, previousPageData)), 1), pageKey = _b[0];
                // Get the cached page data.
                var pageData = pageKey ? (_a = cache.get(pageKey)) === null || _a === void 0 ? void 0 : _a.data : swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .UNDEFINED */ .i_;
                // Return the current data if we can't get it from the cache.
                if ((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(pageData))
                    return dataRef.current;
                data.push(pageData);
                previousPageData = pageData;
            }
            // Return the data
            return data;
        };
        // Extend the SWR API
        var setSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (arg) {
            // It is possible that the key is still falsy.
            if (!infiniteKey)
                return EMPTY_PROMISE;
            var size;
            if ((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .mf)(arg)) {
                size = arg(resolvePageSize());
            }
            else if (typeof arg == 'number') {
                size = arg;
            }
            if (typeof size != 'number')
                return EMPTY_PROMISE;
            set({ _l: size });
            lastPageSizeRef.current = size;
            return mutate(resolvePagesFromCache(size));
        }, 
        // `cache` and `rerender` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [infiniteKey, resolvePageSize, mutate, cache]);
        // Use getter functions to avoid unnecessary re-renders caused by triggering
        // all the getters of the returned swr object.
        return {
            size: resolvePageSize(),
            setSize: setSize,
            mutate: mutate,
            get data() {
                return swr.data;
            },
            get error() {
                return swr.error;
            },
            get isValidating() {
                return swr.isValidating;
            },
            get isLoading() {
                return swr.isLoading;
            }
        };
    };
});
var index = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .withMiddleware */ .xD)(swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, infinite);




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6840), __webpack_exec__(387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);